
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fr1K2", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $7MmCC = parcelRequire("7MmCC");

var $ftdKz = parcelRequire("ftdKz");

var $etAYC = parcelRequire("etAYC");

var $4NkAS = parcelRequire("4NkAS");

var $b2dLE = parcelRequire("b2dLE");

var $9SRAA = parcelRequire("9SRAA");

var $7GWAt = parcelRequire("7GWAt");
/** Used to compose bitmasks for cloning. */ var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $1nIHN(paths, function(path) {
        path = $etAYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $4NkAS(object, $7GWAt(object), result);
    if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
    var length = paths.length;
    while(length--)$ftdKz(result, paths[length]);
    return result;
});
module.exports = $b3caba7e25e0a917$var$omit;

});
parcelRegister("ftdKz", function(module, exports) {

var $etAYC = parcelRequire("etAYC");

var $hYfgW = parcelRequire("hYfgW");

var $8lSJl = parcelRequire("8lSJl");

var $gzebZ = parcelRequire("gzebZ");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b4343aeaece186b7$var$baseUnset(object, path) {
    path = $etAYC(path, object);
    object = $8lSJl(object, path);
    return object == null || delete object[$gzebZ($hYfgW(path))];
}
module.exports = $b4343aeaece186b7$var$baseUnset;

});
parcelRegister("8lSJl", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $614abd39878e1d90$var$parent(object, path) {
    return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
}
module.exports = $614abd39878e1d90$var$parent;

});


parcelRegister("b2dLE", function(module, exports) {

var $1QOns = parcelRequire("1QOns");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $808a8f8fca7f9ff7$var$customOmitClone(value) {
    return $1QOns(value) ? undefined : value;
}
module.exports = $808a8f8fca7f9ff7$var$customOmitClone;

});


parcelRegister("3NMrl", function(module, exports) {

var $i2e26 = parcelRequire("i2e26");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
    return object == null ? {} : $i2e26(object, paths);
});
module.exports = $2c4b85df1af41471$var$pick;

});
parcelRegister("i2e26", function(module, exports) {

var $4gaCO = parcelRequire("4gaCO");

var $fh9gH = parcelRequire("fh9gH");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d2134c8f0f8064b1$var$basePick(object, paths) {
    return $4gaCO(object, paths, function(value, path) {
        return $fh9gH(object, path);
    });
}
module.exports = $d2134c8f0f8064b1$var$basePick;

});


parcelRegister("kUr4d", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f38e08888af96a1f$export$882461b6382ed46c, (v) => $f38e08888af96a1f$export$882461b6382ed46c = v);
var $f38e08888af96a1f$export$882461b6382ed46c;
var $f38e08888af96a1f$export$757ceba2d55c277e;
'use strict';

var $7nsd3 = parcelRequire("7nsd3");
var $f38e08888af96a1f$var$i;
$f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
$f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;

});

parcelRegister("hh0bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8a1e19e7613048$export$2e2bcd8739ae039);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $6c8a1e19e7613048$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...location ? {
                reason: location
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...field ? {
                field: field
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $6c8a1e19e7613048$var$transformApplication(application),
            edition: $6c8a1e19e7613048$var$transformEdition(edition)
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});

parcelRegister("8ApFP", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $a83c9e8eeb3d40c2$export$c71778b3a4356b04);

var $cfDZ3 = parcelRequire("cfDZ3");

var $hVf1M = parcelRequire("hVf1M");
const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $cfDZ3.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $cfDZ3.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $cfDZ3.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $hVf1M.getIsProjectAdmin)
    }
});

});
parcelRegister("hVf1M", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $d8c128d9b214e073$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $d8c128d9b214e073$export$d53e6d79d3fa5f31);
let $d8c128d9b214e073$var$projectAdmin = null;
const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
};
const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $d8c128d9b214e073$var$projectAdmin = projectAdminState;
};

});


parcelRegister("2YzDH", function(module, exports) {

var $7JoAD = parcelRequire("7JoAD");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("gWyQv"));
    const isDevMode = false;
    (0, $7JoAD.defaults).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $7JoAD.defaults).batchUpdates = !false;
    Object.freeze((0, $7JoAD.defaults));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("gWyQv", function(module, exports) {
const $c55d17c8cfd749ca$var$style = document.createElement('style');
$c55d17c8cfd749ca$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($c55d17c8cfd749ca$var$style);

});


parcelRegister("frBVt", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $126443352ff757de$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $126443352ff757de$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointPlaceholder", () => $126443352ff757de$export$db2828f683d11042);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");
function $126443352ff757de$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $126443352ff757de$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $5uXOq.createContext)(new Map());
function $126443352ff757de$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
    const { root: root } = entryPoint;
    const hasMounted = (0, $5uXOq.useRef)(false);
    const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : // eslint-disable-next-line react/no-danger
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name
    }));
    const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (hasMounted.current && placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        entryPoint,
        name,
        placeholders,
        setFallback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onComplete = ()=>{
            if (placeholders.has(name)) placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        };
        const unsubscribe = root.onComplete(onComplete, onComplete);
        return ()=>{
            unsubscribe();
            onComplete();
        };
    }, [
        name,
        placeholders,
        root
    ]);
    (0, $5uXOq.useEffect)(()=>{
        hasMounted.current = true;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-ep-placeholder-id": name
    }, children));
}

});

parcelRegister("7bkFJ", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $fef4d3d4b4c51b47$export$2d291317456ada16);

var $hFKXd = parcelRequire("hFKXd");

var $4R6GH = parcelRequire("4R6GH");

var $co1wz = parcelRequire("co1wz");
const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
    if ((0, $co1wz.ff)('fix_jira_ssr_platform_ff_oxim4')) (0, $hFKXd.setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, $4R6GH.fg)(flagKey) || (0, $co1wz.ff)(flagKey));
};

});

parcelRegister("fz3fB", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $a1827329dcbac5c8$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $a1827329dcbac5c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $6yXtV = parcelRequire("6yXtV");
const $a1827329dcbac5c8$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
    return null;
};
const $a1827329dcbac5c8$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $a1827329dcbac5c8$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
const $a1827329dcbac5c8$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$var$NonCriticalComponent, props));
var $a1827329dcbac5c8$export$2e2bcd8739ae039 = $a1827329dcbac5c8$var$NonCriticalComponent;

});
parcelRegister("6yXtV", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $44de65c7edb80809$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $44de65c7edb80809$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $44de65c7edb80809$export$41e70078eeddaddc);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $7JoAD = parcelRequire("7JoAD");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $44de65c7edb80809$export$ea2491906b753456 = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: $44de65c7edb80809$export$e6897aa59ee7aee5
});
const $44de65c7edb80809$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: setAppReady
        }));
const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: setAppReady,
            args: comparer
        }));

});
parcelRegister("bNvU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c14e3adf575574$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
// eslint-disable-next-line jira/react/no-class-components
class $96c14e3adf575574$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $96c14e3adf575574$export$2e2bcd8739ae039 = $96c14e3adf575574$var$OpTrigger;

});

parcelRegister("4oDnX", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $363cd3235a9267e4$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $363cd3235a9267e4$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $363cd3235a9267e4$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $363cd3235a9267e4$export$b134752525935b78);

var $7JoAD = parcelRequire("7JoAD");

var $7w9eZ = parcelRequire("7w9eZ");
const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $7JoAD.createSubscriber)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $7JoAD.createSubscriber)((0, $7w9eZ.default), {
    selector: null
});
const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $7JoAD.createHook)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$b134752525935b78 = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: null
});

});
parcelRegister("7w9eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85db42238a8acf29$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $7JoAD = parcelRequire("7JoAD");

var $6Bj8c = parcelRequire("6Bj8c");
const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $85db42238a8acf29$var$store = (0, $7JoAD.createStore)({
    name: 'spa-state',
    initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
    actions: $6Bj8c
});
var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;

});
parcelRegister("6Bj8c", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("fI6Pg")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("fI6Pg")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("fI6Pg")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("fI6Pg")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("fI6Pg")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("fI6Pg")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("fI6Pg")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("fI6Pg")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fI6Pg = parcelRequire("fI6Pg");

});
parcelRegister("fI6Pg", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $4a986cd3487bf863$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $4a986cd3487bf863$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $4a986cd3487bf863$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $4a986cd3487bf863$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $4a986cd3487bf863$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $4a986cd3487bf863$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $4a986cd3487bf863$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $4a986cd3487bf863$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $4a986cd3487bf863$export$8ad155d489dcf34d);

var $7Jxgt = parcelRequire("7Jxgt");

var $gWHEk = parcelRequire("gWHEk");

var $co1wz = parcelRequire("co1wz");

var $cfDZ3 = parcelRequire("cfDZ3");

var $dPp96 = parcelRequire("dPp96");

var $7fyET = parcelRequire("7fyET");
const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $gWHEk.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $dPp96.default)(nextRouteUfoName, nextRouteName);
        if ((0, $co1wz.ff)('uip.ufo')) {
            (0, $7fyET.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $7fyET.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
            }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $cfDZ3.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
    };
const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
    };
const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});






parcelRegister("gAeCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5368db3a32c0eb20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");
const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $5uXOq.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $x9xyg.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;

});

parcelRegister("erCTW", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");

var $ghpaW = parcelRequire("ghpaW");

var $gAeCk = parcelRequire("gAeCk");

var $39xOx = parcelRequire("39xOx");

var $7XYc4 = parcelRequire("7XYc4");

var $14V0U = parcelRequire("14V0U");

var $g7crU = parcelRequire("g7crU");

var $jHXUj = parcelRequire("jHXUj");

var $aKiiD = parcelRequire("aKiiD");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");


var $16YKp = parcelRequire("16YKp");

var $cOwuh = parcelRequire("cOwuh");

var $iXVV6 = parcelRequire("iXVV6");

var $6ncxj = parcelRequire("6ncxj");

var $2SVPM = parcelRequire("2SVPM");

var $gmCnE = parcelRequire("gmCnE");

var $kc9FZ = parcelRequire("kc9FZ");

var $6DLIs = parcelRequire("6DLIs");

var $62C9r = parcelRequire("62C9r");

var $4s15Z = parcelRequire("4s15Z");

var $eF0qp = parcelRequire("eF0qp");

var $gxCm0 = parcelRequire("gxCm0");

var $lvpKt = parcelRequire("lvpKt");

var $8Ceqd = parcelRequire("8Ceqd");
const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themed: "_11q71o10 _11q31r52"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $a81b2dc7c8e9cabb$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { hasTheming: hasTheming } = (0, $ghpaW.useBusinessLookAndFeel)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    const mainWrapper = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
            isFixed: true,
            testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                hasTheming && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
            ])
        }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), content));
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ceqd.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: "",
        testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
    }, showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), mainWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNav), null), children)), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $6ncxj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $a81b2dc7c8e9cabb$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    let contentChildren = isJsmPackagingUpdatesEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), children);
    const panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvpKt.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $6ncxj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ceqd.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, panelContent)));
};
const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNew, $a81b2dc7c8e9cabb$var$PageContainerOld);

});
parcelRegister("ghpaW", function(module, exports) {

$parcel$export(module.exports, "useBusinessLookAndFeel", () => $7e2321a1a057b301$export$ad3385faee9e435a);

var $l71WK = parcelRequire("l71WK");

var $65Ltd = parcelRequire("65Ltd");

var $8iyFV = parcelRequire("8iyFV");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $5PD5h = parcelRequire("5PD5h");
const $7e2321a1a057b301$export$ad3385faee9e435a = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const isBusinessRouteGroup = route.group === (0, $65Ltd.ROUTE_GROUPS_CLASSIC_BUSINESS);
    const hasProjectViewNavigation = (0, $3HwlS.getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, $l71WK.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $5PD5h.AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, $8iyFV.AsyncHorizontalNavPlans);
    const hasTheming = (0, $3HwlS.getWillShowNav4)() ? HorizontalNavComponent === (0, $l71WK.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || route.name === (0, $65Ltd.ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
    // Routes showing a themed insetlayout are:
    // - all routes with the business project view navigation
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};

});
parcelRegister("l71WK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $7e6dac351b79a914$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $7e6dac351b79a914$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("h16ll")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));

const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("exvyI")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("h16ll", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("4RRJO")
]).then(()=>parcelRequire('bwmXM'));

});

parcelRegister("exvyI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hTo1l")
]).then(()=>parcelRequire('bNzBR'));

});


parcelRegister("65Ltd", function(module, exports) {

$parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", () => $d90d8ce15e0e3233$export$1ba937db1fe6ef01);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", () => $d90d8ce15e0e3233$export$bbf08d4d25df5504);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", () => $d90d8ce15e0e3233$export$e3e759b7f50aaee1);
$parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", () => $d90d8ce15e0e3233$export$89337611b52bc9a3);
$parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", () => $d90d8ce15e0e3233$export$3d7937b12eb9e5d5);
$parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", () => $d90d8ce15e0e3233$export$7a3d181d86fce9e6);
$parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", () => $d90d8ce15e0e3233$export$7a22726acd7d6021);
$parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", () => $d90d8ce15e0e3233$export$f3f4a9f53ba00861);
$parcel$export(module.exports, "ROUTE_GROUPS_EOC", () => $d90d8ce15e0e3233$export$112d69653b2f1d8b);
$parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", () => $d90d8ce15e0e3233$export$74e0426b66571086);
$parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", () => $d90d8ce15e0e3233$export$c2e20e142c95c1ce);
$parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", () => $d90d8ce15e0e3233$export$f8cea29bebf098c);
$parcel$export(module.exports, "ROUTE_GROUPS_HOME", () => $d90d8ce15e0e3233$export$5801ef8dfc9a2f70);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", () => $d90d8ce15e0e3233$export$7246838143f848f3);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", () => $d90d8ce15e0e3233$export$54f96702980a2f87);
$parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", () => $d90d8ce15e0e3233$export$5566db8fbd042fc4);
$parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", () => $d90d8ce15e0e3233$export$656d0cc2c67b2708);
$parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", () => $d90d8ce15e0e3233$export$bfdbcebc4c81b043);
$parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", () => $d90d8ce15e0e3233$export$82021d71ad19e227);
$parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", () => $d90d8ce15e0e3233$export$6f266218a6973848);
$parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", () => $d90d8ce15e0e3233$export$a846fcaeeea8e0ff);
$parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", () => $d90d8ce15e0e3233$export$6c87a9dff4e7a2de);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", () => $d90d8ce15e0e3233$export$ab79970dcfac06a1);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", () => $d90d8ce15e0e3233$export$d1a70f80bb22f18a);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", () => $d90d8ce15e0e3233$export$bd925e9fcb6ce37f);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", () => $d90d8ce15e0e3233$export$86509a1baabd62ee);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", () => $d90d8ce15e0e3233$export$98823ed9eedfc756);
$parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", () => $d90d8ce15e0e3233$export$da8d13fe1ccd5c09);
$parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", () => $d90d8ce15e0e3233$export$78fb2f6176b7c6b8);
$parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", () => $d90d8ce15e0e3233$export$26efaec7a7a8b361);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", () => $d90d8ce15e0e3233$export$88041353cc69458d);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", () => $d90d8ce15e0e3233$export$f88d57dcb03ba452);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", () => $d90d8ce15e0e3233$export$e8aa63af071c2da9);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", () => $d90d8ce15e0e3233$export$b114d0da2ebcff6c);
$parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", () => $d90d8ce15e0e3233$export$29cc94b8cea5c920);
$parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", () => $d90d8ce15e0e3233$export$4d1b45005cdcfb39);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", () => $d90d8ce15e0e3233$export$a42ea04fdf53eeaf);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", () => $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", () => $d90d8ce15e0e3233$export$d58a5411a2ac6260);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", () => $d90d8ce15e0e3233$export$24514ee19772b5af);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", () => $d90d8ce15e0e3233$export$ec333dd1d6a8b38);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", () => $d90d8ce15e0e3233$export$ed495fbad44791af);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", () => $d90d8ce15e0e3233$export$5281552f8109b7c0);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", () => $d90d8ce15e0e3233$export$6e8473713ed4557a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", () => $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", () => $d90d8ce15e0e3233$export$e7f012f402be01ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", () => $d90d8ce15e0e3233$export$b34d3882b42d660d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", () => $d90d8ce15e0e3233$export$ed869c60c6a56182);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", () => $d90d8ce15e0e3233$export$5013269f29c75b37);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", () => $d90d8ce15e0e3233$export$fc8b48319e993d43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", () => $d90d8ce15e0e3233$export$d6e60a2059f028d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", () => $d90d8ce15e0e3233$export$3d589aae17a00bc9);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", () => $d90d8ce15e0e3233$export$bd92ef03b23dd672);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", () => $d90d8ce15e0e3233$export$fa7fc44c718fc850);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", () => $d90d8ce15e0e3233$export$1dffaf831e01e2b4);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", () => $d90d8ce15e0e3233$export$5f8187412dd60f35);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", () => $d90d8ce15e0e3233$export$3d2c1c04d18f6c43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", () => $d90d8ce15e0e3233$export$cd22a5d8f560a1d8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", () => $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", () => $d90d8ce15e0e3233$export$ee073463b4144367);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", () => $d90d8ce15e0e3233$export$ea034943499772ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", () => $d90d8ce15e0e3233$export$19bc888bcf37d22d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", () => $d90d8ce15e0e3233$export$e0746183e11767fb);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", () => $d90d8ce15e0e3233$export$3e2d215ce157adc8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", () => $d90d8ce15e0e3233$export$8a8485bb05daf40b);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $d90d8ce15e0e3233$export$a2799b01de5bb62);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", () => $d90d8ce15e0e3233$export$2d4f89c4b1ee3640);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $d90d8ce15e0e3233$export$75609d3416c31f79);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", () => $d90d8ce15e0e3233$export$79793dc26e0b7b1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", () => $d90d8ce15e0e3233$export$2eda7466fbfdef43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $d90d8ce15e0e3233$export$417297669917ee1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$8c79f3309ac0737);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $d90d8ce15e0e3233$export$ef71a22e7befd35c);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", () => $d90d8ce15e0e3233$export$62ba1e294f5007c1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", () => $d90d8ce15e0e3233$export$a4315324546ecc89);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", () => $d90d8ce15e0e3233$export$a653cf6d478b3df1);
$parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", () => $d90d8ce15e0e3233$export$b0f268fe53a03e98);
$parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", () => $d90d8ce15e0e3233$export$f4160b48e4ab8f39);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", () => $d90d8ce15e0e3233$export$608f359cf8b08d2e);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", () => $d90d8ce15e0e3233$export$8bfbf790fe89f8d3);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", () => $d90d8ce15e0e3233$export$d7011d1ed949f970);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", () => $d90d8ce15e0e3233$export$bd2506db44585db6);
$parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", () => $d90d8ce15e0e3233$export$200fa5ad16f8c112);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", () => $d90d8ce15e0e3233$export$a296bb962bea95b5);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", () => $d90d8ce15e0e3233$export$b9960c143c0414eb);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", () => $d90d8ce15e0e3233$export$411171d2fcaefaea);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", () => $d90d8ce15e0e3233$export$ee104ed514f63003);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", () => $d90d8ce15e0e3233$export$9233f9ddcecd3062);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", () => $d90d8ce15e0e3233$export$b3240ec044a6c70f);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", () => $d90d8ce15e0e3233$export$2463c779e12367e3);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", () => $d90d8ce15e0e3233$export$dd3e5187eae2abe9);
$parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", () => $d90d8ce15e0e3233$export$38ca7e07048a5bfd);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", () => $d90d8ce15e0e3233$export$48749e87cc44a5a5);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", () => $d90d8ce15e0e3233$export$21c230ef79df9e9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", () => $d90d8ce15e0e3233$export$d2d813dd057a8352);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", () => $d90d8ce15e0e3233$export$54ed2374d14a7e88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", () => $d90d8ce15e0e3233$export$58368fe796f5ecb4);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", () => $d90d8ce15e0e3233$export$bbb4032f8f259109);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", () => $d90d8ce15e0e3233$export$5b17b30c2dd69cf2);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", () => $d90d8ce15e0e3233$export$d18d0b9a9e85e59c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", () => $d90d8ce15e0e3233$export$5126a481501fc518);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", () => $d90d8ce15e0e3233$export$40e720d8c26e6804);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", () => $d90d8ce15e0e3233$export$dc8ac1f7e9373a32);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", () => $d90d8ce15e0e3233$export$8ca3e3f0326ba27f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", () => $d90d8ce15e0e3233$export$c3d17be12795c864);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", () => $d90d8ce15e0e3233$export$9cd1c70eda5cae15);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", () => $d90d8ce15e0e3233$export$99f769b27f537a72);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", () => $d90d8ce15e0e3233$export$5c5fe79d3f9ec214);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", () => $d90d8ce15e0e3233$export$901b974cf0954c88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", () => $d90d8ce15e0e3233$export$b2dd23a345bd5cb3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", () => $d90d8ce15e0e3233$export$8ae7cbc0a73f9351);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", () => $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", () => $d90d8ce15e0e3233$export$a22387b9744e62e3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", () => $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", () => $d90d8ce15e0e3233$export$e6de4aa6c719d2b);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", () => $d90d8ce15e0e3233$export$b195ada84b7e695f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", () => $d90d8ce15e0e3233$export$1800d32171b754a6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", () => $d90d8ce15e0e3233$export$d22a153bfcbaaaa0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", () => $d90d8ce15e0e3233$export$a9a41c76994b6ae9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", () => $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", () => $d90d8ce15e0e3233$export$dc70eff53ff26c70);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", () => $d90d8ce15e0e3233$export$1fe2ca96b360df19);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", () => $d90d8ce15e0e3233$export$1ff01e77517a80b0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$de3f8f3198f8213a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", () => $d90d8ce15e0e3233$export$b2cb569d360db382);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", () => $d90d8ce15e0e3233$export$da985e953465731f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", () => $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", () => $d90d8ce15e0e3233$export$9b6c84986db47d98);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", () => $d90d8ce15e0e3233$export$89276f76fdd700d6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", () => $d90d8ce15e0e3233$export$ea64769f19da8c95);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", () => $d90d8ce15e0e3233$export$4a584839d9a9eb6f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", () => $d90d8ce15e0e3233$export$27d27c817eeb97cc);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", () => $d90d8ce15e0e3233$export$9f533c13cfb48a8f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", () => $d90d8ce15e0e3233$export$6889e571e5aa6ba6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", () => $d90d8ce15e0e3233$export$bdd811277711c53d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", () => $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", () => $d90d8ce15e0e3233$export$a348fc7f3b4cfe34);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", () => $d90d8ce15e0e3233$export$a4eff769c94da831);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", () => $d90d8ce15e0e3233$export$7c928ca9c9822772);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", () => $d90d8ce15e0e3233$export$b48311a8f24f4b63);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", () => $d90d8ce15e0e3233$export$20649eac204f7661);
$parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", () => $d90d8ce15e0e3233$export$62170875a111d729);
$parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", () => $d90d8ce15e0e3233$export$2928f3d69e7ac609);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", () => $d90d8ce15e0e3233$export$259e18cafd820487);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", () => $d90d8ce15e0e3233$export$4b8f333757e638a4);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", () => $d90d8ce15e0e3233$export$ac4f65a14002f892);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", () => $d90d8ce15e0e3233$export$c73ddc4b44ccb359);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", () => $d90d8ce15e0e3233$export$7ad826b482229119);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", () => $d90d8ce15e0e3233$export$3df864df9b639033);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", () => $d90d8ce15e0e3233$export$7d67bf4077ebe18d);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", () => $d90d8ce15e0e3233$export$5ff797dfd5df551f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", () => $d90d8ce15e0e3233$export$8a66ba1da5efa2c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", () => $d90d8ce15e0e3233$export$eadf5aff28def565);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", () => $d90d8ce15e0e3233$export$8f9c045e8fd449b7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", () => $d90d8ce15e0e3233$export$1bf439327974644b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", () => $d90d8ce15e0e3233$export$e2a9d163770d0d46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", () => $d90d8ce15e0e3233$export$21b497c57bcd299a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", () => $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", () => $d90d8ce15e0e3233$export$df5ca261227a6052);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", () => $d90d8ce15e0e3233$export$9f2f4303259b8508);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", () => $d90d8ce15e0e3233$export$7fd53fe07eecc273);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", () => $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", () => $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", () => $d90d8ce15e0e3233$export$f9759b206b651b1f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", () => $d90d8ce15e0e3233$export$7a337a2687b5d5e3);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", () => $d90d8ce15e0e3233$export$a41998c1a3572e41);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", () => $d90d8ce15e0e3233$export$2c9fe9e6005a9c36);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", () => $d90d8ce15e0e3233$export$5d8d82ff1de3586e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", () => $d90d8ce15e0e3233$export$8a0ed100d885c17c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", () => $d90d8ce15e0e3233$export$1c7041445acf79e8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", () => $d90d8ce15e0e3233$export$e4712523d95125f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$7401274ad357ff94);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$6984b21077857555);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", () => $d90d8ce15e0e3233$export$5a2dae98f768aedf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", () => $d90d8ce15e0e3233$export$5eef1c6eb1388ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", () => $d90d8ce15e0e3233$export$69bcf2c26d45e030);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", () => $d90d8ce15e0e3233$export$ba1417cf5de80f81);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", () => $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", () => $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", () => $d90d8ce15e0e3233$export$5c676bbb7e3aae9e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", () => $d90d8ce15e0e3233$export$8bb013ced097489a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", () => $d90d8ce15e0e3233$export$e384ae6a87fadedd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", () => $d90d8ce15e0e3233$export$8f55a911c4bd95bf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", () => $d90d8ce15e0e3233$export$d7b98892cb31fba5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", () => $d90d8ce15e0e3233$export$8be4b203f526b2cd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", () => $d90d8ce15e0e3233$export$df09947903c514c4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", () => $d90d8ce15e0e3233$export$cf4a57a81e0bfbca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", () => $d90d8ce15e0e3233$export$bc64365bbb09c05e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", () => $d90d8ce15e0e3233$export$5b12571311ebe766);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", () => $d90d8ce15e0e3233$export$56dc46fe1de63994);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", () => $d90d8ce15e0e3233$export$65af0e5a36d4b4e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", () => $d90d8ce15e0e3233$export$dec448f9d2e50c90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", () => $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$8aab6fb9a62dda95);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$9f804a2650117f51);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", () => $d90d8ce15e0e3233$export$7dd4b916600f670);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", () => $d90d8ce15e0e3233$export$c1b40a8a70c0aafa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", () => $d90d8ce15e0e3233$export$ff10d812380db045);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", () => $d90d8ce15e0e3233$export$8deeffdf8dfed878);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", () => $d90d8ce15e0e3233$export$561687f2fa9b9cc9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", () => $d90d8ce15e0e3233$export$691d30818c14141c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", () => $d90d8ce15e0e3233$export$8fa58495105f8fb0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", () => $d90d8ce15e0e3233$export$8304c57494d82ffd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", () => $d90d8ce15e0e3233$export$353609deec72a2ba);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", () => $d90d8ce15e0e3233$export$1cb56e4c132ac8fd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", () => $d90d8ce15e0e3233$export$5fe3eec0a6bda09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", () => $d90d8ce15e0e3233$export$12b56880d6fb7ac7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", () => $d90d8ce15e0e3233$export$9986e8be82998857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", () => $d90d8ce15e0e3233$export$3280ec16231916af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", () => $d90d8ce15e0e3233$export$54885d105d1e2b37);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", () => $d90d8ce15e0e3233$export$f34d87c870f3bf43);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$4108ebf71e36e461);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$d42ec33a6e69686e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", () => $d90d8ce15e0e3233$export$8d2cfabd01e2feaa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", () => $d90d8ce15e0e3233$export$d0fe3726dffeca80);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", () => $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", () => $d90d8ce15e0e3233$export$3743711165f5dd4f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", () => $d90d8ce15e0e3233$export$5df6f81deab9567c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", () => $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", () => $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", () => $d90d8ce15e0e3233$export$a03360d8b616ef34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$336e54edc189df7f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$53572e9a81205523);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", () => $d90d8ce15e0e3233$export$b71f2ef452117a2a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", () => $d90d8ce15e0e3233$export$f79745fee583cd62);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", () => $d90d8ce15e0e3233$export$2281663e19f399c1);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", () => $d90d8ce15e0e3233$export$38c52d8c5e5dad29);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", () => $d90d8ce15e0e3233$export$10babc3f11b4e6e2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", () => $d90d8ce15e0e3233$export$adf2f51c41b4e22a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", () => $d90d8ce15e0e3233$export$11b217754d4c7d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", () => $d90d8ce15e0e3233$export$3414f0d81f1c11d);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", () => $d90d8ce15e0e3233$export$5574c73a9a5878ca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", () => $d90d8ce15e0e3233$export$cb2626c385b72992);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", () => $d90d8ce15e0e3233$export$fa7aa7cabc3ec459);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", () => $d90d8ce15e0e3233$export$8b0450672651ef67);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", () => $d90d8ce15e0e3233$export$ef510a15f840e437);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", () => $d90d8ce15e0e3233$export$bc159fa4984a907f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", () => $d90d8ce15e0e3233$export$47bfbce13af95d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", () => $d90d8ce15e0e3233$export$c8cb78e94cd3f83c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", () => $d90d8ce15e0e3233$export$4496279df22177be);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", () => $d90d8ce15e0e3233$export$afdfef5d17c56988);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$ac9b4b1136300033);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", () => $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", () => $d90d8ce15e0e3233$export$c56f5509b93eba68);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", () => $d90d8ce15e0e3233$export$dd9462e97e11637a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", () => $d90d8ce15e0e3233$export$11f8c53e10f63cfb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$758ad3ad6916c9f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", () => $d90d8ce15e0e3233$export$9d65a754315eb617);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", () => $d90d8ce15e0e3233$export$564b665f6ca740dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", () => $d90d8ce15e0e3233$export$256fc89c38c1b9e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", () => $d90d8ce15e0e3233$export$ddeae77164bfac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", () => $d90d8ce15e0e3233$export$fa2b355372963545);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", () => $d90d8ce15e0e3233$export$45511e437e54fa02);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", () => $d90d8ce15e0e3233$export$ad76895f03f27a7c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", () => $d90d8ce15e0e3233$export$1c291d65a59b1636);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", () => $d90d8ce15e0e3233$export$d9bb14d665bfeea5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", () => $d90d8ce15e0e3233$export$8b44cb3da7b8f857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", () => $d90d8ce15e0e3233$export$9ca6a09e1518d3bb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", () => $d90d8ce15e0e3233$export$4c211b3188348679);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", () => $d90d8ce15e0e3233$export$24757bb1837e33af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", () => $d90d8ce15e0e3233$export$95b5d0bd29a3a076);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", () => $d90d8ce15e0e3233$export$d55d4330b58683da);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", () => $d90d8ce15e0e3233$export$f4d5833f0b40a26b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", () => $d90d8ce15e0e3233$export$c78577545f514ca8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", () => $d90d8ce15e0e3233$export$253eb3db7152d010);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", () => $d90d8ce15e0e3233$export$16b4392a63a3eacf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", () => $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", () => $d90d8ce15e0e3233$export$f870832f94ca5009);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", () => $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", () => $d90d8ce15e0e3233$export$15603150075c3d64);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", () => $d90d8ce15e0e3233$export$92536fe760c41862);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", () => $d90d8ce15e0e3233$export$3f4d05032349dae0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", () => $d90d8ce15e0e3233$export$8ff94a2e5f98315f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", () => $d90d8ce15e0e3233$export$c906c6946fef5d99);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", () => $d90d8ce15e0e3233$export$a1916b723e186494);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", () => $d90d8ce15e0e3233$export$5070b4c974017f28);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", () => $d90d8ce15e0e3233$export$bee7f9f93cb74124);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", () => $d90d8ce15e0e3233$export$efe4008073ab3b69);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", () => $d90d8ce15e0e3233$export$9e40228f1c62d4d9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", () => $d90d8ce15e0e3233$export$223f8094878fea34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", () => $d90d8ce15e0e3233$export$2f589c572415c043);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", () => $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", () => $d90d8ce15e0e3233$export$a11311cd333dae90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", () => $d90d8ce15e0e3233$export$2b2f159267202dcc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", () => $d90d8ce15e0e3233$export$c5a6874288d2e609);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", () => $d90d8ce15e0e3233$export$55dd30b027c838fe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", () => $d90d8ce15e0e3233$export$aee9c7dbf672403c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", () => $d90d8ce15e0e3233$export$75f2fbd33e76028e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", () => $d90d8ce15e0e3233$export$ca57c3dfefb2c826);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", () => $d90d8ce15e0e3233$export$8f2e6f133c022a59);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", () => $d90d8ce15e0e3233$export$bcd741cf5a35ece8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", () => $d90d8ce15e0e3233$export$bfd8ab4625d5c275);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", () => $d90d8ce15e0e3233$export$750a33c4058af733);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", () => $d90d8ce15e0e3233$export$1b66c7594340363f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", () => $d90d8ce15e0e3233$export$fe2fa966509db649);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", () => $d90d8ce15e0e3233$export$373b97e8d136f558);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", () => $d90d8ce15e0e3233$export$64909bb6f2181592);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", () => $d90d8ce15e0e3233$export$53d6ade2eaa2ae84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", () => $d90d8ce15e0e3233$export$e49d7a1ddf301d09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", () => $d90d8ce15e0e3233$export$9469cfde1d14fcac);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", () => $d90d8ce15e0e3233$export$be2e231547dca6dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", () => $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", () => $d90d8ce15e0e3233$export$2fb73d5c1c0e7186);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", () => $d90d8ce15e0e3233$export$46b4f43d6ece38fc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", () => $d90d8ce15e0e3233$export$49d1c20d84d46735);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", () => $d90d8ce15e0e3233$export$265062715b11a1ef);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", () => $d90d8ce15e0e3233$export$e9f5eae9444c9b46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", () => $d90d8ce15e0e3233$export$e19bf9459d6eba56);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", () => $d90d8ce15e0e3233$export$40097704c31872d8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", () => $d90d8ce15e0e3233$export$dcdf0405aa7e2078);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", () => $d90d8ce15e0e3233$export$fb75113636566d39);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", () => $d90d8ce15e0e3233$export$e27baa0c7747e67f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", () => $d90d8ce15e0e3233$export$40d189100899f572);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", () => $d90d8ce15e0e3233$export$341933b279728599);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$ae4b815061537207);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", () => $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", () => $d90d8ce15e0e3233$export$bee46016693b19dc);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", () => $d90d8ce15e0e3233$export$c39a25878c902e0a);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", () => $d90d8ce15e0e3233$export$6eaa6ce8101f6468);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", () => $d90d8ce15e0e3233$export$2e90ab5aa3463c0d);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", () => $d90d8ce15e0e3233$export$d70320ae3b4d9e43);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", () => $d90d8ce15e0e3233$export$b2b57cde1fa39bf5);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE", () => $d90d8ce15e0e3233$export$e8e3b3a04b70a016);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", () => $d90d8ce15e0e3233$export$1a3116351e4f3550);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", () => $d90d8ce15e0e3233$export$6e2629d41c380b47);
$parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", () => $d90d8ce15e0e3233$export$ced38e55e6d33a4e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", () => $d90d8ce15e0e3233$export$d61d16755cb40ff3);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", () => $d90d8ce15e0e3233$export$bb6392f1b2e80781);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", () => $d90d8ce15e0e3233$export$6fd25e722e91a0d8);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", () => $d90d8ce15e0e3233$export$18f32f825e7a5a6f);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", () => $d90d8ce15e0e3233$export$b17f22f274f4cd5e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", () => $d90d8ce15e0e3233$export$285854ec33f7cc);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", () => $d90d8ce15e0e3233$export$77cf9c44bbdaa05b);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", () => $d90d8ce15e0e3233$export$d6f1b92110a16f2a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", () => $d90d8ce15e0e3233$export$fea47b97c6086336);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", () => $d90d8ce15e0e3233$export$264d0a2b60d052cd);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", () => $d90d8ce15e0e3233$export$991ba0c465b48539);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", () => $d90d8ce15e0e3233$export$904b472d57dee40d);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", () => $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", () => $d90d8ce15e0e3233$export$8cfdaccf43a32440);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", () => $d90d8ce15e0e3233$export$37bd400c00057d64);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", () => $d90d8ce15e0e3233$export$eb66bd587b5f093d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", () => $d90d8ce15e0e3233$export$521baa72494c2a67);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", () => $d90d8ce15e0e3233$export$ca255c93be51d5bc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", () => $d90d8ce15e0e3233$export$51e45f736a60769b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", () => $d90d8ce15e0e3233$export$e64c3c8f45d7eb28);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", () => $d90d8ce15e0e3233$export$5475ba822739444a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", () => $d90d8ce15e0e3233$export$8483f5c57513e386);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", () => $d90d8ce15e0e3233$export$93c4d1960660bdb3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", () => $d90d8ce15e0e3233$export$a5421dcc88027406);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", () => $d90d8ce15e0e3233$export$81d5ef2e5cb06446);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", () => $d90d8ce15e0e3233$export$77f5621cd10b53c5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", () => $d90d8ce15e0e3233$export$41008c2b014795bf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", () => $d90d8ce15e0e3233$export$3001841111579cf2);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", () => $d90d8ce15e0e3233$export$28dc2fac9c08502e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", () => $d90d8ce15e0e3233$export$4487dfcd6dce7088);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", () => $d90d8ce15e0e3233$export$c344587fa7092e8c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", () => $d90d8ce15e0e3233$export$3fbd487079a23c0f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", () => $d90d8ce15e0e3233$export$d6822df31c37b21a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", () => $d90d8ce15e0e3233$export$d39bcac6fced7707);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", () => $d90d8ce15e0e3233$export$da975f212e8a3e43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", () => $d90d8ce15e0e3233$export$6e6feddeb62a0825);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", () => $d90d8ce15e0e3233$export$d7df906c2ffbeab4);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", () => $d90d8ce15e0e3233$export$c71836085985a7d3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", () => $d90d8ce15e0e3233$export$a17a19a9de903839);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", () => $d90d8ce15e0e3233$export$e66c1e847a52ebb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", () => $d90d8ce15e0e3233$export$f0254c80025ed0fc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", () => $d90d8ce15e0e3233$export$1d4a64220d5b474d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", () => $d90d8ce15e0e3233$export$8af215d394bc18c1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", () => $d90d8ce15e0e3233$export$b6b536a795b08b39);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", () => $d90d8ce15e0e3233$export$59cde094247fca1a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", () => $d90d8ce15e0e3233$export$d27bf19e22921164);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", () => $d90d8ce15e0e3233$export$3467807847c0a87d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $d90d8ce15e0e3233$export$1996eeee6a067f1c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", () => $d90d8ce15e0e3233$export$ec7cb9394e8994c9);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", () => $d90d8ce15e0e3233$export$f01730982626c4af);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", () => $d90d8ce15e0e3233$export$9d1758ddc1563e90);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", () => $d90d8ce15e0e3233$export$ecff223feb9d08be);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", () => $d90d8ce15e0e3233$export$487bc26cddb34312);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $d90d8ce15e0e3233$export$118290072826cd87);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", () => $d90d8ce15e0e3233$export$e5994b7b1acebe82);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", () => $d90d8ce15e0e3233$export$84b0e53f785e02cf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", () => $d90d8ce15e0e3233$export$d58992a667105ce8);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", () => $d90d8ce15e0e3233$export$bb1cea2d23743f65);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$76dac5f55ab3705e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", () => $d90d8ce15e0e3233$export$a7c4adb03bc6e997);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", () => $d90d8ce15e0e3233$export$2dc565d0b2334780);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", () => $d90d8ce15e0e3233$export$28687a1181a7676f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", () => $d90d8ce15e0e3233$export$2e74a7026073fa54);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", () => $d90d8ce15e0e3233$export$58fdfc78d176c564);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", () => $d90d8ce15e0e3233$export$cb8548f16119b181);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", () => $d90d8ce15e0e3233$export$66e3f6af203a567f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", () => $d90d8ce15e0e3233$export$658e7e21f1c7b69b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", () => $d90d8ce15e0e3233$export$1fa628a4527d424c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", () => $d90d8ce15e0e3233$export$c2989c5c00f9f64b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", () => $d90d8ce15e0e3233$export$2d21e5416485b195);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", () => $d90d8ce15e0e3233$export$e514491aa85dd54a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", () => $d90d8ce15e0e3233$export$d9662297242bfcb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", () => $d90d8ce15e0e3233$export$2a53516b15393945);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", () => $d90d8ce15e0e3233$export$62e00190aa938a43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", () => $d90d8ce15e0e3233$export$22a3924a6eab79ab);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", () => $d90d8ce15e0e3233$export$677cf3d89d18bb74);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", () => $d90d8ce15e0e3233$export$7eef86163449ad98);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", () => $d90d8ce15e0e3233$export$8f56061e1403fa5a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", () => $d90d8ce15e0e3233$export$adeb429de8df1e02);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", () => $d90d8ce15e0e3233$export$931d6222073b5708);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", () => $d90d8ce15e0e3233$export$2106f1ac8ba807e1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", () => $d90d8ce15e0e3233$export$36678521a86f620b);
$parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", () => $d90d8ce15e0e3233$export$55248356780fc584);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", () => $d90d8ce15e0e3233$export$cd84c5a333c8d16a);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", () => $d90d8ce15e0e3233$export$624af6f61b05f55);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", () => $d90d8ce15e0e3233$export$2ed9525182145b82);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", () => $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", () => $d90d8ce15e0e3233$export$fa962db82ae571b2);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", () => $d90d8ce15e0e3233$export$e145bf76b1aef705);
$parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", () => $d90d8ce15e0e3233$export$8febbfb647e4c8b9);
$parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", () => $d90d8ce15e0e3233$export$4b34f3d336f4ccd2);
$parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", () => $d90d8ce15e0e3233$export$a979a5c1f5e3631c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", () => $d90d8ce15e0e3233$export$ffcbf91dfadffd0);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", () => $d90d8ce15e0e3233$export$1807a39cc63b856c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$2be8d3c6fedd5276);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$6268da7263eb670d);
$parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", () => $d90d8ce15e0e3233$export$93bd4a896a0fc581);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", () => $d90d8ce15e0e3233$export$2b9b1bfb538ab810);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", () => $d90d8ce15e0e3233$export$d1217085321b2648);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", () => $d90d8ce15e0e3233$export$39624171b7c8a10a);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", () => $d90d8ce15e0e3233$export$1654cd6813e90e6b);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", () => $d90d8ce15e0e3233$export$33059cd02df2febd);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", () => $d90d8ce15e0e3233$export$1d746ff2bc48ceb4);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", () => $d90d8ce15e0e3233$export$145c578104a45fd2);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", () => $d90d8ce15e0e3233$export$a51df1bc877c58e5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", () => $d90d8ce15e0e3233$export$45208fff8de46880);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", () => $d90d8ce15e0e3233$export$c710a35d40378fa5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", () => $d90d8ce15e0e3233$export$15d6b93ff5273ce3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", () => $d90d8ce15e0e3233$export$e26f2863c7ccd504);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", () => $d90d8ce15e0e3233$export$496da9aa0fe819ff);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", () => $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", () => $d90d8ce15e0e3233$export$53ce69fb34f6d286);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", () => $d90d8ce15e0e3233$export$b6e861786143eb1b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", () => $d90d8ce15e0e3233$export$f7e3d3b413c017e1);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", () => $d90d8ce15e0e3233$export$b84d34b8175abde5);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", () => $d90d8ce15e0e3233$export$50e4e3e5231fb74f);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", () => $d90d8ce15e0e3233$export$39d913ae557ba8f3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", () => $d90d8ce15e0e3233$export$a2d9bcceac584c93);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", () => $d90d8ce15e0e3233$export$eb2e5f1608ec8b32);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", () => $d90d8ce15e0e3233$export$9ac90b948c53bf58);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", () => $d90d8ce15e0e3233$export$bb5665894498893f);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", () => $d90d8ce15e0e3233$export$fc61479fdfdd263a);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", () => $d90d8ce15e0e3233$export$5ae82b891e42770e);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", () => $d90d8ce15e0e3233$export$8dcc46e162f2235b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", () => $d90d8ce15e0e3233$export$a934caa57ac0ac0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", () => $d90d8ce15e0e3233$export$25a4e6c77f91c259);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", () => $d90d8ce15e0e3233$export$2a9a9bab313fd713);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", () => $d90d8ce15e0e3233$export$82ad2da638fc34d8);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", () => $d90d8ce15e0e3233$export$ff67cffdbd881a41);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", () => $d90d8ce15e0e3233$export$c41c7d73df3fc08c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", () => $d90d8ce15e0e3233$export$65f234e4799edddc);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", () => $d90d8ce15e0e3233$export$215ea4e7405fa88c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", () => $d90d8ce15e0e3233$export$927b1972180d9cc4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", () => $d90d8ce15e0e3233$export$ff1365ce4d652337);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", () => $d90d8ce15e0e3233$export$79b30013cbfdee04);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", () => $d90d8ce15e0e3233$export$33c2dcc7c7abc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", () => $d90d8ce15e0e3233$export$a6ef20aa08a533b1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", () => $d90d8ce15e0e3233$export$5908e15483da8a45);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", () => $d90d8ce15e0e3233$export$a3812f6f4e60d897);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", () => $d90d8ce15e0e3233$export$3c8c119f40a061a9);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", () => $d90d8ce15e0e3233$export$47e034646abefdb2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", () => $d90d8ce15e0e3233$export$f36f4cf8b17f250f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", () => $d90d8ce15e0e3233$export$841e880a0d425b3e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", () => $d90d8ce15e0e3233$export$1fde4a6e7df24a97);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", () => $d90d8ce15e0e3233$export$69335bf8b709edc7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", () => $d90d8ce15e0e3233$export$946b472f7559a889);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", () => $d90d8ce15e0e3233$export$373fdf6888021ed0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", () => $d90d8ce15e0e3233$export$d6a5f13a3d30923c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", () => $d90d8ce15e0e3233$export$adfff93b0b015409);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", () => $d90d8ce15e0e3233$export$404de4ddea701cff);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", () => $d90d8ce15e0e3233$export$596e1f6f6f4997b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", () => $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", () => $d90d8ce15e0e3233$export$d610a17dff3a01fa);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", () => $d90d8ce15e0e3233$export$284db5107f3db516);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", () => $d90d8ce15e0e3233$export$fbce46826eefc586);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", () => $d90d8ce15e0e3233$export$c86b29c76317ac6f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", () => $d90d8ce15e0e3233$export$3160b86e1b5dc391);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", () => $d90d8ce15e0e3233$export$690c0080c930fca);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", () => $d90d8ce15e0e3233$export$171ba8c33c05c4ef);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$e2f2c23286c3255c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", () => $d90d8ce15e0e3233$export$5a262d40e10207a1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", () => $d90d8ce15e0e3233$export$ab790cb87175797e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", () => $d90d8ce15e0e3233$export$db780b39656c673a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", () => $d90d8ce15e0e3233$export$a77cb4dafc511d3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", () => $d90d8ce15e0e3233$export$253fd82874264ee4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", () => $d90d8ce15e0e3233$export$eaf9ab4ec0c25813);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", () => $d90d8ce15e0e3233$export$574bcdf6b73fcf1f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", () => $d90d8ce15e0e3233$export$a14853dfff8da872);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", () => $d90d8ce15e0e3233$export$1c74da1e52e6d212);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", () => $d90d8ce15e0e3233$export$d416059b17fe7d4e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", () => $d90d8ce15e0e3233$export$d5a3a037d2760bb7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", () => $d90d8ce15e0e3233$export$eb187d42a7448d45);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", () => $d90d8ce15e0e3233$export$688de32d31fc70f5);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", () => $d90d8ce15e0e3233$export$13d770f8814d480a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", () => $d90d8ce15e0e3233$export$3a628f9376166ffb);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", () => $d90d8ce15e0e3233$export$649dafa225625f30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$dbfe76dd37018b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", () => $d90d8ce15e0e3233$export$20db7bb9d1bd8b38);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", () => $d90d8ce15e0e3233$export$a1fa8e6e125780ae);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", () => $d90d8ce15e0e3233$export$fc6b949fd2bc782d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", () => $d90d8ce15e0e3233$export$c940f866ac7760a0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", () => $d90d8ce15e0e3233$export$184d4979f6f9fe7e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", () => $d90d8ce15e0e3233$export$959f50de166cc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", () => $d90d8ce15e0e3233$export$b13b8c8bb4e30a75);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", () => $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", () => $d90d8ce15e0e3233$export$cc1af211e3feda50);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", () => $d90d8ce15e0e3233$export$3873539001f5aed7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", () => $d90d8ce15e0e3233$export$89fcbafce559080b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", () => $d90d8ce15e0e3233$export$c3f05da9e4e13249);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", () => $d90d8ce15e0e3233$export$619694ab37142384);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", () => $d90d8ce15e0e3233$export$cb89b516b9cf418b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", () => $d90d8ce15e0e3233$export$50680f54e95bb859);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", () => $d90d8ce15e0e3233$export$194c2b4da7e38757);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", () => $d90d8ce15e0e3233$export$962d838817f090f8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", () => $d90d8ce15e0e3233$export$eacbdb340a470309);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", () => $d90d8ce15e0e3233$export$6a7782d87a21425d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", () => $d90d8ce15e0e3233$export$c2f56336162e799e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", () => $d90d8ce15e0e3233$export$ba419378ad70624e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $d90d8ce15e0e3233$export$62f38c589a73d386);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", () => $d90d8ce15e0e3233$export$77c8066c0822f152);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", () => $d90d8ce15e0e3233$export$90900ebfa6f48861);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", () => $d90d8ce15e0e3233$export$93ff02c205edd1a8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $d90d8ce15e0e3233$export$db7f5d93be70ee30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $d90d8ce15e0e3233$export$432229516b7f82da);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", () => $d90d8ce15e0e3233$export$8f554d4ef9f084c0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", () => $d90d8ce15e0e3233$export$6b2b99b0055772a3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", () => $d90d8ce15e0e3233$export$83c7a51057be6264);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", () => $d90d8ce15e0e3233$export$46706d786aab3829);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", () => $d90d8ce15e0e3233$export$b690025ef7e3cf6c);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", () => $d90d8ce15e0e3233$export$ea48cc6bf1183d11);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", () => $d90d8ce15e0e3233$export$930e4881302bbd54);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", () => $d90d8ce15e0e3233$export$375801b708576466);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", () => $d90d8ce15e0e3233$export$5b1e8463bd590143);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", () => $d90d8ce15e0e3233$export$1606662a398a24be);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", () => $d90d8ce15e0e3233$export$c5b19a37e49ceb28);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", () => $d90d8ce15e0e3233$export$c46680afe70295f3);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", () => $d90d8ce15e0e3233$export$831fc7eba98b58c9);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", () => $d90d8ce15e0e3233$export$4061c0c586f3b7c8);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", () => $d90d8ce15e0e3233$export$99e0abd8ba1de289);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", () => $d90d8ce15e0e3233$export$cd96a6a0cc4831ab);
$parcel$export(module.exports, "ROUTE_NAMES_ROVO_DEMAND_TESTS", () => $d90d8ce15e0e3233$export$36e61e70347174cc);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", () => $d90d8ce15e0e3233$export$db1b3d2fee80859);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", () => $d90d8ce15e0e3233$export$b0f3f3214ab1b150);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", () => $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", () => $d90d8ce15e0e3233$export$8c8f03e75b6708ac);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP", () => $d90d8ce15e0e3233$export$2e93790099768be5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", () => $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", () => $d90d8ce15e0e3233$export$f9cc808094ce0ddd);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", () => $d90d8ce15e0e3233$export$9bde4a0b155f2972);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", () => $d90d8ce15e0e3233$export$a52f5ffbbe135078);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", () => $d90d8ce15e0e3233$export$e6773bf0fbccdb9c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", () => $d90d8ce15e0e3233$export$8e3dd8487a7b65bd);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", () => $d90d8ce15e0e3233$export$258b44fcc29a5961);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", () => $d90d8ce15e0e3233$export$ea1146ebce07be6d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", () => $d90d8ce15e0e3233$export$53731240ce2d3b76);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", () => $d90d8ce15e0e3233$export$956eb40834ddee22);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", () => $d90d8ce15e0e3233$export$9057470ebf41169);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", () => $d90d8ce15e0e3233$export$c42e107c5275b36);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", () => $d90d8ce15e0e3233$export$3e7c6a54a9d2267a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", () => $d90d8ce15e0e3233$export$c3e2697b35a149c4);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", () => $d90d8ce15e0e3233$export$288c7dd61dd0c291);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", () => $d90d8ce15e0e3233$export$37161a981d69c891);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", () => $d90d8ce15e0e3233$export$cfe61aa92a4d585d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", () => $d90d8ce15e0e3233$export$9ed512ab4c81669c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", () => $d90d8ce15e0e3233$export$37a9bdd8513f462d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", () => $d90d8ce15e0e3233$export$f01162415f3a2ee3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", () => $d90d8ce15e0e3233$export$860dd13b1e836ed8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", () => $d90d8ce15e0e3233$export$5eaf1dce55090ff3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", () => $d90d8ce15e0e3233$export$1fe309e7cdbd1c1);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", () => $d90d8ce15e0e3233$export$fcd9750494ff0236);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", () => $d90d8ce15e0e3233$export$ad856b38e93b93b2);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", () => $d90d8ce15e0e3233$export$a833209ca71d2e56);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", () => $d90d8ce15e0e3233$export$829d1776460a6ad3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", () => $d90d8ce15e0e3233$export$d30ab2da08d8b7b9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", () => $d90d8ce15e0e3233$export$3c71889849aeaa08);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", () => $d90d8ce15e0e3233$export$354bf2df81f6ffb0);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", () => $d90d8ce15e0e3233$export$f8880b461acd270d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", () => $d90d8ce15e0e3233$export$876055c0ede2f8df);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", () => $d90d8ce15e0e3233$export$bf493c66e34711c8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", () => $d90d8ce15e0e3233$export$212f6e2c7c2a53bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", () => $d90d8ce15e0e3233$export$7c28c6e8d8a6545);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", () => $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", () => $d90d8ce15e0e3233$export$f7fbe9a4717b7a50);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", () => $d90d8ce15e0e3233$export$8c800f176d079d28);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", () => $d90d8ce15e0e3233$export$1c5fbcbfc0923176);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", () => $d90d8ce15e0e3233$export$59644e5d8d69a016);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", () => $d90d8ce15e0e3233$export$c7074ebe0ca83f98);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", () => $d90d8ce15e0e3233$export$2b4737953287a354);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", () => $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", () => $d90d8ce15e0e3233$export$5dcba309e2bfa88b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", () => $d90d8ce15e0e3233$export$2d961b0101f8733e);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", () => $d90d8ce15e0e3233$export$195fe2558f1a8591);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", () => $d90d8ce15e0e3233$export$1b3cf68be370a45b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", () => $d90d8ce15e0e3233$export$45c35381e5da2232);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", () => $d90d8ce15e0e3233$export$d479ba53b9bf65a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", () => $d90d8ce15e0e3233$export$ccd12890649c59cc);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", () => $d90d8ce15e0e3233$export$8c84064031188e80);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", () => $d90d8ce15e0e3233$export$46c6fef035fbe8ba);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", () => $d90d8ce15e0e3233$export$6fb23ec5a12d5c24);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", () => $d90d8ce15e0e3233$export$156b2dfbd87d576f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", () => $d90d8ce15e0e3233$export$6961f1ed0407cb26);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", () => $d90d8ce15e0e3233$export$ba284efd679bf637);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", () => $d90d8ce15e0e3233$export$e48a3df597407767);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", () => $d90d8ce15e0e3233$export$c73718d4a6efea1d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", () => $d90d8ce15e0e3233$export$ed454783ba1bacb9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", () => $d90d8ce15e0e3233$export$48f6285d4729ca9d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", () => $d90d8ce15e0e3233$export$8066418cead2d2ef);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", () => $d90d8ce15e0e3233$export$b3db7857ac710a89);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", () => $d90d8ce15e0e3233$export$d574810e3edad044);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", () => $d90d8ce15e0e3233$export$be4b2ffade787316);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", () => $d90d8ce15e0e3233$export$3caf79b5f4be02d7);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", () => $d90d8ce15e0e3233$export$29bc361328055683);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", () => $d90d8ce15e0e3233$export$a4a5a333fe874d97);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", () => $d90d8ce15e0e3233$export$2193b681ac1ae132);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", () => $d90d8ce15e0e3233$export$f1bfd5b3918619a9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", () => $d90d8ce15e0e3233$export$a4c4f7898d6b914a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", () => $d90d8ce15e0e3233$export$6cffae90b9277bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", () => $d90d8ce15e0e3233$export$17e76ebd53424ed5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", () => $d90d8ce15e0e3233$export$b1329dc26a81a277);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", () => $d90d8ce15e0e3233$export$e1cba0bfe330f5c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", () => $d90d8ce15e0e3233$export$8e68c55c334de101);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", () => $d90d8ce15e0e3233$export$5cb7cfba189a0240);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", () => $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", () => $d90d8ce15e0e3233$export$1cf56e2d6c4edb35);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", () => $d90d8ce15e0e3233$export$27c1770584d7e3fe);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", () => $d90d8ce15e0e3233$export$22e0ebdea08537f7);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", () => $d90d8ce15e0e3233$export$4db732436e4edfaf);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", () => $d90d8ce15e0e3233$export$e832418dbed0717e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", () => $d90d8ce15e0e3233$export$ee09be798f0e4471);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", () => $d90d8ce15e0e3233$export$653bf90ae3578f21);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", () => $d90d8ce15e0e3233$export$9da4125a0c62444d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", () => $d90d8ce15e0e3233$export$fbcc0fd9b402bb12);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", () => $d90d8ce15e0e3233$export$e74fe5bd41e23fbd);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", () => $d90d8ce15e0e3233$export$1a93e63ddbe4aa06);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", () => $d90d8ce15e0e3233$export$3b6dbbe49882589d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", () => $d90d8ce15e0e3233$export$eb01394789016fd4);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", () => $d90d8ce15e0e3233$export$f17f4523583fa8e5);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", () => $d90d8ce15e0e3233$export$eaa4d6eec75a6778);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", () => $d90d8ce15e0e3233$export$dcc96e4abbdc0d39);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", () => $d90d8ce15e0e3233$export$9eaf39ba5a56c72a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", () => $d90d8ce15e0e3233$export$495be3320b67814a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", () => $d90d8ce15e0e3233$export$25752eb5bb5e3d32);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", () => $d90d8ce15e0e3233$export$f116716aedb35e10);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", () => $d90d8ce15e0e3233$export$36fffb6b49d9f31d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", () => $d90d8ce15e0e3233$export$a6d07be4ff318f84);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", () => $d90d8ce15e0e3233$export$a9a43f1114df1ad9);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", () => $d90d8ce15e0e3233$export$3a4c7a521a900b4d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", () => $d90d8ce15e0e3233$export$9dcf51a9040a4fd6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", () => $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", () => $d90d8ce15e0e3233$export$f8cb86acf6b74661);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", () => $d90d8ce15e0e3233$export$2d3d850c64058bfb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", () => $d90d8ce15e0e3233$export$af6b51164f66908b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", () => $d90d8ce15e0e3233$export$12efc96fc9c9fb34);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", () => $d90d8ce15e0e3233$export$6ab1901e04e623ba);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", () => $d90d8ce15e0e3233$export$bccc7d0812737c4e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", () => $d90d8ce15e0e3233$export$458fb992f2637a20);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", () => $d90d8ce15e0e3233$export$c9c9c64f68ba51e3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", () => $d90d8ce15e0e3233$export$50264cbc90a39f19);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", () => $d90d8ce15e0e3233$export$b9d0cbe0888fa72e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", () => $d90d8ce15e0e3233$export$b8045610416fa8ca);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", () => $d90d8ce15e0e3233$export$8e80136ad13099e3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", () => $d90d8ce15e0e3233$export$b5fe44c0bc324494);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", () => $d90d8ce15e0e3233$export$7a4f52d9060a20d2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", () => $d90d8ce15e0e3233$export$d6a9e4695952522e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", () => $d90d8ce15e0e3233$export$deab88d0814c564b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", () => $d90d8ce15e0e3233$export$906faff110f898ef);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", () => $d90d8ce15e0e3233$export$ab3f2a34a3b0db87);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", () => $d90d8ce15e0e3233$export$4ed84a2011fdc400);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", () => $d90d8ce15e0e3233$export$f7b286b39bf6051b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", () => $d90d8ce15e0e3233$export$6c4337c0332c8c7f);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", () => $d90d8ce15e0e3233$export$e7c78887745b2326);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", () => $d90d8ce15e0e3233$export$3805e4f07dca7584);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", () => $d90d8ce15e0e3233$export$f77254983320e888);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", () => $d90d8ce15e0e3233$export$2e784832f1c6bb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", () => $d90d8ce15e0e3233$export$7f97fa79520a4c5b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", () => $d90d8ce15e0e3233$export$9e53cdb1ac02195c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", () => $d90d8ce15e0e3233$export$58bd507904dc221c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", () => $d90d8ce15e0e3233$export$7a821e22be2c2f14);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", () => $d90d8ce15e0e3233$export$ca8966ef80bfafc6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", () => $d90d8ce15e0e3233$export$e7423156dba31a7c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", () => $d90d8ce15e0e3233$export$cba7e383b2409c7b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", () => $d90d8ce15e0e3233$export$d5378fb71d5242c0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", () => $d90d8ce15e0e3233$export$4b16b72c72da8833);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", () => $d90d8ce15e0e3233$export$10114d78cefb1f53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", () => $d90d8ce15e0e3233$export$92fe23ed30100817);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", () => $d90d8ce15e0e3233$export$e824495554c83069);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", () => $d90d8ce15e0e3233$export$8df2e9efdd625a44);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", () => $d90d8ce15e0e3233$export$aeb4d3006e298033);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", () => $d90d8ce15e0e3233$export$e15d3c40985c4b53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", () => $d90d8ce15e0e3233$export$1d8c84454fd2d571);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", () => $d90d8ce15e0e3233$export$db61a12efb59745c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", () => $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", () => $d90d8ce15e0e3233$export$182e0167fd960de6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", () => $d90d8ce15e0e3233$export$2d9e2484ee02e7da);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", () => $d90d8ce15e0e3233$export$b7fff19fd89b617f);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", () => $d90d8ce15e0e3233$export$ea23f150f64e8a4e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", () => $d90d8ce15e0e3233$export$116338bd93f78ad0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", () => $d90d8ce15e0e3233$export$c9cd65a78227cf18);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PRESENTATION_TOOLKIT_REPORT", () => $d90d8ce15e0e3233$export$7a4b4b66d7637fbb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", () => $d90d8ce15e0e3233$export$d75d93e5d44182cc);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", () => $d90d8ce15e0e3233$export$cc3027ae3767801);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", () => $d90d8ce15e0e3233$export$3492ce83b8884e0e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", () => $d90d8ce15e0e3233$export$b4798b7e62733393);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", () => $d90d8ce15e0e3233$export$388685c701d6e0d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", () => $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", () => $d90d8ce15e0e3233$export$fa83895c1eac55e7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", () => $d90d8ce15e0e3233$export$5c82bb95a06a1846);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", () => $d90d8ce15e0e3233$export$c725b9c7e11dd69e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", () => $d90d8ce15e0e3233$export$90594f89c675ba05);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", () => $d90d8ce15e0e3233$export$ae0d999dd2bdd59b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", () => $d90d8ce15e0e3233$export$43bbf6935a91d277);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", () => $d90d8ce15e0e3233$export$92e23977438282b2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", () => $d90d8ce15e0e3233$export$296115eb5b7129d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", () => $d90d8ce15e0e3233$export$17574f41c3925d64);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", () => $d90d8ce15e0e3233$export$955692fbfe35fc16);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", () => $d90d8ce15e0e3233$export$30af3a767b8ad2d8);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", () => $d90d8ce15e0e3233$export$f47d664298c2c2f0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", () => $d90d8ce15e0e3233$export$1714b5ad9b672bc7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", () => $d90d8ce15e0e3233$export$c9634bf15518a3a1);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", () => $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", () => $d90d8ce15e0e3233$export$c29d90ae9a4b648e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", () => $d90d8ce15e0e3233$export$8f2717a951373c25);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", () => $d90d8ce15e0e3233$export$831acb5098f5706d);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", () => $d90d8ce15e0e3233$export$d218cda46c433fe1);
$parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", () => $d90d8ce15e0e3233$export$61147168ac2833f9);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", () => $d90d8ce15e0e3233$export$9fe0117c0fd486a8);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", () => $d90d8ce15e0e3233$export$a49474778d15635d);
$parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", () => $d90d8ce15e0e3233$export$af3296e54e7fb362);
$parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", () => $d90d8ce15e0e3233$export$281f2e01ee9e4977);
/**
 * SPA ROUTES
 *
 * This should contain only 3 things:
 *
 *  1. ROUTE_GROUPS - strings that represent the FULL route-group name (not a substring of the actual route-group name).
 *  2. ROUTE_NAMES - strings that represent the FULL route name (not a substring of the actual route name).
 *  3. The types for 1 & 2.
 *
 * This file is used in the following unit tests:
 *  - jira/src/packages/navigation-apps/sidebar-nav4/context/src/common/utils/selected-path/routeToSelectedPath.test.tsx
 *
 * Therefore, any changes to this file is highly-likely to break the unit test(s).
 * If that happens, DON'T PANIC.
 * There will usually be a simple solution to fix the test(s).
 * The failing test-suite will have suggestions on how to fix the breaking-test(s).
 */ const $d90d8ce15e0e3233$export$1ba937db1fe6ef01 = 'archive-issues';
const $d90d8ce15e0e3233$export$3fd002e197e83a30 = 'arj-settings';
const $d90d8ce15e0e3233$export$bbf08d4d25df5504 = 'classic-business';
const $d90d8ce15e0e3233$export$e3e759b7f50aaee1 = 'classic-software';
const $d90d8ce15e0e3233$export$89337611b52bc9a3 = 'components';
const $d90d8ce15e0e3233$export$3d7937b12eb9e5d5 = 'connect';
const $d90d8ce15e0e3233$export$7a3d181d86fce9e6 = 'dashboard';
const $d90d8ce15e0e3233$export$294c878a3842c859 = 'dashboards';
const $d90d8ce15e0e3233$export$7a22726acd7d6021 = 'devops';
const $d90d8ce15e0e3233$export$f3f4a9f53ba00861 = 'directories';
const $d90d8ce15e0e3233$export$112d69653b2f1d8b = 'eoc';
const $d90d8ce15e0e3233$export$74e0426b66571086 = 'errors';
const $d90d8ce15e0e3233$export$c2e20e142c95c1ce = 'global-settings';
const $d90d8ce15e0e3233$export$f8cea29bebf098c = 'helpcenter-settings';
const $d90d8ce15e0e3233$export$5801ef8dfc9a2f70 = 'home';
const $d90d8ce15e0e3233$export$7246838143f848f3 = 'issue';
const $d90d8ce15e0e3233$export$54f96702980a2f87 = 'issue-navigator';
const $d90d8ce15e0e3233$export$5566db8fbd042fc4 = 'legacy';
const $d90d8ce15e0e3233$export$20344ad17b5fca86 = 'legacy-jsd-settings';
const $d90d8ce15e0e3233$export$656d0cc2c67b2708 = 'marketplace';
const $d90d8ce15e0e3233$export$bfdbcebc4c81b043 = 'people-profiles';
const $d90d8ce15e0e3233$export$82021d71ad19e227 = 'personal-settings';
const $d90d8ce15e0e3233$export$6f266218a6973848 = 'plan-settings';
const $d90d8ce15e0e3233$export$a846fcaeeea8e0ff = 'polaris';
const $d90d8ce15e0e3233$export$6c87a9dff4e7a2de = 'proforma';
const $d90d8ce15e0e3233$export$ab79970dcfac06a1 = 'project-settings-classic';
const $d90d8ce15e0e3233$export$d1a70f80bb22f18a = 'project-settings-core';
const $d90d8ce15e0e3233$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
const $d90d8ce15e0e3233$export$86509a1baabd62ee = 'project-settings-software';
const $d90d8ce15e0e3233$export$98823ed9eedfc756 = 'project-settings-software-boards';
const $d90d8ce15e0e3233$export$da8d13fe1ccd5c09 = 'redirects';
const $d90d8ce15e0e3233$export$78fb2f6176b7c6b8 = 'servicedesk';
const $d90d8ce15e0e3233$export$d4a2a2e87da2135a = 'services';
const $d90d8ce15e0e3233$export$26efaec7a7a8b361 = 'software';
const $d90d8ce15e0e3233$export$db781fb68c08f7e2 = 'versions';
const $d90d8ce15e0e3233$export$88041353cc69458d = 'archived-issues-directory';
const $d90d8ce15e0e3233$export$f88d57dcb03ba452 = 'archived-plans-directory';
const $d90d8ce15e0e3233$export$e8aa63af071c2da9 = 'archived-projects-directory';
const $d90d8ce15e0e3233$export$b114d0da2ebcff6c = 'archived-project-direct-link';
const $d90d8ce15e0e3233$export$29cc94b8cea5c920 = 'boards-directory';
const $d90d8ce15e0e3233$export$4d1b45005cdcfb39 = 'browse-project-redirect';
const $d90d8ce15e0e3233$export$a42ea04fdf53eeaf = 'next-gen-business-board';
const $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
const $d90d8ce15e0e3233$export$d58a5411a2ac6260 = 'next-gen-business-reports';
const $d90d8ce15e0e3233$export$24514ee19772b5af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-onboarding-get-started`;
const $d90d8ce15e0e3233$export$ec333dd1d6a8b38 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-calendar`;
const $d90d8ce15e0e3233$export$ed495fbad44791af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-redirect`;
const $d90d8ce15e0e3233$export$5281552f8109b7c0 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-summary`;
const $d90d8ce15e0e3233$export$6e8473713ed4557a = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-timeline`;
const $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-approvals`;
const $d90d8ce15e0e3233$export$e7f012f402be01ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-attachments`;
const $d90d8ce15e0e3233$export$b34d3882b42d660d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board`;
const $d90d8ce15e0e3233$export$ed869c60c6a56182 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board-embed`;
const $d90d8ce15e0e3233$export$5013269f29c75b37 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar`;
const $d90d8ce15e0e3233$export$fc8b48319e993d43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar-embed`;
const $d90d8ce15e0e3233$export$40903feb5b038923 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-files`;
const $d90d8ce15e0e3233$export$d6e60a2059f028d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form`;
const $d90d8ce15e0e3233$export$3d589aae17a00bc9 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-builder`;
const $d90d8ce15e0e3233$export$bd92ef03b23dd672 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit`;
const $d90d8ce15e0e3233$export$fa7fc44c718fc850 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit-embed`;
const $d90d8ce15e0e3233$export$1dffaf831e01e2b4 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list`;
const $d90d8ce15e0e3233$export$5f8187412dd60f35 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list-embed`;
const $d90d8ce15e0e3233$export$3d2c1c04d18f6c43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-sample-onboarding`;
const $d90d8ce15e0e3233$export$cd22a5d8f560a1d8 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-shortcut`;
const $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary`;
const $d90d8ce15e0e3233$export$ee073463b4144367 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary-embed`;
const $d90d8ce15e0e3233$export$ea034943499772ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline`;
const $d90d8ce15e0e3233$export$19bc888bcf37d22d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline-embed`;
const $d90d8ce15e0e3233$export$e0746183e11767fb = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-redirect`;
const $d90d8ce15e0e3233$export$3e2d215ce157adc8 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-code`;
const $d90d8ce15e0e3233$export$8a8485bb05daf40b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $d90d8ce15e0e3233$export$a2799b01de5bb62 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-data-classifications`;
const $d90d8ce15e0e3233$export$1bc2b66dcb07293a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
const $d90d8ce15e0e3233$export$2d4f89c4b1ee3640 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-features`;
const $d90d8ce15e0e3233$export$75609d3416c31f79 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-issue-layout`;
const $d90d8ce15e0e3233$export$79793dc26e0b7b1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-notification-email`;
const $d90d8ce15e0e3233$export$2eda7466fbfdef43 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-link-opsgenie`;
const $d90d8ce15e0e3233$export$417297669917ee1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
const $d90d8ce15e0e3233$export$8c79f3309ac0737 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications`;
const $d90d8ce15e0e3233$export$ef71a22e7befd35c = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-issue-logs`;
const $d90d8ce15e0e3233$export$62ba1e294f5007c1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-edit-forms`;
const $d90d8ce15e0e3233$export$a4315324546ecc89 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-project-forms`;
const $d90d8ce15e0e3233$export$a653cf6d478b3df1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-company-managed`;
const $d90d8ce15e0e3233$export$b0f268fe53a03e98 = 'compass-product-settings';
const $d90d8ce15e0e3233$export$f4160b48e4ab8f39 = 'confluence-product-settings';
const $d90d8ce15e0e3233$export$608f359cf8b08d2e = 'connect-general';
const $d90d8ce15e0e3233$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
const $d90d8ce15e0e3233$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
const $d90d8ce15e0e3233$export$bd2506db44585db6 = 'connect-project';
const $d90d8ce15e0e3233$export$200fa5ad16f8c112 = 'create-project';
const $d90d8ce15e0e3233$export$21702f145fe1bbb0 = 'customer-service-accounts';
const $d90d8ce15e0e3233$export$a296bb962bea95b5 = 'dashboard';
const $d90d8ce15e0e3233$export$b9960c143c0414eb = 'dashboards-directory';
const $d90d8ce15e0e3233$export$411171d2fcaefaea = 'dashboards-directory-secure';
const $d90d8ce15e0e3233$export$ee104ed514f63003 = 'dashboard-edit';
const $d90d8ce15e0e3233$export$9233f9ddcecd3062 = 'dashboard-selected';
const $d90d8ce15e0e3233$export$b3240ec044a6c70f = 'dashboard-view';
const $d90d8ce15e0e3233$export$2463c779e12367e3 = 'dashboard-view-embed';
const $d90d8ce15e0e3233$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
const $d90d8ce15e0e3233$export$38ca7e07048a5bfd = 'devops-connected-project';
const $d90d8ce15e0e3233$export$a9044bbb0247378d = 'eoc-alerts';
const $d90d8ce15e0e3233$export$ae7376e552380ac0 = 'eoc-alert-detail';
const $d90d8ce15e0e3233$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
const $d90d8ce15e0e3233$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
const $d90d8ce15e0e3233$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
const $d90d8ce15e0e3233$export$54ed2374d14a7e88 = 'eoc-api-key-management';
const $d90d8ce15e0e3233$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
const $d90d8ce15e0e3233$export$bbb4032f8f259109 = 'eoc-automations';
const $d90d8ce15e0e3233$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
const $d90d8ce15e0e3233$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
const $d90d8ce15e0e3233$export$5126a481501fc518 = 'eoc-global-alert-detail';
const $d90d8ce15e0e3233$export$40e720d8c26e6804 = 'eoc-global-group-detail';
const $d90d8ce15e0e3233$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
const $d90d8ce15e0e3233$export$8ca3e3f0326ba27f = 'eoc-global-reports';
const $d90d8ce15e0e3233$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
const $d90d8ce15e0e3233$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
const $d90d8ce15e0e3233$export$99f769b27f537a72 = 'eoc-incoming-call';
const $d90d8ce15e0e3233$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
const $d90d8ce15e0e3233$export$901b974cf0954c88 = 'eoc-integrations';
const $d90d8ce15e0e3233$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
const $d90d8ce15e0e3233$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
const $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
const $d90d8ce15e0e3233$export$a22387b9744e62e3 = 'eoc-integration-log';
const $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
const $d90d8ce15e0e3233$export$e6de4aa6c719d2b = 'eoc-on-call';
const $d90d8ce15e0e3233$export$b195ada84b7e695f = `${$d90d8ce15e0e3233$export$e6de4aa6c719d2b}-redirect`;
const $d90d8ce15e0e3233$export$1800d32171b754a6 = 'eoc-overview';
const $d90d8ce15e0e3233$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
const $d90d8ce15e0e3233$export$a9a41c76994b6ae9 = 'eoc-permissions';
const $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c = 'eoc-policies';
const $d90d8ce15e0e3233$export$dc70eff53ff26c70 = 'eoc-reports';
const $d90d8ce15e0e3233$export$1fe2ca96b360df19 = 'eoc-reports-team';
const $d90d8ce15e0e3233$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
const $d90d8ce15e0e3233$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
const $d90d8ce15e0e3233$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
const $d90d8ce15e0e3233$export$c4531cbbea51b6a1 = 'eoc-settings';
const $d90d8ce15e0e3233$export$da985e953465731f = 'eoc-team-alerts';
const $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
const $d90d8ce15e0e3233$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
const $d90d8ce15e0e3233$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
const $d90d8ce15e0e3233$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
const $d90d8ce15e0e3233$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
const $d90d8ce15e0e3233$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
const $d90d8ce15e0e3233$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
const $d90d8ce15e0e3233$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
const $d90d8ce15e0e3233$export$bdd811277711c53d = 'eoc-team-integration-create';
const $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
const $d90d8ce15e0e3233$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
const $d90d8ce15e0e3233$export$a4eff769c94da831 = 'eoc-team-integration-log';
const $d90d8ce15e0e3233$export$7c928ca9c9822772 = 'eoc-team-policies';
const $d90d8ce15e0e3233$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
const $d90d8ce15e0e3233$export$20649eac204f7661 = 'eoc-who-is-on-call';
const $d90d8ce15e0e3233$export$62170875a111d729 = 'errors-not-found';
const $d90d8ce15e0e3233$export$2928f3d69e7ac609 = 'external-import';
const $d90d8ce15e0e3233$export$259e18cafd820487 = 'filters-directory';
const $d90d8ce15e0e3233$export$4b8f333757e638a4 = 'filters-directory-secure';
const $d90d8ce15e0e3233$export$ac4f65a14002f892 = 'forge-spa-admin';
const $d90d8ce15e0e3233$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
const $d90d8ce15e0e3233$export$7ad826b482229119 = 'forge-spa-field-context-config';
const $d90d8ce15e0e3233$export$3df864df9b639033 = 'forge-spa-global';
const $d90d8ce15e0e3233$export$7d67bf4077ebe18d = 'forge-spa-project';
const $d90d8ce15e0e3233$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
const $d90d8ce15e0e3233$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
const $d90d8ce15e0e3233$export$eadf5aff28def565 = 'global-issue-navigator';
const $d90d8ce15e0e3233$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
const $d90d8ce15e0e3233$export$1bf439327974644b = 'global-mail-settings';
const $d90d8ce15e0e3233$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
const $d90d8ce15e0e3233$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
const $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
const $d90d8ce15e0e3233$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
const $d90d8ce15e0e3233$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
const $d90d8ce15e0e3233$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
const $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
const $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
const $d90d8ce15e0e3233$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
const $d90d8ce15e0e3233$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
const $d90d8ce15e0e3233$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
const $d90d8ce15e0e3233$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
const $d90d8ce15e0e3233$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
const $d90d8ce15e0e3233$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
const $d90d8ce15e0e3233$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
const $d90d8ce15e0e3233$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
const $d90d8ce15e0e3233$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
const $d90d8ce15e0e3233$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
const $d90d8ce15e0e3233$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
const $d90d8ce15e0e3233$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
const $d90d8ce15e0e3233$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
const $d90d8ce15e0e3233$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
const $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
const $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
const $d90d8ce15e0e3233$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
const $d90d8ce15e0e3233$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
const $d90d8ce15e0e3233$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
const $d90d8ce15e0e3233$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
const $d90d8ce15e0e3233$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
const $d90d8ce15e0e3233$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
const $d90d8ce15e0e3233$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
const $d90d8ce15e0e3233$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
const $d90d8ce15e0e3233$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
const $d90d8ce15e0e3233$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
const $d90d8ce15e0e3233$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
const $d90d8ce15e0e3233$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
const $d90d8ce15e0e3233$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
const $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
const $d90d8ce15e0e3233$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
const $d90d8ce15e0e3233$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
const $d90d8ce15e0e3233$export$7dd4b916600f670 = 'global-settings-issues-priorities';
const $d90d8ce15e0e3233$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
const $d90d8ce15e0e3233$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
const $d90d8ce15e0e3233$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
const $d90d8ce15e0e3233$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
const $d90d8ce15e0e3233$export$691d30818c14141c = 'global-settings-issues-resolutions';
const $d90d8ce15e0e3233$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
const $d90d8ce15e0e3233$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
const $d90d8ce15e0e3233$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
const $d90d8ce15e0e3233$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
const $d90d8ce15e0e3233$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
const $d90d8ce15e0e3233$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
const $d90d8ce15e0e3233$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
const $d90d8ce15e0e3233$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
const $d90d8ce15e0e3233$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
const $d90d8ce15e0e3233$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
const $d90d8ce15e0e3233$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
const $d90d8ce15e0e3233$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
const $d90d8ce15e0e3233$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
const $d90d8ce15e0e3233$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
const $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
const $d90d8ce15e0e3233$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
const $d90d8ce15e0e3233$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
const $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
const $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
const $d90d8ce15e0e3233$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
const $d90d8ce15e0e3233$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
const $d90d8ce15e0e3233$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
const $d90d8ce15e0e3233$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
const $d90d8ce15e0e3233$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
const $d90d8ce15e0e3233$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
const $d90d8ce15e0e3233$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
const $d90d8ce15e0e3233$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
const $d90d8ce15e0e3233$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
const $d90d8ce15e0e3233$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
const $d90d8ce15e0e3233$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
const $d90d8ce15e0e3233$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
const $d90d8ce15e0e3233$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
const $d90d8ce15e0e3233$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
const $d90d8ce15e0e3233$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
const $d90d8ce15e0e3233$export$ef510a15f840e437 = 'global-settings-issues-types-view';
const $d90d8ce15e0e3233$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
const $d90d8ce15e0e3233$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
const $d90d8ce15e0e3233$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
const $d90d8ce15e0e3233$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
const $d90d8ce15e0e3233$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
const $d90d8ce15e0e3233$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
const $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
const $d90d8ce15e0e3233$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
const $d90d8ce15e0e3233$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
const $d90d8ce15e0e3233$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
const $d90d8ce15e0e3233$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
const $d90d8ce15e0e3233$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
const $d90d8ce15e0e3233$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
const $d90d8ce15e0e3233$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
const $d90d8ce15e0e3233$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
const $d90d8ce15e0e3233$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
const $d90d8ce15e0e3233$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
const $d90d8ce15e0e3233$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
const $d90d8ce15e0e3233$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
const $d90d8ce15e0e3233$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
const $d90d8ce15e0e3233$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
const $d90d8ce15e0e3233$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
const $d90d8ce15e0e3233$export$4c211b3188348679 = 'global-settings-performance-custom-field';
const $d90d8ce15e0e3233$export$24757bb1837e33af = 'global-settings-performance-issue';
const $d90d8ce15e0e3233$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
const $d90d8ce15e0e3233$export$d55d4330b58683da = 'global-settings-performance-overview';
const $d90d8ce15e0e3233$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
const $d90d8ce15e0e3233$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
const $d90d8ce15e0e3233$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
const $d90d8ce15e0e3233$export$16b4392a63a3eacf = 'global-settings-products-applinks';
const $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
const $d90d8ce15e0e3233$export$f870832f94ca5009 = 'global-settings-products-sdmail';
const $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
const $d90d8ce15e0e3233$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
const $d90d8ce15e0e3233$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
const $d90d8ce15e0e3233$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
const $d90d8ce15e0e3233$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
const $d90d8ce15e0e3233$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
const $d90d8ce15e0e3233$export$a1916b723e186494 = 'global-settings-system-helper-permission';
const $d90d8ce15e0e3233$export$5070b4c974017f28 = 'global-settings-system-attachments';
const $d90d8ce15e0e3233$export$bee7f9f93cb74124 = 'global-settings-system-events';
const $d90d8ce15e0e3233$export$efe4008073ab3b69 = 'global-settings-system-events-add';
const $d90d8ce15e0e3233$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
const $d90d8ce15e0e3233$export$223f8094878fea34 = 'global-settings-system-events-edit';
const $d90d8ce15e0e3233$export$2f589c572415c043 = 'global-settings-system-lexorank';
const $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
const $d90d8ce15e0e3233$export$a11311cd333dae90 = 'global-settings-system-webhooks';
const $d90d8ce15e0e3233$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
const $d90d8ce15e0e3233$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
const $d90d8ce15e0e3233$export$55dd30b027c838fe = 'global-settings-system-application-edit';
const $d90d8ce15e0e3233$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
const $d90d8ce15e0e3233$export$75f2fbd33e76028e = 'global-settings-system-export';
const $d90d8ce15e0e3233$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
const $d90d8ce15e0e3233$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
const $d90d8ce15e0e3233$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
const $d90d8ce15e0e3233$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
const $d90d8ce15e0e3233$export$750a33c4058af733 = 'global-settings-system-import-trello';
const $d90d8ce15e0e3233$export$1b66c7594340363f = 'global-settings-system-collectors';
const $d90d8ce15e0e3233$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
const $d90d8ce15e0e3233$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
const $d90d8ce15e0e3233$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
const $d90d8ce15e0e3233$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
const $d90d8ce15e0e3233$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
const $d90d8ce15e0e3233$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
const $d90d8ce15e0e3233$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
const $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
const $d90d8ce15e0e3233$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
const $d90d8ce15e0e3233$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
const $d90d8ce15e0e3233$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
const $d90d8ce15e0e3233$export$265062715b11a1ef = 'global-settings-system-roles-usage';
const $d90d8ce15e0e3233$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
const $d90d8ce15e0e3233$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
const $d90d8ce15e0e3233$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
const $d90d8ce15e0e3233$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
const $d90d8ce15e0e3233$export$fb75113636566d39 = 'global-settings-system-look';
const $d90d8ce15e0e3233$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
const $d90d8ce15e0e3233$export$40d189100899f572 = 'global-settings-system-default-settings';
const $d90d8ce15e0e3233$export$341933b279728599 = $d90d8ce15e0e3233$export$f8cea29bebf098c;
const $d90d8ce15e0e3233$export$ae4b815061537207 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-notifications`;
const $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-email`;
const $d90d8ce15e0e3233$export$bee46016693b19dc = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-kb`;
const $d90d8ce15e0e3233$export$c39a25878c902e0a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
const $d90d8ce15e0e3233$export$6eaa6ce8101f6468 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
const $d90d8ce15e0e3233$export$2e90ab5aa3463c0d = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-web-portal`;
const $d90d8ce15e0e3233$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
const $d90d8ce15e0e3233$export$b2b57cde1fa39bf5 = 'home-redirect';
const $d90d8ce15e0e3233$export$e8e3b3a04b70a016 = 'issue';
const $d90d8ce15e0e3233$export$1a3116351e4f3550 = 'issue-create-embed';
const $d90d8ce15e0e3233$export$6e2629d41c380b47 = 'issue-embed';
const $d90d8ce15e0e3233$export$ced38e55e6d33a4e = 'jira-search';
const $d90d8ce15e0e3233$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
const $d90d8ce15e0e3233$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
const $d90d8ce15e0e3233$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
const $d90d8ce15e0e3233$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
const $d90d8ce15e0e3233$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
const $d90d8ce15e0e3233$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
const $d90d8ce15e0e3233$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
const $d90d8ce15e0e3233$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
const $d90d8ce15e0e3233$export$fea47b97c6086336 = 'knowledge-hub-drafts';
const $d90d8ce15e0e3233$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
const $d90d8ce15e0e3233$export$991ba0c465b48539 = 'knowledge-hub-landing';
const $d90d8ce15e0e3233$export$904b472d57dee40d = 'knowledge-hub-search';
const $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
const $d90d8ce15e0e3233$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
const $d90d8ce15e0e3233$export$37bd400c00057d64 = 'legacy-all-reports';
const $d90d8ce15e0e3233$export$eb66bd587b5f093d = 'legacy-backlog';
const $d90d8ce15e0e3233$export$521baa72494c2a67 = 'legacy-board';
const $d90d8ce15e0e3233$export$ca255c93be51d5bc = 'legacy-connect-general';
const $d90d8ce15e0e3233$export$51e45f736a60769b = 'legacy-connect-project';
const $d90d8ce15e0e3233$export$2da88c0583f7fff0 = 'legacy-core-reports';
const $d90d8ce15e0e3233$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
const $d90d8ce15e0e3233$export$5475ba822739444a = 'legacy-fallback';
const $d90d8ce15e0e3233$export$8483f5c57513e386 = 'legacy-gin';
const $d90d8ce15e0e3233$export$93c4d1960660bdb3 = 'legacy-gin-issue';
const $d90d8ce15e0e3233$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
const $d90d8ce15e0e3233$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
const $d90d8ce15e0e3233$export$bf4001a5c23bef67 = 'legacy-issue';
const $d90d8ce15e0e3233$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
const $d90d8ce15e0e3233$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
const $d90d8ce15e0e3233$export$41008c2b014795bf = 'legacy-jsd-getting-started';
const $d90d8ce15e0e3233$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
const $d90d8ce15e0e3233$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
const $d90d8ce15e0e3233$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
const $d90d8ce15e0e3233$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
const $d90d8ce15e0e3233$export$3fbd487079a23c0f = 'legacy-jsd-reports';
const $d90d8ce15e0e3233$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
const $d90d8ce15e0e3233$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
const $d90d8ce15e0e3233$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
const $d90d8ce15e0e3233$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
const $d90d8ce15e0e3233$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
const $d90d8ce15e0e3233$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
const $d90d8ce15e0e3233$export$c71836085985a7d3 = 'legacy-pin';
const $d90d8ce15e0e3233$export$a17a19a9de903839 = 'legacy-project-releases';
const $d90d8ce15e0e3233$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
const $d90d8ce15e0e3233$export$f0254c80025ed0fc = 'legacy-project-releases-note';
const $d90d8ce15e0e3233$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
const $d90d8ce15e0e3233$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
const $d90d8ce15e0e3233$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
const $d90d8ce15e0e3233$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
const $d90d8ce15e0e3233$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
const $d90d8ce15e0e3233$export$3467807847c0a87d = 'legacy-project-settings-config';
const $d90d8ce15e0e3233$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
const $d90d8ce15e0e3233$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
const $d90d8ce15e0e3233$export$f01730982626c4af = 'legacy-project-settings-dev';
const $d90d8ce15e0e3233$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
const $d90d8ce15e0e3233$export$ecff223feb9d08be = 'legacy-project-settings-fields';
const $d90d8ce15e0e3233$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
const $d90d8ce15e0e3233$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
const $d90d8ce15e0e3233$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
const $d90d8ce15e0e3233$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
const $d90d8ce15e0e3233$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
const $d90d8ce15e0e3233$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
const $d90d8ce15e0e3233$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
const $d90d8ce15e0e3233$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
const $d90d8ce15e0e3233$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
const $d90d8ce15e0e3233$export$28687a1181a7676f = 'legacy-project-settings-people';
const $d90d8ce15e0e3233$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
const $d90d8ce15e0e3233$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
const $d90d8ce15e0e3233$export$cb8548f16119b181 = 'legacy-project-settings-screens';
const $d90d8ce15e0e3233$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
const $d90d8ce15e0e3233$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
const $d90d8ce15e0e3233$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
const $d90d8ce15e0e3233$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
const $d90d8ce15e0e3233$export$2d21e5416485b195 = 'legacy-redirect';
const $d90d8ce15e0e3233$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
const $d90d8ce15e0e3233$export$d9662297242bfcb5 = 'legacy-reports-configure';
const $d90d8ce15e0e3233$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
const $d90d8ce15e0e3233$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
const $d90d8ce15e0e3233$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
const $d90d8ce15e0e3233$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
const $d90d8ce15e0e3233$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
const $d90d8ce15e0e3233$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
const $d90d8ce15e0e3233$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
const $d90d8ce15e0e3233$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
const $d90d8ce15e0e3233$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
const $d90d8ce15e0e3233$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
const $d90d8ce15e0e3233$export$55248356780fc584 = 'login-embed';
const $d90d8ce15e0e3233$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
const $d90d8ce15e0e3233$export$624af6f61b05f55 = 'addons-emcee-public';
const $d90d8ce15e0e3233$export$2ed9525182145b82 = 'marketplace-app-requests';
const $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b = 'marketplace-index';
const $d90d8ce15e0e3233$export$fa962db82ae571b2 = 'global-settings-addons-upm';
const $d90d8ce15e0e3233$export$e145bf76b1aef705 = 'marketplace-promotions';
const $d90d8ce15e0e3233$export$8febbfb647e4c8b9 = 'notification-logs';
const $d90d8ce15e0e3233$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
const $d90d8ce15e0e3233$export$a979a5c1f5e3631c = 'people-index';
const $d90d8ce15e0e3233$export$ffcbf91dfadffd0 = 'personal-settings';
const $d90d8ce15e0e3233$export$1807a39cc63b856c = 'personal-settings-general';
const $d90d8ce15e0e3233$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
const $d90d8ce15e0e3233$export$6268da7263eb670d = 'personal-settings-ops-notifications';
const $d90d8ce15e0e3233$export$93bd4a896a0fc581 = 'plans-directory';
const $d90d8ce15e0e3233$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
const $d90d8ce15e0e3233$export$d1217085321b2648 = 'project-settings-playbooks-list';
const $d90d8ce15e0e3233$export$39624171b7c8a10a = 'polaris-collections';
const $d90d8ce15e0e3233$export$1654cd6813e90e6b = 'polaris-ideas';
const $d90d8ce15e0e3233$export$33059cd02df2febd = 'polaris-insights';
const $d90d8ce15e0e3233$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
const $d90d8ce15e0e3233$export$145c578104a45fd2 = 'polaris-plays';
const $d90d8ce15e0e3233$export$a51df1bc877c58e5 = 'polaris-rooms';
const $d90d8ce15e0e3233$export$45208fff8de46880 = 'polaris-settings-access';
const $d90d8ce15e0e3233$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
const $d90d8ce15e0e3233$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
const $d90d8ce15e0e3233$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
const $d90d8ce15e0e3233$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
const $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
const $d90d8ce15e0e3233$export$53ce69fb34f6d286 = 'products-jsm-configuration';
const $d90d8ce15e0e3233$export$b6e861786143eb1b = 'products-jsm-customer-access';
const $d90d8ce15e0e3233$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
const $d90d8ce15e0e3233$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
const $d90d8ce15e0e3233$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
const $d90d8ce15e0e3233$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
const $d90d8ce15e0e3233$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
const $d90d8ce15e0e3233$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
const $d90d8ce15e0e3233$export$9ac90b948c53bf58 = 'products-jsw-configuration';
const $d90d8ce15e0e3233$export$bb5665894498893f = 'products-jsw-storage-management';
const $d90d8ce15e0e3233$export$fc61479fdfdd263a = 'classic-business-proforma-export';
const $d90d8ce15e0e3233$export$5ae82b891e42770e = 'servicedesk-proforma-export';
const $d90d8ce15e0e3233$export$8dcc46e162f2235b = 'software-proforma-export';
const $d90d8ce15e0e3233$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
const $d90d8ce15e0e3233$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
const $d90d8ce15e0e3233$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
const $d90d8ce15e0e3233$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
const $d90d8ce15e0e3233$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
const $d90d8ce15e0e3233$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
const $d90d8ce15e0e3233$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
const $d90d8ce15e0e3233$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
const $d90d8ce15e0e3233$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
const $d90d8ce15e0e3233$export$ff1365ce4d652337 = 'projects-directory';
const $d90d8ce15e0e3233$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
const $d90d8ce15e0e3233$export$33c2dcc7c7abc45e = 'projects-directory-manage';
const $d90d8ce15e0e3233$export$a6ef20aa08a533b1 = 'projects-redirect';
const $d90d8ce15e0e3233$export$5908e15483da8a45 = 'project-components';
const $d90d8ce15e0e3233$export$a3812f6f4e60d897 = 'project-directory-redirect';
const $d90d8ce15e0e3233$export$3c8c119f40a061a9 = 'issue-navigator';
const $d90d8ce15e0e3233$export$47e034646abefdb2 = 'issue-navigator-classic';
const $d90d8ce15e0e3233$export$f36f4cf8b17f250f = 'issue-navigator-core';
const $d90d8ce15e0e3233$export$841e880a0d425b3e = 'project-not-found';
const $d90d8ce15e0e3233$export$1fde4a6e7df24a97 = 'project-pages';
const $d90d8ce15e0e3233$export$69335bf8b709edc7 = 'project-settings-automation';
const $d90d8ce15e0e3233$export$946b472f7559a889 = 'project-settings-components';
const $d90d8ce15e0e3233$export$373fdf6888021ed0 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access`;
const $d90d8ce15e0e3233$export$d6a5f13a3d30923c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access-redirect`;
const $d90d8ce15e0e3233$export$adfff93b0b015409 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-approvals`;
const $d90d8ce15e0e3233$export$404de4ddea701cff = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps`;
const $d90d8ce15e0e3233$export$596e1f6f6f4997b2 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps-fields`;
const $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-automation`;
const $d90d8ce15e0e3233$export$d610a17dff3a01fa = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-data-classifications`;
const $d90d8ce15e0e3233$export$284db5107f3db516 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-redirect`;
const $d90d8ce15e0e3233$export$fbce46826eefc586 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-details`;
const $d90d8ce15e0e3233$export$c86b29c76317ac6f = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-fields`;
const $d90d8ce15e0e3233$export$3160b86e1b5dc391 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-forge-apps`;
const $d90d8ce15e0e3233$export$690c0080c930fca = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes`;
const $d90d8ce15e0e3233$export$171ba8c33c05c4ef = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes-workflow`;
const $d90d8ce15e0e3233$export$e2f2c23286c3255c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications`;
const $d90d8ce15e0e3233$export$5a262d40e10207a1 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-issue-logs`;
const $d90d8ce15e0e3233$export$ab790cb87175797e = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-notification-email`;
const $d90d8ce15e0e3233$export$db780b39656c673a = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
const $d90d8ce15e0e3233$export$a77cb4dafc511d3 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $d90d8ce15e0e3233$export$253fd82874264ee4 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-forge-apps`;
const $d90d8ce15e0e3233$export$eaf9ab4ec0c25813 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-forge`;
const $d90d8ce15e0e3233$export$574bcdf6b73fcf1f = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-apps-fields`;
const $d90d8ce15e0e3233$export$a14853dfff8da872 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-chat`;
const $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-notifications`;
const $d90d8ce15e0e3233$export$1c74da1e52e6d212 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-permissions`;
const $d90d8ce15e0e3233$export$d416059b17fe7d4e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-email`;
const $d90d8ce15e0e3233$export$d5a3a037d2760bb7 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-widget`;
const $d90d8ce15e0e3233$export$eb187d42a7448d45 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
const $d90d8ce15e0e3233$export$688de32d31fc70f5 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-details`;
const $d90d8ce15e0e3233$export$13d770f8814d480a = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-forge-apps`;
const $d90d8ce15e0e3233$export$3a628f9376166ffb = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
const $d90d8ce15e0e3233$export$649dafa225625f30 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
const $d90d8ce15e0e3233$export$dbfe76dd37018b2 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications`;
const $d90d8ce15e0e3233$export$20db7bb9d1bd8b38 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications-notification-email`;
const $d90d8ce15e0e3233$export$a1fa8e6e125780ae = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notification-email`;
const $d90d8ce15e0e3233$export$fc6b949fd2bc782d = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-portal-settings`;
const $d90d8ce15e0e3233$export$c940f866ac7760a0 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-types-config`;
const $d90d8ce15e0e3233$export$184d4979f6f9fe7e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-type-fields`;
const $d90d8ce15e0e3233$export$959f50de166cc45e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
const $d90d8ce15e0e3233$export$b13b8c8bb4e30a75 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
const $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
const $d90d8ce15e0e3233$export$cc1af211e3feda50 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-fields`;
const $d90d8ce15e0e3233$export$3873539001f5aed7 = 'project-settings-software-automation';
const $d90d8ce15e0e3233$export$89fcbafce559080b = 'project-settings-software-boards-card';
const $d90d8ce15e0e3233$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
const $d90d8ce15e0e3233$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
const $d90d8ce15e0e3233$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
const $d90d8ce15e0e3233$export$50680f54e95bb859 = 'project-settings-software-boards-features';
const $d90d8ce15e0e3233$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
const $d90d8ce15e0e3233$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
const $d90d8ce15e0e3233$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
const $d90d8ce15e0e3233$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
const $d90d8ce15e0e3233$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
const $d90d8ce15e0e3233$export$ba419378ad70624e = 'project-settings-software-data-classifications';
const $d90d8ce15e0e3233$export$62f38c589a73d386 = 'project-settings-software-details';
const $d90d8ce15e0e3233$export$77c8066c0822f152 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-fields`;
const $d90d8ce15e0e3233$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
const $d90d8ce15e0e3233$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
const $d90d8ce15e0e3233$export$db7f5d93be70ee30 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications`;
const $d90d8ce15e0e3233$export$432229516b7f82da = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications-issue-logs`;
const $d90d8ce15e0e3233$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
const $d90d8ce15e0e3233$export$6b2b99b0055772a3 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-link-opsgenie`;
const $d90d8ce15e0e3233$export$83c7a51057be6264 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-team-managed`;
const $d90d8ce15e0e3233$export$46706d786aab3829 = 'project-settings-versions';
const $d90d8ce15e0e3233$export$b690025ef7e3cf6c = 'project-versions';
const $d90d8ce15e0e3233$export$ea48cc6bf1183d11 = 'rapidboard';
const $d90d8ce15e0e3233$export$930e4881302bbd54 = 'rapidboard-backlog';
const $d90d8ce15e0e3233$export$375801b708576466 = 'rapidboard-backlog-embed';
const $d90d8ce15e0e3233$export$5b1e8463bd590143 = 'rapidboard-board';
const $d90d8ce15e0e3233$export$1606662a398a24be = 'rapidboard-board-embed';
const $d90d8ce15e0e3233$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
const $d90d8ce15e0e3233$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
const $d90d8ce15e0e3233$export$c46680afe70295f3 = 'rapidboard-report';
const $d90d8ce15e0e3233$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
const $d90d8ce15e0e3233$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
const $d90d8ce15e0e3233$export$99e0abd8ba1de289 = 'rapidboard-user-board';
const $d90d8ce15e0e3233$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
const $d90d8ce15e0e3233$export$36e61e70347174cc = 'rovo-demand-tests';
const $d90d8ce15e0e3233$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
const $d90d8ce15e0e3233$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
const $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
const $d90d8ce15e0e3233$export$8c8f03e75b6708ac = 'servicedesk-calendar';
const $d90d8ce15e0e3233$export$2e93790099768be5 = 'servicedesk-calendar-eap';
const $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
const $d90d8ce15e0e3233$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
const $d90d8ce15e0e3233$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
const $d90d8ce15e0e3233$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
const $d90d8ce15e0e3233$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
const $d90d8ce15e0e3233$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
const $d90d8ce15e0e3233$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
const $d90d8ce15e0e3233$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
const $d90d8ce15e0e3233$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
const $d90d8ce15e0e3233$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
const $d90d8ce15e0e3233$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
const $d90d8ce15e0e3233$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
const $d90d8ce15e0e3233$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
const $d90d8ce15e0e3233$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
const $d90d8ce15e0e3233$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
const $d90d8ce15e0e3233$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
const $d90d8ce15e0e3233$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
const $d90d8ce15e0e3233$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
const $d90d8ce15e0e3233$export$37a9bdd8513f462d = 'servicedesk-connect-project';
const $d90d8ce15e0e3233$export$f01162415f3a2ee3 = 'servicedesk-create-project';
const $d90d8ce15e0e3233$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
const $d90d8ce15e0e3233$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
const $d90d8ce15e0e3233$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
const $d90d8ce15e0e3233$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
const $d90d8ce15e0e3233$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
const $d90d8ce15e0e3233$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
const $d90d8ce15e0e3233$export$829d1776460a6ad3 = 'servicedesk-incidents';
const $d90d8ce15e0e3233$export$d30ab2da08d8b7b9 = 'servicedesk-index';
const $d90d8ce15e0e3233$export$3c71889849aeaa08 = 'servicedesk-issue';
const $d90d8ce15e0e3233$export$354bf2df81f6ffb0 = 'servicedesk-issues';
const $d90d8ce15e0e3233$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
const $d90d8ce15e0e3233$export$876055c0ede2f8df = 'servicedesk-automation';
const $d90d8ce15e0e3233$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
const $d90d8ce15e0e3233$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
const $d90d8ce15e0e3233$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
const $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
const $d90d8ce15e0e3233$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
const $d90d8ce15e0e3233$export$8c800f176d079d28 = 'servicedesk-organization-details';
const $d90d8ce15e0e3233$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
const $d90d8ce15e0e3233$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
const $d90d8ce15e0e3233$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
const $d90d8ce15e0e3233$export$2b4737953287a354 = 'servicedesk-practice-issue';
const $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
const $d90d8ce15e0e3233$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
const $d90d8ce15e0e3233$export$2d961b0101f8733e = 'servicedesk-practice-new';
const $d90d8ce15e0e3233$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
const $d90d8ce15e0e3233$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
const $d90d8ce15e0e3233$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
const $d90d8ce15e0e3233$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
const $d90d8ce15e0e3233$export$ccd12890649c59cc = 'servicedesk-queues-issue';
const $d90d8ce15e0e3233$export$8c84064031188e80 = 'servicedesk-queues-landing';
const $d90d8ce15e0e3233$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
const $d90d8ce15e0e3233$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
const $d90d8ce15e0e3233$export$156b2dfbd87d576f = 'servicedesk-redirect';
const $d90d8ce15e0e3233$export$6961f1ed0407cb26 = 'servicedesk-reports';
const $d90d8ce15e0e3233$export$ba284efd679bf637 = 'servicedesk-reports-custom';
const $d90d8ce15e0e3233$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
const $d90d8ce15e0e3233$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
const $d90d8ce15e0e3233$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
const $d90d8ce15e0e3233$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
const $d90d8ce15e0e3233$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
const $d90d8ce15e0e3233$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
const $d90d8ce15e0e3233$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
const $d90d8ce15e0e3233$export$be4b2ffade787316 = 'servicedesk-reports-summary';
const $d90d8ce15e0e3233$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
const $d90d8ce15e0e3233$export$29bc361328055683 = 'servicedesk-reports-workload';
const $d90d8ce15e0e3233$export$a4a5a333fe874d97 = 'servicedesk-services';
const $d90d8ce15e0e3233$export$2193b681ac1ae132 = 'servicedesk-services-new';
const $d90d8ce15e0e3233$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
const $d90d8ce15e0e3233$export$a4c4f7898d6b914a = 'servicedesk-service-details';
const $d90d8ce15e0e3233$export$6cffae90b9277bb = 'servicedesk-service-details-new';
const $d90d8ce15e0e3233$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
const $d90d8ce15e0e3233$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
const $d90d8ce15e0e3233$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
const $d90d8ce15e0e3233$export$8e68c55c334de101 = 'servicedesk-sla-settings';
const $d90d8ce15e0e3233$export$5cb7cfba189a0240 = 'service-hub-services';
const $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
const $d90d8ce15e0e3233$export$1cf56e2d6c4edb35 = 'global-automation';
const $d90d8ce15e0e3233$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
const $d90d8ce15e0e3233$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
const $d90d8ce15e0e3233$export$4db732436e4edfaf = 'recommendations';
const $d90d8ce15e0e3233$export$e832418dbed0717e = 'view-custom-fields';
const $d90d8ce15e0e3233$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
const $d90d8ce15e0e3233$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
const $d90d8ce15e0e3233$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
const $d90d8ce15e0e3233$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
const $d90d8ce15e0e3233$export$e74fe5bd41e23fbd = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies`;
const $d90d8ce15e0e3233$export$1a93e63ddbe4aa06 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies-redirect`;
const $d90d8ce15e0e3233$export$3b6dbbe49882589d = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-financial-year`;
const $d90d8ce15e0e3233$export$eb01394789016fd4 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits`;
const $d90d8ce15e0e3233$export$f17f4523583fa8e5 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits-redirect`;
const $d90d8ce15e0e3233$export$eaa4d6eec75a6778 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions`;
const $d90d8ce15e0e3233$export$dcc96e4abbdc0d39 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions-redirect`;
const $d90d8ce15e0e3233$export$9eaf39ba5a56c72a = 'software-backlog';
const $d90d8ce15e0e3233$export$495be3320b67814a = 'software-backlog-embed';
const $d90d8ce15e0e3233$export$25752eb5bb5e3d32 = 'software-boards';
const $d90d8ce15e0e3233$export$f116716aedb35e10 = 'software-boards-embed';
const $d90d8ce15e0e3233$export$36fffb6b49d9f31d = 'software-calendar';
const $d90d8ce15e0e3233$export$a6d07be4ff318f84 = 'software-calendar-classic';
const $d90d8ce15e0e3233$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
const $d90d8ce15e0e3233$export$3a4c7a521a900b4d = 'software-calendar-embed';
const $d90d8ce15e0e3233$export$9dcf51a9040a4fd6 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
const $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
const $d90d8ce15e0e3233$export$f8cb86acf6b74661 = 'software-code';
const $d90d8ce15e0e3233$export$2d3d850c64058bfb = 'software-code-classic';
const $d90d8ce15e0e3233$export$af6b51164f66908b = 'software-deployments';
const $d90d8ce15e0e3233$export$12efc96fc9c9fb34 = 'software-deployments-classic';
const $d90d8ce15e0e3233$export$6ab1901e04e623ba = 'software-form';
const $d90d8ce15e0e3233$export$bccc7d0812737c4e = 'software-form-classic';
const $d90d8ce15e0e3233$export$458fb992f2637a20 = 'software-form-builder';
const $d90d8ce15e0e3233$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
const $d90d8ce15e0e3233$export$50264cbc90a39f19 = 'software-form-submit';
const $d90d8ce15e0e3233$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
const $d90d8ce15e0e3233$export$b8045610416fa8ca = 'software-goals';
const $d90d8ce15e0e3233$export$8e80136ad13099e3 = 'software-goals-classic';
const $d90d8ce15e0e3233$export$b5fe44c0bc324494 = 'software-incidents';
const $d90d8ce15e0e3233$export$7a4f52d9060a20d2 = 'software-incidents-classic';
const $d90d8ce15e0e3233$export$d6a9e4695952522e = 'software-issue-navigator';
const $d90d8ce15e0e3233$export$deab88d0814c564b = 'software-list';
const $d90d8ce15e0e3233$export$906faff110f898ef = 'software-list-classic';
const $d90d8ce15e0e3233$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
const $d90d8ce15e0e3233$export$4ed84a2011fdc400 = 'software-list-embed';
const $d90d8ce15e0e3233$export$f7b286b39bf6051b = 'software-nextgen-redirect';
const $d90d8ce15e0e3233$export$6c4337c0332c8c7f = 'software-onboarding';
const $d90d8ce15e0e3233$export$e7c78887745b2326 = 'software-onboarding-get-started';
const $d90d8ce15e0e3233$export$3805e4f07dca7584 = 'software-periscope';
const $d90d8ce15e0e3233$export$f77254983320e888 = 'software-periscope-classic';
const $d90d8ce15e0e3233$export$2e784832f1c6bb = 'software-plan-calendar';
const $d90d8ce15e0e3233$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
const $d90d8ce15e0e3233$export$9e53cdb1ac02195c = 'software-plan-dependencies';
const $d90d8ce15e0e3233$export$58bd507904dc221c = 'software-plan-dependencies-embed';
const $d90d8ce15e0e3233$export$7a821e22be2c2f14 = 'software-plan-increment';
const $d90d8ce15e0e3233$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
const $d90d8ce15e0e3233$export$e7423156dba31a7c = 'software-plan-increments';
const $d90d8ce15e0e3233$export$cba7e383b2409c7b = 'software-plan-releases';
const $d90d8ce15e0e3233$export$d5378fb71d5242c0 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-auto-scheduler`;
const $d90d8ce15e0e3233$export$4b16b72c72da8833 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-custom-fields`;
const $d90d8ce15e0e3233$export$10114d78cefb1f53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-exclusion-rules`;
const $d90d8ce15e0e3233$export$92fe23ed30100817 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-find-your-issue`;
const $d90d8ce15e0e3233$export$e824495554c83069 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-issue-sources`;
const $d90d8ce15e0e3233$export$8df2e9efdd625a44 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-permissions`;
const $d90d8ce15e0e3233$export$aeb4d3006e298033 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-plan-info`;
const $d90d8ce15e0e3233$export$e15d3c40985c4b53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-program-boards`;
const $d90d8ce15e0e3233$export$1d8c84454fd2d571 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-removed-issues`;
const $d90d8ce15e0e3233$export$db61a12efb59745c = `${$d90d8ce15e0e3233$export$6f266218a6973848}-saved-views`;
const $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scenarios`;
const $d90d8ce15e0e3233$export$182e0167fd960de6 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scheduling`;
const $d90d8ce15e0e3233$export$2d9e2484ee02e7da = 'software-plan-summary';
const $d90d8ce15e0e3233$export$b7fff19fd89b617f = 'software-plan-summary-embed';
const $d90d8ce15e0e3233$export$ea23f150f64e8a4e = 'software-plan-teams';
const $d90d8ce15e0e3233$export$116338bd93f78ad0 = 'software-plan-timeline';
const $d90d8ce15e0e3233$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
const $d90d8ce15e0e3233$export$7a4b4b66d7637fbb = 'software-presentation-toolkit-report';
const $d90d8ce15e0e3233$export$d75d93e5d44182cc = 'software-release-notes';
const $d90d8ce15e0e3233$export$cc3027ae3767801 = 'software-reports';
const $d90d8ce15e0e3233$export$3492ce83b8884e0e = 'software-reports-burndown';
const $d90d8ce15e0e3233$export$b4798b7e62733393 = 'software-reports-burnup';
const $d90d8ce15e0e3233$export$388685c701d6e0d3 = 'software-reports-control';
const $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
const $d90d8ce15e0e3233$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
const $d90d8ce15e0e3233$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
const $d90d8ce15e0e3233$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
const $d90d8ce15e0e3233$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
const $d90d8ce15e0e3233$export$ae0d999dd2bdd59b = 'software-reports-velocity';
const $d90d8ce15e0e3233$export$43bbf6935a91d277 = 'software-requests';
const $d90d8ce15e0e3233$export$92e23977438282b2 = 'software-requests-classic';
const $d90d8ce15e0e3233$export$296115eb5b7129d3 = 'software-roadmap';
const $d90d8ce15e0e3233$export$17574f41c3925d64 = 'software-roadmap-classic';
const $d90d8ce15e0e3233$export$955692fbfe35fc16 = 'software-roadmap-redirect';
const $d90d8ce15e0e3233$export$30af3a767b8ad2d8 = 'software-security';
const $d90d8ce15e0e3233$export$f47d664298c2c2f0 = 'software-security-classic';
const $d90d8ce15e0e3233$export$1714b5ad9b672bc7 = 'software-timeline';
const $d90d8ce15e0e3233$export$c9634bf15518a3a1 = 'software-timeline-classic';
const $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed = 'software-version-detail';
const $d90d8ce15e0e3233$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
const $d90d8ce15e0e3233$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
const $d90d8ce15e0e3233$export$831acb5098f5706d = 'system-configuration-general';
const $d90d8ce15e0e3233$export$d218cda46c433fe1 = 'system-dashboard-edit';
const $d90d8ce15e0e3233$export$61147168ac2833f9 = 'trashed-plan-direct-link';
const $d90d8ce15e0e3233$export$9fe0117c0fd486a8 = 'trash-plans-directory';
const $d90d8ce15e0e3233$export$a49474778d15635d = 'trash-projects-directory';
const $d90d8ce15e0e3233$export$af3296e54e7fb362 = 'user-segmentation';
const $d90d8ce15e0e3233$export$281f2e01ee9e4977 = 'your-work';

});

parcelRegister("8iyFV", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $ee88d7a7192b9e04$export$84e1a5f003939496);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("aNUpj")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("aNUpj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");


module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gnY34")),
    $6fhBS("dsiAd"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("aqH3P")
]).then(()=>parcelRequire('fYibJ'));

});
parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
var $bab49d2fea43af49$var$cachedBundles = {};
var $bab49d2fea43af49$var$cachedPreloads = {};
var $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("cPiXk", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $2edc33969f533189$export$205771a0e64e4c7c);

var $l71WK = parcelRequire("l71WK");

var $2vSU6 = parcelRequire("2vSU6");

var $65Ltd = parcelRequire("65Ltd");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $14V0U = parcelRequire("14V0U");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $5PD5h = parcelRequire("5PD5h");

var $dIdda = parcelRequire("dIdda");

const $2edc33969f533189$export$965942f8308cd740 = (0, $dIdda.createRouterSelector)((state)=>(0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $2edc33969f533189$export$205771a0e64e4c7c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const hasBoardSettingsPageQueryParam = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4R6GH.fg)('jira_hide_horizontal_nav_on_board_settings_pages') && $2edc33969f533189$export$965942f8308cd740();
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isChromeless] = (0, $14V0U.useIsChromeless)();
        if (isChromeless) return null;
    }
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
        if ((0, $3HwlS.getWillShowNav4)()) return null;
        switch(projectData?.projectType){
            case 0, $2vSU6.CORE_PROJECT:
                return 0, $l71WK.AsyncHorizontalProjectNav;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === (0, $65Ltd.ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, $3HwlS.getWillShowNav4)() && (0, $co1wz.ff)('simplified-boards-milestone-2_07hbk')) return null;
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $l71WK.AsyncHorizontalProjectNav;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if ((0, $3HwlS.getWillShowNav4)()) return 0, $5PD5h.AsyncHorizontalSoftwareProjectNav;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if ('onlyShowHorziontalOnNav4' in route.navigation && route.navigation.onlyShowHorziontalOnNav4) return (0, $3HwlS.getWillShowNav4)() ? route.navigation.horizontal : null;
    if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
        // Society: "Use a constant!"
        // Me: no! I was told to inline my feature flags!
        case 'jsm_views_of_work_phase_1':
            return (0, $4R6GH.fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
        default:
            {
                // a little bit of magic to ensure that we handle all feature flags defined in
                // HorizontalFeatureFlags - if the switch statement is missing a case, this line
                // will cause a compile error.
                const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                return exhaustiveCheck;
            }
    }
    return route.navigation.horizontal;
};

});
parcelRegister("14V0U", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $96950c90e73fdad9$export$c88b74884f5222ba);

var $7JoAD = parcelRequire("7JoAD");

var $5e5zm = parcelRequire("5e5zm");
const $96950c90e73fdad9$export$c88b74884f5222ba = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isChromeless
});

});
parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);

var $7JoAD = parcelRequire("7JoAD");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $7JoAD.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $7JoAD.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $7JoAD.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $7JoAD.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $7JoAD.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});




parcelRegister("3HwlS", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4", () => $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $ifO6r = parcelRequire("ifO6r");

var $9qXgw = parcelRequire("9qXgw");
const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, $4R6GH.fg)('jira_nav4') && ((0, $ifO6r.getWillShowNav4ForDogfooding)() || (0, $9qXgw.getWillShowNav4ForEap)() || (0, $c0dQj.isMobileAndInMVPExperiment)());

});
parcelRegister("c0dQj", function(module, exports) {

$parcel$export(module.exports, "isMobileAndInMVPExperiment", () => $7275e40842570ace$export$f29d7974ab92d702);
$parcel$export(module.exports, "MobileWebExperimentExposure", () => $7275e40842570ace$export$b93f740e619fc842);

var $bCdIp = parcelRequire("bCdIp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
    const [mobileWebConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp');
    return(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_mobile_web_mvp_feature_gate') && (0, $bCdIp.default)() && mobileWebConfig.get('isEnabled', false));
};
const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
    const [, manuallyFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_mobile_web_mvp');
    if ((0, $bCdIp.default)()) manuallyFireExposure();
    return null;
};

});
parcelRegister("6s1PB", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $d0d3e1363a65fa96$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $d0d3e1363a65fa96$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $d0d3e1363a65fa96$export$677f9fa2e1ae6fec);

var $gywce = parcelRequire("gywce");

var $40Gox = parcelRequire("40Gox");

var $5aN3N = parcelRequire("5aN3N");
function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $gywce.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5aN3N.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    return $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
class $d0d3e1363a65fa96$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5aN3N.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $d0d3e1363a65fa96$var$cache = new Map();
function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
    if (instance == null) {
        // Handle vendorless scripts use of gates
        (0, $40Gox.UNSAFE_initIfNeeded)();
        const config = (0, $gywce.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $gywce.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
    }
    return instance;
}

});


parcelRegister("ifO6r", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForDogfooding", () => $b6db23b0cddd1764$export$9ca0d92d31816d4f);

var $4R6GH = parcelRequire("4R6GH");

var $1MhR0 = parcelRequire("1MhR0");

var $8MTso = parcelRequire("8MTso");
const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
    if (!(0, $4R6GH.fg)('jira_nav4_dogfooding')) return false;
    const phase1 = (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1');
    const phase2 = (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2');
    const phase3 = !(phase1 || phase2);
    return phase3 || phase2 && !(0, $1MhR0.getIsNav4UserOptOut)() || phase1 && !(0, $1MhR0.getIsNav4UserOptOut)() && !(0, $8MTso.getIsRouteExcludedForDogfoodingPhase1)();
};

});
parcelRegister("1MhR0", function(module, exports) {

$parcel$export(module.exports, "getMetaBoolean", () => $039259847fa24143$export$9683360b0ae70629);
$parcel$export(module.exports, "getIsNav4UserOptOut", () => $039259847fa24143$export$3fbfe0fdf05e0f9f);

var $gJBT6 = parcelRequire("gJBT6");

var $j8DrX = parcelRequire("j8DrX");

var $7qZOo = parcelRequire("7qZOo");
const $039259847fa24143$export$9683360b0ae70629 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((name)=>(0, $j8DrX.default)(`ajs-${name}`) === 'true');
const $039259847fa24143$export$7d046765d192af80 = ()=>$039259847fa24143$export$9683360b0ae70629((0, $7qZOo.IS_ADMIN));
const $039259847fa24143$export$ba89637357392be6 = ()=>$039259847fa24143$export$9683360b0ae70629((0, $7qZOo.IS_NAV4_USER_OPT_IN));
const $039259847fa24143$export$3fbfe0fdf05e0f9f = ()=>$039259847fa24143$export$9683360b0ae70629((0, $7qZOo.IS_NAV4_USER_OPT_OUT));

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "IS_ADMIN", () => $92928f70e02753a5$export$4261d5d429e288ec);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", () => $92928f70e02753a5$export$153ded4d539b820d);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", () => $92928f70e02753a5$export$9c962957701a4fe8);
$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$4261d5d429e288ec = 'is-admin';
const $92928f70e02753a5$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $92928f70e02753a5$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};
const $92928f70e02753a5$export$9cd4b8dc5f7153b8 = {
    NONE: 'none',
    DOGFOODING: 'dogfooding',
    EAP: 'eap',
    BETA: 'beta',
    GA: 'ga'
};

});


parcelRegister("8MTso", function(module, exports) {

$parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", () => $5866baf2a5010361$export$f0abfe25b95778e3);

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX = new RegExp('^/jira/polaris/roadmaps(/)*$');
const $5866baf2a5010361$export$f0abfe25b95778e3 = ()=>{
    if (false) return false;
    const pathname = $5866baf2a5010361$var$getPathname();
    if (!(0, $co1wz.ff)('polaris.sidebar-v4') && (pathname.includes('/jira/polaris/') || pathname.includes('/secure/JiraProductDiscoveryEmbedded') || pathname.includes('/jira/discovery/'))) return true;
    if (pathname.includes('/jira/polaris/roadmaps')) {
        const isJpdCollectionsOverview = $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX.test(pathname);
        if (isJpdCollectionsOverview && (0, $4R6GH.fg)('jpd-sidebar-v4-for-roadmaps-overview')) // do not exclude collection overview route
        return false;
        // if main gate for roadmaps is disabled then exclude route
        if (!(0, $4R6GH.fg)('jpd-sidebar-v4-for-roadmaps')) return true;
    }
    return false;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $5866baf2a5010361$var$getPathname = ()=>window.location.pathname;

});


parcelRegister("9qXgw", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForEap", () => $77cd593041adc2b6$export$393f53ae320de085);

var $4R6GH = parcelRequire("4R6GH");

var $1MhR0 = parcelRequire("1MhR0");
const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, $4R6GH.fg)('jira_nav4_eap') && !(0, $1MhR0.getIsNav4UserOptOut)();

});


parcelRegister("6jY6G", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $dda4cada2257eb1d$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $dda4cada2257eb1d$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $dda4cada2257eb1d$export$1e5fb68306bd0b92);

var $dIdda = parcelRequire("dIdda");

var $cfDZ3 = parcelRequire("cfDZ3");
const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $dIdda.createRouterSelector)((state)=>state.route);
const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $dIdda.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $dIdda.useRouter)();
    return (0, $cfDZ3.getPreviousRouterState)();
};

});

parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("324W5", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $0c2698427b7aacc1$export$61dad767cf446185);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $dIdda = parcelRequire("dIdda");

var $geWXd = parcelRequire("geWXd");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
/**
 * Reusable hook, to pass *custom context* to the React router resource
 */ const $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            routerContext: (0, $dIdda.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const resourceResponse = (0, $dIdda.useResource)(resource, useResourceArgCustomContext);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $geWXd.useInitFetchResource)(resourceResponse, !customRouterContext);
    return resourceResponse;
};
/**
 * Allows for router resources to be to be fetched on a route that doesn't include the required router params. A custom router context can be passed to the resource to fetch the data.
 * The resource will be automatically fetched via `refresh()` when the component mounts, unless disabled via `options.autoFetch = false`. If you don't need this behaviour, use `useResource` instead.
 */ function $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $dIdda.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $dIdda.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $geWXd.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}
const $0c2698427b7aacc1$export$61dad767cf446185 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('fix_useinitresource_data_bug'), $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions, $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld);

});
parcelRegister("e5wyW", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $12199147dc0ae1fa$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $12199147dc0ae1fa$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("geWXd", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $b632b0c18495344b$export$5b98692301d8680);
$parcel$export(module.exports, "usePrefetchableResource", () => $b632b0c18495344b$export$99f17ace416cfe75);

var $5uXOq = parcelRequire("5uXOq");
const $b632b0c18495344b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $5uXOq.useEffect)(()=>{
        if (skipInitFetch) return;
        if (!data && !loading && !error && refresh) refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};
function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("dxCvy", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $fb0493b5a465ed74$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $fb0493b5a465ed74$export$d75816e37af81473);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");


const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("2VAeN"));
const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $dIdda.createResource)({
    type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
    maxAge: 1800000
});
const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;

});
parcelRegister("1nb22", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyId", () => $061afadfbcc74f44$export$1f7213d0f9054f06);
const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
    const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("2VAeN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7UkBG").then(()=>parcelRequire('fsLhR'));

});



parcelRegister("c1mlA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $4c8f71f257051803$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $4c8f71f257051803$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $4c8f71f257051803$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $4c8f71f257051803$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $4c8f71f257051803$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $4c8f71f257051803$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $4c8f71f257051803$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $4c8f71f257051803$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $4c8f71f257051803$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $4c8f71f257051803$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $4c8f71f257051803$export$46efc2c8d8106cff);
$parcel$export(module.exports, "FEATURE_ENABLED_STATUS", () => $4c8f71f257051803$export$a1046f102eae498);
const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'insightsConfig',
    'dateFields'
];
const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    filter: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    columns: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    swimlanes: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    quickFilters: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    cardColors: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    cardLayout: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    estimation: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
        jsmAllowed: false,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false
    },
    time: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
        jsmAllowed: false,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    timelineConfig: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
        jsmAllowed: false,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true
    },
    insightsConfig: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.insightsConfig,
        jsmAllowed: false,
        userLocatedBoardAllowed: false,
        kanbanAllowed: false
    },
    dateFields: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    }
};
const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $4c8f71f257051803$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $4c8f71f257051803$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';
const $4c8f71f257051803$export$450e5ddc9f1ff901 = 'DISABLED';

});

parcelRegister("5PD5h", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", () => $a816ddf70513a004$export$128d5d79815580ca);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("gMULe")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
});
const $a816ddf70513a004$export$128d5d79815580ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-software-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav, null));

});
parcelRegister("gMULe", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("djQ7G")
]).then(()=>parcelRequire('1f09g'));

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';



parcelRegister("7XYc4", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $d8879edec083173e$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $d8879edec083173e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("g7crU", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $aa937e51388f56fd$export$d397eccea5f37b0a);

var $7JoAD = parcelRequire("7JoAD");

var $5e5zm = parcelRequire("5e5zm");
const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("jHXUj", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $89937a782c6cb988$export$b9f3a70460995c32);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $c34Wf = parcelRequire("c34Wf");


var $90yGq = parcelRequire("90yGq");

var $dIdda = parcelRequire("dIdda");

var $5e5zm = parcelRequire("5e5zm");

var $gPQRI = parcelRequire("gPQRI");

var $hsmeR = parcelRequire("hsmeR");

var $2TwSO = parcelRequire("2TwSO");
/**
 * Synchronizes the layout's local state with the remote server to ensure consistency across sessions.
 * It monitors changes in the layout, such as sidebar adjustments, and updates the server accordingly.
 * Critical errors encountered during the update process are captured and reported to facilitate
 * troubleshooting and continuous improvement. This component plays a pivotal role in maintaining
 * a seamless user experience by ensuring that layout preferences are consistently reflected.
 */ const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $iqLcb.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $hsmeR.useRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $c34Wf.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    (0, $5uXOq.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData
    ]);
    return null;
};
/**
 * The old layout remote state updater used a hook to subscribe to the DS left sidebar state,
 * and would then update the `react-sweet-state` store as well as the remote state.
 *
 * Now the side nav integration is wired to update the `react-sweet-state` store directly,
 * and this will just update the remote state. This is because the new side nav does not expose its
 * state through a hook. We can change this in the future if necessary.
 *
 * In the future, we could also consider moving the remote update logic into the `react-sweet-state`
 * action which updates the left sidebar, removing the need for a subscriber like this.
 */ const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const leftSidebar = (0, $gPQRI.useLeftSidebarState)();
    const rightSidebar = (0, $hsmeR.useRightSidebarState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    (0, $5uXOq.useEffect)(()=>{
        if (!accountId) return;
        (0, $2TwSO.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar
    ]);
    return null;
};
const $89937a782c6cb988$export$b9f3a70460995c32 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);

});
parcelRegister("89SaW", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $646571db30c23ce6$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $646571db30c23ce6$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $646571db30c23ce6$export$b3126db2ef6e34ed);

var $gHS8W = parcelRequire("gHS8W");

var $jJZqs = parcelRequire("jJZqs");
const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), {
        ...(0, $gHS8W.default),
        method: 'PUT',
        body: data
    });
const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), (0, $gHS8W.default)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $jJZqs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);

});
parcelRegister("gHS8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c6318209de3901$export$2e2bcd8739ae039);
const $33c6318209de3901$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
var $33c6318209de3901$export$2e2bcd8739ae039 = $33c6318209de3901$var$defaultOptions;

});


parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7rDGI = parcelRequire("7rDGI");
var $1uoeA = parcelRequire("1uoeA");
var $9n3gP = parcelRequire("9n3gP");
var $5MRMB = parcelRequire("5MRMB");
var $kvY7a = parcelRequire("kvY7a");
var $a23yy = parcelRequire("a23yy");
var $9z04s = parcelRequire("9z04s");
var $gcs9G = parcelRequire("gcs9G");
var $8BmEd = parcelRequire("8BmEd");
var $XCRgf = parcelRequire("XCRgf");
var $gjLh9 = parcelRequire("gjLh9");
var $e2lHC = parcelRequire("e2lHC");
var $ksgid = parcelRequire("ksgid");

var $3HwlS = parcelRequire("3HwlS");

var $e7PeG = parcelRequire("e7PeG");
var $dWeCG = parcelRequire("dWeCG");
var $gVU1U = parcelRequire("gVU1U");
var $3RFMY = parcelRequire("3RFMY");
var $3APfc = parcelRequire("3APfc");
var $T0nre = parcelRequire("T0nre");
var $bB8zd = parcelRequire("bB8zd");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3APfc.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcs9G.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWeCG.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rDGI.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bB8zd.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjLh9.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MRMB.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $T0nre.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a23yy.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $T0nre.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvY7a.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVU1U.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9z04s.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9n3gP.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7PeG.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XCRgf.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RFMY.Panel), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BmEd.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : (0, $e2lHC.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : (0, $ksgid.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : (0, $ksgid.usePageLayoutResize)();
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $1uoeA.BANNER_HEIGHT);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $1uoeA.LEFT_PANEL_WIDTH);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $1uoeA.LEFT_SIDEBAR_WIDTH);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $1uoeA.RIGHT_PANEL_WIDTH);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $1uoeA.RIGHT_SIDEBAR_WIDTH);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $1uoeA.TOP_NAVIGATION_HEIGHT);

});
parcelRegister("7rDGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff816f50723fe1f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");

var $8lyEZ = parcelRequire("8lyEZ");
const $4ff816f50723fe1f$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $1uoeA.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1uoeA.BANNER)
});
const $4ff816f50723fe1f$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $1uoeA.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $1uoeA.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $4ff816f50723fe1f$var$Banner = (props)=>{
    const { children: children, height: height = (0, $1uoeA.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $4ff816f50723fe1f$var$bannerStyles,
                isFixed && $4ff816f50723fe1f$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
            variableName: (0, $1uoeA.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $4ff816f50723fe1f$export$2e2bcd8739ae039 = $4ff816f50723fe1f$var$Banner;

});
parcelRegister("1uoeA", function(module, exports) {

$parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$cbfb0f5b2869b17b);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$c103b605cd368aed);
$parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$fa34f417972d6341);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $cbddd70aa2fa524a$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_BANNER_HEIGHT", () => $cbddd70aa2fa524a$export$bcd94a6a792e7f96);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $cbddd70aa2fa524a$export$b6744d31294864fd);
$parcel$export(module.exports, "DIMENSIONS", () => $cbddd70aa2fa524a$export$d67ac355184b7646);
$parcel$export(module.exports, "LEFT_PANEL", () => $cbddd70aa2fa524a$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $cbddd70aa2fa524a$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $cbddd70aa2fa524a$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $cbddd70aa2fa524a$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $cbddd70aa2fa524a$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", () => $cbddd70aa2fa524a$export$be83e7118304b28e);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $cbddd70aa2fa524a$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$539e68c09584883a);
$parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$b92df8810d2fcd01);
$parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$c3e41153b9288bcf);
$parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$c4d6152f86ea28f6);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $cbddd70aa2fa524a$export$991d5285ad765a3d);
$parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", () => $cbddd70aa2fa524a$export$6949d4f32b161684);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $cbddd70aa2fa524a$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $cbddd70aa2fa524a$export$3749e1104328fde4);
$parcel$export(module.exports, "FLYOUT_DELAY", () => $cbddd70aa2fa524a$export$1074d925b0b82be5);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $cbddd70aa2fa524a$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $cbddd70aa2fa524a$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $cbddd70aa2fa524a$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", () => $cbddd70aa2fa524a$export$70c702a8c5895f03);
$parcel$export(module.exports, "GRAB_AREA_SELECTOR", () => $cbddd70aa2fa524a$export$48a43f91e4becf4e);
$parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", () => $cbddd70aa2fa524a$export$dac2fb31a9f6844d);
$parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", () => $cbddd70aa2fa524a$export$9ecd22db14e6c70e);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $cbddd70aa2fa524a$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $cbddd70aa2fa524a$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $cbddd70aa2fa524a$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $cbddd70aa2fa524a$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $cbddd70aa2fa524a$export$b44ab66843c05a69);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $cbddd70aa2fa524a$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $cbddd70aa2fa524a$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $cbddd70aa2fa524a$export$d2fa14f05b61e66);
// dimension vars
const $cbddd70aa2fa524a$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $cbddd70aa2fa524a$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $cbddd70aa2fa524a$export$c103b605cd368aed = 'rightSidebarWidth';
const $cbddd70aa2fa524a$export$fa34f417972d6341 = 'rightPanelWidth';
const $cbddd70aa2fa524a$export$3a6a779d9181047c = 'topNavigationHeight';
const $cbddd70aa2fa524a$export$bcd94a6a792e7f96 = 'bannerHeight';
const $cbddd70aa2fa524a$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $cbddd70aa2fa524a$export$d67ac355184b7646 = [
    $cbddd70aa2fa524a$export$cbfb0f5b2869b17b,
    $cbddd70aa2fa524a$export$fa34f417972d6341,
    $cbddd70aa2fa524a$export$bcd94a6a792e7f96,
    $cbddd70aa2fa524a$export$3a6a779d9181047c,
    $cbddd70aa2fa524a$export$a30f2e00489a8957,
    $cbddd70aa2fa524a$export$c103b605cd368aed
];
const $cbddd70aa2fa524a$export$344062f7cfc9528e = 'left-panel';
const $cbddd70aa2fa524a$export$c7139cc2d6110b5f = 'right-panel';
const $cbddd70aa2fa524a$export$238d30785c4bca84 = 'banner';
const $cbddd70aa2fa524a$export$bec6dca2e63de4ae = 'top-navigation';
const $cbddd70aa2fa524a$export$d1213e82613ff4df = 'content';
const $cbddd70aa2fa524a$export$2d8180803f50fc5 = 'main';
const $cbddd70aa2fa524a$export$50ea883ba6f28ff5 = 'left-sidebar';
const $cbddd70aa2fa524a$export$7bf43119a6b49ddb = 'right-sidebar';
const $cbddd70aa2fa524a$export$be83e7118304b28e = 56;
const $cbddd70aa2fa524a$export$4a98ee0bd1ae362 = 56;
const $cbddd70aa2fa524a$export$539e68c09584883a = 240;
const $cbddd70aa2fa524a$export$b92df8810d2fcd01 = 280;
const $cbddd70aa2fa524a$export$c3e41153b9288bcf = 368;
const $cbddd70aa2fa524a$export$c4d6152f86ea28f6 = 368;
const $cbddd70aa2fa524a$export$46acf8758e9e2636 = 20;
const $cbddd70aa2fa524a$export$70740f5ad8360a78 = 16;
const $cbddd70aa2fa524a$export$f562af313cda0684 = 80;
const $cbddd70aa2fa524a$export$991d5285ad765a3d = 240;
const $cbddd70aa2fa524a$export$6949d4f32b161684 = 200;
const $cbddd70aa2fa524a$export$d6e7e8af042815bb = 350;
const $cbddd70aa2fa524a$export$3749e1104328fde4 = 300;
const $cbddd70aa2fa524a$export$1074d925b0b82be5 = 200;
const $cbddd70aa2fa524a$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
const $cbddd70aa2fa524a$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $cbddd70aa2fa524a$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $cbddd70aa2fa524a$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $cbddd70aa2fa524a$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
const $cbddd70aa2fa524a$export$70c702a8c5895f03 = 'data-grab-area-line';
const $cbddd70aa2fa524a$export$48a43f91e4becf4e = 'data-grab-area';
const $cbddd70aa2fa524a$export$dac2fb31a9f6844d = 'data-resize-button';
const $cbddd70aa2fa524a$export$9ecd22db14e6c70e = 'data-resize-control';
const $cbddd70aa2fa524a$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $cbddd70aa2fa524a$export$206a08f7f8beb554 = 'Skip to:';
const $cbddd70aa2fa524a$export$659ee746b31b360d = 'data-layout-container';
const $cbddd70aa2fa524a$export$f963aecf2d4465bd = `var(--${$cbddd70aa2fa524a$export$cbfb0f5b2869b17b}, 0px)`;
const $cbddd70aa2fa524a$export$750459958906793 = `var(--${$cbddd70aa2fa524a$export$fa34f417972d6341}, 0px)`;
const $cbddd70aa2fa524a$export$f897e1ed9f8ed251 = `var(--${$cbddd70aa2fa524a$export$a30f2e00489a8957}, 0px)`;
const $cbddd70aa2fa524a$export$b44ab66843c05a69 = `var(--${$cbddd70aa2fa524a$export$c103b605cd368aed}, 0px)`;
const $cbddd70aa2fa524a$export$aeff86a16f13529 = `var(--${$cbddd70aa2fa524a$export$3a6a779d9181047c}, 0px)`;
const $cbddd70aa2fa524a$export$ed7cc0d417ee89e = `var(--${$cbddd70aa2fa524a$export$bcd94a6a792e7f96}, 0px)`;
const $cbddd70aa2fa524a$export$d2fa14f05b61e66 = `var(--${$cbddd70aa2fa524a$export$b6744d31294864fd}, ${$cbddd70aa2fa524a$export$991d5285ad765a3d}px)`;

});

parcelRegister("cHS4c", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $ee68e9455f055694$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $ee68e9455f055694$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $ee68e9455f055694$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $ee68e9455f055694$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $ee68e9455f055694$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $ee68e9455f055694$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $ee68e9455f055694$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $ee68e9455f055694$export$218ece2c32b7db0e);

var $1uoeA = parcelRequire("1uoeA");

var $6nki3 = parcelRequire("6nki3");
const $ee68e9455f055694$export$576dabd404a1ed99 = (0, $1uoeA.DIMENSIONS).reduce((acc, currentValue)=>({
        ...acc,
        [currentValue]: 0
    }), {});
const $ee68e9455f055694$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $6nki3.default)().getItem((0, $1uoeA.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $6nki3.default)().setItem((0, $1uoeA.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $ee68e9455f055694$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $6nki3.default)().getItem((0, $1uoeA.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $ee68e9455f055694$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $6nki3.default)().getItem((0, $1uoeA.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $6nki3.default)().setItem((0, $1uoeA.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $ee68e9455f055694$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $ee68e9455f055694$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $ee68e9455f055694$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $1uoeA.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $ee68e9455f055694$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $ee68e9455f055694$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $1uoeA.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $ee68e9455f055694$export$218ece2c32b7db0e = (slotName)=>`[${0, $1uoeA.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("6nki3", function(module, exports) {

$parcel$export(module.exports, "default", () => $73d39fd404fbca6c$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $73d39fd404fbca6c$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $73d39fd404fbca6c$var$safeLocalStorage = ()=>{
    if ($73d39fd404fbca6c$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $73d39fd404fbca6c$export$2e2bcd8739ae039 = $73d39fd404fbca6c$var$safeLocalStorage;

});


parcelRegister("eM5Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e9a758217ef8bf$export$2e2bcd8739ae039);

var $cHS4c = parcelRequire("cHS4c");
const $a1e9a758217ef8bf$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $cHS4c.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $cHS4c.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $a1e9a758217ef8bf$export$2e2bcd8739ae039 = $a1e9a758217ef8bf$var$publishGridState;

});

parcelRegister("2y2Hb", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $97a268c19953b940$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $97a268c19953b940$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $97a268c19953b940$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $97a268c19953b940$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $13czV.default),
    unregisterSkipLink: (0, $13czV.default)
});
const $97a268c19953b940$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($97a268c19953b940$export$4c5cc3b14c7678a);
const $97a268c19953b940$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $97a268c19953b940$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("dfynK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eaedf57f1cb003b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $0eaedf57f1cb003b$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $0eaedf57f1cb003b$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $0eaedf57f1cb003b$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($0eaedf57f1cb003b$var$sidebarFocusStyles) : css($0eaedf57f1cb003b$var$focusStyles)
        }));
};
var $0eaedf57f1cb003b$export$2e2bcd8739ae039 = $0eaedf57f1cb003b$var$SlotFocusRing;

});
var $dbda9f692ace54dd$exports = {};

$parcel$export($dbda9f692ace54dd$exports, "R50", () => $dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", () => $dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", () => $dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", () => $dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", () => $dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", () => $dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", () => $dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", () => $dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", () => $dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", () => $dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", () => $dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", () => $dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", () => $dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", () => $dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", () => $dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", () => $dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", () => $dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", () => $dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", () => $dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", () => $dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", () => $dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", () => $dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", () => $dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", () => $dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", () => $dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", () => $dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", () => $dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", () => $dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", () => $dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", () => $dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", () => $dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", () => $dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", () => $dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", () => $dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", () => $dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", () => $dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", () => $dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", () => $dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", () => $dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", () => $dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", () => $dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", () => $dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", () => $dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", () => $dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", () => $dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", () => $dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", () => $dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", () => $dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", () => $dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", () => $dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", () => $dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", () => $dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", () => $dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", () => $dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", () => $dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", () => $dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", () => $dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", () => $dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", () => $dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", () => $dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", () => $dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", () => $dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", () => $dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", () => $dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", () => $dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", () => $dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", () => $dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", () => $dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", () => $dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", () => $dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", () => $dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", () => $dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", () => $dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", () => $dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", () => $dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", () => $dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", () => $dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", () => $dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", () => $dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", () => $dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", () => $dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", () => $dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", () => $dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", () => $dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", () => $dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", () => $dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", () => $dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", () => $dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", () => $dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", () => $dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", () => $dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", () => $dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", () => $dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", () => $dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", () => $dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", () => $dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", () => $dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", () => $dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", () => $dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", () => $dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", () => $dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", () => $dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", () => $dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", () => $dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", () => $dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", () => $dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", () => $dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", () => $dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", () => $dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", () => $dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", () => $dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", () => $dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", () => $dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", () => $dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", () => $dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", () => $dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", () => $dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", () => $dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", () => $dbda9f692ace54dd$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';


parcelRegister("8lyEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $269828e9a0e17046$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eYa7e = parcelRequire("eYa7e");
/**
 * Hoists slot dimension styles to the root element.
 */ const $269828e9a0e17046$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $eYa7e.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", null, style));
};
var $269828e9a0e17046$export$2e2bcd8739ae039 = $269828e9a0e17046$var$SlotDimensions;

});


parcelRegister("9n3gP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b2bad992fad0f30$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");
const $3b2bad992fad0f30$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1uoeA.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $3b2bad992fad0f30$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $3b2bad992fad0f30$var$contentStyles
    }, children);
};
var $3b2bad992fad0f30$export$2e2bcd8739ae039 = $3b2bad992fad0f30$var$Content;

});

parcelRegister("5MRMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ffa1ca5500bb5c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");

var $8lyEZ = parcelRequire("8lyEZ");
const $d8ffa1ca5500bb5c$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1uoeA.LEFT_PANEL)
});
const $d8ffa1ca5500bb5c$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.LEFT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d8ffa1ca5500bb5c$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $1uoeA.DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_LEFT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $d8ffa1ca5500bb5c$var$leftPanelStyles,
                isFixed && $d8ffa1ca5500bb5c$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
            variableName: (0, $1uoeA.VAR_LEFT_PANEL_WIDTH),
            value: leftPanelWidth
        }), children));
};
var $d8ffa1ca5500bb5c$export$2e2bcd8739ae039 = $d8ffa1ca5500bb5c$var$LeftPanel;

});

parcelRegister("kvY7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eddfa136e83718f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lOST4 = parcelRequire("lOST4");


var $dP7RZ = parcelRequire("dP7RZ");


var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $ksgid = parcelRequire("ksgid");
var $2y2Hb = parcelRequire("2y2Hb");

var $87g67 = parcelRequire("87g67");

var $hhP7z = parcelRequire("hhP7z");

var $fORNg = parcelRequire("fORNg");

var $5B84Y = parcelRequire("5B84Y");

var $8lyEZ = parcelRequire("8lyEZ");
const $3eddfa136e83718f$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $dbda9f692ace54dd$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $3eddfa136e83718f$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $3eddfa136e83718f$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $ksgid.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $cHS4c.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $cHS4c.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $cHS4c.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT], (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT], (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $cHS4c.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $1uoeA.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $1uoeA.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $1uoeA.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $1uoeA.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $1uoeA.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $1uoeA.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $dP7RZ.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $dP7RZ.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $lOST4.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $3eddfa136e83718f$var$hiddenBackdropStyles,
            isFlyoutOpen && $3eddfa136e83718f$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fORNg.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
        variableName: (0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH),
        value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $1uoeA.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhP7z.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5B84Y.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $87g67.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $3eddfa136e83718f$export$2e2bcd8739ae039 = $3eddfa136e83718f$var$LeftSidebar;

});
const $8a33cd8536c3f898$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $8a33cd8536c3f898$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $8a33cd8536c3f898$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("ksgid", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $9c2bdb040644b9a1$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $9c2bdb040644b9a1$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $9c2bdb040644b9a1$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $9c2bdb040644b9a1$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true
};
const $9c2bdb040644b9a1$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $13czV.default),
    collapseLeftSidebar: (0, $13czV.default),
    leftSidebarState: $9c2bdb040644b9a1$var$leftSidebarState,
    setLeftSidebarState: (0, $13czV.default),
    toggleLeftSidebar: (0, $13czV.default)
});
const $9c2bdb040644b9a1$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($9c2bdb040644b9a1$export$aa5a712eea4c2ae8);
    return context;
};
const $9c2bdb040644b9a1$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($9c2bdb040644b9a1$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("87g67", function(module, exports) {

$parcel$export(module.exports, "default", () => $235a3ea41040e673$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $dP7RZ = parcelRequire("dP7RZ");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $ksgid = parcelRequire("ksgid");

var $dcwF0 = parcelRequire("dcwF0");

var $2gH7K = parcelRequire("2gH7K");

var $8rujO = parcelRequire("8rujO");
function $235a3ea41040e673$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $235a3ea41040e673$var$cssSelector = {
    [(0, $1uoeA.RESIZE_CONTROL_SELECTOR)]: true
};
const $235a3ea41040e673$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $235a3ea41040e673$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $235a3ea41040e673$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $235a3ea41040e673$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $ksgid.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $dP7RZ.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH] - (0, $cHS4c.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $1uoeA.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $1uoeA.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $cHS4c.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $1uoeA.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $1uoeA.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $1uoeA.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $cHS4c.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $cHS4c.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $cHS4c.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$235a3ea41040e673$var$cssSelector,
        css: [
            $235a3ea41040e673$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $235a3ea41040e673$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8rujO.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dcwF0.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $2gH7K.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $235a3ea41040e673$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$235a3ea41040e673$export$2e2bcd8739ae039 = $235a3ea41040e673$var$ResizeControl;

});
parcelRegister("dcwF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $90796be9747e9dee$export$2e2bcd8739ae039);
/* eslint-disable react/react-in-jsx-scope */ /**
                                               * @jsxRuntime classic
                                               * @jsx jsx
                                               */ 
var $f8Sb3 = parcelRequire("f8Sb3");


var $1uoeA = parcelRequire("1uoeA");
function $90796be9747e9dee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $90796be9747e9dee$var$varLineColor = '--ds-line';
const $90796be9747e9dee$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$90796be9747e9dee$var$varLineColor]: `var(--ds-border-selected, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`
    }
});
const $90796be9747e9dee$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $90796be9747e9dee$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $90796be9747e9dee$var$grabAreaLineSelector = {
    [(0, $1uoeA.GRAB_AREA_LINE_SELECTOR)]: true
};
const $90796be9747e9dee$var$grabAreaSelector = {
    [(0, $1uoeA.GRAB_AREA_SELECTOR)]: true
};
const $90796be9747e9dee$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$90796be9747e9dee$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $90796be9747e9dee$var$grabAreaStyles,
            isLeftSidebarCollapsed && $90796be9747e9dee$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $90796be9747e9dee$var$lineStyles,
        ...$90796be9747e9dee$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$90796be9747e9dee$export$2e2bcd8739ae039 = $90796be9747e9dee$var$GrabArea;

});

parcelRegister("2gH7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ec5de7edda582b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $kKi7Q = parcelRequire("kKi7Q");


var $3n5IF = parcelRequire("3n5IF");

var $eYa7e = parcelRequire("eYa7e");


var $1uoeA = parcelRequire("1uoeA");
function $c6ec5de7edda582b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c6ec5de7edda582b$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $c6ec5de7edda582b$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $c6ec5de7edda582b$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- TODO: https://product-fabric.atlassian.net/browse/DSP-3392; this boxShadow needs further investigation, along with the hover and active background colors.
    boxShadow: `0 0 0 1px ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $3n5IF.smallDurationMs)}ms linear,
    color ${(0, $3n5IF.smallDurationMs)}ms linear,
    opacity ${(0, $3n5IF.mediumDurationMs)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $dbda9f692ace54dd$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $c6ec5de7edda582b$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $c6ec5de7edda582b$var$preventDefault = (event)=>event.preventDefault();
const $c6ec5de7edda582b$var$cssSelector = {
    [(0, $1uoeA.RESIZE_BUTTON_SELECTOR)]: true
};
const $c6ec5de7edda582b$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$c6ec5de7edda582b$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $c6ec5de7edda582b$var$resizeIconButtonStyles,
            $c6ec5de7edda582b$var$mobileStyles,
            !isLeftSidebarCollapsed && $c6ec5de7edda582b$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $c6ec5de7edda582b$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKi7Q))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $c6ec5de7edda582b$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c6ec5de7edda582b$export$2e2bcd8739ae039 = $c6ec5de7edda582b$var$ResizeButton;

});

parcelRegister("8rujO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c14d4200ee8bb09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $1UCHs = parcelRequire("1UCHs");
const $9c14d4200ee8bb09$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $9c14d4200ee8bb09$var$direction = 'to left';
const $9c14d4200ee8bb09$var$transitionDuration = '0.22s';
const $9c14d4200ee8bb09$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$9c14d4200ee8bb09$var$direction}, ${$9c14d4200ee8bb09$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $9c14d4200ee8bb09$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)
});
const $9c14d4200ee8bb09$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$9c14d4200ee8bb09$var$direction}, ${$9c14d4200ee8bb09$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $9c14d4200ee8bb09$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $1UCHs.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $9c14d4200ee8bb09$var$shadowStyles,
            isDragging && $9c14d4200ee8bb09$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9c14d4200ee8bb09$export$2e2bcd8739ae039 = $9c14d4200ee8bb09$var$Shadow;

});
parcelRegister("1UCHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f87afced7909c44$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1uoeA = parcelRequire("1uoeA");
const $4f87afced7909c44$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $1uoeA.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $4f87afced7909c44$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($4f87afced7909c44$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($4f87afced7909c44$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $1uoeA.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $4f87afced7909c44$export$2e2bcd8739ae039 = $4f87afced7909c44$var$useIsSidebarDragging;

});



parcelRegister("hhP7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $dada436806981013$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $iX4mi = parcelRequire("iX4mi");

var $eYa7e = parcelRequire("eYa7e");

var $1uoeA = parcelRequire("1uoeA");

var $1UCHs = parcelRequire("1UCHs");
function $dada436806981013$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $dada436806981013$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $iX4mi.prefersReducedMotion)());
const $dada436806981013$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1uoeA.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $1uoeA.BANNER_HEIGHT)} + ${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $1uoeA.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`
    }
});
const $dada436806981013$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $1uoeA.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $1uoeA.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $dada436806981013$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $1uoeA.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $1uoeA.BANNER_HEIGHT)} + ${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $1uoeA.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`
});
const $dada436806981013$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $dada436806981013$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $dada436806981013$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $dada436806981013$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $1UCHs.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $dada436806981013$var$mobileStyles,
            isFlyoutOpen && $dada436806981013$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $dada436806981013$var$staticInnerStyles,
            isFixed && $dada436806981013$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $dada436806981013$var$fixedInnerFlyoutStyles,
            isDragging && $dada436806981013$var$draggingStyles,
            $dada436806981013$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dada436806981013$export$2e2bcd8739ae039 = $dada436806981013$var$LeftSidebarInner;

});

parcelRegister("fORNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f23d75806a1396$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iX4mi = parcelRequire("iX4mi");

var $eYa7e = parcelRequire("eYa7e");

var $1uoeA = parcelRequire("1uoeA");

var $1UCHs = parcelRequire("1UCHs");

var $cHS4c = parcelRequire("cHS4c");

var $ksgid = parcelRequire("ksgid");

var $dfynK = parcelRequire("dfynK");
function $59f23d75806a1396$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $59f23d75806a1396$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $iX4mi.prefersReducedMotion)());
const $59f23d75806a1396$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $1uoeA.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $1uoeA.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $59f23d75806a1396$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $59f23d75806a1396$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $59f23d75806a1396$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $59f23d75806a1396$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1uoeA.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $59f23d75806a1396$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $59f23d75806a1396$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $59f23d75806a1396$var$selector = (0, $cHS4c.getPageLayoutSlotSelector)('left-sidebar');
const $59f23d75806a1396$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $1UCHs.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $ksgid.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $59f23d75806a1396$var$mobileStyles,
                isFlyoutOpen && $59f23d75806a1396$var$mobileFlyoutStyles,
                // generic styles
                $59f23d75806a1396$var$outerStyles,
                isFixed && $59f23d75806a1396$var$fixedStyles,
                isFlyoutOpen && $59f23d75806a1396$var$flyoutStyles,
                isFlyoutOpen && isFixed && $59f23d75806a1396$var$flyoutFixedStyles,
                isDragging && $59f23d75806a1396$var$draggingStyles,
                $59f23d75806a1396$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$59f23d75806a1396$var$selector
        }, children));
};
const $59f23d75806a1396$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($59f23d75806a1396$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59f23d75806a1396$export$2e2bcd8739ae039 = $59f23d75806a1396$var$LeftSidebarOuter;

});

parcelRegister("5B84Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a8957bb91ce418$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $iX4mi = parcelRequire("iX4mi");

var $1uoeA = parcelRequire("1uoeA");

var $cwZKv = parcelRequire("cwZKv");
function $c3a8957bb91ce418$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3a8957bb91ce418$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $iX4mi.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $c3a8957bb91ce418$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: `opacity 0ms linear, visibility 0ms linear`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $1uoeA.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $c3a8957bb91ce418$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $c3a8957bb91ce418$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $c3a8957bb91ce418$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $cwZKv.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $c3a8957bb91ce418$var$resizableChildrenWrapperStyles,
            isHidden && $c3a8957bb91ce418$var$hideLeftSidebarContentsStyles,
            $c3a8957bb91ce418$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $c3a8957bb91ce418$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c3a8957bb91ce418$export$2e2bcd8739ae039 = $c3a8957bb91ce418$var$ResizableChildrenWrapper;

});
parcelRegister("cwZKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb9a11d2b4b66b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1uoeA = parcelRequire("1uoeA");
const $0cbb9a11d2b4b66b$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $1uoeA.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $0cbb9a11d2b4b66b$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($0cbb9a11d2b4b66b$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($0cbb9a11d2b4b66b$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $1uoeA.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $0cbb9a11d2b4b66b$export$2e2bcd8739ae039 = $0cbb9a11d2b4b66b$var$useIsSidebarCollapsing;

});



parcelRegister("a23yy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3496ea3c6ecc01f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $hhP7z = parcelRequire("hhP7z");

var $fORNg = parcelRequire("fORNg");

var $8lyEZ = parcelRequire("8lyEZ");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e3496ea3c6ecc01f$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fORNg.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
        variableName: (0, $1uoeA.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhP7z.default), {
        isFixed: isFixed
    }, children));
};
var $e3496ea3c6ecc01f$export$2e2bcd8739ae039 = $e3496ea3c6ecc01f$var$LeftSidebarWithoutResize;

});

parcelRegister("9z04s", function(module, exports) {

$parcel$export(module.exports, "default", () => $12d383c773fc04b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iX4mi = parcelRequire("iX4mi");


var $1uoeA = parcelRequire("1uoeA");

var $1UCHs = parcelRequire("1UCHs");

var $cHS4c = parcelRequire("cHS4c");

var $ksgid = parcelRequire("ksgid");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");
function $12d383c773fc04b6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $12d383c773fc04b6$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $iX4mi.prefersReducedMotion)());
const $12d383c773fc04b6$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $1uoeA.TRANSITION_DURATION)}ms ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)} 0s`
});
const $12d383c773fc04b6$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $12d383c773fc04b6$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $1uoeA.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $1uoeA.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $12d383c773fc04b6$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $1UCHs.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $ksgid.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $12d383c773fc04b6$var$mainStyles,
                isDragging && $12d383c773fc04b6$var$draggingStyles,
                isFlyoutOpen && !isFixed && $12d383c773fc04b6$var$flyoutStyles,
                $12d383c773fc04b6$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('main')
        }, children));
};
var $12d383c773fc04b6$export$2e2bcd8739ae039 = $12d383c773fc04b6$var$Main;

});

parcelRegister("gcs9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $540f93d20008666a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eYa7e = parcelRequire("eYa7e");

var $1uoeA = parcelRequire("1uoeA");

var $2Et9t = parcelRequire("2Et9t");
var $4jWXY = parcelRequire("4jWXY");

var $a8wlq = parcelRequire("a8wlq");
const $540f93d20008666a$var$pageLayoutSelector = {
    [(0, $1uoeA.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $540f93d20008666a$var$gridTemplateAreasMobile = `
${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.BANNER)}"
  ${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.TOP_NAVIGATION)}"
  ${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.CONTENT)}"
 `;
const $540f93d20008666a$var$gridTemplateAreas = `
${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.BANNER)} ${(0, $1uoeA.RIGHT_PANEL)}"
  ${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.TOP_NAVIGATION)} ${(0, $1uoeA.RIGHT_PANEL)}"
${''}
  "${(0, $1uoeA.LEFT_PANEL)} ${(0, $1uoeA.CONTENT)} ${(0, $1uoeA.RIGHT_PANEL)}"
 `;
const $540f93d20008666a$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $540f93d20008666a$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $1uoeA.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $1uoeA.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $1uoeA.BANNER_HEIGHT)} ${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $540f93d20008666a$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $eYa7e.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $540f93d20008666a$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $1uoeA.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $540f93d20008666a$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $1uoeA.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jWXY.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a8wlq.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$540f93d20008666a$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $540f93d20008666a$var$gridStyles,
            $540f93d20008666a$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Et9t.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $540f93d20008666a$export$2e2bcd8739ae039 = $540f93d20008666a$var$PageLayout;

});
parcelRegister("2Et9t", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $f2b70429c3265a9c$export$850bd1bba41f1448);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $13czV = parcelRequire("13czV");

var $iX4mi = parcelRequire("iX4mi");

var $dP7RZ = parcelRequire("dP7RZ");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $ksgid = parcelRequire("ksgid");
const $f2b70429c3265a9c$var$handleDataAttributesAndCb = (callback = (0, $13czV.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $1uoeA.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $f2b70429c3265a9c$var$leftSidebarSelector = (0, $cHS4c.getPageLayoutSlotCSSSelector)('left-sidebar');
const $f2b70429c3265a9c$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $dP7RZ.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $f2b70429c3265a9c$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $1uoeA.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $f2b70429c3265a9c$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($f2b70429c3265a9c$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $iX4mi.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $f2b70429c3265a9c$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $1uoeA.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $1uoeA.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $f2b70429c3265a9c$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($f2b70429c3265a9c$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $iX4mi.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksgid.SidebarResizeContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("4jWXY", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $6e87fbe1e88f2a7d$export$da7be99d6a868f3d);

var $5uXOq = parcelRequire("5uXOq");

var $1uoeA = parcelRequire("1uoeA");

var $2y2Hb = parcelRequire("2y2Hb");
const $6e87fbe1e88f2a7d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $1uoeA.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $6e87fbe1e88f2a7d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($6e87fbe1e88f2a7d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2y2Hb.SkipLinksContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("a8wlq", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $29a340ce270d1a80$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $lxThX = parcelRequire("lxThX");

var $iX4mi = parcelRequire("iX4mi");


var $1uoeA = parcelRequire("1uoeA");

var $2y2Hb = parcelRequire("2y2Hb");
function $29a340ce270d1a80$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $29a340ce270d1a80$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $iX4mi.prefersReducedMotion)());
const $29a340ce270d1a80$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)}, 0 2px 10px ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $dbda9f692ace54dd$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $8a33cd8536c3f898$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $29a340ce270d1a80$var$skipLinkHeadingStyles = {
    name: "16ceglb",
    styles: "font-weight:600"
};
const $29a340ce270d1a80$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $29a340ce270d1a80$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $29a340ce270d1a80$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $29a340ce270d1a80$var$assignIndex(num + 1, arr);
};
const $29a340ce270d1a80$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $2y2Hb.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $29a340ce270d1a80$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $1uoeA.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $1uoeA.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $29a340ce270d1a80$var$skipLinkStyles,
            $29a340ce270d1a80$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $29a340ce270d1a80$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $29a340ce270d1a80$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($29a340ce270d1a80$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};
const $29a340ce270d1a80$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $29a340ce270d1a80$var$handleBlur);
};
const $29a340ce270d1a80$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $29a340ce270d1a80$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $29a340ce270d1a80$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $29a340ce270d1a80$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lxThX.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $29a340ce270d1a80$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("8BmEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4424cbf256e792ff$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");

var $8lyEZ = parcelRequire("8lyEZ");
const $4424cbf256e792ff$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1uoeA.RIGHT_PANEL)
});
const $4424cbf256e792ff$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.RIGHT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $4424cbf256e792ff$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $1uoeA.DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_RIGHT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $4424cbf256e792ff$var$baseStyles,
                isFixed && $4424cbf256e792ff$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
            variableName: (0, $1uoeA.VAR_RIGHT_PANEL_WIDTH),
            value: rightPanelWidth
        }), children));
};
var $4424cbf256e792ff$export$2e2bcd8739ae039 = $4424cbf256e792ff$var$RightPanel;

});

parcelRegister("XCRgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8fadffc00a02a7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");

var $8lyEZ = parcelRequire("8lyEZ");
function $da8fadffc00a02a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $da8fadffc00a02a7$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1uoeA.RIGHT_SIDEBAR_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $1uoeA.BANNER_HEIGHT)} + ${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $1uoeA.RIGHT_PANEL_WIDTH)})`
});
const $da8fadffc00a02a7$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $da8fadffc00a02a7$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $1uoeA.RIGHT_SIDEBAR_WIDTH)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $da8fadffc00a02a7$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $1uoeA.RIGHT_SIDEBAR_WIDTH),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $da8fadffc00a02a7$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $1uoeA.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $da8fadffc00a02a7$var$outerStyles,
                isFixed && $da8fadffc00a02a7$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
            variableName: (0, $1uoeA.VAR_RIGHT_SIDEBAR_WIDTH),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $da8fadffc00a02a7$var$fixedInnerStyles,
                !isFixed && $da8fadffc00a02a7$var$staticInnerStyles
            ]
        }, children)));
};
var $da8fadffc00a02a7$export$2e2bcd8739ae039 = $da8fadffc00a02a7$var$RightSidebar;

});

parcelRegister("gjLh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $579657aad3cc139b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1uoeA = parcelRequire("1uoeA");

var $cHS4c = parcelRequire("cHS4c");

var $eM5Ef = parcelRequire("eM5Ef");
var $2y2Hb = parcelRequire("2y2Hb");

var $dfynK = parcelRequire("dfynK");

var $8lyEZ = parcelRequire("8lyEZ");
const $579657aad3cc139b$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $1uoeA.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1uoeA.TOP_NAVIGATION)
});
const $579657aad3cc139b$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $1uoeA.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $1uoeA.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $1uoeA.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $579657aad3cc139b$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $1uoeA.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $cHS4c.resolveDimension)((0, $1uoeA.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $eM5Ef.default)({
            [(0, $1uoeA.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $eM5Ef.default)({
                [(0, $1uoeA.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $2y2Hb.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfynK.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $579657aad3cc139b$var$topNavigationStyles,
                isFixed && $579657aad3cc139b$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $cHS4c.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8lyEZ.default), {
            variableName: (0, $1uoeA.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $579657aad3cc139b$export$2e2bcd8739ae039 = $579657aad3cc139b$var$TopNavigation;

});

parcelRegister("e2lHC", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $0b2b354be8e7bceb$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2y2Hb = parcelRequire("2y2Hb");
const $0b2b354be8e7bceb$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $2y2Hb.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("e7PeG", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $90c4dc7dcb39bfce$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $76ufE = parcelRequire("76ufE");

var $eYa7e = parcelRequire("eYa7e");

var $davxz = parcelRequire("davxz");

var $lCYqu = parcelRequire("lCYqu");

var $cZR2B = parcelRequire("cZR2B");

var $3S0bJ = parcelRequire("3S0bJ");

var $ajMxh = parcelRequire("ajMxh");

var $3yzbK = parcelRequire("3yzbK");
const $90c4dc7dcb39bfce$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $90c4dc7dcb39bfce$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $90c4dc7dcb39bfce$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
const $90c4dc7dcb39bfce$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
};
function $90c4dc7dcb39bfce$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $cZR2B.DangerouslyHoistSlotSizes));
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $davxz.useSkipLink)(CID, label);
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $76ufE.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$90c4dc7dcb39bfce$var$asideWidthSlotBounds.min}, ${width}px, ${$90c4dc7dcb39bfce$var$asideWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("aside", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $90c4dc7dcb39bfce$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $lCYqu.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lCYqu.UNSAFE_asideLayoutVar),
        value: "0px",
        mediaQuery: (0, $eYa7e.media).above.md,
        responsiveValue: asideVariableWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajMxh.PanelSplitterProvider), {
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $90c4dc7dcb39bfce$var$asideWidthResizeBounds,
        resizingCssVar: $90c4dc7dcb39bfce$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            isFixed && $90c4dc7dcb39bfce$var$styles.fixedContentArea
        ])
    }, children)));
}

});
parcelRegister("davxz", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $ed9abe8f8ac6de81$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLink", () => $ed9abe8f8ac6de81$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $ed9abe8f8ac6de81$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $13czV.default),
    unregisterSkipLink: (0, $13czV.default)
});
const $ed9abe8f8ac6de81$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($ed9abe8f8ac6de81$export$4c5cc3b14c7678a);
const $ed9abe8f8ac6de81$export$89d9323301efc7d6 = (id, label, listIndex)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ed9abe8f8ac6de81$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        label,
        listIndex,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("lCYqu", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $305148fd496ad159$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $305148fd496ad159$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $305148fd496ad159$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $305148fd496ad159$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $305148fd496ad159$export$a96e934b2a1eeee);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $305148fd496ad159$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $305148fd496ad159$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $305148fd496ad159$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $305148fd496ad159$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $305148fd496ad159$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $305148fd496ad159$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $305148fd496ad159$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $305148fd496ad159$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $305148fd496ad159$export$951bf5156e86d974 = '--n_sNvw';
const $305148fd496ad159$export$594e6a30db7c057e = '--n_asDw';
const $305148fd496ad159$export$db0c2e1d744fb281 = '--n_pnlW';
const $305148fd496ad159$export$515a0b1baafe906c = '--n_bnrM';
const $305148fd496ad159$export$a96e934b2a1eeee = '--n_tbrM';
const $305148fd496ad159$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $305148fd496ad159$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $305148fd496ad159$export$f4afb213f937404c = '--topNavigationHeight';
const $305148fd496ad159$export$26354f9814213292 = '--bannerHeight';
const $305148fd496ad159$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $305148fd496ad159$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $305148fd496ad159$export$753bf7651b25db91 = '--rightPanelWidth';
const $305148fd496ad159$export$6460bd6a2446260 = `calc(var(${$305148fd496ad159$export$26354f9814213292}, 0px) + var(${$305148fd496ad159$export$f4afb213f937404c}, 0px))`;
const $305148fd496ad159$export$3055529fab2b4edf = `var(${$305148fd496ad159$export$6bfc931a04ec5741}, 0px)`;
const $305148fd496ad159$export$166d8fd766c3eb92 = `calc(var(${$305148fd496ad159$export$bbbace2ff0c7ae1b}, 0px) + var(${$305148fd496ad159$export$753bf7651b25db91}, 0px))`;
const $305148fd496ad159$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};

});

parcelRegister("cZR2B", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $4a9477aeb827e636$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $4a9477aeb827e636$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("3S0bJ", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $a08c10f79d745fdf$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $a08c10f79d745fdf$export$9f45a1325e3cdfb8);

var $5uXOq = parcelRequire("5uXOq");

var $3APfc = parcelRequire("3APfc");
const $a08c10f79d745fdf$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", null, `#${(0, $3APfc.gridRootId)} { ${variableName}: ${value}px }`);
const $a08c10f79d745fdf$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $a08c10f79d745fdf$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$a08c10f79d745fdf$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$a08c10f79d745fdf$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", null, style));
};

});
parcelRegister("3APfc", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $bd33115d9b201b9e$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $bd33115d9b201b9e$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $a7lX5 = parcelRequire("a7lX5");

var $4czVW = parcelRequire("4czVW");

var $cwGqL = parcelRequire("cwGqL");

var $cZR2B = parcelRequire("cZR2B");

var $lobIi = parcelRequire("lobIi");

var $6COLK = parcelRequire("6COLK");

var $5VsFy = parcelRequire("5VsFy");
const $bd33115d9b201b9e$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $bd33115d9b201b9e$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $bd33115d9b201b9e$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VsFy.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6COLK.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lobIi.SideNavFlyoutLockProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4czVW.HomeActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZR2B.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwGqL.SkipLinksProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7lX5.SkipLinksContainer), {
        label: skipLinksLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $bd33115d9b201b9e$var$styles.root,
            xcss
        ]),
        id: $bd33115d9b201b9e$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children)))))));
}

});
parcelRegister("a7lX5", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $455e76aac71cb7bc$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2zROn = parcelRequire("2zROn");

var $f0pW8 = parcelRequire("f0pW8");

var $9S7tt = parcelRequire("9S7tt");
// TODO (BLU-3215): Fix avoid using ts-ignore
const $455e76aac71cb7bc$var$styles = {
    root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _11q71bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaidpf _1mygkb7n _66dk1kli",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozg1sck"
};
// Correctly typed handler for use with native DOM events
const $455e76aac71cb7bc$var$handleBlur = (event)=>{
    if (!(event.target instanceof Element)) return;
    event.target.removeAttribute('tabindex');
    event.target.removeEventListener('blur', $455e76aac71cb7bc$var$handleBlur);
};
const $455e76aac71cb7bc$var$escapeHandler = (event)=>{
    if (event.key === 'Escape') {
        const activeElement = document.activeElement;
        if (activeElement !== null) activeElement.blur();
    }
};
const $455e76aac71cb7bc$var$attachEscHandler = ()=>window.addEventListener('keydown', $455e76aac71cb7bc$var$escapeHandler, false);
const $455e76aac71cb7bc$var$removeEscHandler = ()=>window.removeEventListener('keydown', $455e76aac71cb7bc$var$escapeHandler, false);
const $455e76aac71cb7bc$export$fce25a0c32fbc1e1 = ({ label: label })=>{
    const sortedSkipLinks = (0, $f0pW8.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const emptyLabelOverride = !!label?.match(/^\s+$/);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onFocus: $455e76aac71cb7bc$var$attachEscHandler,
        onBlur: $455e76aac71cb7bc$var$removeEscHandler,
        className: (0, $bwpsq.default)([
            $455e76aac71cb7bc$var$styles.root
        ])
    }, emptyLabelOverride ? null : /*#__PURE__*/ $5uXOq.createElement((0, $2zROn.default), {
        weight: "medium"
    }, label), /*#__PURE__*/ $5uXOq.createElement("ol", {
        className: (0, $bwpsq.default)([
            $455e76aac71cb7bc$var$styles.skipLinkList
        ])
    }, sortedSkipLinks.map(({ id: id, label: label })=>/*#__PURE__*/ $5uXOq.createElement((0, $9S7tt.SkipLink), {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, label))));
};

});
parcelRegister("f0pW8", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $d820f7ddd2fd1818$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $d820f7ddd2fd1818$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $d820f7ddd2fd1818$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $d820f7ddd2fd1818$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $d820f7ddd2fd1818$var$assignIndex(num + 1, arr);
};
const $d820f7ddd2fd1818$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $d820f7ddd2fd1818$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $d820f7ddd2fd1818$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($d820f7ddd2fd1818$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $d820f7ddd2fd1818$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("9S7tt", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $038a8823e780331a$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2ABuV = parcelRequire("2ABuV");
const $038a8823e780331a$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
const $038a8823e780331a$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $038a8823e780331a$var$assignIndex(num + 1, arr);
};
const $038a8823e780331a$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $038a8823e780331a$var$handleBlur);
};
const $038a8823e780331a$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $038a8823e780331a$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $038a8823e780331a$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ $5uXOq.createElement("li", {
        className: (0, $bwpsq.default)([
            $038a8823e780331a$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2ABuV.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $038a8823e780331a$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("4czVW", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $78f7f8740c04e1b6$export$8b9089606266983e);

var $5uXOq = parcelRequire("5uXOq");

var $76S98 = parcelRequire("76S98");
const $78f7f8740c04e1b6$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76S98.HomeActionsElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76S98.HomeActionsAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("76S98", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $7a45d0c02cdef855$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $7a45d0c02cdef855$export$762fcfeaa67873eb);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $7a45d0c02cdef855$export$4128169e0878a41d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $7a45d0c02cdef855$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $13czV.default));

});


parcelRegister("cwGqL", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $9eaa0a17bd90711e$export$fe514f9f7b03d46f);

var $5uXOq = parcelRequire("5uXOq");

var $davxz = parcelRequire("davxz");

var $f0pW8 = parcelRequire("f0pW8");
const $9eaa0a17bd90711e$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $9eaa0a17bd90711e$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($9eaa0a17bd90711e$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $davxz.SkipLinksContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0pW8.SkipLinksDataContext).Provider, {
        value: links
    }, children));
};

});

parcelRegister("lobIi", function(module, exports) {

$parcel$export(module.exports, "SideNavFlyoutLockProvider", () => $05e67d1bd4ae4f49$export$7003dd76deb92ad);

var $5uXOq = parcelRequire("5uXOq");

var $4JnxB = parcelRequire("4JnxB");
const $05e67d1bd4ae4f49$export$7003dd76deb92ad = ({ children: children })=>{
    // State is used so that we re-render subscribers when the flyout lock count changes.
    // Otherwise we could get into a situation where all flyout locks are removed, but the flyout stays open as
    // nothing has triggered it to update.
    const [flyoutLock, setFlyoutLock] = (0, $5uXOq.useState)(0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4JnxB.FlyoutLockCount).Provider, {
        value: flyoutLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4JnxB.SetFlyoutLockCount).Provider, {
        value: setFlyoutLock
    }, children));
};

});
parcelRegister("4JnxB", function(module, exports) {

$parcel$export(module.exports, "FlyoutLockCount", () => $98ce7ff4e70cdc9c$export$962eb1e8d553c86f);
$parcel$export(module.exports, "SetFlyoutLockCount", () => $98ce7ff4e70cdc9c$export$52e873d56b3942a3);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $98ce7ff4e70cdc9c$export$962eb1e8d553c86f = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
const $98ce7ff4e70cdc9c$export$52e873d56b3942a3 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $13czV.default));

});


parcelRegister("6COLK", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $92410ad8f4bab5fc$export$ceb8e60e9790fc0f);

var $5uXOq = parcelRequire("5uXOq");

var $1XYVC = parcelRequire("1XYVC");
const $92410ad8f4bab5fc$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XYVC.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XYVC.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("1XYVC", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $c7d843815fefc4c5$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $c7d843815fefc4c5$export$fb8fa9a80240785e);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $c7d843815fefc4c5$export$9c1768094bef896 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c7d843815fefc4c5$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $13czV.default));

});


parcelRegister("5VsFy", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $ea8c1d4690649e74$export$aac8e996360f6ad9);

var $5uXOq = parcelRequire("5uXOq");

var $hFA1y = parcelRequire("hFA1y");
const $ea8c1d4690649e74$export$aac8e996360f6ad9 = ({ children: children })=>{
    const [visibleOnDesktop, setVisibleOnDesktop] = (0, $5uXOq.useState)(null);
    const [visibleOnMobile, setVisibleOnMobile] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFA1y.SideNavDesktopVisibility).Provider, {
        value: visibleOnDesktop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFA1y.SetSideNavDesktopVisibility).Provider, {
        value: setVisibleOnDesktop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFA1y.SideNavMobileVisibility).Provider, {
        value: visibleOnMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFA1y.SetSideNavMobileVisibility).Provider, {
        value: setVisibleOnMobile
    }, children))));
};

});
parcelRegister("hFA1y", function(module, exports) {

$parcel$export(module.exports, "SideNavDesktopVisibility", () => $6747b3fb5e4de357$export$1771e3b63861d206);
$parcel$export(module.exports, "SideNavMobileVisibility", () => $6747b3fb5e4de357$export$c5f483eeea865395);
$parcel$export(module.exports, "SetSideNavDesktopVisibility", () => $6747b3fb5e4de357$export$5edca135c5bde4af);
$parcel$export(module.exports, "SetSideNavMobileVisibility", () => $6747b3fb5e4de357$export$64be6ca751606276);

var $5uXOq = parcelRequire("5uXOq");

var $13czV = parcelRequire("13czV");
const $6747b3fb5e4de357$export$1771e3b63861d206 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6747b3fb5e4de357$export$c5f483eeea865395 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $6747b3fb5e4de357$export$5edca135c5bde4af = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $13czV.default));
const $6747b3fb5e4de357$export$64be6ca751606276 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $13czV.default));

});




parcelRegister("ajMxh", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $bec5ebbdc0f995bd$export$f662bfb764348932);
/* provider.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3XefF = parcelRequire("3XefF");
const $bec5ebbdc0f995bd$var$styles = {
    panelChildrenWrapper: "_1reo1wug _18m91wug _4t3i1osq _1e0c1txw _2lx21bp4"
};
const $bec5ebbdc0f995bd$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            resizeBounds: resizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        isEnabled,
        onCompleteResize,
        panelRef,
        panelWidth,
        position,
        resizeBounds,
        resizingCssVar
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, /*#__PURE__*/ $5uXOq.createElement((0, $3XefF.PanelSplitterContext).Provider, {
        value: context
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $bec5ebbdc0f995bd$var$styles.panelChildrenWrapper
        ])
    }, children)), /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: portalRef
    }));
};

});
parcelRegister("3XefF", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $9c60b183f43fba3b$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $9c60b183f43fba3b$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("3yzbK", function(module, exports) {

$parcel$export(module.exports, "usePrefixedUID", () => $ced872b5e548598d$export$86433d4fd18455f4);

var $agEJC = parcelRequire("agEJC");
const $ced872b5e548598d$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, $agEJC.useId)()}`;

});


parcelRegister("dWeCG", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $c687f43545a01877$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $davxz = parcelRequire("davxz");

var $lCYqu = parcelRequire("lCYqu");

var $cZR2B = parcelRequire("cZR2B");

var $3S0bJ = parcelRequire("3S0bJ");

var $3yzbK = parcelRequire("3yzbK");
const $c687f43545a01877$var$styles = {
    root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
};
function $c687f43545a01877$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $cZR2B.DangerouslyHoistSlotSizes));
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $davxz.useSkipLink)(CID, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: CID,
        role: "banner",
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $c687f43545a01877$var$styles.root,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.HoistCssVarToLocalGrid), {
        variableName: (0, $lCYqu.bannerMountedVar),
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lCYqu.UNSAFE_bannerVar),
        value: UNSAFE_height
    }), children);
}

});

parcelRegister("gVU1U", function(module, exports) {

$parcel$export(module.exports, "Main", () => $912dc2f23d452d2a$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $davxz = parcelRequire("davxz");

var $7zpXn = parcelRequire("7zpXn");

var $3yzbK = parcelRequire("3yzbK");

var $j67n8 = parcelRequire("j67n8");
const $912dc2f23d452d2a$var$styles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    mainCurvedCorner: "_1orwi2wt",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
};
const $912dc2f23d452d2a$var$contentBorderStyles = {
    largeViewportTop: "_vchhusvi _mqm2zgxb _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _dm2518uv",
    largeViewportLeft: "_vchhusvi _izbqoyrj _191wzgxb _1s1gi2wt _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _dm2518uv",
    curvedBorder: "_1s1gi2wt _h7aloyrj"
};
function $912dc2f23d452d2a$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    const { visibleOnDesktop: isSideNavVisibleOnDesktop } = (0, $7zpXn.useSideNavVisibility)();
    (0, $davxz.useSkipLink)(CID, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $912dc2f23d452d2a$var$styles.root,
            isSideNavVisibleOnDesktop && $912dc2f23d452d2a$var$styles.mainCurvedCorner,
            isFixed && $912dc2f23d452d2a$var$styles.fixedContentArea,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j67n8.MainStickyContext).Provider, {
        value: Boolean(isFixed)
    }, children)), isSideNavVisibleOnDesktop && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // CALL OUT: If this component is NOT mounted then the border around the
        // content area on large viewports will NOT be rendered.
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $912dc2f23d452d2a$var$contentBorderStyles.largeViewportLeft
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $912dc2f23d452d2a$var$contentBorderStyles.largeViewportTop,
            isSideNavVisibleOnDesktop && $912dc2f23d452d2a$var$contentBorderStyles.curvedBorder
        ])
    }));
}

});
parcelRegister("7zpXn", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $fbd60febe2b03f96$export$4a602ad7e09bdb2c);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $hFA1y = parcelRequire("hFA1y");
const $fbd60febe2b03f96$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const visibleOnDesktop = (0, $5uXOq.useContext)((0, $hFA1y.SideNavDesktopVisibility));
    const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, $hFA1y.SetSideNavDesktopVisibility));
    const visibleOnMobile = (0, $5uXOq.useContext)((0, $hFA1y.SideNavMobileVisibility));
    const setVisibleOnMobile = (0, $5uXOq.useContext)((0, $hFA1y.SetSideNavMobileVisibility));
    const [isSideNavVisible, setIsSideNavVisible] = (0, $5uXOq.useState)(!defaultCollapsed);
    (0, $5uXOq.useEffect)(()=>{
        const isSideNavVisibleOnDesktop = visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop;
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
        // reactive screen size changes
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
            }
        });
    }, [
        defaultCollapsed,
        visibleOnDesktop,
        visibleOnMobile
    ]);
    const showSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        matches ? setVisibleOnDesktop(true) : setVisibleOnMobile(true);
    }, [
        setVisibleOnDesktop,
        setVisibleOnMobile
    ]);
    return {
        visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
        visibleOnMobile: visibleOnMobile,
        setVisibleOnDesktop: setVisibleOnDesktop,
        setVisibleOnMobile: setVisibleOnMobile,
        isSideNavVisible: isSideNavVisible,
        showSideNav: showSideNav
    };
};

});

parcelRegister("j67n8", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $2c640d4b74faf3c8$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $2c640d4b74faf3c8$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("3RFMY", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $57173d1a1b849b99$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eYa7e = parcelRequire("eYa7e");

var $davxz = parcelRequire("davxz");

var $lCYqu = parcelRequire("lCYqu");

var $cZR2B = parcelRequire("cZR2B");

var $3S0bJ = parcelRequire("3S0bJ");

var $ajMxh = parcelRequire("ajMxh");

var $3yzbK = parcelRequire("3yzbK");
const $57173d1a1b849b99$var$panelSplitterResizingVar = '--n_pnlRsz';
const $57173d1a1b849b99$var$panelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $57173d1a1b849b99$var$panelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
const $57173d1a1b849b99$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq"
};
function $57173d1a1b849b99$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $cZR2B.DangerouslyHoistSlotSizes));
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $davxz.useSkipLink)(CID, label);
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const panelVariableWidth = `clamp(${$57173d1a1b849b99$var$panelWidthSlotBounds.min}, ${width}px, ${$57173d1a1b849b99$var$panelWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $57173d1a1b849b99$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $lCYqu.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lCYqu.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: (0, $eYa7e.media).above.lg,
        responsiveValue: panelVariableWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajMxh.PanelSplitterProvider), {
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $57173d1a1b849b99$var$panelWidthResizeBounds,
        resizingCssVar: $57173d1a1b849b99$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $57173d1a1b849b99$var$styles.scrollContainer
        ])
    }, children)));
}

});

parcelRegister("T0nre", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $0202eda8ef38f1fb$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $fkF0Y = parcelRequire("fkF0Y");
var $6q0Xq = parcelRequire("6q0Xq");

var $eYa7e = parcelRequire("eYa7e");

var $akaX2 = parcelRequire("akaX2");

var $76S98 = parcelRequire("76S98");

var $davxz = parcelRequire("davxz");

var $lCYqu = parcelRequire("lCYqu");

var $cZR2B = parcelRequire("cZR2B");

var $3S0bJ = parcelRequire("3S0bJ");

var $ajMxh = parcelRequire("ajMxh");

var $3yzbK = parcelRequire("3yzbK");

var $1XYVC = parcelRequire("1XYVC");

var $7zpXn = parcelRequire("7zpXn");

var $cKfbL = parcelRequire("cKfbL");

var $1VmNe = parcelRequire("1VmNe");
const $0202eda8ef38f1fb$var$panelSplitterResizingVar = '--n_snvRsz';
const $0202eda8ef38f1fb$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
const $0202eda8ef38f1fb$var$sideNavFlyoutCloseDelayMs = 400;
/**
 * Returns the current state of the side nav based on the provided props.
 * It has been ordered to ensure that the flyout state is least prioritised over the other toggled visibility states
 */ const $0202eda8ef38f1fb$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
    if (visibleOnDesktop && visibleOnMobile) return 'idle';
    if (!visibleOnMobile && visibleOnDesktop) return 'hidden-mobile-only';
    if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
    if (visibleOnMobile && !visibleOnDesktop) return 'hidden-desktop-only';
    return 'hidden-mobile-and-desktop';
};
const $0202eda8ef38f1fb$var$styles = {
    root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
    flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
    interactionSurface: "_1bsb1osq _4t3i1osq",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $0202eda8ef38f1fb$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $davxz.useSkipLink)(CID, label);
    const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, $7zpXn.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$0202eda8ef38f1fb$var$widthResizeBounds.min}, ${width}px, ${$0202eda8ef38f1fb$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $cZR2B.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $1XYVC.SideNavToggleButtonElement));
    const homeActionsElement = (0, $5uXOq.useContext)((0, $76S98.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const [isFlyoutVisible, setIsFlyoutVisible] = (0, $5uXOq.useState)(false);
    const openLayerObserver = (0, $6q0Xq.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const sideNavState = $0202eda8ef38f1fb$var$getSideNavState({
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile,
        isFlyoutVisible: isFlyoutVisible
    });
    const updateFlyoutState = (0, $5uXOq.useCallback)((action)=>{
        if (action === 'open') {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
            flyoutStateRef.current = {
                type: 'open'
            };
            setIsFlyoutVisible(true);
        }
        if (action === 'waiting-for-close') {
            if (flyoutStateRef.current.type === 'waiting-for-close') return;
            // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
            // us to cancel the close if the user mouses back in.
            const timeout = setTimeout(()=>{
                updateFlyoutState('ready-to-close');
            }, $0202eda8ef38f1fb$var$sideNavFlyoutCloseDelayMs);
            flyoutStateRef.current = {
                type: 'waiting-for-close',
                abort () {
                    clearTimeout(timeout);
                }
            };
        }
        if (action === 'ready-to-close') {
            flyoutStateRef.current = {
                type: 'ready-to-close'
            };
            // If there are no open layers, we can close the flyout.
            if (openLayerObserver.getCount() === 0) {
                flyoutStateRef.current = {
                    type: 'not-active'
                };
                setIsFlyoutVisible(false);
            }
        }
    }, [
        openLayerObserver
    ]);
    const toggleVisibility = (0, $1VmNe.useToggleSideNav)();
    // Sync the visibility in context with the local state value after SSR hydration, as it contains the default value from props
    (0, $5uXOq.useEffect)(()=>{
        setVisibleOnDesktop(visibleOnDesktop);
    }, [
        setVisibleOnDesktop,
        visibleOnDesktop
    ]);
    (0, $cKfbL.useSideNavVisibilityCallbacks)({
        onExpand: onExpand,
        onCollapse: onCollapse,
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        visibleOnDesktop,
        visibleOnMobile
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (visibleOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        visibleOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        visibleOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        visibleOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(function onChange({ count: count }) {
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) {
                setIsFlyoutVisible(false);
                flyoutStateRef.current = {
                    type: 'not-active'
                };
            }
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("nav", {
        id: CID,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $lCYqu.sideNavVar)]: clampedWidth
        },
        ref: navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $0202eda8ef38f1fb$var$styles.root,
            sideNavState === 'hidden-mobile-only' && $0202eda8ef38f1fb$var$styles.hiddenMobileOnly,
            sideNavState === 'hidden-desktop-only' && $0202eda8ef38f1fb$var$styles.hiddenDesktopOnly,
            sideNavState === 'hidden-mobile-and-desktop' && $0202eda8ef38f1fb$var$styles.hiddenMobileAndDesktop,
            sideNavState === 'flyout' && $0202eda8ef38f1fb$var$styles.flyout
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lCYqu.UNSAFE_sideNavLayoutVar),
        value: "0px",
        mediaQuery: (0, $eYa7e.media).above.md,
        responsiveValue: visibleOnDesktop ? clampedWidth : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akaX2.InteractionSurface), {
        xcss: $0202eda8ef38f1fb$var$styles.interactionSurface
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajMxh.PanelSplitterProvider), {
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $0202eda8ef38f1fb$var$widthResizeBounds,
        resizingCssVar: $0202eda8ef38f1fb$var$panelSplitterResizingVar,
        isEnabled: sideNavState === 'idle' || sideNavState === 'hidden-mobile-only'
    }, children)));
}
function $0202eda8ef38f1fb$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkF0Y.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0202eda8ef38f1fb$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children));
}

});
parcelRegister("fkF0Y", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $80ca53b56b5cbfa8$export$97afddda23bcd287);

var $5uXOq = parcelRequire("5uXOq");

var $FihOu = parcelRequire("FihOu");
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $80ca53b56b5cbfa8$var$createInternalAPI() {
    let count = 0;
    const registry = new Set();
    function onChange(listener) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        registry.add(wrapped);
        return function unsubscribe() {
            registry.delete(wrapped);
        };
    }
    function increment() {
        count += 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach((listener)=>listener({
                count: count
            }));
    }
    function decrement() {
        count -= 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach((listener)=>listener({
                count: count
            }));
    }
    return {
        getCount () {
            return count;
        },
        onChange: onChange,
        increment: increment,
        decrement: decrement
    };
}
function $80ca53b56b5cbfa8$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$80ca53b56b5cbfa8$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $FihOu.OpenLayerObserverContext));
    const increment = (0, $5uXOq.useCallback)(()=>{
        internalAPI.increment();
        // If the `OpenLayerObserver` is nested, increment the layer count in the parent context as well.
        if (parentContext !== null) parentContext.increment();
    }, [
        internalAPI,
        parentContext
    ]);
    const decrement = (0, $5uXOq.useCallback)(()=>{
        internalAPI.decrement();
        // If the `OpenLayerObserver` is nested, decrement the layer count in the parent context as well.
        if (parentContext !== null) parentContext.decrement();
    }, [
        internalAPI,
        parentContext
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            getCount: internalAPI.getCount,
            onChange: internalAPI.onChange,
            increment: increment,
            decrement: decrement
        }), [
        decrement,
        increment,
        internalAPI.getCount,
        internalAPI.onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FihOu.OpenLayerObserverContext).Provider, {
        value: contextValue
    }, children);
}

});

parcelRegister("6q0Xq", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $626a1153d9aa0b10$export$750f5b0d6c51617e);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $FihOu = parcelRequire("FihOu");
function $626a1153d9aa0b10$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $FihOu.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange
        }), [
        context.getCount,
        context.onChange
    ]);
    return publicAPI;
}

});

parcelRegister("akaX2", function(module, exports) {

$parcel$export(module.exports, "InteractionSurface", () => $4fcc8c478558f460$export$b77883dd274d64b);
$parcel$export(module.exports, "InteractionConsumer", () => $4fcc8c478558f460$export$65f09dabf608e4ae);
/* interaction-surface.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
// These CSS variables are "compressed" to discourage direct usage.
// Using `opacity` so that the element is still in the document flow while hidden, so that it can be part of the accessibilty tree
// when the surface is not interacted with. Use case: keeping the element in the tab order.
const $4fcc8c478558f460$var$opacityCssVar = '--n_sfc_o';
// `display` is used when the element should be removed from the document flow when hidden.
const $4fcc8c478558f460$var$displayCssVar = '--n_sfc_d';
const $4fcc8c478558f460$var$surfaceStyles = {
    root: "_17lff1ug _2wlvglyw _1ebb1osq _1yth1osq _1s0b1ule _1dle1ule"
};
const $4fcc8c478558f460$export$b77883dd274d64b = ({ children: children, xcss: xcss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $4fcc8c478558f460$var$surfaceStyles.root,
            xcss
        ])
    }, children);
const $4fcc8c478558f460$var$behaviorStyles = {
    hideOnLeave: "_tzy41j9r",
    removeOnLeave: "_1e0c13fu"
};
const $4fcc8c478558f460$export$65f09dabf608e4ae = ({ children: children, testId: testId, xcss: xcss, behavior: behavior = 'hideOnLeave' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            behavior === 'hideOnLeave' && $4fcc8c478558f460$var$behaviorStyles.hideOnLeave,
            behavior === 'removeOnLeave' && $4fcc8c478558f460$var$behaviorStyles.removeOnLeave,
            xcss
        ])
    }, children);

});

parcelRegister("cKfbL", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $e07e8ea2752ac27d$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $76ufE = parcelRequire("76ufE");
function $e07e8ea2752ac27d$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousVisibleOnDesktop = (0, $76ufE.default)(visibleOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (visibleOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousVisibleOnDesktop,
        visibleOnDesktop
    ]);
    const previousVisibleOnMobile = (0, $76ufE.default)(visibleOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (visibleOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousVisibleOnMobile,
        visibleOnMobile
    ]);
}

});

parcelRegister("1VmNe", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $9c60c5fadc52c569$export$477ee35601a0a8ce);

var $5uXOq = parcelRequire("5uXOq");

var $hFA1y = parcelRequire("hFA1y");
const $9c60c5fadc52c569$export$477ee35601a0a8ce = ()=>{
    const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, $hFA1y.SetSideNavDesktopVisibility));
    const setVisibleOnMobile = (0, $5uXOq.useContext)((0, $hFA1y.SetSideNavMobileVisibility));
    const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setVisibleOnDesktop((prev)=>!prev);
        else setVisibleOnMobile((prev)=>!prev);
    }, [
        setVisibleOnDesktop,
        setVisibleOnMobile
    ]);
    return toggleSideNav;
};

});


parcelRegister("bB8zd", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $8addb79aae7bbbb7$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $davxz = parcelRequire("davxz");

var $8Wtip = parcelRequire("8Wtip");

var $4OwX8 = parcelRequire("4OwX8");

var $lCYqu = parcelRequire("lCYqu");

var $cZR2B = parcelRequire("cZR2B");

var $3S0bJ = parcelRequire("3S0bJ");

var $3yzbK = parcelRequire("3yzbK");
const $8addb79aae7bbbb7$var$styles = {
    root: "_1e0c11p5 _yv0e1mfv _18zrutpp _zulpu2gc _4cvr1h6o _bfhkvuon _vchhusvi _nd5l8cbt _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
};
const $8addb79aae7bbbb7$var$contentBorderStyles = {
    smallViewportTop: "_179rzgxb _nd5l8cbt _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
};
function $8addb79aae7bbbb7$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $cZR2B.DangerouslyHoistSlotSizes));
    const UID = (0, $3yzbK.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $davxz.useSkipLink)(CID, label);
    const customTheme = (0, $4OwX8.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Wtip.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("header", {
        id: CID,
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $8addb79aae7bbbb7$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.HoistCssVarToLocalGrid), {
        variableName: (0, $lCYqu.topBarMountedVar),
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S0bJ.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lCYqu.UNSAFE_topBarVar),
        value: UNSAFE_height
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // CALL OUT: If this component is NOT mounted to a page then the border between
        // the top bar and main content will not be rendered.
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $8addb79aae7bbbb7$var$contentBorderStyles.smallViewportTop
        ])
    }));
}

});
parcelRegister("4OwX8", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $9232ca1a3a3ccba1$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");

var $ccIG7 = parcelRequire("ccIG7");
function $9232ca1a3a3ccba1$export$c0c5f5b297b77726(theme) {
    const style = (0, $5uXOq.useMemo)(()=>{
        /**
		 * TODO: After cleaning up this flag we may want to remove `isEnabled`
		 * and just use `Boolean(theme)` directly.
		 */ if (!(0, $hFKXd.fg)('platform_design_system_nav4_top_bar_theming')) return null;
        if (!theme) return null;
        return (0, $ccIG7.getCustomThemeStyles)(theme);
    }, [
        theme
    ]);
    if (!style) return {
        isEnabled: false
    };
    return {
        isEnabled: true,
        style: style
    };
}

});
parcelRegister("ccIG7", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $bb798f56f804b24a$export$3986d75fe2da3239);

var $aFSmz = parcelRequire("aFSmz");

var $b3AMT = parcelRequire("b3AMT");

var $6FxTd = parcelRequire("6FxTd");

var $23H7c = parcelRequire("23H7c");
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $bb798f56f804b24a$var$buttonStyles = {
    light: {
        [(0, $b3AMT.themedButtonBackground)]: 'transparent',
        [(0, $b3AMT.themedButtonBackgroundHovered)]: '#0515240F',
        [(0, $b3AMT.themedButtonBackgroundPressed)]: '#0B120E24',
        [(0, $b3AMT.themedButtonBorder)]: '#0B120E24',
        [(0, $b3AMT.themedButtonSelectedText)]: '#1868DB',
        [(0, $b3AMT.themedButtonSelectedBackground)]: '#E9F2FE',
        [(0, $b3AMT.themedButtonSelectedBackgroundHovered)]: '#CFE1FD',
        [(0, $b3AMT.themedButtonSelectedBackgroundPressed)]: '#8FB8F6'
    },
    dark: {
        [(0, $b3AMT.themedButtonBackground)]: 'transparent',
        [(0, $b3AMT.themedButtonBackgroundHovered)]: '#CECED912',
        [(0, $b3AMT.themedButtonBackgroundPressed)]: '#E3E4F21F',
        [(0, $b3AMT.themedButtonBorder)]: '#E3E4F21F',
        [(0, $b3AMT.themedButtonSelectedText)]: '#669DF1',
        [(0, $b3AMT.themedButtonSelectedBackground)]: '#1C2B42',
        [(0, $b3AMT.themedButtonSelectedBackgroundHovered)]: '#123263',
        [(0, $b3AMT.themedButtonSelectedBackgroundPressed)]: '#1558BC'
    }
};
const $bb798f56f804b24a$var$logoStyles = {
    light: {
        [(0, $aFSmz.themedLogoIcon)]: '#101214',
        [(0, $aFSmz.themedLogoText)]: '#101214'
    },
    dark: {
        [(0, $aFSmz.themedLogoIcon)]: '#FFFFFF',
        [(0, $aFSmz.themedLogoText)]: '#FFFFFF'
    }
};
function $bb798f56f804b24a$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const isLightBackground = (0, $6FxTd.isLight)(backgroundColor);
    const color = (0, $6FxTd.getTextColor)(backgroundColor);
    const highlightTextColor = (0, $6FxTd.getTextColor)(highlightColor);
    const highlightRgb = (0, $6FxTd.hexToRGB)(highlightColor);
    const colorRgb = (0, $6FxTd.hexToRGB)(color);
    return {
        backgroundColor: backgroundColor,
        color: color,
        ...$bb798f56f804b24a$var$buttonStyles[isLightBackground ? 'light' : 'dark'],
        ...$bb798f56f804b24a$var$logoStyles[isLightBackground ? 'light' : 'dark'],
        [(0, $b3AMT.themedButtonPrimaryBackground)]: highlightColor,
        /**
		 * These interaction states are the same as nav3
		 */ [(0, $b3AMT.themedButtonPrimaryBackgroundHovered)]: (0, $6FxTd.toRGBAString)(highlightRgb, 0.8),
        [(0, $b3AMT.themedButtonPrimaryBackgroundPressed)]: (0, $6FxTd.toRGBAString)(highlightRgb, 0.65),
        [(0, $b3AMT.themedButtonPrimaryText)]: highlightTextColor,
        // Taken from nav3
        [(0, $23H7c.themedSearchBorder)]: (0, $6FxTd.toRGBAString)(colorRgb, 0.5),
        [(0, $23H7c.themedSearchBorderFocused)]: (0, $6FxTd.toRGBAString)(highlightRgb, 0.8)
    };
}

});
parcelRegister("6FxTd", function(module, exports) {

$parcel$export(module.exports, "toRGBAString", () => $f39fa7f0fb85551c$export$b597d7418f37d50a);
$parcel$export(module.exports, "hexToRGB", () => $f39fa7f0fb85551c$export$848d71df1f759bc);
$parcel$export(module.exports, "isLight", () => $f39fa7f0fb85551c$export$44af652f4cca9039);
$parcel$export(module.exports, "getTextColor", () => $f39fa7f0fb85551c$export$5357fe757c335c0d);
// valid hex color (with no alpha channel) - 3 or 6 digits
const $f39fa7f0fb85551c$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
function $f39fa7f0fb85551c$export$b597d7418f37d50a({ r: r, g: g, b: b }, alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function $f39fa7f0fb85551c$export$848d71df1f759bc(hex) {
    if (!$f39fa7f0fb85551c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let channels;
    if (hex.length === 4) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: hex[1].repeat(2),
        g: hex[2].repeat(2),
        b: hex[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: hex.slice(1, 3),
        g: hex.slice(3, 5),
        b: hex.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $f39fa7f0fb85551c$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $f39fa7f0fb85551c$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $f39fa7f0fb85551c$var$linearizeRGBChannel(normal.r),
        g: $f39fa7f0fb85551c$var$linearizeRGBChannel(normal.g),
        b: $f39fa7f0fb85551c$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
function $f39fa7f0fb85551c$export$d061e26956a60b0a(foreground, background) {
    if (!$f39fa7f0fb85551c$var$isValidHex(foreground) || !$f39fa7f0fb85551c$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $f39fa7f0fb85551c$export$848d71df1f759bc(foreground);
    const backgroundRgb = $f39fa7f0fb85551c$export$848d71df1f759bc(background);
    const foregroundLuminance = $f39fa7f0fb85551c$var$relativeLuminanceW3C(foregroundRgb);
    const backgroundLuminance = $f39fa7f0fb85551c$var$relativeLuminanceW3C(backgroundRgb);
    // calculate the color contrast ratio
    const brightest = Math.max(foregroundLuminance, backgroundLuminance);
    const darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $f39fa7f0fb85551c$var$flipLuminance = 0.179129;
function $f39fa7f0fb85551c$export$44af652f4cca9039(color) {
    const rgb = $f39fa7f0fb85551c$export$848d71df1f759bc(color);
    return $f39fa7f0fb85551c$var$relativeLuminanceW3C(rgb) >= $f39fa7f0fb85551c$var$flipLuminance;
}
function $f39fa7f0fb85551c$export$5357fe757c335c0d(backgroundColor) {
    if ($f39fa7f0fb85551c$export$44af652f4cca9039(backgroundColor)) return '#000';
    return '#FFF';
}

});

parcelRegister("23H7c", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", () => $74c088727e5d7a2a$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $74c088727e5d7a2a$export$ee42b8430f4c19bd);

var $b3AMT = parcelRequire("b3AMT");

var $8Wtip = parcelRequire("8Wtip");
const $74c088727e5d7a2a$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $74c088727e5d7a2a$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
const $74c088727e5d7a2a$export$7931ecdcbff2536 = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$74c088727e5d7a2a$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$74c088727e5d7a2a$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$74c088727e5d7a2a$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(${(0, $b3AMT.themedButtonBackgroundHovered)})`
    }
};
function $74c088727e5d7a2a$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $8Wtip.useHasCustomTheme)();
    if (hasCustomTheme) return $74c088727e5d7a2a$export$7931ecdcbff2536;
    return undefined;
}

});





parcelRegister("c34Wf", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $976a0f933d5d0ba8$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $8QpSo = parcelRequire("8QpSo");

var $dIdda = parcelRequire("dIdda");

var $kJPyG = parcelRequire("kJPyG");

const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, $8QpSo.default)((atlassianAccountId)=>(0, $kJPyG.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $dIdda.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("kJPyG", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $a5efaf793a61ef5e$export$29999268b070c9bd);

var $89SaW = parcelRequire("89SaW");


var $1yqku = parcelRequire("1yqku");
const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $1yqku.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $89SaW.getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $1yqku.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("1yqku", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $fa4273588466a1c1$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $fa4273588466a1c1$export$ec13c725e067146a);

var $8Rkzz = parcelRequire("8Rkzz");

var $dJl1T = parcelRequire("dJl1T");

const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    const item = localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $fa4273588466a1c1$var$queryLocalStorageSync();
        resolve(item);
    });
const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $7JoAD = parcelRequire("7JoAD");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});

parcelRegister("2TwSO", function(module, exports) {

$parcel$export(module.exports, "setRemoteLayoutState", () => $9d3e8b8a199ea341$export$ad53b565e6cd4261);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("aKiiD", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $1ca472b9239dbdd7$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $1ca472b9239dbdd7$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $heNNl = parcelRequire("heNNl");

var $l8ruj = parcelRequire("l8ruj");

var $hvrWv = parcelRequire("hvrWv");

var $hsmeR = parcelRequire("hsmeR");

var $5e5zm = parcelRequire("5e5zm");
function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $5e5zm.useDetailPanelWidth)();
    const rightSidebar = (0, $hsmeR.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $hvrWv.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ca472b9239dbdd7$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $darnD = parcelRequire("darnD");

var $7sZUk = parcelRequire("7sZUk");

var $hhGDe = parcelRequire("hhGDe");

var $5MT9r = parcelRequire("5MT9r");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $7sZUk.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $hhGDe.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $hhGDe.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $darnD.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MT9r.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("hvrWv", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $4dcd4c0b25ba3fd4$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $4dcd4c0b25ba3fd4$export$de496fd0e0151c81);

var $7JoAD = parcelRequire("7JoAD");

var $5e5zm = parcelRequire("5e5zm");
const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $7JoAD.createStateHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $7JoAD.createActionsHook)((0, $5e5zm.layoutStore));

});


const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;

parcelRegister("16YKp", function(module, exports) {

$parcel$export(module.exports, "useBannerJsmPackagingUpdates", () => $32df9c26e8c82916$export$a0dde3f151a99607);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $gzrJT = parcelRequire("gzrJT");

var $90yGq = parcelRequire("90yGq");

var $l2Uy7 = parcelRequire("l2Uy7");
const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const accountId = (0, $90yGq.useAccountId)();
    const isServiceProject = project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, $l2Uy7.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $gzrJT.useJsmRepackagingAnnouncementResource)(accountId);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isInJsmBoundary && shouldShow && (0, $4R6GH.fg)('jsm-packaging-pricing-changes-announcement'),
            dismissAnnouncement: dismissAnnouncement
        }), [
        dismissAnnouncement,
        isInJsmBoundary,
        shouldShow
    ]);
};

});
parcelRegister("gzrJT", function(module, exports) {

$parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", () => $e073f4ec0b653e88$export$47d5fef12f2d184b);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $dIdda = parcelRequire("dIdda");

var $hj0lE = parcelRequire("hj0lE");

const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("fjlZb"));
const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, $dIdda.createResource)({
    type: 'JSM_REPACKAGING_ANNOUNCEMENT',
    getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
    getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
    maxAge: Infinity
});
const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $dIdda.useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
    const loadingRef = (0, $5uXOq.useRef)(false);
    const errorRef = (0, $5uXOq.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
        const announcementDismissState = {
            shouldShow: false
        };
        update(()=>({
                announcementDismissState: announcementDismissState
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $hj0lE.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        accountId,
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        const { announcementDismissState: announcementDismissState } = data;
        if (!announcementDismissState) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            ...announcementDismissState,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
parcelRegister("hj0lE", function(module, exports) {

$parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $4bad9f9efc7d29c0$export$d2137827dc00e559);
$parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", () => $4bad9f9efc7d29c0$export$341176bfdf8c92);
const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
    shouldShow: true
};

});

parcelRegister("fjlZb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("37oAo").then(()=>parcelRequire('lGYvJ'));

});


parcelRegister("l2Uy7", function(module, exports) {

$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $257d172b6cc842a0$export$c28a66ae6d31a34b);
const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);

});


parcelRegister("cOwuh", function(module, exports) {

$parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", () => $5589b5a823eb55d2$export$76c6ab35aee49900);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $5589b5a823eb55d2$var$BannerTransition = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("boNJG")).then((module)=>module.BannerJsmPackagingUpdate), {
    moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
});
const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-jsm-packaging-updates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));

});
parcelRegister("boNJG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3lSYe").then(()=>parcelRequire('kuFA7'));

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("6ncxj", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $1b12ea52aa3c0323$export$5f4dc7c98070d93e);

var $5uXOq = parcelRequire("5uXOq");

var $doxsH = parcelRequire("doxsH");

var $2vSU6 = parcelRequire("2vSU6");

var $8JIza = parcelRequire("8JIza");

var $gmGW3 = parcelRequire("gmGW3");

var $8NA5p = parcelRequire("8NA5p");

var $7kqCT = parcelRequire("7kqCT");

var $7jo2g = parcelRequire("7jo2g");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7N30e = parcelRequire("7N30e");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $7XYc4 = parcelRequire("7XYc4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $3lMZZ = parcelRequire("3lMZZ");

var $7Lkcv = parcelRequire("7Lkcv");

var $9YvQF = parcelRequire("9YvQF");

var $km1Z8 = parcelRequire("km1Z8");

var $e1ETT = parcelRequire("e1ETT");

var $aqDVH = parcelRequire("aqDVH");

var $lpwtK = parcelRequire("lpwtK");

var $jElqQ = parcelRequire("jElqQ");

var $kKa8l = parcelRequire("kKa8l");

var $bmetd = parcelRequire("bmetd");

var $izgL1 = parcelRequire("izgL1");

var $lyCmi = parcelRequire("lyCmi");

var $1XrjK = parcelRequire("1XrjK");

var $kgLzl = parcelRequire("kgLzl");

var $dYRe6 = parcelRequire("dYRe6");

var $koeKL = parcelRequire("koeKL");

var $dz0Q5 = parcelRequire("dz0Q5");

var $kXv2J = parcelRequire("kXv2J");

var $4p6rw = parcelRequire("4p6rw");

var $7B17s = parcelRequire("7B17s");

var $ec3NH = parcelRequire("ec3NH");

var $lDu2T = parcelRequire("lDu2T");

var $jnXgM = parcelRequire("jnXgM");
const $1b12ea52aa3c0323$var$isTrialEndLockScreenExperimentEnabled = ()=>(0, $co1wz.ff)('jsm-trial-end-lock-screen-experiment_nowmr') || (0, $co1wz.ff)('jpd-trial-end-lock-screen-experiment');
// +owner:pdhanuka
// eslint-disable-next-line jira/ff/inline-usage
const $1b12ea52aa3c0323$var$isPendoIntegrationEnabled = ()=>(0, $co1wz.ff)('jira-frontend-pendo-analytics_s6sj5');

// -owner:pdhanuka
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$Global = (0, $7B17s.lazy)(()=>(parcelRequire("2Afwf")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$Navigation = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("aQHAS")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$Trackers = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("i1RfD")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$RemoteActions = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("iRWz9")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$LazyNonCriticalDesShareLinkFlag = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("76ZCo")).then(({ NonCriticalDesShareLinkFlag: NonCriticalDesShareLinkFlag })=>NonCriticalDesShareLinkFlag), {
    ssr: false,
    moduleId: "./src/packages/growth/des-share-link/src/ui/index.tsx"
});

// No need for a whole chunk for a single component
/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $1b12ea52aa3c0323$var$AfterPaintIssuePreEval = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("D2tCn")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit = (0, $7B17s.lazy)(()=>(parcelRequire("lGCVr")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $1b12ea52aa3c0323$var$runtimeProps = {};
const $1b12ea52aa3c0323$var$entryPointParams = {};
const $1b12ea52aa3c0323$export$70b554b486395223 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kXv2J.upgradeOnboardingExperimentEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.upgradeOnboardingExperiment",
        packageName: "issue-view",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
    });
};
const $1b12ea52aa3c0323$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kgLzl.rovoVideoModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
    });
};
const $1b12ea52aa3c0323$export$3211958f96133af8 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aqDVH.jiraLossAversionModalEntryPoint), $1b12ea52aa3c0323$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.jiraLossAversion",
        packageName: "jira-loss-aversion-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
    });
};
const $1b12ea52aa3c0323$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type) || null;
    const productKey = (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7kqCT.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NA5p.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1b12ea52aa3c0323$var$runtimeProps
    }));
};
const $1b12ea52aa3c0323$var$DeferEditionModal = (0, $cSD7y.componentWithFG)('cross-flow-defer-edition-communication-gate', $1b12ea52aa3c0323$export$bb0d8fff645668ce, ()=>null);
const $1b12ea52aa3c0323$var$DeferRovoVideoModal = (0, $cSD7y.componentWithFG)('rovo_video_player_gate', $1b12ea52aa3c0323$export$3859d35c5447350b, ()=>null);
const $1b12ea52aa3c0323$var$DeferJiraLossAversionModal = (0, $cSD7y.componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $1b12ea52aa3c0323$export$3211958f96133af8, ()=>null);
const $1b12ea52aa3c0323$var$DesShareLinkFlag = (0, $cSD7y.componentWithFG)('jira_des_share_link_gate', $1b12ea52aa3c0323$var$LazyNonCriticalDesShareLinkFlag, ()=>null);
const $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal = (0, $cSD7y.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $lyCmi.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
$1b12ea52aa3c0323$var$DeferEditionModal.displayName = 'DeferEditionModal';
$1b12ea52aa3c0323$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$1b12ea52aa3c0323$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
$1b12ea52aa3c0323$var$DesShareLinkFlag.displayName = 'DesShareLinkFlag';
$1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
const $1b12ea52aa3c0323$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $kKa8l.MatchedRouteListener),
        (0, $bmetd.PreviousRouterStateListener),
        (0, $lDu2T.LoadingPhaseManager),
        (0, $3lMZZ.LoadingBarUIController),
        (0, $doxsH.default),
        (0, $ec3NH.BreadcrumbAdapter),
        (0, $izgL1.default),
        (0, $jElqQ.PageDwellAnalyticsListener),
        (0, $km1Z8.ImperativeAPI),
        (0, $jnXgM.TrackClicksBeforeTTI),
        (0, $dYRe6.default),
        (0, $dz0Q5.AsyncUpflowIframeComponent),
        (0, $4p6rw.JiraHeritageLoader),
        $1b12ea52aa3c0323$var$AsyncBrowserStorageControlsInit,
        ...$1b12ea52aa3c0323$var$isPendoIntegrationEnabled() ? [
            (0, $8JIza.AsyncPendoAnalyticsWrapper)
        ] : [],
        (0, $7N30e.default),
        $1b12ea52aa3c0323$var$RemoteActions,
        ...$1b12ea52aa3c0323$var$isTrialEndLockScreenExperimentEnabled() ? [
            (0, $e1ETT.AsyncLockScreenExperimentSharedWrapper)
        ] : [],
        (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_upgrade_onboarding'), $1b12ea52aa3c0323$export$70b554b486395223, ()=>null),
        $1b12ea52aa3c0323$var$DeferEditionModal,
        $1b12ea52aa3c0323$var$DeferRovoVideoModal,
        $1b12ea52aa3c0323$var$DeferJiraLossAversionModal,
        (0, $7jo2g.AsyncEndOfTrialMessageSharedWrapper),
        $1b12ea52aa3c0323$var$DesShareLinkFlag,
        $1b12ea52aa3c0323$var$AsyncRecommendPremiumToStandardModal
    ],
    $1b12ea52aa3c0323$var$Global,
    $1b12ea52aa3c0323$var$Navigation,
    $1b12ea52aa3c0323$var$Trackers,
    $1b12ea52aa3c0323$var$AfterPaintIssuePreEval
];
const $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YvQF.SafeEmbeddedConfluencePanel), null) : null;
};
const $1b12ea52aa3c0323$export$5f4dc7c98070d93e = (0, $1XrjK.createLayout)({
    rightSidebars: [
        (0, $7Lkcv.SafeHelpPanel),
        (0, $gmGW3.SafeConversationAssistantPanel),
        $1b12ea52aa3c0323$var$SafeEmbeddedConfluencePanelWithExperiments
    ],
    globalComponents: $1b12ea52aa3c0323$var$sharedGlobalComponents
});

});
parcelRegister("doxsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $899e926f09852ef7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $1NZBJ = parcelRequire("1NZBJ");
const $899e926f09852ef7$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $1NZBJ.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;

});
parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});
parcelRegister("bSSG7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $63804f80e89e547d$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $63804f80e89e547d$export$59acef2b3ab1df90);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $dEJQ9 = parcelRequire("dEJQ9");
const $63804f80e89e547d$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)(appPrefix, (0, $dEJQ9.makeLocalStore)()));
const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $dEJQ9.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("fNVZf", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $04caddce42518619$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $04caddce42518619$export$8441605555fbd60c);

var $fKgem = parcelRequire("fKgem");

var $c7J1U = parcelRequire("c7J1U");
const $04caddce42518619$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
    (0, $c7J1U.default)
];
const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("c7J1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d922a6a243a194$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $cuNKJ = parcelRequire("cuNKJ");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $99d922a6a243a194$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $cuNKJ.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $jcw0u.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $cuNKJ.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $cuNKJ.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $cuNKJ.ONE_WEEK) >= (0, $cuNKJ.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $cuNKJ.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;

});
parcelRegister("cuNKJ", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $d21613ddd27d5bbf$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $d21613ddd27d5bbf$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $d21613ddd27d5bbf$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $d21613ddd27d5bbf$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $d21613ddd27d5bbf$export$ea28dfd9333cda2d);
const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("dEJQ9", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $dcae70c06981fc99$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $dcae70c06981fc99$export$cf816b43e73de947);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $4Zgux = parcelRequire("4Zgux");

var $2NjNT = parcelRequire("2NjNT");

var $fNVZf = parcelRequire("fNVZf");
const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});




parcelRegister("8JIza", function(module, exports) {

$parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", () => $5adeefc5ea77d534$export$1c388e7c464f3699);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $7B17s = parcelRequire("7B17s");

const $5adeefc5ea77d534$var$AsyncPendoAnalytics = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("iuS4J")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
    moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
});
const $5adeefc5ea77d534$export$1c388e7c464f3699 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: "martech",
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5adeefc5ea77d534$var$AsyncPendoAnalytics, null)));

});
parcelRegister("iuS4J", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("4sJqf")
]).then(()=>parcelRequire('8bI7u'));

});


parcelRegister("gmGW3", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $836bcaaba692e6c5$export$453401d0b697d2db);

var $5uXOq = parcelRequire("5uXOq");

var $acKsZ = parcelRequire("acKsZ");


var $39xOx = parcelRequire("39xOx");

var $hsmeR = parcelRequire("hsmeR");

var $2Dcc2 = parcelRequire("2Dcc2");

var $2vgok = parcelRequire("2vgok");
const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $90daffeb17102814$export$dffb4ed44e20ea9a)) {
            /**
			 * The right-sidebar is showing the conversation assistant...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $acKsZ.FabricChannel).aiMate);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the conversation assistant,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $90daffeb17102814$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vgok.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    });
};
const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $90daffeb17102814$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $90daffeb17102814$export$64aee74ba59709e5 = 439; // px
const $90daffeb17102814$export$1c07393c5bb1bc27 = 439; // px
const $90daffeb17102814$export$aa3478deee7adbeb = 350; // px
const $90daffeb17102814$export$21e515a86cd1733b = 'Chat';

parcelRegister("2vgok", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $2321abcc17b38bef$export$da8473714271a41d);

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $kDWyO = parcelRequire("kDWyO");
var $6GRu4 = parcelRequire("6GRu4");


var $co1wz = parcelRequire("co1wz");

var $j8DrX = parcelRequire("j8DrX");

var $hsmeR = parcelRequire("hsmeR");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");
const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const isSyntheticTenant = (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $co1wz.ff)('jsw.pollinator.tenants');
    let baseUrl = '/gateway/api/assist';
    if ((0, $co1wz.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
    else if ((0, $hFKXd.getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
    const config = (0, $5uXOq.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                baseUrl: baseUrl
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant,
        baseUrl
    ]);
    const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
        openRightSidebar((0, $90daffeb17102814$export$dffb4ed44e20ea9a), width);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GRu4.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDWyO.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, $ii5wQ.xcss)({
    width: '100%'
});

});
parcelRegister("kDWyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8b5694adce53f6$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

var $8d8b5694adce53f6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aq7yK")),
    loading: ()=>null
});

});
parcelRegister("4qBtX", function(module, exports) {
"use strict";
var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $3396aa4dae68f4b9$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $3396aa4dae68f4b9$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $3396aa4dae68f4b9$var$render(loaded, props) {
    return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
}
function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $3396aa4dae68f4b9$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
        if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
            var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5uXOq.Component), _class.contextTypes = {
        loadable: $8rCP3.shape({
            report: $8rCP3.func.isRequired
        })
    }, _temp;
}
function $3396aa4dae68f4b9$var$Loadable(opts) {
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
}
function $3396aa4dae68f4b9$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
}
$3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
    $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
        return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5uXOq.Children.only(this.props.children);
    };
    return Capture;
}($5uXOq.Component);
$3396aa4dae68f4b9$var$Capture.propTypes = {
    report: $8rCP3.func.isRequired
};
$3396aa4dae68f4b9$var$Capture.childContextTypes = {
    loadable: $8rCP3.shape({
        report: $8rCP3.func.isRequired
    }).isRequired
};
$3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
    });
}
$3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $3396aa4dae68f4b9$var$Loadable;

});

parcelRegister("aq7yK", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("ekDvM")
]).then(()=>parcelRequire('fN8tZ'));

});


parcelRegister("6GRu4", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $094ebb41022fd8da$export$c7990a6594835e51);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $1uoeA = parcelRequire("1uoeA");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

const $094ebb41022fd8da$var$rootStyles = (0, $ii5wQ.xcss)({
    right: 'space.0',
    display: 'flex',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)} - ${(0, $1uoeA.BANNER_HEIGHT)})`
});
const $094ebb41022fd8da$var$handleStyles = (0, $ii5wQ.xcss)({
    cursor: 'ew-resize',
    userSelect: 'none',
    position: 'absolute',
    top: 'space.200',
    bottom: 'space.0',
    left: 'space.0',
    width: '24px',
    borderTopLeftRadius: 'border.radius.200',
    transition: 'border 0.2s ease-in-out',
    borderLeft: '2px solid transparent',
    ':hover': {
        borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
    }
});
const $094ebb41022fd8da$var$handleSpacerStyles = (0, $ii5wQ.xcss)({
    width: '24px',
    position: 'absolute',
    display: 'block',
    left: '-24px',
    top: 'space.0',
    bottom: 'space.0'
});
const $094ebb41022fd8da$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $90daffeb17102814$export$64aee74ba59709e5), minWidth: minWidth = (0, $90daffeb17102814$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
    const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    const initialMousePositionRef = (0, $5uXOq.useRef)(0);
    const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
    const rafRef = (0, $5uXOq.useRef)(null);
    const getWrapperWidth = ()=>{
        return wrapperRef.current?.getBoundingClientRect()?.width || 0;
    };
    const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const mouseMoveHandler = (0, $cBeZP.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $cBeZP.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $094ebb41022fd8da$var$rootStyles,
        ref: wrapperRef,
        role: "presentation",
        testId: "panel-resize-wrapper",
        style: {
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        testId: "panel-resize-handle",
        onMouseDown: handleMouseDown,
        xcss: $094ebb41022fd8da$var$handleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $094ebb41022fd8da$var$handleSpacerStyles
    })), children);
};

});

parcelRegister("fY39E", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $d72c67677898c114$export$43686faa787c943);

var $9OXo1 = parcelRequire("9OXo1");
const $d72c67677898c114$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});



parcelRegister("8NA5p", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $2684c9c6a6fb887b$export$4fa5b26bccc7e3df);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $7B17s = parcelRequire("7B17s");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("cpWGf")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
});
const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));

});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';

parcelRegister("cpWGf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("bVgxH")
]).then(()=>parcelRequire('1DysC'));

});


parcelRegister("7kqCT", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $110a94ef04661997$export$51f384a783f47807);

var $fiH7W = parcelRequire("fiH7W");

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");
const $110a94ef04661997$var$Fallback = ()=>null;

const $110a94ef04661997$export$51f384a783f47807 = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(async ()=>{
        if (!false) return (parcelRequire("fscIg")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
        return $110a94ef04661997$var$Fallback;
    }, {
        moduleId: "fe342c6b"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $fiH7W.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("fiH7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18804309a0f9ffd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<538598f02d4274863e69f87ef93afee0>>
 * @relayHash b88a5c8f8a06940641d1109bbd763eff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac
const $d18804309a0f9ffd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;

});

parcelRegister("fscIg", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hmyGT")
]).then(()=>parcelRequire('8IIKL'));

});


parcelRegister("7jo2g", function(module, exports) {

$parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", () => $b603c0291b5c0134$export$ae154a7bf883999f);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $7B17s = parcelRequire("7B17s");

var $bZB1h = parcelRequire("bZB1h");

const $b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("doUe0")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
    moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
});
const $b603c0291b5c0134$export$ae154a7bf883999f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "end-of-trial-message-shared-async",
        packageName: (0, $bZB1h.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $bZB1h.TEAM_NAME),
        id: "end-of-trial-message-shared-async",
        packageName: (0, $bZB1h.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));

});
parcelRegister("bZB1h", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $25fa48d758254005$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $25fa48d758254005$export$d57b6b390e78d90f);
$parcel$export(module.exports, "STARGATE_URL", () => $25fa48d758254005$export$c7e6a6b283196232);
$parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", () => $25fa48d758254005$export$1986890201f1a80);

var $2vSU6 = parcelRequire("2vSU6");
const $25fa48d758254005$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
const $25fa48d758254005$export$d57b6b390e78d90f = 'transmuters-growth';
const $25fa48d758254005$export$c7e6a6b283196232 = '/gateway/api';
const $25fa48d758254005$export$1986890201f1a80 = {
    [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: [
        'jpd_standard_end_of_trial_message_day_14',
        'jpd_standard_end_of_trial_message_day_13',
        'jpd_standard_end_of_trial_message_day_12',
        'jpd_standard_end_of_trial_message_day_11',
        'jpd_standard_end_of_trial_message_day_10',
        'jpd_standard_end_of_trial_message_day_9',
        'jpd_standard_end_of_trial_message_day_8',
        'jpd_standard_end_of_trial_message_day_7',
        'jpd_standard_end_of_trial_message_day_6',
        'jpd_standard_end_of_trial_message_day_5',
        'jpd_standard_end_of_trial_message_day_4',
        'jpd_standard_end_of_trial_message_day_3',
        'jpd_standard_end_of_trial_message_day_2',
        'jpd_standard_end_of_trial_message_day_1'
    ],
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: [
        'jsm_standard_end_of_trial_message_day_14',
        'jsm_standard_end_of_trial_message_day_13',
        'jsm_standard_end_of_trial_message_day_12',
        'jsm_standard_end_of_trial_message_day_11',
        'jsm_standard_end_of_trial_message_day_10',
        'jsm_standard_end_of_trial_message_day_9',
        'jsm_standard_end_of_trial_message_day_8',
        'jsm_standard_end_of_trial_message_day_7',
        'jsm_standard_end_of_trial_message_day_6',
        'jsm_standard_end_of_trial_message_day_5',
        'jsm_standard_end_of_trial_message_day_4',
        'jsm_standard_end_of_trial_message_day_3',
        'jsm_standard_end_of_trial_message_day_2',
        'jsm_standard_end_of_trial_message_day_1'
    ]
};

});

parcelRegister("doUe0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eXdJ6")
]).then(()=>parcelRequire('bOc3m'));

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jQsty = parcelRequire("jQsty");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("fiv1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dee5a929ec50c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $41dee5a929ec50c3$export$83fb48644dee72f0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");
function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
        environment: (0, $5yJb9.default)()
    }, children);
}
function $41dee5a929ec50c3$export$83fb48644dee72f0() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("5yJb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $eiowN = parcelRequire("eiowN");

var $aWXMn = parcelRequire("aWXMn");
let $0dfb67cb8d2ba29a$var$relayEnvironment;
function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
    if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
        const environmentConfig = (0, $aWXMn.getRelayEnvironmentConfig)();
        $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
    }
    return $0dfb67cb8d2ba29a$var$relayEnvironment;
}

});
parcelRegister("aWXMn", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $eb7981c11bea2531$export$a451c85db2d1cda3);

var $4XQuR = parcelRequire("4XQuR");

var $d89yU = parcelRequire("d89yU");

var $SFCUj = parcelRequire("SFCUj");
const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, $SFCUj.getDefaultRelayEnvironmentConfig)({
        network: (0, $d89yU.getNetwork)(),
        log: (0, $4XQuR.default),
        requiredFieldLogger: $4XQuR.requiredFieldLogger
    });

});
parcelRegister("4XQuR", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $50b0aa0805b37d6d$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $50b0aa0805b37d6d$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $jQsty = parcelRequire("jQsty");

var $hhGDe = parcelRequire("hhGDe");
const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
const $50b0aa0805b37d6d$var$requests = {};
const $50b0aa0805b37d6d$var$queries = {};
const $50b0aa0805b37d6d$var$resources = {};
const $50b0aa0805b37d6d$var$executes = {};
const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
    if ((0, $jQsty.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                    $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                        delete $50b0aa0805b37d6d$var$queries[name];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $50b0aa0805b37d6d$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $hhGDe.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $50b0aa0805b37d6d$var$queries[node.name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $50b0aa0805b37d6d$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $50b0aa0805b37d6d$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $50b0aa0805b37d6d$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("d89yU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $7997274d03790a98$export$7de4970ebfd8206d);

var $eiowN = parcelRequire("eiowN");

var $gIJXH = parcelRequire("gIJXH");

var $k1TrK = parcelRequire("k1TrK");

var $fwvto = parcelRequire("fwvto");
const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
    if ((0, $fwvto.isSSR)()) (0, $eiowN.Network).create((0, $gIJXH.fetch));
    return (0, $eiowN.Network).create((0, $gIJXH.fetch), (0, $k1TrK.subscribe));
};

});
parcelRegister("gIJXH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $1UikQ = parcelRequire("1UikQ");

var $eiowN = parcelRequire("eiowN");

var $in8kY = parcelRequire("in8kY");

var $eYRXH = parcelRequire("eYRXH");

var $aDvGo = parcelRequire("aDvGo");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $6b2ko = parcelRequire("6b2ko");

var $4tcSU = parcelRequire("4tcSU");

var $5a0Nh = parcelRequire("5a0Nh");

var $gwtGO = parcelRequire("gwtGO");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $1TM3p = parcelRequire("1TM3p");

var $khBMq = parcelRequire("khBMq");

var $7nt8t = parcelRequire("7nt8t");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");
let $2963ed038d5e3581$var$redirecting = false;
const $2963ed038d5e3581$var$redirect = ()=>{
    const identity = (0, $in8kY.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
// Silence error logs from queries in this list
const $2963ed038d5e3581$var$blocklist = [
    'issueAggQuery'
];
const $2963ed038d5e3581$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $6b2ko.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $2963ed038d5e3581$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
/**
 * Given a set of options, produce a new set of options for consumption which contains
 * a combination of the given set and the default options
 * @param {RequestOptions} options
 * @returns RequestOptions
 */ const $2963ed038d5e3581$var$generateOptions = (options = {})=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $4tcSU.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $aDvGo.default),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $2963ed038d5e3581$var$checkAuthentication = ()=>{
    if (!false && !$2963ed038d5e3581$var$redirecting) {
        const heartbeatService = (0, $eYRXH.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            $2963ed038d5e3581$var$redirect();
            // Set flag to prevent multiple redirects
            $2963ed038d5e3581$var$redirecting = true;
        }
    }
};
const $2963ed038d5e3581$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    $2963ed038d5e3581$var$checkAuthentication();
    if ($2963ed038d5e3581$var$redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $khBMq.getAggEndpoint)(request, cacheConfig);
            const body = (0, $khBMq.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $7pVV3.QueryResponseCache).get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $7pVV3.QueryResponseCache).delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, $2963ed038d5e3581$var$generateOptions({
                        body: body
                    })),
                retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...$2963ed038d5e3581$var$generateOptions({
                    body: body
                }),
                retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $7nt8t.addTraceId)(queryName, $2963ed038d5e3581$var$getTraceIdFromExtensions(response));
                (0, $1TM3p.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!$2963ed038d5e3581$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $5a0Nh.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $5a0Nh.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $7pVV3.QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) (0, $kipqU.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("eusud", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3637c0f7edbd2bb4$export$8e9baed7697e4959);
$parcel$export(module.exports, "applyErrorHandling", () => $3637c0f7edbd2bb4$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3637c0f7edbd2bb4$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3637c0f7edbd2bb4$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3637c0f7edbd2bb4$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3637c0f7edbd2bb4$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3637c0f7edbd2bb4$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3637c0f7edbd2bb4$export$a5717cbee13f28b7);

var $aDvGo = parcelRequire("aDvGo");


var $co1wz = parcelRequire("co1wz");

var $jQsty = parcelRequire("jQsty");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $6b2ko = parcelRequire("6b2ko");

var $iwPwz = parcelRequire("iwPwz");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $jJZqs.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3637c0f7edbd2bb4$var$putOptions = {
    ...(0, $aDvGo.default),
    method: 'PUT'
};
const $3637c0f7edbd2bb4$var$postOptions = {
    ...(0, $aDvGo.default),
    method: 'POST'
};
const $3637c0f7edbd2bb4$var$deleteOptions = {
    ...(0, $aDvGo.default),
    method: 'DELETE'
};
const $3637c0f7edbd2bb4$var$patchOptions = {
    ...(0, $aDvGo.default),
    method: 'PATCH'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
    const traceId = (0, $iwPwz.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $co1wz.ff)('issue.details.hard-limits.milestone-1') && (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $jQsty.default)('platform_fetch_retries')) return executeRequest();
    return (0, $6b2ko.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...(0, $aDvGo.default),
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...(0, $aDvGo.default),
        ...options
    });
const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    });

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("6b2ko", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6910b563ec955346$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6910b563ec955346$export$f859c88bfac2cf2c);
const $6910b563ec955346$export$81189edc9b923717 = 1;
const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});


parcelRegister("5a0Nh", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $cf86a52470c84b66$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $cf86a52470c84b66$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $cf86a52470c84b66$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $cf86a52470c84b66$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7Jxgt = parcelRequire("7Jxgt");
const $cf86a52470c84b66$var$errorCollector = new Map();
const $cf86a52470c84b66$export$da396ad2a542b095 = 120000; // 2min
const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $cf86a52470c84b66$var$errorCollector.delete(key);
    }, $cf86a52470c84b66$export$da396ad2a542b095);
};
const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4())=>{
    $cf86a52470c84b66$var$errorCollector.set(key, []);
    $cf86a52470c84b66$var$scheduleCleanup(key);
    return key;
};
const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
    const errors = $cf86a52470c84b66$var$errorCollector.get(key);
    $cf86a52470c84b66$var$errorCollector.delete(key);
    return errors || [];
};
const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
        $cf86a52470c84b66$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("gwtGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1019e315ad42f34a$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'virtual-agent-beta',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});

parcelRegister("kipqU", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $f428f7f15822f637$export$607b80f5bc6e396d);
const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();

});

parcelRegister("7pVV3", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $675c7f0a9d659efe$export$688bd21be71b9e5d);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $eiowN = parcelRequire("eiowN");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $kizcd = parcelRequire("kizcd");
function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eiowN.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $kizcd.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $dJl1T.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d.serialize();

});
parcelRegister("kizcd", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $f174935352f053b0$export$8431e42d062de453);
class $f174935352f053b0$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
        this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $b5JOY = parcelRequire("b5JOY");

var $khBMq = parcelRequire("khBMq");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $khBMq.getAggEndpoint)(compiledQuery.params);
    const body = (0, $khBMq.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $b5JOY.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});


parcelRegister("lKFKm", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $42cb6e1c2fdc593e$export$758fcc357484571e);

var $pa9q9 = parcelRequire("pa9q9");

var $fjcgS = parcelRequire("fjcgS");

var $8iiwm = parcelRequire("8iiwm");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
    (0, $pa9q9.showFlag)({
        type: 'error',
        title: (0, $8iiwm.default).title,
        description: (0, $8iiwm.default).description,
        actions: [
            {
                content: (0, $8iiwm.default).login,
                onClick: $42cb6e1c2fdc593e$var$reloadPage
            }
        ]
    });
    $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("pa9q9", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $00ff685527f9e8c1$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $00ff685527f9e8c1$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $00ff685527f9e8c1$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $00ff685527f9e8c1$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $00ff685527f9e8c1$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $00ff685527f9e8c1$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $00ff685527f9e8c1$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $00ff685527f9e8c1$export$c126d8b307b8ab86);

var $fHfPB = parcelRequire("fHfPB");

var $gEdnQ = parcelRequire("gEdnQ");

var $01A9Z = parcelRequire("01A9Z");

var $7HGHK = parcelRequire("7HGHK");
const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, $gEdnQ.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, $fHfPB.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
    $00ff685527f9e8c1$export$900a08a292ad23cd((0, $fHfPB.dismissFlag)(id));
};
const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, $01A9Z.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
    showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
    dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
};
const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
        hasFlag: $00ff685527f9e8c1$var$hasFlag
    });
const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $7HGHK.DISMISS_COMMAND);
const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fHfPB", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $8eb241d1a1f5d9b7$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $8eb241d1a1f5d9b7$export$2e2bcd8739ae039);

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $7HGHK.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $d6YjM.dismissFlagAction)(action.id));
    };

});
parcelRegister("d6YjM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $07f19e2fef34903b$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $07f19e2fef34903b$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $07f19e2fef34903b$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $07f19e2fef34903b$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $07f19e2fef34903b$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $07f19e2fef34903b$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $07f19e2fef34903b$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $07f19e2fef34903b$export$aad8462122ac592b);
const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
        type: $07f19e2fef34903b$export$9d04158a25ce4cd,
        payload: payload
    });
const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
        type: $07f19e2fef34903b$export$b31a07d2e6382678,
        payload: payload
    });
const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
        type: $07f19e2fef34903b$export$1eb56620df104bf,
        payload: payload
    });
const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
        type: $07f19e2fef34903b$export$4a991c87e640ef77
    });

});

parcelRegister("7HGHK", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $9deb2cdefe93babb$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $9deb2cdefe93babb$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $9deb2cdefe93babb$export$188cdb77b72629d7);
const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("gEdnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c019df33694ffbe1$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $d6YjM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $7HGHK.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $d6YjM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("01A9Z", function(module, exports) {

$parcel$export(module.exports, "store", () => $5787309a6ab0ba9c$export$6f57813fe9f31bf9);

var $imvpl = parcelRequire("imvpl");
const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, $imvpl.createStore)();

});
parcelRegister("imvpl", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6bbcd4b408b9a94e$export$f51a9068ac82ea43);

var $F2Mxm = parcelRequire("F2Mxm");

var $gG398 = parcelRequire("gG398");
const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'flags',
        rootReducer: $gG398.default,
        rootEpic: rootEpic
    });

});
parcelRegister("F2Mxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca77440264e922e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $i9gPl = parcelRequire("i9gPl");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i9gPl.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, $hkadP.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("iGv2H", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $a4079cece44c0fab$export$342c99cc1e9bc5c6);
const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("hkadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c98afd3082218$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $3f2cs.compose;
};

});

parcelRegister("i9gPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $330df53c22ed8aaf$export$2e2bcd8739ae039);
class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("gG398", function(module, exports) {

$parcel$export(module.exports, "default", () => $1feeabef4760da78$export$2e2bcd8739ae039);

var $ifg6x = parcelRequire("ifg6x");

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");
const $1feeabef4760da78$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
    switch(action.type){
        case 0, $d6YjM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))([
                    {
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $d6YjM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $d6YjM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $d6YjM.RESET:
            return $1feeabef4760da78$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("8iiwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ec0f26423b786$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("7isEg", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $6c554999a424d172$export$726e1df8186bb981);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");
const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});


parcelRegister("k1TrK", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $4ced6779db298dc0$export$ec068583843480e7);

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $lWhTC = parcelRequire("lWhTC");

var $1Uhm6 = parcelRequire("1Uhm6");

var $cfDZ3 = parcelRequire("cfDZ3");
const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
        const client = (0, $lWhTC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.agg?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $cfDZ3.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("lWhTC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $2a46eca1e9133707$export$6bb76d6eba7e258c);

var $4U1PW = parcelRequire("4U1PW");

var $jQsty = parcelRequire("jQsty");

var $gwtGO = parcelRequire("gwtGO");


var $hoQbP = parcelRequire("hoQbP");
let $2a46eca1e9133707$var$client;
const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hoQbP.isSSR)() || (0, $jQsty.default)('graphql_subscriptions')) return null;
    if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, $4U1PW.createClient)({
        url: (0, $hoQbP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
        retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(',')
        }
    });
    return $2a46eca1e9133707$var$client;
};
const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
    $2a46eca1e9133707$var$client = null;
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("hoQbP", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $9e6d9986231c3fe5$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $9e6d9986231c3fe5$export$29a72e89601dfc59);
const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("1Uhm6", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $db2d4e9951ebaa0f$export$ece4736473c28965);
const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});


parcelRegister("fwvto", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $c5bf640417859136$export$48d7c418edadb60c);
const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = ()=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("7N30e", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $5d68e3874efadecb$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $5d68e3874efadecb$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $5d68e3874efadecb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $3vBBc = parcelRequire("3vBBc");

var $fjcgS = parcelRequire("fjcgS");

var $lsa9q = parcelRequire("lsa9q");

var $6b6Tk = parcelRequire("6b6Tk");

const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
let $5d68e3874efadecb$var$stopDelayTimeout;
let $5d68e3874efadecb$var$lastDelayActionPromise = (0, $fjcgS.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $5d68e3874efadecb$export$a928755af449867 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $3vBBc.isEventDelayActive)()) return client;
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
        (0, $3vBBc.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $3vBBc.isEventDelayActive)()) {
            (0, $kUU4G.default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
            (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $3vBBc.setEventDelayActive)(true);
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
const $5d68e3874efadecb$var$EventDelayController = ()=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;

});
parcelRegister("kUU4G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb4d2f8b5a69f79$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $6RCeq.default) && (0, $6RCeq.default).getEntries && (0, $6RCeq.default).clearMarks) return (0, $6RCeq.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $6RCeq.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("3vBBc", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $63f3b8c0745d0500$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $63f3b8c0745d0500$export$3536b0184fa98d19);
let $63f3b8c0745d0500$var$eventDelayActive = false;
const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
};
const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;

});

parcelRegister("lsa9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f20cb56a66aca22$export$2e2bcd8739ae039);

var $7JoAD = parcelRequire("7JoAD");


var $7w9eZ = parcelRequire("7w9eZ");
const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
});
var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;

});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;


parcelRegister("cSD7y", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $9b560cafc84bf9e8$export$cf56d0f54cfcce4);

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $9b560cafc84bf9e8$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("3lMZZ", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $ade6fcbf7908cda7$export$39bdf67fc71ce8c8);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $d46Cs = parcelRequire("d46Cs");

var $lsa9q = parcelRequire("lsa9q");

var $bVDE5 = parcelRequire("bVDE5");

var $dIdda = parcelRequire("dIdda");

var $04unK = parcelRequire("04unK");

var $cYUbO = parcelRequire("cYUbO");
const $ade6fcbf7908cda7$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $ade6fcbf7908cda7$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $5uXOq.useState)({});
    const sheetRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $04unK.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cYUbO.generateLoadingBarStyles)(0, (0, $04unK.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $ade6fcbf7908cda7$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $ade6fcbf7908cda7$var$getUniqueTransitionKey = $ade6fcbf7908cda7$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $ade6fcbf7908cda7$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $dIdda.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $04unK.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $5uXOq.useMemo)(()=>$ade6fcbf7908cda7$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $dJl1T.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ade6fcbf7908cda7$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("d46Cs", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $65545b2eb3978204$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $61WP1 = parcelRequire("61WP1");
const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $65545b2eb3978204$export$899393f3e23f724b = 15000;
const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, $61WP1.getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $65545b2eb3978204$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$65545b2eb3978204$var$setupLoadingBarActionController();

});
parcelRegister("61WP1", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $22b3d998cd498e5f$export$c47913ca32a5c6f7);
const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("bVDE5", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $1f866bb77da3c907$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $1f866bb77da3c907$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");

var $7JoAD = parcelRequire("7JoAD");

var $7w9eZ = parcelRequire("7w9eZ");
const $1f866bb77da3c907$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $6RCeq.default) && (0, $6RCeq.default).timing && (0, $6RCeq.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, $7JoAD.createSubscriber)((0, $7w9eZ.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;

});

parcelRegister("04unK", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $ac75ec265428b4c8$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $ac75ec265428b4c8$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $ac75ec265428b4c8$export$cf3a5ed89e041425);

var $8QpSo = parcelRequire("8QpSo");

var $65Ltd = parcelRequire("65Ltd");

var $j8DrX = parcelRequire("j8DrX");
const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
    (0, $65Ltd.ROUTE_NAMES_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_ISSUE_EMBED),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $65Ltd.ROUTE_NAMES_YOUR_WORK),
    (0, $65Ltd.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
    (0, $65Ltd.ROUTE_NAMES_BOARDS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
    (0, $65Ltd.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_PAGES),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ROADMAP),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
];
const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, $8QpSo.default)(()=>{
    const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, $8QpSo.default)(()=>(0, $j8DrX.default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);

});

parcelRegister("cYUbO", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $e5278a73a699aa95$export$3036104bc81246b1);

var $gwIPs = parcelRequire("gwIPs");

var $04unK = parcelRequire("04unK");
const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $gwIPs.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $04unK.LOADER_STYLESHEET_ID}>
            ${0, $04unK.LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, $04unK.getLoadingBarColor)())}}
        </style>`;

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $80d528dbc2b11cbc$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $80d528dbc2b11cbc$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $80d528dbc2b11cbc$export$b3219800bda33a1f);

var $1wToE = parcelRequire("1wToE");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, $1wToE.gridSize)();
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $1wToE.borderRadius)();
const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, $1wToE.fontSize)();
const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, $1wToE.fontFamily)();
const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, $1wToE.codeFontFamily)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $1wToE.layers).navigation(),
    card: (0, $1wToE.layers).card(),
    dialog: (0, $1wToE.layers).dialog(),
    navigation: (0, $1wToE.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $1wToE.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $1wToE.layers).navigation() - 1,
    layer: (0, $1wToE.layers).layer(),
    blanket: (0, $1wToE.layers).blanket(),
    modal: (0, $1wToE.layers).modal(),
    flag: (0, $1wToE.layers).flag(),
    spotlight: (0, $1wToE.layers).spotlight(),
    tooltip: (0, $1wToE.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
};

});



parcelRegister("7Lkcv", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $70a8cef9c47c5a71$export$cd2ada2fb14048fc);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $39xOx = parcelRequire("39xOx");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");


var $7dTw7 = parcelRequire("7dTw7");

var $1SVH7 = parcelRequire("1SVH7");

var $hsmeR = parcelRequire("hsmeR");

var $90yGq = parcelRequire("90yGq");
const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dTw7.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1SVH7.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $6BNJk.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $6BNJk.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
};
const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);

var $7JoAD = parcelRequire("7JoAD");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $7JoAD.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $7JoAD.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $7JoAD.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $7JoAD.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $7JoAD = parcelRequire("7JoAD");

var $958ua = parcelRequire("958ua");
const $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $465615692863cce9$var$initialState = {
    navigationData: {
        // @ts-expect-error - TS2322 - Type '"HELP_ARTICLE"' is not assignable to type 'ARTICLE_TYPE'.
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        history: $465615692863cce9$var$iphStorage.get('history') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("eNf8a", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $b98f887ad675a269$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $b98f887ad675a269$export$e0a2e9a062c6a695);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $j9Vq5 = parcelRequire("j9Vq5");
const $b98f887ad675a269$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)(appPrefix, (0, $j9Vq5.makeSessionStore)()));
const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $j9Vq5.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("j9Vq5", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $93ac2abe604287b3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $93ac2abe604287b3$export$a8f626c8ded9a06c);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $2NjNT = parcelRequire("2NjNT");

var $c74za = parcelRequire("c74za");

var $fNVZf = parcelRequire("fNVZf");
const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});


parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("7dTw7", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $52205ad66fbf5dd9$export$3db011870dd4330f);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $kspz4 = parcelRequire("kspz4");

const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
    const accountId = (0, $90yGq.useAccountId)();
    const [debouncedUpdateData] = (0, $laWvb.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
    (0, $5uXOq.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});
parcelRegister("laWvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $5uXOq.useRef)(null);
    var maxWaitArgs = (0, $5uXOq.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $5uXOq.useRef)(false);
    var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
    var isComponentUnmounted = (0, $5uXOq.useRef)(false);
    var debouncedFunction = (0, $5uXOq.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $5uXOq.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $5uXOq.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});


parcelRegister("1SVH7", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $311d1a0e95633292$export$51c79455aef7d178);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $6s1PB = parcelRequire("6s1PB");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $iXVV6 = parcelRequire("iXVV6");

var $bjVJA = parcelRequire("bjVJA");

var $jVpMq = parcelRequire("jVpMq");

var $7rrMi = parcelRequire("7rrMi");

var $4RupH = parcelRequire("4RupH");
const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $cYlk7.useCurrentUser)();
    const IPH_USE_HELP_AGGREGATOR_FLAG = (0, $6s1PB.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rrMi.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        attributes: {
            searchService: IPH_USE_HELP_AGGREGATOR_FLAG ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjVJA.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4RupH.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);

var $7JoAD = parcelRequire("7JoAD");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $7JoAD.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $7JoAD.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $7JoAD.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};

});




parcelRegister("jVpMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bb188482996cb7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5CrlE = parcelRequire("5CrlE");
const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4pxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$HeaderLoading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingRectangle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $lD23V.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $lD23V.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $lD23V.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleListItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5CrlE", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $2dbd0534194918a8$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $2dbd0534194918a8$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $2dbd0534194918a8$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $2dbd0534194918a8$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2dbd0534194918a8$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1kl71osx _1reo15vq _18m915vq _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1i8v _11q71bhr",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$9f6251c714594f23 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7rrMi", function(module, exports) {

$parcel$export(module.exports, "useSearchContext", () => $c0047fc735c61769$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $c0047fc735c61769$export$6bd70292443463a4);

var $5uXOq = parcelRequire("5uXOq");

var $jFLAi = parcelRequire("jFLAi");
const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, $jFLAi.createCtx)();
const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
    const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("jFLAi", function(module, exports) {

$parcel$export(module.exports, "createCtx", () => $b612e461f4fc901f$export$d653a1a643c9a98c);

var $5uXOq = parcelRequire("5uXOq");
function $b612e461f4fc901f$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
    function useCtx() {
        const c = (0, $5uXOq.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("4RupH", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $4ce54108d7c5ac07$export$7ff46d33d0f13518);

var $7B17s = parcelRequire("7B17s");

const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("9Y8nX")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("9Y8nX", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("cBrFc")
]).then(()=>parcelRequire('jj3on'));

});




parcelRegister("9YvQF", function(module, exports) {

$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $3e89344d89118823$export$2d901a489872dd0d);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $9KYrx = parcelRequire("9KYrx");

var $gXSrH = parcelRequire("gXSrH");

var $39xOx = parcelRequire("39xOx");

var $hsmeR = parcelRequire("hsmeR");

var $9V9QO = parcelRequire("9V9QO");
const $3e89344d89118823$var$DELAY = 310;
const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $9V9QO.useEmbeddedPanelEntryPoint)();
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $3e89344d89118823$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $3e89344d89118823$var$panelStyles
    }, entryPoint);
};
const $3e89344d89118823$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXSrH.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
const $3e89344d89118823$var$panelStyles = (0, $ii5wQ.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("9KYrx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $e486b17128606747$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $e486b17128606747$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $e486b17128606747$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $e486b17128606747$export$a497288e64e9a343);
const $e486b17128606747$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("gXSrH", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $27a5db923b3bcebb$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $27a5db923b3bcebb$export$518aeea31a00450e);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");

var $hsmeR = parcelRequire("hsmeR");

var $7JoAD = parcelRequire("7JoAD");

var $9KYrx = parcelRequire("9KYrx");

var $aQLD7 = parcelRequire("aQLD7");

var $bvqNo = parcelRequire("bvqNo");

var $5labn = parcelRequire("5labn");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $27a5db923b3bcebb$var$Container = (0, $7JoAD.createContainer)();
const $27a5db923b3bcebb$var$DefaultStore = (0, $7JoAD.createStore)({
    actions: $aQLD7.actions,
    containedBy: $27a5db923b3bcebb$var$Container,
    initialState: $aQLD7.initialState,
    name: (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $27a5db923b3bcebb$var$NonContainerStore = (0, $7JoAD.createStore)({
    actions: $aQLD7.actions,
    initialState: $aQLD7.initialState,
    name: (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $27a5db923b3bcebb$var$defaultStoreHook = (0, $7JoAD.createHook)($27a5db923b3bcebb$var$DefaultStore);
const $27a5db923b3bcebb$var$nonContainerStoreHook = (0, $7JoAD.createHook)($27a5db923b3bcebb$var$NonContainerStore);
const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    /*
		The condition below is a temporary workaround for the Side Panel experiment to avoid
		throwing an error when the Store is not contained by a container. This logic should be removed
		once the experiment has been productionized: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jira_issue_view_side_by_side_modeless_ep
	*/ const [embedConfluenceSidepanelConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
    const [state, { setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceName: setDeferredSpaceName, openSidePanel: openSidePanelAction, closeSidePanel: closeSidePanelAction }] = isInExperiment ? $27a5db923b3bcebb$var$defaultStoreHook() : $27a5db923b3bcebb$var$nonContainerStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $5labn.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $bvqNo.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
        closeRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceName: setDeferredSpaceName,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection
        }
    ];
};

});
parcelRegister("2gCtH", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $9e67f38435565e11$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $9e67f38435565e11$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $9e67f38435565e11$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $9e67f38435565e11$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $9e67f38435565e11$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $9e67f38435565e11$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $9e67f38435565e11$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $9e67f38435565e11$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $9e67f38435565e11$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $9e67f38435565e11$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $9e67f38435565e11$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $9e67f38435565e11$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $9e67f38435565e11$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $9e67f38435565e11$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $9e67f38435565e11$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $9e67f38435565e11$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $9e67f38435565e11$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $9e67f38435565e11$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $9e67f38435565e11$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $9e67f38435565e11$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $9e67f38435565e11$export$b131d9f6da853161);
$parcel$export(module.exports, "useIsJiraIssue", () => $9e67f38435565e11$export$cf5fc815f761fb4b);

var $5uXOq = parcelRequire("5uXOq");


var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $93Yeu = parcelRequire("93Yeu");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $koiRX = parcelRequire("koiRX");
const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $koiRX.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $koiRX.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $koiRX.useIssueContextStoreIsModal)();
    return isModal;
};
const $9e67f38435565e11$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $koiRX.useIssueContextStoreIssueId)();
    return issueId;
};
const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $koiRX.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $koiRX.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return (0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
};
const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $koiRX.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $koiRX.useIssueContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $koiRX.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $koiRX.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $9e67f38435565e11$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $koiRX.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $koiRX.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $koiRX.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $koiRX.useIssueContextStoreViewMode)();
    return viewMode;
};
const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $koiRX.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $koiRX.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $9e67f38435565e11$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $koiRX.useIssueContextStoreBoardId)();
    return boardId;
};
const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $koiRX.useIssueContextStoreBoardType)();
    return boardType;
};
const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $koiRX.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $koiRX.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $koiRX.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $koiRX.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $koiRX.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
};
const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
};
const $9e67f38435565e11$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $koiRX.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};
const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $9e67f38435565e11$export$22108eca27445997();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    return [
        (0, $2vSU6.SOFTWARE_PROJECT),
        (0, $2vSU6.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $1daUm.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $7JoAD = parcelRequire("7JoAD");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $7JoAD.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});



parcelRegister("7trqb", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $5fcaa3f734e9c444$export$268651a63abe408a);

var $9OXo1 = parcelRequire("9OXo1");
const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("koiRX", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $35da250daae5206d$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $35da250daae5206d$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $35da250daae5206d$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $35da250daae5206d$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $35da250daae5206d$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $35da250daae5206d$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $35da250daae5206d$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $35da250daae5206d$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $35da250daae5206d$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $35da250daae5206d$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $35da250daae5206d$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $35da250daae5206d$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $35da250daae5206d$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $35da250daae5206d$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $35da250daae5206d$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $35da250daae5206d$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $35da250daae5206d$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $35da250daae5206d$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $35da250daae5206d$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $35da250daae5206d$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $35da250daae5206d$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $35da250daae5206d$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $35da250daae5206d$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $35da250daae5206d$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $35da250daae5206d$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $35da250daae5206d$export$965360ae27fcae98);

var $g5X3G = parcelRequire("g5X3G");

var $7JoAD = parcelRequire("7JoAD");

var $fMAcJ = parcelRequire("fMAcJ");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $35da250daae5206d$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $g5X3G.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $edJtc.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    name: 'issue-context',
    initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
    actions: $fMAcJ.actions
});
const $35da250daae5206d$var$getIssueContext = (state)=>state;
const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueContext
});
const $35da250daae5206d$export$abdbea56d86b4aac = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesLimit)
});
const $35da250daae5206d$export$326ff2b963d51c5c = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesIssueLimitUrls)
});
const $35da250daae5206d$export$44bcaaabb74e402b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueKey
});
const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueId
});
const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsArchived
});
const $35da250daae5206d$export$b9eebaa1da421997 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsClassifyEditEnabled
});
const $35da250daae5206d$export$daa47fd600e43a32 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsModal
});
const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewScreenId
});
const $35da250daae5206d$export$74d38d6c437efc1b = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getAnalyticsSource
});
const $35da250daae5206d$export$2092528ee170d9e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewMap
});
const $35da250daae5206d$export$57898374e6239a5a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getMaxTokenLength
});
const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoadedWithPage
});
const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getEstimationStatistic
});
const $35da250daae5206d$export$fe7085456138f0fc = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoading
});
const $35da250daae5206d$export$c339e36468c12443 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewMode
});
const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBackButtonUrl
});
const $35da250daae5206d$export$8accd063c74cd455 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueNavigatorData
});
const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardId
});
const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardType
});
const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsSpaEnabled
});
const $35da250daae5206d$export$bbd8ba0180545556 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getLoginRedirectUrl
});
const $35da250daae5206d$export$aaa89627762c7d00 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getOnIssueKeyChange
});
const $35da250daae5206d$export$796589b0ec52848a = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewId
});
const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsAiOptInEnabled
});
const $35da250daae5206d$export$93db6a8f3342dddf = (0, $7JoAD.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
const $35da250daae5206d$export$965360ae27fcae98 = (0, $7JoAD.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fMAcJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $043cabfbcc6107f0$export$e324594224ef24da);

var $7l48d = parcelRequire("7l48d");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $iElCl.getChildIssuesLimit)(getState());
const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $edJtc.getViewModeFromLocalStorage)()
        });
    };
const $043cabfbcc6107f0$export$e324594224ef24da = {
    setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
    mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
    getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
    getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
    getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
    getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
    getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
    setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
    resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
};

});
parcelRegister("7l48d", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $e736233a6ed098e3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $e736233a6ed098e3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$a13f7f627010bccd);

var $bSSG7 = parcelRequire("bSSG7");
const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_issue_view');
const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("iElCl", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $fde75c94a28741e3$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $fde75c94a28741e3$export$8f43520910e8128c);

var $dJl1T = parcelRequire("dJl1T");

var $7l48d = parcelRequire("7l48d");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $7l48d.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("edJtc", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$cae7c4c591dcc261);

var $7l48d = parcelRequire("7l48d");
const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>(0, $7l48d.localStorage).get((0, $7l48d.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';

});




parcelRegister("aQLD7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $0ebe24e18a9cec5a$export$e324594224ef24da);

var $ikhc7 = parcelRequire("ikhc7");

var $bvqNo = parcelRequire("bvqNo");
const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $bvqNo.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $bvqNo.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false
    },
    modal: {
        isOpen: false
    }
};
const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    };
const $0ebe24e18a9cec5a$export$1a38f537b5932219 = (deferredSpaceName)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $0ebe24e18a9cec5a$export$e324594224ef24da = {
    closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
    setDeferredSpaceName: $0ebe24e18a9cec5a$export$1a38f537b5932219,
    openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
    setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a
};

});
parcelRegister("ikhc7", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $5bf38af506e4762b$export$816ef638e478449a);
var $5bf38af506e4762b$export$816ef638e478449a;
(function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
})($5bf38af506e4762b$export$816ef638e478449a || ($5bf38af506e4762b$export$816ef638e478449a = {}));

});

parcelRegister("bvqNo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentTypes", () => $ea031aa9e3d5ef89$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $ea031aa9e3d5ef89$export$c294d3f3727c1a0);
const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("5labn", function(module, exports) {

$parcel$export(module.exports, "getDisplayInformation", () => $e7deee7a3cbc4953$export$ee79869f97207574);

var $bvqNo = parcelRequire("bvqNo");
const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
        displayType: (0, $bvqNo.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $bvqNo.DisplayTypes).MODAL
    };
};

});


parcelRegister("9V9QO", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $a6b6d10e82ec149e$export$75ef2f025ecbf1de);

var $5uXOq = parcelRequire("5uXOq");

var $5gBas = parcelRequire("5gBas");

var $gvpit = parcelRequire("gvpit");

var $gXSrH = parcelRequire("gXSrH");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $2POIy = parcelRequire("2POIy");

var $iwjqc = parcelRequire("iwjqc");

var $4TSh0 = parcelRequire("4TSh0");

var $fvjUj = parcelRequire("fvjUj");
const $a6b6d10e82ec149e$var$entryPointParams = {};
const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, actions] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const parentProduct = (0, $fvjUj.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2POIy.embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const deferSpaceToast = (0, $co1wz.ff)('toast_defer_space_ntufi');
    const isTemplateBrowserEnabled = (0, $co1wz.ff)('jira.issue-view.create-confluence-page.template-browser');
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    const themeState = (0, $5gBas.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $iwjqc.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
        fireAnalyticsEvent({
            action: action,
            eventName: eventName,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
    }, [
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            ...isTemplateBrowserEnabled ? [
                'template-browser'
            ] : []
        ], [
        isDeferSpaceSelection,
        isTemplateBrowserEnabled
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $gvpit.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            mode: mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            ...deferSpaceToast && {
                onPublish: actions.setDeferredSpaceName
            },
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceName,
        contentId,
        contentType,
        contentUrl,
        deferSpaceToast,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures
    ]);
    return shouldOpenPanel ? {
        entryPointActions: entryPointActions,
        entryPoint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("gvpit", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $0f1e44d3961926f5$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $0f1e44d3961926f5$export$7a5253c0f62e0150);

var $6vAaw = parcelRequire("6vAaw");

var $70VoX = parcelRequire("70VoX");

var $78ttk = parcelRequire("78ttk");

var $8JI7z = parcelRequire("8JI7z");

var $ikhc7 = parcelRequire("ikhc7");

var $Kdacc = parcelRequire("Kdacc");
function $0f1e44d3961926f5$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
    const parsedAllowedFeatures = $0f1e44d3961926f5$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const parsedProps = $0f1e44d3961926f5$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $78ttk.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // If the props are explicity passed in along with URL, those passed-in props will be overriding the URL-extract props.
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct;
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $Kdacc.VIEW_PAGE).name:
        case (0, $Kdacc.VIEW_BLOG).name:
        case (0, $Kdacc.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $Kdacc.EDIT_PAGE_EMBED).name:
        case (0, $Kdacc.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
    }
    return {
        allowedFeatures: $0f1e44d3961926f5$export$350c411f568eceb9(allowedFeatures),
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        ...passThroughProps
    };
}
function $0f1e44d3961926f5$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $0f1e44d3961926f5$var$findAndMatchRoute((0, $Kdacc.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: match.params.contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash,
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState
    };
}
function $0f1e44d3961926f5$var$findAndMatchRoute(routes, url) {
    for (const routeName of Object.keys(routes)){
        const pattern = routes[routeName].pattern;
        const match = $0f1e44d3961926f5$var$matchUrl(pattern, url);
        if (match) return {
            routeName: routeName,
            ...match
        };
    }
}
function $0f1e44d3961926f5$var$matchUrl(pattern, url) {
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $70VoX.default)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $70VoX.default)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
    return {
        url: url,
        protocol: parsed?.protocol || 'https:',
        host: parsed?.host || '',
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}
function $0f1e44d3961926f5$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $8JI7z.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures?.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("70VoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b50f39010f1f0a$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $51b50f39010f1f0a$var$patternCache = {};
var $51b50f39010f1f0a$var$cacheLimit = 10000;
var $51b50f39010f1f0a$var$cacheCount = 0;
var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $51b50f39010f1f0a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;

});
parcelRegister("d4Ora", function(module, exports) {

var $oJ7gO = parcelRequire("oJ7gO");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $9852c5da38ba91d1$var$pathToRegexp;
module.exports.parse = $9852c5da38ba91d1$var$parse;
module.exports.compile = $9852c5da38ba91d1$var$compile;
module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $9852c5da38ba91d1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
    return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $9852c5da38ba91d1$var$compile(str, options) {
    return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($oJ7gO(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $9852c5da38ba91d1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $9852c5da38ba91d1$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
    return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
    return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
        else {
            var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $9852c5da38ba91d1$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("oJ7gO", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});



parcelRegister("8JI7z", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $62126507fea1d018$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $62126507fea1d018$export$3207c60940c4a9b0);

var $gOvjG = parcelRequire("gOvjG");
var $ikhc7 = parcelRequire("ikhc7");
var $62126507fea1d018$export$241b9888a4d565c9;
(function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
})($62126507fea1d018$export$241b9888a4d565c9 || ($62126507fea1d018$export$241b9888a4d565c9 = {}));
const $62126507fea1d018$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $62126507fea1d018$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $62126507fea1d018$var$pageAllowedFeatures = {
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.edit,
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.view
};
const $62126507fea1d018$var$blogPostAllowedFeatures = {
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.edit,
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.view
};
const $62126507fea1d018$var$whiteboardAllowedFeatures = {
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $62126507fea1d018$export$a3fda3dcee62e1cc.whiteboard
};
const $62126507fea1d018$var$contentTypeAllowedFeatures = {
    [(0, $gOvjG.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $62126507fea1d018$var$pageAllowedFeatures,
    [(0, $gOvjG.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $62126507fea1d018$var$blogPostAllowedFeatures,
    [(0, $gOvjG.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $62126507fea1d018$var$whiteboardAllowedFeatures
};
const $62126507fea1d018$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $ikhc7.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$62126507fea1d018$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("gOvjG", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $4a72ef939a00f346$export$942a5fac9b8c9dc2);
var $4a72ef939a00f346$export$942a5fac9b8c9dc2;
(function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
})($4a72ef939a00f346$export$942a5fac9b8c9dc2 || ($4a72ef939a00f346$export$942a5fac9b8c9dc2 = {}));

});


parcelRegister("Kdacc", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $4a63d9896194a6bc$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $4a63d9896194a6bc$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $4a63d9896194a6bc$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $4a63d9896194a6bc$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $4a63d9896194a6bc$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "namedRoutes", () => $4a63d9896194a6bc$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $4a63d9896194a6bc$export$5c59aa0922e65f1a);
const $4a63d9896194a6bc$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
};
const $4a63d9896194a6bc$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
};
const $4a63d9896194a6bc$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $4a63d9896194a6bc$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
};
const $4a63d9896194a6bc$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
};
const $4a63d9896194a6bc$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
};
const $4a63d9896194a6bc$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $4a63d9896194a6bc$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $4a63d9896194a6bc$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $4a63d9896194a6bc$export$65b723bb995d4fb6,
    VIEW_PAGE: $4a63d9896194a6bc$export$9257b5b55c8e2555,
    VIEW_BLOG: $4a63d9896194a6bc$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $4a63d9896194a6bc$export$bd2c9bb170b3681d
};
const $4a63d9896194a6bc$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("2POIy", function(module, exports) {

$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $ae604dc9c27c8401$export$32561f984de7bece);

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");

const $ae604dc9c27c8401$export$32561f984de7bece = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(()=>(parcelRequire("eEEPC")), {
        moduleId: "293c24d0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eEEPC", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("joESl")
]).then(()=>parcelRequire('k1Lui'));

});


parcelRegister("iwjqc", function(module, exports) {

$parcel$export(module.exports, "createActivePageUrl", () => $5538d20fe7287eae$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $5538d20fe7287eae$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $5538d20fe7287eae$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $5538d20fe7287eae$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $5538d20fe7287eae$export$af98278c506da0f4);

var $Geeam = parcelRequire("Geeam");

var $jg9TU = parcelRequire("jg9TU");
const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $Geeam.getHostnameFromUrl)(url);
    return (0, $jg9TU.isCustomDomain)(parentHost) || hostname && (0, $jg9TU.isCustomDomain)(hostname);
};
const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $Geeam.getHostnameFromUrl)(url);
    return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, $Geeam.getHostnameFromUrl)(parentHost) : contentHost;
};
const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $Geeam.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $Geeam.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subType,
            links: createResponse._links
        }
    });

});
parcelRegister("Geeam", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $43eec760bfcb2d7e$export$280e79c794cf814e);

var $cN3DC = parcelRequire("cN3DC");
const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, $cN3DC.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("cN3DC", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $8759602a30c2f837$export$bef94a5618bf18bf);
const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("jg9TU", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $cbdd6bc245553e48$export$97f4c254b641e719);
const $cbdd6bc245553e48$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("4TSh0", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $391c3839ff18e3b3$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $2Dcc2 = parcelRequire("2Dcc2");

var $9OXo1 = parcelRequire("9OXo1");

var $gFmVN = parcelRequire("gFmVN");

var $kEkg3 = parcelRequire("kEkg3");
const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $gFmVN.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType
        };
        (0, $kEkg3.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("gFmVN", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $e40b1af8ddf646ed$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $e40b1af8ddf646ed$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $e40b1af8ddf646ed$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $e40b1af8ddf646ed$export$e873edb2560a07ef);

var $2vSU6 = parcelRequire("2vSU6");




const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});

parcelRegister("kEkg3", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $502082c06cc8bb17$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});


parcelRegister("fvjUj", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $af9df26010027d57$export$1b09c6e3737c8eb7);

var $dAfqg = parcelRequire("dAfqg");

var $gFmVN = parcelRequire("gFmVN");
const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $gFmVN.getParentProduct)(projectType);
};

});



parcelRegister("km1Z8", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $b3ed488811f6683d$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");

var $jH6yN = parcelRequire("jH6yN");
const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH6yN.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("axSKo", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $da7a6c3542bd9710$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $da7a6c3542bd9710$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $itvk3 = parcelRequire("itvk3");

var $7KTvf = parcelRequire("7KTvf");
const $da7a6c3542bd9710$var$Context = (0, $itvk3.default)('ItemManagers');
const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            managers: {}
        };
        this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $7KTvf.fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        };
        this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        };
        this.pendingManagers = {};
        this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;

});
parcelRegister("itvk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b840b80ca03789$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $5uXOq.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("7KTvf", function(module, exports) {

$parcel$export(module.exports, "fromManagerKey", () => $067bae373d6cebdd$export$fef172a673b3ef47);
const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("jH6yN", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $9B86Q = parcelRequire("9B86Q");

var $dJl1T = parcelRequire("dJl1T");

var $7oGEb = parcelRequire("7oGEb");

var $1ADgn = parcelRequire("1ADgn");

var $gPQRI = parcelRequire("gPQRI");

var $1J3t1 = parcelRequire("1J3t1");

var $jRCeJ = parcelRequire("jRCeJ");

var $7KTvf = parcelRequire("7KTvf");

var $dIdda = parcelRequire("dIdda");

var $fTkzd = parcelRequire("fTkzd");
const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $gPQRI.useLeftSidebarController)();
    const { refresh: refresh } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { push: push } = (0, $dIdda.useRouterActions)();
    const sidebarState = (0, $gPQRI.useLeftSidebarState)();
    const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
    const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
    const imperativeAPIRef = (0, $5uXOq.useRef)({
        viewIds: $fTkzd.viewIds,
        itemIds: $fTkzd.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, $7KTvf.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $1ADgn.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $7oGEb.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRCeJ.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});



parcelRegister("7oGEb", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $6e1dad164f29ee43$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $6e1dad164f29ee43$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $6e1dad164f29ee43$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $6e1dad164f29ee43$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $6e1dad164f29ee43$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $6e1dad164f29ee43$var$containerApi = null;
let $6e1dad164f29ee43$var$navigationApi = null;
const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
    $6e1dad164f29ee43$var$containerApi = api;
};
const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
    $6e1dad164f29ee43$var$navigationApi = api;
};
const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
    $6e1dad164f29ee43$var$containerApi = null;
    $6e1dad164f29ee43$var$navigationApi = null;
};

});

parcelRegister("1ADgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5ce13af6407cab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $6BZYo.loadBridge)({
        name: $7a5ce13af6407cab$var$amdModuleName
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);
$parcel$export(module.exports, "loadBridgeStrict", () => (parcelRequire("7T84i")).loadBridgeStrict);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $dJl1T = parcelRequire("dJl1T");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $dJl1T.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});

parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});

parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});



parcelRegister("1J3t1", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $bb292f58b8ec7804$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $bb292f58b8ec7804$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $bb292f58b8ec7804$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $bb292f58b8ec7804$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $bb292f58b8ec7804$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $bb292f58b8ec7804$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $bb292f58b8ec7804$export$d63d92edebe543d9);

var $5uXOq = parcelRequire("5uXOq");

var $b2pl3 = parcelRequire("b2pl3");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $loy04 = parcelRequire("loy04");

var $ggg5j = parcelRequire("ggg5j");

var $324W5 = parcelRequire("324W5");

var $dIdda = parcelRequire("dIdda");

var $727Q1 = parcelRequire("727Q1");
const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $324W5.useResourceWithCustomRouterContext)((0, $ggg5j.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $727Q1.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $dIdda.useResource)((0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $dIdda.useResource)((0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $dIdda.useResource)((0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $dIdda.useResource)((0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("b2pl3", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $565682b770797f58$export$fab84295e18e9246);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $jAGOQ = parcelRequire("jAGOQ");
const $565682b770797f58$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $565682b770797f58$export$fab84295e18e9246 = (0, $dIdda.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("jAGOQ", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $45e9310ad65e3e88$export$b15f9f5cf6db359e);

var $eusud = parcelRequire("eusud");
const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("6zFAI", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ee61b377cbb3343f$export$b8c6e2666f12f4bb);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $jAGOQ = parcelRequire("jAGOQ");
const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $dIdda.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("gcI3W", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $e60f9280597d4f0e$export$b662f3f877add30d);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $jAGOQ = parcelRequire("jAGOQ");
const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $dIdda.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("loy04", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$2d5a704ae6f6b050);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $jAGOQ = parcelRequire("jAGOQ");
const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $dIdda.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $dIdda.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);

});

parcelRegister("ggg5j", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $3ec7290d9b237c27$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $3ec7290d9b237c27$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $3ec7290d9b237c27$export$b692cfadccf4e047);

var $65Ltd = parcelRequire("65Ltd");

var $95bh0 = parcelRequire("95bh0");

var $8YTna = parcelRequire("8YTna");

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $gDyED = parcelRequire("gDyED");
const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $95bh0.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    const boardId = (0, $8YTna.getBoardId)(match, query);
    return (0, $95bh0.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $dIdda.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $gDyED.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $dIdda.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);

});
parcelRegister("95bh0", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $4cc145d0cf66273c$export$68278f7cf66944f9);

const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';


parcelRegister("8YTna", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $f7f12dfb24bc320d$export$557c2f222778cea6);
const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("gDyED", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $b6d61a4c2e3b518c$export$8a51470472777e11);

var $eusud = parcelRequire("eusud");
const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("727Q1", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $5300bc04c6e3c00f$export$780174995da89d60);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ggg5j = parcelRequire("ggg5j");

var $dIdda = parcelRequire("dIdda");
const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $dIdda.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $dIdda.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $dIdda.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $dIdda.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $dIdda.useRouter)();
    const isOnBoardBasedRoute = (0, $ggg5j.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $5uXOq.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});


parcelRegister("jRCeJ", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $54656242ba3a5025$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $54656242ba3a5025$export$339ec9ca159ad81f);

var $7JoAD = parcelRequire("7JoAD");

var $3h4uJ = parcelRequire("3h4uJ");
const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, $7JoAD.createSubscriber)((0, $3h4uJ.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $54656242ba3a5025$export$339ec9ca159ad81f = (0, $7JoAD.createContainer)((0, $3h4uJ.default));

});
parcelRegister("3h4uJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca73b0c81372577$export$2e2bcd8739ae039);

var $7JoAD = parcelRequire("7JoAD");

var $8pFbi = parcelRequire("8pFbi");
const $8ca73b0c81372577$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
    name: 'navigation-ui',
    initialState: $8ca73b0c81372577$var$initialState,
    actions: $8pFbi.default
});

});
parcelRegister("8pFbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96738f03994c2c6$export$2e2bcd8739ae039);

var $cIPJW = parcelRequire("cIPJW");
var $aUW0i = parcelRequire("aUW0i");
var $44KUn = parcelRequire("44KUn");
var $5UAf7 = parcelRequire("5UAf7");
const $c96738f03994c2c6$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
            dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
            dispatch($c96738f03994c2c6$var$actions.expandStartClear());
            dispatch($c96738f03994c2c6$var$actions.expandEndClear());
        }
};
var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;

});
parcelRegister("cIPJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a193bdf9026fb7$export$2e2bcd8739ae039);

var $44KUn = parcelRequire("44KUn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $44KUn.default)(key, callback));
    };

});
parcelRegister("44KUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("aUW0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $0765ad08a31511d2$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("5UAf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc474c9b594a3d77$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("fTkzd", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $e0d97c8d376b70de$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $e0d97c8d376b70de$export$8ee2fd038785d9dc);

var $16J3A = parcelRequire("16J3A");
const $e0d97c8d376b70de$var$ROOT = 'root/index';
const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
const $e0d97c8d376b70de$var$USER = 'user/index';
const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
const $e0d97c8d376b70de$var$rootProjectViewIds = {
    AGILITY: $e0d97c8d376b70de$var$AGILITY,
    SERVICE_DESK: $16J3A.SERVICE_DESK,
    OPS: $e0d97c8d376b70de$var$OPS,
    BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
    SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
};
const $e0d97c8d376b70de$var$rootViewIds = {
    ROOT: $e0d97c8d376b70de$var$ROOT,
    ISSUES: $e0d97c8d376b70de$var$ISSUES,
    DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
    PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
};
const $e0d97c8d376b70de$export$443ec49e59de3663 = {
    WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
    PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
    WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
    PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $16J3A.SERVICE_DESK_ITEMS)
};
const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
    ...$e0d97c8d376b70de$var$rootViewIds,
    ...$e0d97c8d376b70de$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $16J3A.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $16J3A.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $16J3A.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $16J3A.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $16J3A.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $16J3A.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $16J3A.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $16J3A.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $16J3A.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $e0d97c8d376b70de$var$USER,
    USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
};

});
parcelRegister("16J3A", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $6fb2b1c825061655$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $6fb2b1c825061655$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "SETTINGS_IDS", () => $6fb2b1c825061655$export$5fd6685a693e1064);
$parcel$export(module.exports, "PRACTICES_IDS", () => $6fb2b1c825061655$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $6fb2b1c825061655$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $6fb2b1c825061655$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "TEAM_PRIORITY_QUEUE_ADMIN_SPOTLIGHT", () => $6fb2b1c825061655$export$aaffd3035e9d6c2d);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $6fb2b1c825061655$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $6fb2b1c825061655$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $6fb2b1c825061655$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $6fb2b1c825061655$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $6fb2b1c825061655$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $6fb2b1c825061655$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $6fb2b1c825061655$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $6fb2b1c825061655$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $6fb2b1c825061655$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $6fb2b1c825061655$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $6fb2b1c825061655$export$9a6deaa9c1af559f);
const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $6fb2b1c825061655$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
    QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
    CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
    PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
    CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
    RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
    ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
    SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $6fb2b1c825061655$export$304aefafb7155b23 = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $6fb2b1c825061655$export$5fd6685a693e1064 = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $6fb2b1c825061655$export$50b1b8fc419aca98 = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $6fb2b1c825061655$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $6fb2b1c825061655$export$304aefafb7155b23,
        SETTINGS: $6fb2b1c825061655$export$5fd6685a693e1064,
        QUEUES: $6fb2b1c825061655$export$50b1b8fc419aca98,
        REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
    }
};
const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $6fb2b1c825061655$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("e1ETT", function(module, exports) {

$parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", () => $82a7a36c9e8ee7c8$export$129bdc881130bc9);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $7B17s = parcelRequire("7B17s");


const $82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("l6gsK")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
    moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
});
const $82a7a36c9e8ee7c8$export$129bdc881130bc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $e113a6ff9475fdf6$export$d57b6b390e78d90f),
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82a7a36c9e8ee7c8$var$AsyncLockScreenExperimentShared, null)));

});
const $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $e113a6ff9475fdf6$export$d57b6b390e78d90f = 'transmuters-growth';

parcelRegister("l6gsK", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3slCJ").then(()=>parcelRequire('0FUnI'));

});


parcelRegister("aqDVH", function(module, exports) {

$parcel$export(module.exports, "jiraLossAversionModalEntryPoint", () => $5bb417d947b6f1f3$export$e224c255d72cf9b5);

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");

const $5bb417d947b6f1f3$export$e224c255d72cf9b5 = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(async ()=>(parcelRequire("2EAmB")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
        moduleId: "35d17363"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2EAmB", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eU8LY")
]).then(()=>parcelRequire('4VIPJ'));

});


parcelRegister("lpwtK", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $f3d7644b5666677d$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");

var $bsuuc = parcelRequire("bsuuc");

var $1J3t1 = parcelRequire("1J3t1");
const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    const project = (0, $5uXOq.useMemo)(()=>data && (0, $bsuuc.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("bsuuc", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $36c780ae7e3dc8c8$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $36c780ae7e3dc8c8$export$9df5fa0a366163d2);

var $2vSU6 = parcelRequire("2vSU6");
const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC;
const $36c780ae7e3dc8c8$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey
    });
const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});


parcelRegister("jElqQ", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $e847f78ebf17acd8$export$6cf89f098b551dad);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $dAfqg = parcelRequire("dAfqg");

var $6yXtV = parcelRequire("6yXtV");

var $hMvRp = parcelRequire("hMvRp");
const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const interval = (0, $5uXOq.useRef)(null);
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $e847f78ebf17acd8$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("hMvRp", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $124c6a08c4f63b4e$export$6c98eb2f12f4ec61);

var $5uXOq = parcelRequire("5uXOq");

var $laTox = parcelRequire("laTox");
const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $laTox.isPageVisible)());
    (0, $5uXOq.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $laTox.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("laTox", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $845c75a1dcb2afb9$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $845c75a1dcb2afb9$export$ae4f9b990bc70f70);
const $845c75a1dcb2afb9$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];

});



parcelRegister("kKa8l", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $6e59b41cd017c405$export$c6d9204abc182c3b);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $dIdda = parcelRequire("dIdda");
const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $dIdda.useRouter)();
    (0, $5uXOq.useMemo)(()=>(0, $cfDZ3.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("bmetd", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $0b73f894404a9cc2$export$49e28489f2124002);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $cfDZ3 = parcelRequire("cfDZ3");

var $dIdda = parcelRequire("dIdda");
const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $1XJ20.usePrevious)(routerState);
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $0b73f894404a9cc2$export$49e28489f2124002 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("izgL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c092f8fb0732f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $1u3Jv = parcelRequire("1u3Jv");

var $7nE2n = parcelRequire("7nE2n");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dIdda = parcelRequire("dIdda");

var $gKKyW = parcelRequire("gKKyW");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nE2n.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
                if (!showFlag) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $gKKyW.default)[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
                    op: ()=>{
                        if ((0, $gKKyW.default)[showFlag]) flagService.showFlag((0, $gKKyW.default)[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`);
                    }
                }));
            }))));
var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;

});
parcelRegister("1u3Jv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4400becd9e439df4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $4400becd9e439df4$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $4400becd9e439df4$export$2e2bcd8739ae039 = $4400becd9e439df4$var$OpTrigger;

});

parcelRegister("7nE2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $4855eee5a10070a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, $pa9q9.flagService)));
var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;

});

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $2keUK = parcelRequire("2keUK");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $2keUK.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("gKKyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdf0672c10209bc$export$2e2bcd8739ae039);

var $7HGHK = parcelRequire("7HGHK");

var $lVqGY = parcelRequire("lVqGY");
const $2fdf0672c10209bc$var$notificationMessages = {
    'jsw.board-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).boardNotFound,
        description: (0, $lVqGY.default).boardNotFoundDescription
    },
    'jsw.project-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).projectNotFound,
        description: (0, $lVqGY.default).projectNotFoundDescription
    }
};
var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;

});
parcelRegister("lVqGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a629f5c887c4955a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// Don't confuse Intl messages with `Flag`s
const $a629f5c887c4955a$var$messages = (0, $7VHMR.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    }
});
var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;

});



parcelRegister("lyCmi", function(module, exports) {

$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $881dabfa53ffbc01$export$2a43717c77dd3a56);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $7B17s = parcelRequire("7B17s");

var $gnleF = parcelRequire("gnleF");

const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("191Yr")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $gnleF.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("gnleF", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3413b320036771c2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $3413b320036771c2$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $3413b320036771c2$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $3413b320036771c2$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $3413b320036771c2$export$de9f5b160db96e26);
const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-message-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-message-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-message-3'
    ]
]);

});

parcelRegister("191Yr", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("aIcwu").then(()=>parcelRequire('hxssF'));

});


parcelRegister("1XrjK", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $3b8b9d6fe762babb$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $3b8b9d6fe762babb$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $3b8b9d6fe762babb$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $3b8b9d6fe762babb$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $3b8b9d6fe762babb$export$e97a7da67a5b8ce4);

var $5uXOq = parcelRequire("5uXOq");

var $lpwtK = parcelRequire("lpwtK");

var $lfTZh = parcelRequire("lfTZh");

const $3b8b9d6fe762babb$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $3b8b9d6fe762babb$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $3b8b9d6fe762babb$export$6e5538615c060df7(displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null)));
    });
const $3b8b9d6fe762babb$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $3b8b9d6fe762babb$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $3b8b9d6fe762babb$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $3b8b9d6fe762babb$export$3dd437ade36ede40(layout);
};
const $3b8b9d6fe762babb$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $3b8b9d6fe762babb$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $3b8b9d6fe762babb$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $3b8b9d6fe762babb$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $3b8b9d6fe762babb$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $lpwtK.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
    };
    const name = $3b8b9d6fe762babb$export$6e5538615c060df7(Component.displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $3b8b9d6fe762babb$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});

parcelRegister("kgLzl", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $1c7272db9b45cdb2$export$2f67fedc6d5555a5);

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");

const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(async ()=>(parcelRequire("9qaNk")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9qaNk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("l4e09")
]).then(()=>parcelRequire('14875'));

});


parcelRegister("dYRe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $05aa88b82a329166$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $5oFIy = parcelRequire("5oFIy");

var $dxCvy = parcelRequire("dxCvy");

var $dIdda = parcelRequire("dIdda");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $5oFIy.FireOperationalAnalytics), Redirect: Redirect = (0, $dIdda.Redirect), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    const { data: projectContext } = useResource((0, $dxCvy.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: to
    }));
};
var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;

});

parcelRegister("dz0Q5", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $aab5ccb109290e76$export$7f34679273a30171);

var $7B17s = parcelRequire("7B17s");

const $aab5ccb109290e76$export$7f34679273a30171 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("it3EE")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});

});
parcelRegister("it3EE", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1umXM").then(()=>parcelRequire('f7aUi'));

});


parcelRegister("kXv2J", function(module, exports) {

$parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", () => $49f1088be59356e0$export$94ad1b5fd850909f);

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");

const $49f1088be59356e0$export$94ad1b5fd850909f = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(async ()=>(parcelRequire("gqztb")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
        moduleId: "86e9ce71"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gqztb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("8f5Ah")
]).then(()=>parcelRequire('a48Ze'));

});


parcelRegister("4p6rw", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $da151c89e6acf066$export$9499deca9933db5b);

var $5uXOq = parcelRequire("5uXOq");

var $cQZXC = parcelRequire("cQZXC");

var $1r4rO = parcelRequire("1r4rO");

var $6jY6G = parcelRequire("6jY6G");

var $6yXtV = parcelRequire("6yXtV");

var $4su49 = parcelRequire("4su49");

var $kiABc = parcelRequire("kiABc");

var $8Z3n8 = parcelRequire("8Z3n8");
const $da151c89e6acf066$export$9499deca9933db5b = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
    (0, $8Z3n8.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $4su49.asyncWrmRequire)([
            ...(0, $1r4rO.jiraSuperBatchDependencies),
            ...(0, $kiABc.getJiraHeritageDependencies)()
        ]).then(()=>(0, $cQZXC.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
$da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("4su49", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $ae90ef6541667ecb$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $ae90ef6541667ecb$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $8JNtu.wrmRequire)(resourcesToRequire);
const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $5Ik5Y.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("kiABc", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("8Z3n8", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $b2fe1e724cbc12ec$export$7ff53723d9d2886d);

var $5uXOq = parcelRequire("5uXOq");

var $6yXtV = parcelRequire("6yXtV");

var $bVDE5 = parcelRequire("bVDE5");
const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("ec3NH", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $ea76f165da82af61$export$2255367d5c9162b3);

var $5uXOq = parcelRequire("5uXOq");

var $67Adx = parcelRequire("67Adx");
const $ea76f165da82af61$export$2255367d5c9162b3 = ()=>{
    const baseUrl = '';
    // @ts-expect-error - TS2322 - Type '{ baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Omit<PropsWithDefault, "baseUrl" | keyof InjectedProps>'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67Adx.default), {
        baseUrl: baseUrl
    });
};

});
parcelRegister("67Adx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce4053be7c0ea3f$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $aYHuU = parcelRequire("aYHuU");

var $7GR7x = parcelRequire("7GR7x");

var $bQtVL = parcelRequire("bQtVL");

var $3XHss = parcelRequire("3XHss");

var $1DFxi = parcelRequire("1DFxi");
var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $aYHuU.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $7GR7x.default,
    LegacyBreadcrumbConnector: $bQtVL.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $1DFxi.default,
    LegacyBreadcrumbRenderer: $3XHss.default
});

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});

parcelRegister("aYHuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2640273d477c5ef9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $heNNl = parcelRequire("heNNl");

const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);

});
parcelRegister("jzjy1", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $578c443a5ba38dde$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $578c443a5ba38dde$export$ec9f54bd4341ceb);

var $jiu8g = parcelRequire("jiu8g");
const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $jiu8g.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $jiu8g.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});


parcelRegister("7GR7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2002ff619891e$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $hciGg = parcelRequire("hciGg");
const $e1c2002ff619891e$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $hciGg.default), $e1c2002ff619891e$var$analyticsEvents);

});
parcelRegister("1bJTy", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $065c8ba87a790756$export$79f423cc3fd39762);

var $4f8Oj = parcelRequire("4f8Oj");

var $jcw0u = parcelRequire("jcw0u");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
const $065c8ba87a790756$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $065c8ba87a790756$var$isNotUndefined);
};
const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$065c8ba87a790756$var$mapPayload(payload),
            analyticsType: (0, $gvRPW.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("i4iBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a364fe632bf506b$export$2e2bcd8739ae039);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};

});


parcelRegister("hciGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d1d7061b6e3c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $8oe80 = parcelRequire("8oe80");

var $c1YJb = parcelRequire("c1YJb");
// eslint-disable-next-line jira/react/no-class-components
class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $c1YJb.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        };
        this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        };
        this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        };
        this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $kVLXA.Observable).empty();
        };
    }
}
var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, $8oe80.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($060d1d7061b6e3c1$var$LegacyApiBridge);

});
parcelRegister("8oe80", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6b229cbb45328e$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $jiu8g = parcelRequire("jiu8g");
var $2keUK = parcelRequire("2keUK");
const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $jiu8g.default)({
            componentName: componentName
        })((0, $2keUK.default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;

});

parcelRegister("c1YJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c3f644565eaafc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $9B86Q = parcelRequire("9B86Q");

var $dJl1T = parcelRequire("dJl1T");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $9B86Q.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));

});



parcelRegister("bQtVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c34ce41a7e16e82$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $c2D8L = parcelRequire("c2D8L");

var $btYLD = parcelRequire("btYLD");

var $gEFwt = parcelRequire("gEFwt");

var $75PvK = parcelRequire("75PvK");

var $7OPFF = parcelRequire("7OPFF");

var $5fGpW = parcelRequire("5fGpW");
var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $7OPFF.default), {
    Breadcrumb: $c2D8L.default,
    ProjectBreadcrumb: $gEFwt.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $btYLD.default,
    UserBreadcrumb: $75PvK.default,
    ContextProvider: $5fGpW.default
});

});
parcelRegister("c2D8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $904f5413e35195e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $7Jxgt = parcelRequire("7Jxgt");

var $aIVNN = parcelRequire("aIVNN");
// eslint-disable-next-line jira/react/no-class-components
class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.id = '';
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$904f5413e35195e5$var$Breadcrumb.defaultProps = {
    children: null
};
var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;

});
parcelRegister("aIVNN", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $446946e3e8bfa528$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $446946e3e8bfa528$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $446946e3e8bfa528$export$c7432936d9c50db7);

var $7JoAD = parcelRequire("7JoAD");
const $446946e3e8bfa528$var$initialState = {
    trail: []
};
const $446946e3e8bfa528$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $446946e3e8bfa528$var$Store = (0, $7JoAD.createStore)({
    initialState: $446946e3e8bfa528$var$initialState,
    actions: $446946e3e8bfa528$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, $7JoAD.createSubscriber)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, $7JoAD.createHook)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, $7JoAD.createSubscriber)($446946e3e8bfa528$var$Store, {
    selector: null
});
const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, $7JoAD.createContainer)($446946e3e8bfa528$var$Store);

});


parcelRegister("btYLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $97548d5fa76ccc5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");
const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $81ps3.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
$97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;

});
parcelRegister("81ps3", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $e04610b9d6540e69$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $e04610b9d6540e69$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $e04610b9d6540e69$export$7037e05c8c7af6dc);

var $02Psx = parcelRequire("02Psx");
const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $02Psx.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});
parcelRegister("02Psx", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $a59737cd16881573$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $a59737cd16881573$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $a59737cd16881573$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $a59737cd16881573$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $a59737cd16881573$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $a59737cd16881573$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $a59737cd16881573$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$dad567762dae162e);
$parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$8b304050f4836b59);

var $2vSU6 = parcelRequire("2vSU6");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('urls'), (0, $gl0PU.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $a59737cd16881573$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
};
const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
const $a59737cd16881573$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;

});
parcelRegister("3XO6n", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $594ec5369f29a734$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $594ec5369f29a734$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $594ec5369f29a734$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $594ec5369f29a734$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $594ec5369f29a734$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $594ec5369f29a734$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $594ec5369f29a734$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $594ec5369f29a734$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $594ec5369f29a734$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $594ec5369f29a734$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $594ec5369f29a734$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $594ec5369f29a734$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $594ec5369f29a734$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $594ec5369f29a734$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $594ec5369f29a734$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $594ec5369f29a734$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $594ec5369f29a734$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $594ec5369f29a734$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $594ec5369f29a734$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $594ec5369f29a734$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $594ec5369f29a734$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $594ec5369f29a734$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $594ec5369f29a734$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $594ec5369f29a734$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $594ec5369f29a734$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $594ec5369f29a734$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $594ec5369f29a734$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $594ec5369f29a734$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $594ec5369f29a734$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $594ec5369f29a734$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $594ec5369f29a734$export$ac655f5b3ff7b929);
// Issue Type Templates

var $lzeFL = parcelRequire("lzeFL");

var $5fc53 = parcelRequire("5fc53");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");
const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
const $594ec5369f29a734$export$952581bc40160893 = 'custom';
const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
    $594ec5369f29a734$export$9355e489ad16f98e,
    $594ec5369f29a734$export$bcf558c186108044,
    $594ec5369f29a734$export$1ea39a3ae330045,
    $594ec5369f29a734$export$3cb4a99a332e4186
];
const $594ec5369f29a734$export$39cd48613b53ce2f = (0, $5fc53.TEXT_AREA_CF_TYPE);
const $594ec5369f29a734$export$56eae1056efd4899 = (0, $5fc53.DESCRIPTION_TYPE);
const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, $5fc53.ENVIRONMENT_TYPE);
const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
    $594ec5369f29a734$export$56eae1056efd4899,
    $594ec5369f29a734$export$39cd48613b53ce2f,
    $594ec5369f29a734$export$ca61f05d869b2ea3
];
const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
const $594ec5369f29a734$export$d77765147749db6b = 'select';
const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $ldyPw.populateApplicationEditions)(),
        appPermissions: (0, $7qPn9.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        cloudId: (0, $g5X3G.toCloudId)(''),
        activationId: (0, $g5X3G.toActivationId)(''),
        cloudName: (0, $g5X3G.toCloudName)(''),
        devopsProjectSignupSource: (0, $g5X3G.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $ef5Xn.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $lzeFL.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null
    });

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $81f079589240b9b7$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
    });
    if ((0, $co1wz.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
    });
    if ((0, $4R6GH.fg)('jsm-sentiment-analysis')) Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    Object.assign(types, {
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $dJl1T.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("gEFwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b024406020849893$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $4V6Dv = parcelRequire("4V6Dv");
var $b024406020849893$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $4V6Dv.default));

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("4V6Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83ca195db24613ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $bnbo9 = parcelRequire("bnbo9");
const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $bnbo9.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $81ps3.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;

});
parcelRegister("bnbo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b60cdda05341e39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("75PvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6b338da4258947$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");
const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;

});

parcelRegister("7OPFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $760c31310830da08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;

});

parcelRegister("5fGpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc7aa08354ae9ed$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $4DPZY = parcelRequire("4DPZY");

var $dIdda = parcelRequire("dIdda");
const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $dIdda.usePathParam)('boardId');
    const [rapidView] = (0, $dIdda.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $4DPZY.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $dIdda = parcelRequire("dIdda");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("7xTO3", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $7371ef5d04dd1248$export$5839dd8142de842e);

var $dJl1T = parcelRequire("dJl1T");

var $8YTna = parcelRequire("8YTna");

var $dIdda = parcelRequire("dIdda");

var $55UpE = parcelRequire("55UpE");
const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $dIdda.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $55UpE.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("55UpE", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $e577b36e40c022cb$export$306fb49fca60b34);

var $eusud = parcelRequire("eusud");
const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});




parcelRegister("3XHss", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b3956e27a1612f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $dJl1T = parcelRequire("dJl1T");

var $jS4lj = parcelRequire("jS4lj");
const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $dJl1T.default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), targetElement);
    }
}

});
parcelRegister("jS4lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6eafb2b612d104$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $9OXo1 = parcelRequire("9OXo1");

var $0SW74 = parcelRequire("0SW74");
const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $0SW74.default), {
    onMount: $8c6eafb2b612d104$var$fireAnalytics,
    TenantContextSubscriber: $9OXo1.TenantContextSubscriber
});

});
parcelRegister("0SW74", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2b8169c8c69f79$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $6lcpk = parcelRequire("6lcpk");

var $3HwlS = parcelRequire("3HwlS");

var $aIVNN = parcelRequire("aIVNN");
// Adapt to prop type from breadcrumbs app
const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $aIVNN.useBreadcrumbs)();
    const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(onMount, []);
    if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lcpk.default), {
        isVisible: true,
        items: items
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa2b8169c8c69f79$var$BreadcrumbsWrapperOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lcpk.default), {
        isVisible: true,
        items: items
    }));
};
var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, $8oe80.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($fa2b8169c8c69f79$var$BreadcrumbRenderer);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa2b8169c8c69f79$var$BreadcrumbsWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke1tcg",
            __cmplp.className
        ])
    });
});
const $fa2b8169c8c69f79$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke1tcg _nwukkwex _1o8hu22k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6lcpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $741d99934750459a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $j6iTu = parcelRequire("j6iTu");
function $741d99934750459a$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6iTu.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("j6iTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be1ac78992edda2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $by6xj = parcelRequire("by6xj");
var $kWriA = parcelRequire("kWriA");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $92r9l = parcelRequire("92r9l");

var $2UzOj = parcelRequire("2UzOj");
const $5be1ac78992edda2$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kWriA.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by6xj.default), {
        text: "",
        "aria-label": formatMessage((0, $2UzOj.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92r9l.default), {
            key: index,
            index: index,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("by6xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b575d4f060b01fc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9fYN9 = parcelRequire("9fYN9");

var $3Pcsk = parcelRequire("3Pcsk");

var $4XWll = parcelRequire("4XWll");
function $1b575d4f060b01fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b575d4f060b01fc$var$itemWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $1b575d4f060b01fc$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $1b575d4f060b01fc$var$ICON_WIDTH_ESTIMATE = 24;
const $1b575d4f060b01fc$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $1b575d4f060b01fc$var$staticItemWithTruncationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    maxWidth: `var(${$1b575d4f060b01fc$var$VAR_STEP_TRUNCATION_WIDTH})`
});
const $1b575d4f060b01fc$var$staticItemWithoutTruncationStyles = {
    name: "1t1nv0p",
    styles: "min-width:0;flex-shrink:1"
};
const $1b575d4f060b01fc$var$BreadcrumbsItem = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (props.iconBefore) iconWidthAllowance += $1b575d4f060b01fc$var$ICON_WIDTH_ESTIMATE;
    if (props.iconAfter) iconWidthAllowance += $1b575d4f060b01fc$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $4XWll.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    const buttonProps = {
        ...restButtonProps,
        ref: buttonRef,
        hasOverflow: hasOverflow
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$1b575d4f060b01fc$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = truncationWidth ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Pcsk.default), {
        ...buttonProps,
        css: [
            $1b575d4f060b01fc$var$staticItemStyles,
            $1b575d4f060b01fc$var$staticItemWithTruncationStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicItemStyles
    }, text) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Pcsk.default), {
        ...buttonProps,
        css: [
            $1b575d4f060b01fc$var$staticItemStyles,
            $1b575d4f060b01fc$var$staticItemWithoutTruncationStyles
        ]
    }, text);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $1b575d4f060b01fc$var$itemWrapperStyles
    }, showTooltip ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1b575d4f060b01fc$export$2e2bcd8739ae039 = $1b575d4f060b01fc$var$BreadcrumbsItem;

});
parcelRegister("3Pcsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d6284cfdb47e9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7UFJi = parcelRequire("7UFJi");

var $goLm2 = parcelRequire("goLm2");

var $13czV = parcelRequire("13czV");
const $44d6284cfdb47e9b$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $44d6284cfdb47e9b$var$noop = (0, $13czV.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $44d6284cfdb47e9b$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $44d6284cfdb47e9b$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
    const handleClicked = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$44d6284cfdb47e9b$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goLm2.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href,
        ...props
    });
});
var $44d6284cfdb47e9b$export$2e2bcd8739ae039 = $44d6284cfdb47e9b$var$Step;

});

parcelRegister("4XWll", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db12271c7954c3f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $0db12271c7954c3f$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $5uXOq.useState)(true);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $5uXOq.useEffect)(()=>{
        if (truncationWidth && buttonRefCurrent) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("kWriA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8185b5238abe9241$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7UFJi = parcelRequire("7UFJi");

var $jE7nX = parcelRequire("jE7nX");

var $13czV = parcelRequire("13czV");


var $eYCCB = parcelRequire("eYCCB");

var $j4LuA = parcelRequire("j4LuA");
function $8185b5238abe9241$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8185b5238abe9241$var$defaultMaxItems = 8;
const $8185b5238abe9241$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $8185b5238abe9241$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $8185b5238abe9241$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children;
const $8185b5238abe9241$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8185b5238abe9241$var$noop = (0, $13czV.default);
const $8185b5238abe9241$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $8185b5238abe9241$var$breadcrumbStyles = {
    name: "m6vsls",
    styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
};
const $8185b5238abe9241$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $8185b5238abe9241$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $8185b5238abe9241$var$noop, analyticsContext: analyticsContext, label: label = $8185b5238abe9241$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $8185b5238abe9241$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $8185b5238abe9241$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($8185b5238abe9241$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $j4LuA.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$8185b5238abe9241$var$analyticsAttributes
    });
    const childrenArray = $8185b5238abe9241$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYCCB.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        "aria-label": label,
        ref: (0, $jE7nX.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        "data-testid": testId,
        css: $8185b5238abe9241$var$breadcrumbStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$f563ee71e9ee74cd)})`
        }
    }, breadcrumbsItems));
});
const $8185b5238abe9241$var$Breadcrumbs = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($8185b5238abe9241$var$InnerBreadcrumbs, {
        ...props,
        ref: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8185b5238abe9241$export$2e2bcd8739ae039 = $8185b5238abe9241$var$Breadcrumbs;

});
parcelRegister("eYCCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $52c21ec989be59f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $goLm2 = parcelRequire("goLm2");

var $13czV = parcelRequire("13czV");
function $52c21ec989be59f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52c21ec989be59f3$var$noop = (0, $13czV.default);
const $52c21ec989be59f3$var$itemWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: "var(--ds-space-100, 8px)",
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $52c21ec989be59f3$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $52c21ec989be59f3$var$EllipsisItem = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { onClick: onClick = $52c21ec989be59f3$var$noop, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $52c21ec989be59f3$var$itemWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $goLm2.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label,
        css: $52c21ec989be59f3$var$staticItemStyles
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$52c21ec989be59f3$export$2e2bcd8739ae039 = $52c21ec989be59f3$var$EllipsisItem;

});

parcelRegister("j4LuA", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $40912ea2aca0372c$export$e9c4922b2ecf808a);

var $5uXOq = parcelRequire("5uXOq");

var $76ufE = parcelRequire("76ufE");
function $40912ea2aca0372c$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $76ufE.default)(isExpanded);
    (0, $5uXOq.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("92r9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $77e0cddbf99d95bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $by6xj = parcelRequire("by6xj");

var $dOvpK = parcelRequire("dOvpK");
class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {}
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by6xj.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component
        });
    }
    constructor(...args){
        super(...args);
        this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("dOvpK", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $8c2abcc805e894f7$export$4909253b5bf1eed7);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $8c2abcc805e894f7$var$isNotUndefined);
};
const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$8c2abcc805e894f7$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("2UzOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3ad53695e8cbba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("1DFxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3b01c7b039743c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $9b3b01c7b039743c$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initialState: $9b3b01c7b039743c$var$defaultInitialState
        };
    }
    constructor(props){
        super(props);
        this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                }));
        };
        this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        };
        /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        };
        /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("lDu2T", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $c284a07391432f3b$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $lsa9q = parcelRequire("lsa9q");

var $9dfz4 = parcelRequire("9dfz4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $9dfz4.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("jnXgM", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $0e1519f86dabd57c$export$2846c12b8c092470);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $6yXtV = parcelRequire("6yXtV");
const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                };
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("2Afwf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("bnKSn")
]).then(()=>parcelRequire('6kz4R'));

});

parcelRegister("aQHAS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kpDDc").then(()=>parcelRequire('a8CW2'));

});

parcelRegister("i1RfD", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("humN1").then(()=>parcelRequire('7l6f4'));

});

parcelRegister("iRWz9", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("pGAVo").then(()=>parcelRequire('hfEgP'));

});

parcelRegister("76ZCo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3zxpm")
]).then(()=>parcelRequire('da0Wn'));

});

parcelRegister("D2tCn", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8f0xo").then(()=>parcelRequire('cDo25'));

});

parcelRegister("lGCVr", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3TwVo").then(()=>parcelRequire('aUZKu'));

});


parcelRegister("gmCnE", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $08223c6bc94e2fa4$export$3b4e64e77073e307);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");


var $kfAVA = parcelRequire("kfAVA");

var $co1wz = parcelRequire("co1wz");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $asgRx = parcelRequire("asgRx");

var $6ohPr = parcelRequire("6ohPr");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $9L6Zg = parcelRequire("9L6Zg");

var $gk4cG = parcelRequire("gk4cG");

var $c1ivz = parcelRequire("c1ivz");

var $iaN8D = parcelRequire("iaN8D");

var $14pJv = parcelRequire("14pJv");

var $921us = parcelRequire("921us");

var $9Cdg4 = parcelRequire("9Cdg4");

var $aAExw = parcelRequire("aAExw");

var $9ylrc = parcelRequire("9ylrc");

var $l8ruj = parcelRequire("l8ruj");

var $dm0Uk = parcelRequire("dm0Uk");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $08223c6bc94e2fa4$var$TEST_ID = 'page-layout.banner';
const $08223c6bc94e2fa4$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height,
        testId: $08223c6bc94e2fa4$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $08223c6bc94e2fa4$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $08223c6bc94e2fa4$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, $gk4cG.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1ivz.BannerAnnouncementAsync), null), bannerName === (0, $asgRx.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ohPr.IPBlocklistingBannerAsync), null), bannerName === (0, $aAExw.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ylrc.ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfAVA.CookieConsentBannerAsync), null), (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, $iaN8D.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14pJv.BannerTransitionAsync), null), bannerName === (0, $921us.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Cdg4.MailExpiryBannerAsync), null));
const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $08223c6bc94e2fa4$export$496ffd8dda3bf451, $08223c6bc94e2fa4$export$b5cfff585ada92ce);

});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;

parcelRegister("kfAVA", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $cbbe578478bf6317$export$f110a9cbbbd3fa3a);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cbbe578478bf6317$var$LazyCookieConsentBanner = (0, $7B17s.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("bKpcl")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/index.tsx"
});
const $cbbe578478bf6317$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $cbbe578478bf6317$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cbbe578478bf6317$var$LazyCookieConsentBanner, null))));
const $cbbe578478bf6317$var$boxStyles = (0, $ii5wQ.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("bKpcl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("6h9FI")
]).then(()=>parcelRequire('bwpT1'));

});


parcelRegister("asgRx", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $692526aac37c19f2$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $692526aac37c19f2$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $692526aac37c19f2$export$86047f02632f9f5b = (0, $gwIPs.gridSize) * 7;
const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("6ohPr", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $f9467d6df1e451da$export$fafc306b802ab39d);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("57iCZ")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));

});
parcelRegister("57iCZ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("12K5T")
]).then(()=>parcelRequire('h9o9V'));

});


parcelRegister("9L6Zg", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $83eb9a3cdcaec997$export$de40f69ba30f2376);

var $5uXOq = parcelRequire("5uXOq");

var $iPh5B = parcelRequire("iPh5B");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $iMzQW = parcelRequire("iMzQW");

var $14V0U = parcelRequire("14V0U");

var $6RMJw = parcelRequire("6RMJw");

var $hESBP = parcelRequire("hESBP");

var $2jAre = parcelRequire("2jAre");

var $lrZro = parcelRequire("lrZro");
const $83eb9a3cdcaec997$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ()=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const announcement = (0, $6RMJw.useBannerAnnouncement)();
    const transition = (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, $hESBP.useBannerEocTransition)() : undefined;
    const returnToMobile = (0, $lrZro.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $iMzQW.useBannerIPBlocklisting)();
    const cookieConsent = (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $iPh5B.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $2jAre.useBannerMailExpiry)();
    return (0, $5uXOq.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromeless) return $83eb9a3cdcaec997$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        return $83eb9a3cdcaec997$var$noBanner;
    }, [
        cookieConsent,
        isChromeless,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry
    ]);
};

});
parcelRegister("iPh5B", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $e552544bdd302edb$export$c7a51b5ee06f5794);

var $5uXOq = parcelRequire("5uXOq");

var $e7OnS = parcelRequire("e7OnS");
var $1q8Xn = parcelRequire("1q8Xn");

var $3TzYp = parcelRequire("3TzYp");

var $co1wz = parcelRequire("co1wz");

var $e5wyW = parcelRequire("e5wyW");

var $2eyDn = parcelRequire("2eyDn");


var $gubdC = parcelRequire("gubdC");
const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
    try {
        const shouldShowBannerBit = (0, $3TzYp.getCookie)((0, $e7OnS.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
        const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
        return data && (0, $1q8Xn.shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
    } catch (e) {
        return true;
    }
};
const $e552544bdd302edb$var$useBannerCookieConsentV2 = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $gubdC.useCookieConsentBannerSettings)();
    const { data: data } = (0, $2eyDn.useConsentBannerUserPreferencesResource)();
    (0, $5uXOq.useEffect)(()=>{
        const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $gubdC.isInIframe)()) onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $91be75e714d10b24$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $e552544bdd302edb$var$useBannerCookieConsentV1 = ()=>{
    const [{ isDismissed: isDismissed, height: height }] = (0, $gubdC.useCookieConsentBannerSettings)();
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $91be75e714d10b24$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $e552544bdd302edb$export$c7a51b5ee06f5794 = (0, $e5wyW.functionWithCondition)(()=>(0, $co1wz.ff)('platform.moonjelly.browser-storage-controls-v2'), $e552544bdd302edb$var$useBannerCookieConsentV2, $e552544bdd302edb$var$useBannerCookieConsentV1);

});
parcelRegister("e7OnS", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $a488cd5ca5197429$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $a488cd5ca5197429$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $a488cd5ca5197429$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", () => $a488cd5ca5197429$export$f57af01b64fc97b8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $a488cd5ca5197429$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $a488cd5ca5197429$export$37073d560ecebada);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $a488cd5ca5197429$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $a488cd5ca5197429$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $a488cd5ca5197429$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $a488cd5ca5197429$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $a488cd5ca5197429$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $a488cd5ca5197429$export$31deaeaebce525bb);

var $iG1qD = parcelRequire("iG1qD");
const $a488cd5ca5197429$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $a488cd5ca5197429$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $a488cd5ca5197429$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $a488cd5ca5197429$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $a488cd5ca5197429$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $a488cd5ca5197429$export$37073d560ecebada = 'atl-testing-consents';
const $a488cd5ca5197429$export$b28b5d760fe14a21 = {
    [(0, $iG1qD.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $iG1qD.PreferenceCategory).Functional]: true,
    [(0, $iG1qD.PreferenceCategory).Marketing]: true,
    [(0, $iG1qD.PreferenceCategory).Analytics]: true,
    [(0, $iG1qD.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $a488cd5ca5197429$export$4a12f9e99971760a = {
    [(0, $iG1qD.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $iG1qD.PreferenceCategory).Functional]: false,
    [(0, $iG1qD.PreferenceCategory).Marketing]: false,
    [(0, $iG1qD.PreferenceCategory).Analytics]: false,
    [(0, $iG1qD.PreferenceCategory).Unknown]: false
};
const $a488cd5ca5197429$export$f0fd1d13ec1d48f2 = {
    ...$a488cd5ca5197429$export$4a12f9e99971760a,
    [(0, $iG1qD.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $a488cd5ca5197429$export$f95182b7aa141c57 = '001';
const $a488cd5ca5197429$export$1f25427b34f9c405 = '002';
const $a488cd5ca5197429$export$31deaeaebce525bb = '003';

});
parcelRegister("iG1qD", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $d98d41ec52002465$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $d98d41ec52002465$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $d98d41ec52002465$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $d98d41ec52002465$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CachedKeysDataProperty", () => $d98d41ec52002465$export$cd5dd043a4a3cfee);
$parcel$export(module.exports, "Status", () => $d98d41ec52002465$export$96e9906d6d93a972);
let $d98d41ec52002465$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
let $d98d41ec52002465$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
let $d98d41ec52002465$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
let $d98d41ec52002465$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
let $d98d41ec52002465$export$cd5dd043a4a3cfee = /*#__PURE__*/ function(CachedKeysDataProperty) {
    CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
    CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataProperty["Cookies"] = "keys";
    CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataProperty;
}({});
let $d98d41ec52002465$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});

});


parcelRegister("1q8Xn", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $108f2ac081db59d2$export$6406464aa126433e);

var $j78Eu = parcelRequire("j78Eu");

var $4qYnX = parcelRequire("4qYnX");

var $fIz84 = parcelRequire("fIz84");
const $108f2ac081db59d2$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $4qYnX.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $fIz84.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $j78Eu.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $fIz84.getBannerVisibility)(consentPrefsData);
};

});
parcelRegister("j78Eu", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $dea561e3ec632085$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $dea561e3ec632085$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $dea561e3ec632085$export$f8422650c3dec8b2);

var $cala7 = parcelRequire("cala7");

var $7PdQG = parcelRequire("7PdQG");
const $dea561e3ec632085$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $dea561e3ec632085$var$POST_CONSENTS_URL = `${$dea561e3ec632085$var$BASE_CONSENTS_URL}/user`;
const $dea561e3ec632085$var$GET_CONSENTS_URL = `${$dea561e3ec632085$var$POST_CONSENTS_URL}/consents/cookies`;
const $dea561e3ec632085$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $7PdQG.serializeConsents)(consentData);
        const consentTimestamp = (0, $7PdQG.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $7PdQG.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $dea561e3ec632085$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$dea561e3ec632085$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $dea561e3ec632085$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $cala7.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $dea561e3ec632085$export$bd9f5bcbf9cd947c();
    }
};
const $dea561e3ec632085$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $7PdQG.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $dea561e3ec632085$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$dea561e3ec632085$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $dea561e3ec632085$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $7PdQG.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $cala7.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});
parcelRegister("7PdQG", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $5b2809e72e2d850c$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $5b2809e72e2d850c$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $5b2809e72e2d850c$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $5b2809e72e2d850c$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $5b2809e72e2d850c$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $5b2809e72e2d850c$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $5b2809e72e2d850c$export$a79c0ea3d7c2444a);

var $1Vlui = parcelRequire("1Vlui");

var $e7OnS = parcelRequire("e7OnS");

var $eMLDH = parcelRequire("eMLDH");

var $iG1qD = parcelRequire("iG1qD");

var $413OZ = parcelRequire("413OZ");
const $5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $e7OnS.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $5b2809e72e2d850c$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $e7OnS.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $5b2809e72e2d850c$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $5b2809e72e2d850c$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV2ConsentToken = $5b2809e72e2d850c$var$isLegacyGeoTargetingV2Token(consentToken);
    const isLegacyV1ConsentToken = $5b2809e72e2d850c$var$isLegacyV1Token(consentToken);
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $5b2809e72e2d850c$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    return false;
    const isDefaultToken = (0, $1Vlui.getBoolFromBitValue)(consentToken[7]);
    return isDefaultToken;
};
const $5b2809e72e2d850c$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $e7OnS.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $e7OnS.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $iG1qD.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $1Vlui.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $1Vlui.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $1Vlui.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $5b2809e72e2d850c$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $e7OnS.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $1Vlui.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $413OZ.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $1Vlui.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $413OZ.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $1Vlui.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $413OZ.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $1Vlui.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $413OZ.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $5b2809e72e2d850c$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $eMLDH.getCookie)((0, $e7OnS.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $5b2809e72e2d850c$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $5b2809e72e2d850c$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $5b2809e72e2d850c$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $5b2809e72e2d850c$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $iG1qD.PreferenceCategory).StrictlyNecessary,
        (0, $iG1qD.PreferenceCategory).Functional,
        (0, $iG1qD.PreferenceCategory).Analytics,
        (0, $iG1qD.PreferenceCategory).Marketing,
        (0, $iG1qD.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $iG1qD.PreferenceCategory).StrictlyNecessary]: (0, $413OZ.ConsentHubKey).StrictlyNecessary,
        [(0, $iG1qD.PreferenceCategory).Functional]: (0, $413OZ.ConsentHubKey).Functional,
        [(0, $iG1qD.PreferenceCategory).Analytics]: (0, $413OZ.ConsentHubKey).Analytics,
        [(0, $iG1qD.PreferenceCategory).Marketing]: (0, $413OZ.ConsentHubKey).Marketing,
        [(0, $iG1qD.PreferenceCategory).Unknown]: (0, $413OZ.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $5b2809e72e2d850c$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $5b2809e72e2d850c$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $5b2809e72e2d850c$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $5b2809e72e2d850c$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $5b2809e72e2d850c$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("1Vlui", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $166bc856fd06b60e$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $166bc856fd06b60e$export$27647458f3cf29d2);
const $166bc856fd06b60e$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $166bc856fd06b60e$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("413OZ", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $2eca384755b92c3c$export$31140359b1e505cf);
// If consents are present and populated, the user is authenticated and has recorded preferences.
// If consents are present but empty, the user is authenticated and has no preferences in the system.
// If consents are not present in the DB, the user is unauthenticated and has no preferences in the system.
// currentLocale will always be present if available ("UNKNOWN" if not), regardless of auth status
// localeWhenConsented will never be relevant for unauthenticated users.
// Typical locale format: <countryCode>-<subdivisionCode> e.g. 'FR-ARA' for France, or 'US-VA' for Virginia
// There are ~30m users who do not have the modern version of their locale stored in ConsentHub (inclusive of the subdivision)
// which means we need to account for instances where we ONLY have the country code of US.
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
let $2eca384755b92c3c$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});



parcelRegister("4qYnX", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $33a86e65aee8b4c4$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $33a86e65aee8b4c4$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $33a86e65aee8b4c4$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $33a86e65aee8b4c4$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $33a86e65aee8b4c4$export$7962405c3ca274b1);

var $hFKXd = parcelRequire("hFKXd");

var $1Vlui = parcelRequire("1Vlui");

var $e7OnS = parcelRequire("e7OnS");

var $7PdQG = parcelRequire("7PdQG");

var $iG1qD = parcelRequire("iG1qD");
const $33a86e65aee8b4c4$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $e7OnS.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $e7OnS.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $e7OnS.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $e7OnS.V001_SCHEMA_KEY),
        (0, $e7OnS.V002_SCHEMA_KEY),
        (0, $e7OnS.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $33a86e65aee8b4c4$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $e7OnS.V001_SCHEMA_KEY);
    return [
        version,
        (0, $1Vlui.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $1Vlui.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $1Vlui.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $1Vlui.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $33a86e65aee8b4c4$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $iG1qD.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $iG1qD.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $iG1qD.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $iG1qD.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $iG1qD.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $33a86e65aee8b4c4$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $e7OnS.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $iG1qD.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $iG1qD.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $iG1qD.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $iG1qD.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Functional]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Analytics]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Marketing]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Unknown]),
        (0, $1Vlui.getBitValueFromBool)(isDefaultConsentBit),
        (0, $1Vlui.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $1Vlui.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $33a86e65aee8b4c4$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $7PdQG.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$33a86e65aee8b4c4$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $iG1qD.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $33a86e65aee8b4c4$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $e7OnS.V003_SCHEMA_KEY);
    return [
        version,
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Functional]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Analytics]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Marketing]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.PreferenceCategory).Unknown]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $1Vlui.getBitValueFromBool)(userPreferences[(0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $33a86e65aee8b4c4$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $iG1qD.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $iG1qD.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $iG1qD.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $iG1qD.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $iG1qD.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $iG1qD.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $33a86e65aee8b4c4$var$V002SpecificBitKeys = [
    (0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $iG1qD.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $iG1qD.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $iG1qD.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $iG1qD.ConsentPreferenceV2).ConsentedUnderFADP
];
const $33a86e65aee8b4c4$var$V003SpecificBitKeys = [
    (0, $iG1qD.ContextualConsentProperty).ConsentsAreDefault,
    (0, $iG1qD.ContextualConsentProperty).UserIsAuthenticated,
    (0, $iG1qD.ContextualConsentProperty).ConsentDataUnavailable
];
function $33a86e65aee8b4c4$export$3199823fec979bd1(userPreferences) {
    if (!(0, $hFKXd.fg)('platform.moonjelly.browser-storage-controls-v2')) return $33a86e65aee8b4c4$var$packPrefsVersion001(userPreferences);
    const isV002 = $33a86e65aee8b4c4$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $33a86e65aee8b4c4$var$packPrefsVersion002(userPreferences);
    const isV003 = $33a86e65aee8b4c4$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $33a86e65aee8b4c4$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $33a86e65aee8b4c4$var$packPrefsVersion001(userPreferences);
}
function $33a86e65aee8b4c4$export$8d213cb390bab4fa(userPreferencesCookie) {
    if (!(0, $hFKXd.fg)('platform.moonjelly.browser-storage-controls-v2')) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $e7OnS.V001_SCHEMA_KEY)) return $33a86e65aee8b4c4$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $33a86e65aee8b4c4$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $33a86e65aee8b4c4$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $33a86e65aee8b4c4$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $33a86e65aee8b4c4$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $33a86e65aee8b4c4$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $33a86e65aee8b4c4$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $iG1qD.PrefetchedPreferenceState).INTERNAL) {
        if ($33a86e65aee8b4c4$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $33a86e65aee8b4c4$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $7PdQG.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $33a86e65aee8b4c4$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $iG1qD.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});

parcelRegister("fIz84", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $b71636fc0a96ad84$export$bfdb9f82a9194c1e);

var $3zdAw = parcelRequire("3zdAw");

var $1Vlui = parcelRequire("1Vlui");

var $e7OnS = parcelRequire("e7OnS");

var $7PdQG = parcelRequire("7PdQG");

var $eMLDH = parcelRequire("eMLDH");

var $4qYnX = parcelRequire("4qYnX");
const $b71636fc0a96ad84$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $4qYnX.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $1Vlui.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $7PdQG.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $7PdQG.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $7PdQG.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $b71636fc0a96ad84$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $1Vlui.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $7PdQG.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $b71636fc0a96ad84$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $7PdQG.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $b71636fc0a96ad84$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $7PdQG.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $b71636fc0a96ad84$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $3zdAw.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $eMLDH.getCookie)((0, $e7OnS.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $b71636fc0a96ad84$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $1Vlui.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $b71636fc0a96ad84$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $b71636fc0a96ad84$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});


parcelRegister("2eyDn", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $e7OnS = parcelRequire("e7OnS");

var $3TzYp = parcelRequire("3TzYp");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $dIdda = parcelRequire("dIdda");

const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $dIdda.createResource)({
    type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $3TzYp.getCookie)((0, $e7OnS.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $3TzYp.getCookie)((0, $e7OnS.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if ((0, $4R6GH.fg)('jfp-magma-browser-storage-bump-3')) {
            if (consentToken) return {
                consentToken: consentToken,
                fallbackConsentToken: fallbackConsentToken
            };
        } else {
            const currentLocale = (0, $3TzYp.getCookie)((0, $e7OnS.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
            if (consentToken && currentLocale) return {
                consentToken: consentToken,
                currentLocale: currentLocale,
                fallbackConsentToken: fallbackConsentToken
            };
        }
        const data = await (0, $eusud.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $dIdda.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);

});
const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("gubdC", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $53f6acf0285fde21$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $53f6acf0285fde21$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $53f6acf0285fde21$export$ecbab4dc5f9ad844);

var $eMLDH = parcelRequire("eMLDH");
var $e7OnS = parcelRequire("e7OnS");

var $co1wz = parcelRequire("co1wz");

var $7JoAD = parcelRequire("7JoAD");
function $53f6acf0285fde21$export$8d213cb390bab4fa(userPreferencesCookie) {
    // Format 0000000
    // 000 (schema version 3 digits)
    // 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
    // 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
    // 0/1 (1 digit, MARKETING cookies disabled/enabled)
    // 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
    if (userPreferencesCookie.length < 3) // Wrong format, no version
    return;
    const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
    if (version !== '001') // We support version 001 only
    return;
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        STRICTLY_NECESSARY: true,
        FUNCTIONAL: userPreferencesCookie[3] === '1',
        ANALYTICS: userPreferencesCookie[4] === '1',
        MARKETING: userPreferencesCookie[5] === '1',
        UNKNOWN: userPreferencesCookie[6] === '1'
    };
}
const $53f6acf0285fde21$export$1de6a888ae076ff8 = ()=>{
    if (false) return undefined;
    const packedPrefs = (0, $eMLDH.getCookie)((0, $e7OnS.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
    if (!packedPrefs) return undefined;
    return $53f6acf0285fde21$export$8d213cb390bab4fa(packedPrefs);
};
const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    if ((0, $co1wz.ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
    return $53f6acf0285fde21$export$1de6a888ae076ff8() !== undefined || $53f6acf0285fde21$export$9f140ed41af5108c();
};
const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
    isDismissed: $53f6acf0285fde21$export$aa1483cc2e197f6e(),
    height: 0
};
const $53f6acf0285fde21$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                height: height
            });
        }
};
const $53f6acf0285fde21$var$Store = (0, $7JoAD.createStore)({
    name: 'cookie-consent-banner',
    initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
    actions: $53f6acf0285fde21$export$e324594224ef24da
});
const $53f6acf0285fde21$export$ae97931560f092a4 = (0, $7JoAD.createHook)($53f6acf0285fde21$var$Store);
const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, $7JoAD.createActionsHook)($53f6acf0285fde21$var$Store);

});


parcelRegister("iMzQW", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $014906e38669dbae$export$564412c1d9cd4ccc);

var $5uXOq = parcelRequire("5uXOq");

var $9B86Q = parcelRequire("9B86Q");

var $asgRx = parcelRequire("asgRx");
const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $asgRx.BANNER_NAME),
            height: (0, $asgRx.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("6RMJw", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $6710252c02f204b2$export$1e775b1ab04f2888);

var $5uXOq = parcelRequire("5uXOq");

var $5kYzp = parcelRequire("5kYzp");

var $cZpsT = parcelRequire("cZpsT");

var $gk4cG = parcelRequire("gk4cG");
const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $5kYzp.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $gk4cG.NAME),
            height: (0, $gk4cG.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("5kYzp", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $dIdda = parcelRequire("dIdda");

var $4AdUG = parcelRequire("4AdUG");

var $2EmJy = parcelRequire("2EmJy");

var $9UEf0 = parcelRequire("9UEf0");
const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $dIdda.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $2EmJy.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $dIdda.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $4AdUG.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);

});
parcelRegister("4AdUG", function(module, exports) {

$parcel$export(module.exports, "get", () => $90a9ae99ea774144$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $90a9ae99ea774144$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("2EmJy", function(module, exports) {

$parcel$export(module.exports, "get", () => $02ac2f2e29fd92e6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';


parcelRegister("9UEf0", function(module, exports) {

$parcel$export(module.exports, "get", () => $0fff4d2d98ff5692$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0fff4d2d98ff5692$export$adaa4cf7ef1b65be);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $89SaW.getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $89SaW.setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("gk4cG", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $8ea828cd42179fda$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $8ea828cd42179fda$export$3c5e605ca7ade9f2);

var $gwIPs = parcelRequire("gwIPs");
const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 8;
const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("hESBP", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $304370119e420b48$export$b6539a8209f95b48);

var $5uXOq = parcelRequire("5uXOq");

var $ez5GD = parcelRequire("ez5GD");

var $201IG = parcelRequire("201IG");

var $8J6rn = parcelRequire("8J6rn");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $iaN8D = parcelRequire("iaN8D");
const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $ez5GD.useOgConsolidationUserState)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $8J6rn.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $201IG.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $iaN8D.BANNER_NAME),
            height: data && (0, $201IG.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $iaN8D.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("ez5GD", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $e71f39314801737b$export$c35632c02599163f);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $kMiZJ = parcelRequire("kMiZJ");

var $iXaZ3 = parcelRequire("iXaZ3");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");

var $fLIp1 = parcelRequire("fLIp1");
const $e71f39314801737b$export$c35632c02599163f = ()=>{
    const errorRef = (0, $5uXOq.useRef)();
    const loadingRef = (0, $5uXOq.useRef)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $dIdda.useResource)((0, $kMiZJ.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const update = (0, $5uXOq.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $fLIp1.default).errorFlagTitle)
                });
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("kMiZJ", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $1e0457dbe68ab17d$export$4b870505c49999ef);

var $jcw0u = parcelRequire("jcw0u");

var $dIdda = parcelRequire("dIdda");

var $9QTNT = parcelRequire("9QTNT");

const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $dIdda.createResource)({
    type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
    getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $9QTNT.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("9QTNT", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $1a9945d1ee35f024$export$df7594d56c9ebe57);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $iXaZ3 = parcelRequire("iXaZ3");
const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $iXaZ3.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $89SaW.getUserProperty)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $jcw0u.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $jJZqs.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("iXaZ3", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $58f10b27bad0d860$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$23da4710c3a29eae);
const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $58f10b27bad0d860$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $58f10b27bad0d860$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("fLIp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c9811268c2fa85$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("201IG", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $f068b5042603902f$export$25a52eb2dc74e2f9);
const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("8J6rn", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $31f27587daf0b28f$export$990ea9ff15ca04f7);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $daoB1 = parcelRequire("daoB1");

var $dIdda = parcelRequire("dIdda");

var $3H5ry = parcelRequire("3H5ry");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const enabled = (0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error');
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (enabled && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh,
        enabled
    ]);
};
const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $dIdda.useResource)((0, $bHhiy.getConsolidationStateResource)());
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $3H5ry.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $3H5ry.checkIsConsolidated)(tenantInfoResource.data),
        isTransitioning: (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $3H5ry.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $3H5ry.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("bHhiy", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $cd33a435a46904ef$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $cIB9k = parcelRequire("cIB9k");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $dIdda = parcelRequire("dIdda");

var $bgC2H = parcelRequire("bgC2H");

const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
    let url = '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED
            });
        });
        return promise;
    }
    if (false) promise = (0, $cIB9k.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $4R6GH.fg)('tenant-info-issuer-change') ? 'og-customer-int-api' : 'og-apigw-atlassian-gw'
        }
    });
    else promise = (0, $cIB9k.eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
    if ((0, $co1wz.ff)('eoc-tenant-info-hook_dq6ke')) return promise;
    return promise.then((response)=>response.consolidationState);
};
const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $dIdda.createResource)({
        type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});
parcelRegister("cIB9k", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $abe00734ac47f029$export$212b9c60150b5a0a);

var $hL5HH = parcelRequire("hL5HH");

var $hhGDe = parcelRequire("hhGDe");

var $fbVPl = parcelRequire("fbVPl");
const $abe00734ac47f029$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') input = (0, $fbVPl.withPrefix)(input, init);
    else input = {
        ...input,
        url: (0, $fbVPl.withPrefix)(input.url, init)
    };
    const errorTransformer = init?.errorTransformer ?? (0, $fbVPl.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $hL5HH.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $hL5HH.HTTPError)(response);
        const sanitizedUrl = (0, $fbVPl.sanitizeUrlString)((0, $fbVPl.getRequestUrl)(input));
        (0, $hhGDe.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $hL5HH.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("hL5HH", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $e327382b318b34ba$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $e327382b318b34ba$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $e327382b318b34ba$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $e327382b318b34ba$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $e327382b318b34ba$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $e327382b318b34ba$export$4f52fcea95c8f97d);

var $8366h = parcelRequire("8366h");
class $e327382b318b34ba$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!');
        this.name = name;
        this.cause = cause;
    }
}
class $e327382b318b34ba$export$aa9d629c530f62a7 extends $e327382b318b34ba$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $8366h.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $e327382b318b34ba$export$c30b5b02747d791c extends $e327382b318b34ba$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response);
        this.cause = cause;
        this.data = data;
        this.message = message;
        this.message = message;
        this.name = (0, $8366h.ERROR_NAMES).StreamedHTTPError;
    }
}
const $e327382b318b34ba$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $e327382b318b34ba$export$aa9d629c530f62a7 || [
        (0, $8366h.ERROR_NAMES).HTTPError,
        (0, $8366h.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $e327382b318b34ba$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $e327382b318b34ba$export$bae979e68e4dc802 || [
        (0, $8366h.ERROR_NAMES).NetworkError,
        (0, $8366h.ERROR_NAMES).HTTPError,
        (0, $8366h.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $e327382b318b34ba$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $e327382b318b34ba$export$c30b5b02747d791c || candidate?.name === (0, $8366h.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("8366h", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $f04cf8fbf5ec86cf$export$daceac3b97803ce1);
var $f04cf8fbf5ec86cf$export$daceac3b97803ce1;
(function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
})($f04cf8fbf5ec86cf$export$daceac3b97803ce1 || ($f04cf8fbf5ec86cf$export$daceac3b97803ce1 = {}));

});


parcelRegister("fbVPl", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $4e9f960e5f988e9f$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $4e9f960e5f988e9f$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $4e9f960e5f988e9f$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $4e9f960e5f988e9f$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $4e9f960e5f988e9f$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $4e9f960e5f988e9f$export$ceb09b958e605eff);

var $fhcID = parcelRequire("fhcID");

var $hL5HH = parcelRequire("hL5HH");

let $4e9f960e5f988e9f$var$metaCloudId;
let $4e9f960e5f988e9f$var$isJSMAvailable = true;
function $4e9f960e5f988e9f$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $fhcID.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($4e9f960e5f988e9f$var$metaCloudId) return $4e9f960e5f988e9f$var$metaCloudId;
    if ($4e9f960e5f988e9f$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $4e9f960e5f988e9f$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $4e9f960e5f988e9f$var$isJSMAvailable = !!$4e9f960e5f988e9f$var$metaCloudId;
    }
    return $4e9f960e5f988e9f$var$metaCloudId;
}
function $4e9f960e5f988e9f$export$5a75f4aeb58ba80f(id) {
    $4e9f960e5f988e9f$var$metaCloudId = id;
}
function $4e9f960e5f988e9f$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $4e9f960e5f988e9f$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $9683bb764278266b$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $4e9f960e5f988e9f$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $4e9f960e5f988e9f$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $hL5HH.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $4e9f960e5f988e9f$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $hL5HH.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $hL5HH.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $4e9f960e5f988e9f$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $hL5HH.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $4e9f960e5f988e9f$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $hL5HH.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $hL5HH.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $4e9f960e5f988e9f$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $4e9f960e5f988e9f$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("fhcID", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $e5b11caa60b0566e$export$6acf61af03e62db);
const $e5b11caa60b0566e$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $9683bb764278266b$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("bgC2H", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $7JoAD = parcelRequire("7JoAD");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $7JoAD.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("3H5ry", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $bc03080c674ccba2$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $bc03080c674ccba2$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $bc03080c674ccba2$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $bc03080c674ccba2$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $bc03080c674ccba2$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $bc03080c674ccba2$export$cd227238525e8d57);

var $bgC2H = parcelRequire("bgC2H");

const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo !== (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED;
};
const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONING;
};
const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).CONSOLIDATED;
};
const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONED;
};
const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
};
const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
};

});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';



parcelRegister("itmJb", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);

var $9OXo1 = parcelRequire("9OXo1");
const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("iaN8D", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $d45809d2691157ce$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $d45809d2691157ce$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $d45809d2691157ce$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("2jAre", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $85ae441f6f576caa$export$3906461ac9b87d2);

var $5uXOq = parcelRequire("5uXOq");

var $hZhhj = parcelRequire("hZhhj");

var $921us = parcelRequire("921us");

var $1cxlJ = parcelRequire("1cxlJ");
const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $hZhhj.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $1cxlJ.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $1cxlJ.useBannerState)();
    (0, $5uXOq.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $hZhhj.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $921us.BANNER_NAME),
            height: (0, $921us.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("hZhhj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0f1ada479bbc578a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0f1ada479bbc578a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0f1ada479bbc578a$export$283aa034b7d4e2a0);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dIdda = parcelRequire("dIdda");

const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $eusud.performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
const $0f1ada479bbc578a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $dIdda.createResource)({
    type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $dIdda.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0f1ada479bbc578a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("921us", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $c8abb4ba3ebc926f$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $c8abb4ba3ebc926f$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("1cxlJ", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $b47a5e6c2ea18541$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $b47a5e6c2ea18541$export$fa4ffa872ee90bd0);

var $7JoAD = parcelRequire("7JoAD");
const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $b47a5e6c2ea18541$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $b47a5e6c2ea18541$var$Store = (0, $7JoAD.createStore)({
    name: 'mail-expiry-banner',
    initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
    actions: $b47a5e6c2ea18541$export$e324594224ef24da
});
const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, $7JoAD.createActionsHook)($b47a5e6c2ea18541$var$Store);
const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, $7JoAD.createStateHook)($b47a5e6c2ea18541$var$Store);

});


parcelRegister("lrZro", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $2d8151e19ddaa4d5$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $2d8151e19ddaa4d5$export$a898dd7b7ec9917a);

var $5uXOq = parcelRequire("5uXOq");

var $bCdIp = parcelRequire("bCdIp");

var $7JoAD = parcelRequire("7JoAD");

var $aAExw = parcelRequire("aAExw");
const $2d8151e19ddaa4d5$var$initialState = {
    isEnabled: (0, $bCdIp.shouldShowReturnToMobileBanner)()
};
const $2d8151e19ddaa4d5$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $2d8151e19ddaa4d5$var$store = (0, $7JoAD.createStore)({
    initialState: $2d8151e19ddaa4d5$var$initialState,
    actions: $2d8151e19ddaa4d5$var$actions
});
const $2d8151e19ddaa4d5$export$571311559507e90 = (0, $7JoAD.createHook)($2d8151e19ddaa4d5$var$store);
const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabled }] = $2d8151e19ddaa4d5$export$571311559507e90();
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $aAExw.BANNER_NAME),
            height: (0, $aAExw.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("aAExw", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $61da032f64bef3a5$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $61da032f64bef3a5$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $61da032f64bef3a5$export$698c82a2c8445300);

var $gwIPs = parcelRequire("gwIPs");
const $61da032f64bef3a5$export$aa875602f5712b77 = (0, $gwIPs.gridSize) * 6;
const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});



parcelRegister("c1ivz", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $d10936fc02d4c9c5$export$aa03f7909e0828ec);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $d10936fc02d4c9c5$var$BannerAnnouncement = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("2cw99")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/index.tsx"
});
const $d10936fc02d4c9c5$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d10936fc02d4c9c5$var$BannerAnnouncement, null));

});
parcelRegister("2cw99", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("eOo6L")
]).then(()=>parcelRequire('58JTH'));

});


parcelRegister("14pJv", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $710b388646922007$export$8bf182764b9d2eb8);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $710b388646922007$var$BannerTransition = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("kUqkC")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $710b388646922007$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));

});
parcelRegister("kUqkC", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1OPKz").then(()=>parcelRequire('iGIQS'));

});


parcelRegister("9Cdg4", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $9a323272de0aa4c0$export$11a26ffa2d1b48ed);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("fKslw")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));

});
parcelRegister("fKslw", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hjh1F")
]).then(()=>parcelRequire('4tHNi'));

});


parcelRegister("9ylrc", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $369ea7a3ed2830c2$export$81c4f1e869d5a87);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, $7B17s.lazy)(()=>(parcelRequire("7jJzW")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
});
const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));

});
parcelRegister("7jJzW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("MUWFq")
]).then(()=>parcelRequire('4TzBF'));

});


parcelRegister("dm0Uk", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $1be350c372161cad$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1be350c372161cad$export$6bdda512681a5774 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $lD23V.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kc9FZ", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $87d424e5b411dd1e$export$461c2ed3163c74ff);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $39xOx = parcelRequire("39xOx");


var $6jY6G = parcelRequire("6jY6G");

var $1XrjK = parcelRequire("1XrjK");

var $2SVPM = parcelRequire("2SVPM");

var $imS60 = parcelRequire("imS60");
const $87d424e5b411dd1e$var$routeComponents = [];
const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $1XrjK.renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $1XrjK.renderGlobalComponents)(sharedGlobalComponents));
const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};

});
parcelRegister("imS60", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b7686623a2955e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $darnD = parcelRequire("darnD");

var $7sZUk = parcelRequire("7sZUk");

var $b6CGL = parcelRequire("b6CGL");
const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $7sZUk.useInteractionContext)();
    const rllProfilerContext = (0, $5uXOq.useContext)((0, $darnD.ProfilerContext));
    const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
    const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
            current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b6b7686623a2955e$var$flowRight([
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $darnD.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
}
function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6CGL.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("b6CGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d34152361734da$export$2e2bcd8739ae039);

var $7iAiU = parcelRequire("7iAiU");
var $b9d34152361734da$export$2e2bcd8739ae039 = (0, $7iAiU.default);

});
parcelRegister("7iAiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee6990652e1be93$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7sZUk = parcelRequire("7sZUk");
function $8ee6990652e1be93$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $7sZUk.useInteractionContext)();
    const newContext = (0, $5uXOq.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sZUk.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});




parcelRegister("6DLIs", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $1f7483f6f5b15b02$export$3b677a7048d7ae0);

var $5uXOq = parcelRequire("5uXOq");

var $kjig3 = parcelRequire("kjig3");

var $lRFpu = parcelRequire("lRFpu");

var $jD5no = parcelRequire("jD5no");

var $2i4sA = parcelRequire("2i4sA");

var $gAeCk = parcelRequire("gAeCk");

var $5tsrJ = parcelRequire("5tsrJ");

var $j8DrX = parcelRequire("j8DrX");

var $lJ5jf = parcelRequire("lJ5jf");

var $3HwlS = parcelRequire("3HwlS");


var $8ApFP = parcelRequire("8ApFP");

var $4yEIl = parcelRequire("4yEIl");

var $iPMn1 = parcelRequire("iPMn1");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $2SVPM = parcelRequire("2SVPM");

var $9OXo1 = parcelRequire("9OXo1");

var $eKtC8 = parcelRequire("eKtC8");

var $bAjl9 = parcelRequire("bAjl9");

var $lvG9V = parcelRequire("lvG9V");

var $gPTB6 = parcelRequire("gPTB6");

var $9kep9 = parcelRequire("9kep9");

var $eSznd = parcelRequire("eSznd");

var $ivvwC = parcelRequire("ivvwC");
const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAjl9.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lRFpu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKtC8.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjig3.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kep9.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvG9V.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPTB6.NavigationContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivvwC.UserContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSznd.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "page-container-v2.nav-v3.app-base",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ5jf.SidebarNav4ControllerProvider), null, children) : children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iPMn1.ScreenSpaceFlagsPlacement), null)))))))))))))));
};

});
parcelRegister("kjig3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fbdb43386f4b093$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cGedv = parcelRequire("cGedv");

var $ghWs5 = parcelRequire("ghWs5");
const $1fbdb43386f4b093$var$InsideAppProviderContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $1fbdb43386f4b093$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $5uXOq.useContext)($1fbdb43386f4b093$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGedv.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fbdb43386f4b093$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghWs5.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $1fbdb43386f4b093$export$2e2bcd8739ae039 = $1fbdb43386f4b093$export$c7dacf3845253dcf;

});

parcelRegister("2i4sA", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $c08cc6207a190361$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $c08cc6207a190361$export$e0241c84ce5db240);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $jNwWT = parcelRequire("jNwWT");

var $aD4Nm = parcelRequire("aD4Nm");

var $ehKaJ = parcelRequire("ehKaJ");
const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("ehKaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a267f2f54170b1c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");


var $jNwWT = parcelRequire("jNwWT");
class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props);
        this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        };
        this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        };
        this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $hh0bW.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("lJ5jf", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $ba2af518cd3fa886$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $ba2af518cd3fa886$export$641950c86d73374);

var $5uXOq = parcelRequire("5uXOq");

var $fMcVX = parcelRequire("fMcVX");
const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $fMcVX.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $ba2af518cd3fa886$export$641950c86d73374() {
    const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});
parcelRegister("fMcVX", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $ad785f9726254880$export$cdcd6885320eec31);

var $lhMtU = parcelRequire("lhMtU");
function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $lhMtU.isMenuIdList)(menuId) ? (0, $lhMtU.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("lhMtU", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $dc9d941dfadd4b5a$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $dc9d941dfadd4b5a$export$d8e017f58178e379);
const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   '; // Three spaces
function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
    return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}
function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
}
function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}

});



parcelRegister("4yEIl", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $21214568f856c41e$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $21214568f856c41e$export$9f8d3084fd3d5fc0);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $4R6GH = parcelRequire("4R6GH");

var $jQsty = parcelRequire("jQsty");

var $lpwtK = parcelRequire("lpwtK");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $cNd4s = parcelRequire("cNd4s");

var $DVljb = parcelRequire("DVljb");

var $1kdO2 = parcelRequire("1kdO2");
var $8fSqG = parcelRequire("8fSqG");

var $dIdda = parcelRequire("dIdda");

var $adncp = parcelRequire("adncp");
const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const locale = (0, $DVljb.useLocale)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const editions = (0, $k9JTq.useAppEditions)();
    const subproduct = data?.type;
    const context = (0, $5uXOq.useMemo)(()=>{
        const edition = (0, $adncp.subproductToEdition)(subproduct, editions);
        return {
            current: {
                ...(0, $adncp.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        locale,
        editions
    ]);
    const env = (0, $5uXOq.useMemo)(()=>({
            env: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kdO2.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $jQsty.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $dIdda.useRouter)();
    (0, $8fSqG.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $jQsty.default)('killswitch_post_office_in_jira');
    const isScreenSpaceFlagsEnabled = (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe');
    return isPostOfficeEnabled && isScreenSpaceFlagsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("1kdO2", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $244c074d372f4bb5$export$fb465b6e855c1e85);

var $5uXOq = parcelRequire("5uXOq");

var $LpImS = parcelRequire("LpImS");

var $1UikQ = parcelRequire("1UikQ");

var $gI4nF = parcelRequire("gI4nF");

var $ZKvet = parcelRequire("ZKvet");

var $8fSqG = parcelRequire("8fSqG");

var $cplpV = parcelRequire("cplpV");

var $bgidj = parcelRequire("bgidj");

var $hynLS = parcelRequire("hynLS");

var $bRYFx = parcelRequire("bRYFx");
const $244c074d372f4bb5$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $bgidj.useStableObject)((0, $bRYFx.generateEnvironmentConfigWithOverrides)((0, $ZKvet.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $bgidj.useStableObject)($244c074d372f4bb5$var$composeConfig((0, $gI4nF.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, $hynLS.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZKvet.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gI4nF.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cplpV.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hynLS.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fSqG.RouteListenerProvider), null, children)))));
};
const $244c074d372f4bb5$var$composeConfig = (base, ...rest)=>rest.reduce((a, v)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(a, v), (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(base));

});
parcelRegister("gI4nF", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $526a3311d2dc3dfb$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $526a3311d2dc3dfb$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $526a3311d2dc3dfb$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $526a3311d2dc3dfb$export$5bd9099e0ae94a43);

var $5uXOq = parcelRequire("5uXOq");
const $526a3311d2dc3dfb$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $526a3311d2dc3dfb$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($526a3311d2dc3dfb$export$da5dc9062cba6715);
const $526a3311d2dc3dfb$export$3a10495c2cd2db0c = $526a3311d2dc3dfb$export$a228be81fcb77b42.Provider;
const $526a3311d2dc3dfb$export$b77983be89bb0a4e = $526a3311d2dc3dfb$export$3a10495c2cd2db0c;
const $526a3311d2dc3dfb$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($526a3311d2dc3dfb$export$a228be81fcb77b42);

});

parcelRegister("ZKvet", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $406eeb710bc9477c$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $406eeb710bc9477c$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $406eeb710bc9477c$export$877b97169cc75e8b);

var $5uXOq = parcelRequire("5uXOq");

const $406eeb710bc9477c$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        test: {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7ecc71a1b310ea07$export$1e9fed4c0197724c),
                pathname: (0, $7ecc71a1b310ea07$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7ecc71a1b310ea07$export$1e9fed4c0197724c),
                pathname: (0, $7ecc71a1b310ea07$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7ecc71a1b310ea07$export$1e9fed4c0197724c),
                pathname: (0, $7ecc71a1b310ea07$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7ecc71a1b310ea07$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7ecc71a1b310ea07$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7ecc71a1b310ea07$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $7ecc71a1b310ea07$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7ecc71a1b310ea07$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $406eeb710bc9477c$export$fceca2c399b32565 = (0, $5uXOq.createContext)($406eeb710bc9477c$export$b4ede87479bfcf09);
const $406eeb710bc9477c$export$604607f913ef367c = $406eeb710bc9477c$export$fceca2c399b32565.Provider;
const $406eeb710bc9477c$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($406eeb710bc9477c$export$fceca2c399b32565);

});
var $7ecc71a1b310ea07$exports = {};

$parcel$export($7ecc71a1b310ea07$exports, "API_ORIGIN_LOCAL", () => $7ecc71a1b310ea07$export$1e9fed4c0197724c);
$parcel$export($7ecc71a1b310ea07$exports, "API_PATHNAME_LOCAL", () => $7ecc71a1b310ea07$export$919a9569bce66f17);
$parcel$export($7ecc71a1b310ea07$exports, "API_PATHNAME_STG_PROD", () => $7ecc71a1b310ea07$export$d4fe3482c88e73a8);
$parcel$export($7ecc71a1b310ea07$exports, "REMOTE_MODULE_URI_LOCAL", () => $7ecc71a1b310ea07$export$67be2569ef5d7666);
$parcel$export($7ecc71a1b310ea07$exports, "REMOTE_MODULE_URI_STG", () => $7ecc71a1b310ea07$export$b49738b89db261cd);
$parcel$export($7ecc71a1b310ea07$exports, "REMOTE_MODULE_URI_PROD", () => $7ecc71a1b310ea07$export$bbd96cd490b0df63);
const $7ecc71a1b310ea07$export$1e9fed4c0197724c = 'http://localhost:8081';
const $7ecc71a1b310ea07$export$919a9569bce66f17 = '/api/v1/placements/';
const $7ecc71a1b310ea07$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $7ecc71a1b310ea07$export$67be2569ef5d7666 = 'http://localhost:9009';
const $7ecc71a1b310ea07$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $7ecc71a1b310ea07$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';


parcelRegister("8fSqG", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $79d042efe54b848c$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $79d042efe54b848c$export$31986273b686f5ea);

var $5uXOq = parcelRequire("5uXOq");

var $yt27k = parcelRequire("yt27k");

var $jGbvv = parcelRequire("jGbvv");
const $79d042efe54b848c$var$noop = ()=>{};
const $79d042efe54b848c$var$RouteListenerContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    update: $79d042efe54b848c$var$noop
});
const $79d042efe54b848c$export$7a2084f4baac29a7 = ()=>(0, $yt27k.createSimplePubSub)();
const $79d042efe54b848c$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($79d042efe54b848c$var$RouteListenerContext);
const $79d042efe54b848c$export$755edb1665399d41 = ()=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $79d042efe54b848c$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $5uXOq.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $5uXOq.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $79d042efe54b848c$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $79d042efe54b848c$export$72fd8977abf03d60();
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $79d042efe54b848c$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $79d042efe54b848c$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79d042efe54b848c$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jGbvv.PostOfficeRouteProvider), route, children));
};

});
parcelRegister("yt27k", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $1fead0e5a82702f3$export$92469b55607f005b);
const $1fead0e5a82702f3$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});

parcelRegister("jGbvv", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $6b127dd44d81bb18$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $6b127dd44d81bb18$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $6b127dd44d81bb18$export$79301b66f7808cd8);

var $5uXOq = parcelRequire("5uXOq");

var $8tyNL = parcelRequire("8tyNL");

var $bgidj = parcelRequire("bgidj");
const $6b127dd44d81bb18$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $6b127dd44d81bb18$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current) return;
        state = {
            previous: state.current,
            current: next
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $6b127dd44d81bb18$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $bgidj.useStableObject)(route);
};
const $6b127dd44d81bb18$var$initialState = {
    previous: undefined,
    current: undefined
};
const $6b127dd44d81bb18$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$6b127dd44d81bb18$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined
    });
const $6b127dd44d81bb18$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $5uXOq.createContext)($6b127dd44d81bb18$var$initialState);
const $6b127dd44d81bb18$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $6b127dd44d81bb18$export$98c77e1bd702ed15(props);
    const route = $6b127dd44d81bb18$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b127dd44d81bb18$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $6b127dd44d81bb18$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($6b127dd44d81bb18$export$f7f47a74e8b47b1f); //Route listener

});
parcelRegister("bgidj", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $47868aff2736a83b$export$ed02d4adf2068b08);

var $5uXOq = parcelRequire("5uXOq");
function $47868aff2736a83b$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $47868aff2736a83b$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>obj, $47868aff2736a83b$export$cdf98ded28406f69(obj));
}

});



parcelRegister("cplpV", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $e6ce2f3eae906354$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $e6ce2f3eae906354$export$f51d04a086368016);

var $5uXOq = parcelRequire("5uXOq");

var $faVBT = parcelRequire("faVBT");
const $e6ce2f3eae906354$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $e6ce2f3eae906354$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placements: $e6ce2f3eae906354$var$initialPlacementState
});
const $e6ce2f3eae906354$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($e6ce2f3eae906354$var$PostOfficeScreenContext);
const $e6ce2f3eae906354$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $e6ce2f3eae906354$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($e6ce2f3eae906354$var$PostOfficeScreenUpdateContext);
const $e6ce2f3eae906354$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $5uXOq.useState)($e6ce2f3eae906354$var$initialPlacementState);
    const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $faVBT.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $faVBT.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6ce2f3eae906354$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6ce2f3eae906354$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $e6ce2f3eae906354$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $e6ce2f3eae906354$export$5d27c0ee02be2a23();
    (0, $5uXOq.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("faVBT", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $eb0f8414d6118403$export$bbd17ecb0679edd7);
const $eb0f8414d6118403$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});


parcelRegister("hynLS", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $6f655b2b43ac6021$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $6f655b2b43ac6021$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $6f655b2b43ac6021$export$89f8e1f623d8f5ac);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $6f655b2b43ac6021$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $6f655b2b43ac6021$export$a28a0c048b24fc5a = ()=>{
    const [onMessageDismiss, dismissMessageFromPlacement] = $6f655b2b43ac6021$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $6f655b2b43ac6021$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $6f655b2b43ac6021$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $6f655b2b43ac6021$var$createPubSub();
    return {
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $6f655b2b43ac6021$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $5uXOq.createContext)($6f655b2b43ac6021$export$a28a0c048b24fc5a());
const $6f655b2b43ac6021$export$c7535f8ebc5b75a9 = $6f655b2b43ac6021$export$ea58328f3ceee4d4.Provider;
const $6f655b2b43ac6021$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f655b2b43ac6021$export$c7535f8ebc5b75a9, {
            value: $6f655b2b43ac6021$export$a28a0c048b24fc5a()
        }, children);
const $6f655b2b43ac6021$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($6f655b2b43ac6021$export$ea58328f3ceee4d4);

});

parcelRegister("bRYFx", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $4ff7270c8d686771$export$ae3dab16eb1fc2cc);
const $4ff7270c8d686771$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});


parcelRegister("adncp", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $8d0bdd2f51e19696$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $8d0bdd2f51e19696$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $8d0bdd2f51e19696$export$cfacfecb20987ff1);

var $3qX4x = parcelRequire("3qX4x");
const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
    locale: 'en'
};
const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $3qX4x.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
    const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});
parcelRegister("3qX4x", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $28019f51d977bb92$export$d4d0794234e3fd53);

var $b1EkX = parcelRequire("b1EkX");

var $fe7YR = parcelRequire("fe7YR");

var $224I1 = parcelRequire("224I1");
// src/jira/workspace/manifest.ts
var $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $b1EkX.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $b1EkX.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $28019f51d977bb92$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $fe7YR.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $224I1.AriParser).fromOpts(derivedOpts, $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $224I1.AriParser).fromString(maybeAri, $28019f51d977bb92$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("b1EkX", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $806f13cc47cff352$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $806f13cc47cff352$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";

});




parcelRegister("iPMn1", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $3ba8955bb8ac2826$export$f6564e60882bdf90);

var $5uXOq = parcelRequire("5uXOq");

var $6ZFyk = parcelRequire("6ZFyk");

var $4R6GH = parcelRequire("4R6GH");

var $jQsty = parcelRequire("jQsty");

var $hpfWX = parcelRequire("hpfWX");


var $j2nvL = parcelRequire("j2nvL");
const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
    return !false && !(0, $jQsty.default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2nvL.PlacementFetchProvider), {
        placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpfWX.default), {
        placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
        PlacementComponent: (0, $6ZFyk.default),
        disableInitialData: true
    })) : null;
}; // Comment to trigger Jira cypress tests

});
parcelRegister("6ZFyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00dc61eaa650336$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gywce = parcelRequire("gywce");

var $kgs9b = parcelRequire("kgs9b");
var $hynLS = parcelRequire("hynLS");

var $812Tf = parcelRequire("812Tf");
var $hlD8q = parcelRequire("hlD8q");

var $fsWkK = parcelRequire("fsWkK");

var $2VVeB = parcelRequire("2VVeB");

var $8eyXr = parcelRequire("8eyXr");


var $adGTL = parcelRequire("adGTL");
const $c00dc61eaa650336$export$c60b43809441c5b0 = (0, $adGTL.withScreenSpaceFlagsIntlProvider)((0, $812Tf.createPlacementComponent)((0, $3adb2c051b516f3b$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)();
    (0, $hlD8q.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked } = (0, $hynLS.useMessagePlacementHooks)();
    const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
    };
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    const activeScopes = (0, $kgs9b.usePostOfficeContextScope)({
        scopes: $2VVeB.scopes
    });
    const messagesState = (0, $fsWkK.usePlacementApi)('/update-messages', {
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $gywce.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $8eyXr.MessageRenderer), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: ()=>setLocalMessageState([])
            }))
    }) : null;
}));
var $c00dc61eaa650336$export$2e2bcd8739ae039 = $c00dc61eaa650336$export$c60b43809441c5b0;

});
parcelRegister("2OMIu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iIkmJ"));

});
parcelRegister("iIkmJ", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d9fc223fda04f9ed$export$ffb0004e005737fa, (v) => $d9fc223fda04f9ed$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d9fc223fda04f9ed$export$34b9dba7ce09269b, (v) => $d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d9fc223fda04f9ed$export$25062201e9e25d76, (v) => $d9fc223fda04f9ed$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9fc223fda04f9ed$export$ffb0004e005737fa;
var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
var $d9fc223fda04f9ed$export$25062201e9e25d76;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d9fc223fda04f9ed$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d9fc223fda04f9ed$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d9fc223fda04f9ed$var$n.current
    };
}
$d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
$d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
$d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;

});


parcelRegister("kgs9b", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContextScope", () => $f17cc6e5aab16997$export$daf66a67c26dc848);

var $5uXOq = parcelRequire("5uXOq");

var $kye0Q = parcelRequire("kye0Q");

var $gI4nF = parcelRequire("gI4nF");

var $jGbvv = parcelRequire("jGbvv");

var $yt27k = parcelRequire("yt27k");
const $f17cc6e5aab16997$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $f17cc6e5aab16997$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $5uXOq.useCallback)((input)=>$f17cc6e5aab16997$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $5uXOq.useState)($f17cc6e5aab16997$var$initialState);
    const route = (0, $jGbvv.usePostOfficeRoute)();
    const context = (0, $gI4nF.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $f17cc6e5aab16997$var$usePostOfficeScopeSpy(state, config);
    (0, $5uXOq.useEffect)(()=>{
        if ($f17cc6e5aab16997$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $f17cc6e5aab16997$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $f17cc6e5aab16997$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $f17cc6e5aab16997$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $f17cc6e5aab16997$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route?.current ? {
            route: $f17cc6e5aab16997$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $f17cc6e5aab16997$var$matchScope({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $f17cc6e5aab16997$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $f17cc6e5aab16997$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$f17cc6e5aab16997$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $f17cc6e5aab16997$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $f17cc6e5aab16997$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $f17cc6e5aab16997$var$matchScope({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $f17cc6e5aab16997$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $f17cc6e5aab16997$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($f17cc6e5aab16997$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $f17cc6e5aab16997$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $f17cc6e5aab16997$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $yt27k.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $5uXOq.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $f17cc6e5aab16997$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("kye0Q", function(module, exports) {

var $b1bUS = parcelRequire("b1bUS");

var $2TGin = parcelRequire("2TGin");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $b1bUS(object, source, $2TGin(source), customizer);
}
module.exports = $ef61da41fa345164$var$isMatchWith;

});


parcelRegister("812Tf", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $5b3f37e39ea70737$export$8a57effc6307f916);

var $2OMIu = parcelRequire("2OMIu");

var $bgidj = parcelRequire("bgidj");

var $7aTNA = parcelRequire("7aTNA");

var $1T37v = parcelRequire("1T37v");

var $hKOHf = parcelRequire("hKOHf");
var $35re6 = parcelRequire("35re6");

var $5dx8l = parcelRequire("5dx8l");
const $5b3f37e39ea70737$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, $5dx8l.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $bgidj.useStableObject)(context);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hKOHf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35re6.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $5b3f37e39ea70737$export$8a57effc6307f916 = (placementId, Component)=>{
    const placement = $5b3f37e39ea70737$export$eaeb39efb2b24b52(placementId, Component);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1T37v.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $7aTNA.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("7aTNA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $355d0a4cbce9bf26$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $355d0a4cbce9bf26$export$71ff7382870ef1b0);
const $355d0a4cbce9bf26$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $355d0a4cbce9bf26$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("1T37v", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $cc1c0503e2685e6e$export$3d127465d22fe4e5);

var $5uXOq = parcelRequire("5uXOq");
const $cc1c0503e2685e6e$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("hKOHf", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $f5e75fdea436de1a$export$9a335a42ce02bdb8);

var $2OMIu = parcelRequire("2OMIu");

var $gywce = parcelRequire("gywce");

var $8FQgd = parcelRequire("8FQgd");

var $hoVEu = parcelRequire("hoVEu");

var $hH7Lf = parcelRequire("hH7Lf");
const $f5e75fdea436de1a$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $gywce.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $hH7Lf.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8FQgd.UFOv2).UFOSegment, {
        name: (0, $8FQgd.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOLoadHold, {
                name: (0, $8FQgd.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hoVEu.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("8FQgd", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $ab778e1b0d9cba26$export$c91b09caa8ecbab1);

var $iziuT = parcelRequire("iziuT");

var $5MT9r = parcelRequire("5MT9r");
const $ab778e1b0d9cba26$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $iziuT.default,
    UFOSegment: $5MT9r.default
};

});

parcelRegister("hoVEu", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $8c2e62875991de36$export$21b400a8c8ebc91a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $8c2e62875991de36$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("hH7Lf", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $51e3177ab47eaff2$export$317d52099614f316);

var $5uXOq = parcelRequire("5uXOq");
const $51e3177ab47eaff2$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const onMount = (0, $5uXOq.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $5uXOq.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("35re6", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $d6168e4d1d2d3f04$export$2b6596bcb1383a71);

var $2OMIu = parcelRequire("2OMIu");

var $hXeyY = parcelRequire("hXeyY");

var $dqhxC = parcelRequire("dqhxC");

var $b6DQB = parcelRequire("b6DQB");

var $1PKJ1 = parcelRequire("1PKJ1");

var $67Kwc = parcelRequire("67Kwc");

var $hKOHf = parcelRequire("hKOHf");
const $d6168e4d1d2d3f04$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b6DQB.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PKJ1.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $67Kwc.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hXeyY.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqhxC.StableChoreographerProvider), {
                        children: children
                    })
                })
            })
        })
    });

});
parcelRegister("hXeyY", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $9de582d38bb51c5c$export$5a66cdc9893b43e);

var $2OMIu = parcelRequire("2OMIu");

var $bVYhW = parcelRequire("bVYhW");
const $9de582d38bb51c5c$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $9de582d38bb51c5c$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.PostOfficeAnalyticsContext), {
        data: $9de582d38bb51c5c$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("dqhxC", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $fd1fc8431c17acfd$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $fd1fc8431c17acfd$export$cab5a8adbabcee23);

var $2OMIu = parcelRequire("2OMIu");

var $gI4nF = parcelRequire("gI4nF");
var $ZKvet = parcelRequire("ZKvet");

var $5uXOq = parcelRequire("5uXOq");

var $1E8wr = parcelRequire("1E8wr");
const $fd1fc8431c17acfd$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $fd1fc8431c17acfd$var$defaultContext = {
    choreographerEnabled: $fd1fc8431c17acfd$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $fd1fc8431c17acfd$var$ChoreographerContext = /*#__PURE__*/ (0, $5uXOq.createContext)($fd1fc8431c17acfd$var$defaultContext);
const $fd1fc8431c17acfd$export$e68b2c75bfb5682a = ({ children: children })=>{
    const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)($fd1fc8431c17acfd$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $ZKvet.usePostOfficeEnvironment)();
    const context = (0, $gI4nF.usePostOfficeContext)();
    const choreographerFactory = new (0, $1E8wr.default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
    const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fd1fc8431c17acfd$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $fd1fc8431c17acfd$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($fd1fc8431c17acfd$var$ChoreographerContext);

});
parcelRegister("1E8wr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2de00b9ad3c6714$export$2e2bcd8739ae039);

var $feCtB = parcelRequire("feCtB");
var $hhBpm = parcelRequire("hhBpm");

var $bqjIS = parcelRequire("bqjIS");
const $a2de00b9ad3c6714$var$mapEnvToAnalyticsEnv = (env)=>{
    switch(env){
        case 'test':
        case 'local':
            return (0, $bqjIS.envType).LOCAL;
        case 'dev':
            return (0, $bqjIS.envType).DEV;
        case 'staging':
        case 'stg-fedm-east':
            return (0, $bqjIS.envType).STAGING;
        case 'production':
        case 'prod-fedm-east':
            return (0, $bqjIS.envType).PROD;
        default:
            return (0, $bqjIS.envType).DEV;
    }
};
class $a2de00b9ad3c6714$var$ChoreographerRegistry {
    constructor(product, environment){
        this.product = product;
        this.environment = environment;
    }
    getPostOfficeChoreographerFactory() {
        if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
        const maybeChoreographerFactory = window.choreographerRegistry.get((0, $hhBpm.ProductIds).POST_OFFICE);
        if (maybeChoreographerFactory) return maybeChoreographerFactory;
        const factory = (0, $feCtB.choreographerFactory)((0, $hhBpm.ProductIds).POST_OFFICE, $a2de00b9ad3c6714$var$mapEnvToAnalyticsEnv(this.environment), {
            sourceProductId: this.product
        });
        window.choreographerRegistry.set((0, $hhBpm.ProductIds).POST_OFFICE, factory);
        return factory;
    }
}
var $a2de00b9ad3c6714$export$2e2bcd8739ae039 = $a2de00b9ad3c6714$var$ChoreographerRegistry;

});


parcelRegister("b6DQB", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $9a628b724426e24f$export$d4982c0a28b18f63);

var $2OMIu = parcelRequire("2OMIu");

var $gI4nF = parcelRequire("gI4nF");
var $bgidj = parcelRequire("bgidj");

var $7aTNA = parcelRequire("7aTNA");
const $9a628b724426e24f$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $bgidj.useStableObject)({
        ...(0, $7aTNA.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gI4nF.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("1PKJ1", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $7306a975d5abc81c$export$e9fd288527498af6);

var $2OMIu = parcelRequire("2OMIu");

var $bgidj = parcelRequire("bgidj");

var $axKDH = parcelRequire("axKDH");
const $7306a975d5abc81c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $bgidj.useStableObject)(placement);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $axKDH.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("axKDH", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $4cde54650759f8aa$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $4cde54650759f8aa$export$4fc0446ee742ad80);

var $2OMIu = parcelRequire("2OMIu");

var $bVYhW = parcelRequire("bVYhW");

var $cplpV = parcelRequire("cplpV");

var $5uXOq = parcelRequire("5uXOq");
const $4cde54650759f8aa$export$6394bf86db095a8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementId: undefined
});
const $4cde54650759f8aa$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $cplpV.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4cde54650759f8aa$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $4cde54650759f8aa$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($4cde54650759f8aa$export$6394bf86db095a8);

});


parcelRegister("67Kwc", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $20daa234359ea223$export$ce13d00e696dfc96);

var $2OMIu = parcelRequire("2OMIu");

var $jGbvv = parcelRequire("jGbvv");
var $bgidj = parcelRequire("bgidj");

var $ctz2p = parcelRequire("ctz2p");
const $20daa234359ea223$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $ctz2p.useLocationHref)();
    const stableRoute = (0, $bgidj.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jGbvv.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("ctz2p", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $86e7484ed690ef29$export$49fc3f3d8c7f99);
const $86e7484ed690ef29$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $86e7484ed690ef29$export$49fc3f3d8c7f99 = ()=>{
    return $86e7484ed690ef29$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("5dx8l", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $46771e95eb7d0770$export$f0c7a449e0cfaec7);

var $2OMIu = parcelRequire("2OMIu");


var $eTKMF = parcelRequire("eTKMF");

var $bDIUh = parcelRequire("bDIUh");
const $46771e95eb7d0770$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eTKMF.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $6252f4c5224b497a$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $2OMIu.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDIUh.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...data
            })
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6252f4c5224b497a$export$a1562d08625f5d7e = 'ui';
const $6252f4c5224b497a$export$947dac6c72b26f81 = 'track';
const $6252f4c5224b497a$export$f1d537d508d2945a = 'screen';
const $6252f4c5224b497a$export$12346a674644c156 = 'operational';
const $6252f4c5224b497a$export$b055de0e665cb20c = 'unknown';

parcelRegister("eTKMF", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $cf1f08c5cc6277d2$export$57d19d18d6e255a5);

var $2Dcc2 = parcelRequire("2Dcc2");

var $5uXOq = parcelRequire("5uXOq");
const $cf1f08c5cc6277d2$export$85183a312807388d = 'postOffice';
const $cf1f08c5cc6277d2$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((event, attributes)=>{
        createAnalyticsEvent({
            ...event,
            side: 'client',
            attributes: {
                ...event.attributes,
                ...attributes
            }
        }).fire($cf1f08c5cc6277d2$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("bDIUh", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $87962bbf3b745078$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $87962bbf3b745078$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $87962bbf3b745078$var$initialState = {
    didCatch: false,
    error: null
};
class $87962bbf3b745078$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $87962bbf3b745078$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($87962bbf3b745078$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $87962bbf3b745078$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($87962bbf3b745078$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($87962bbf3b745078$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $87962bbf3b745078$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $87962bbf3b745078$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $87962bbf3b745078$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($87962bbf3b745078$export$b16d9fb1a22de840);
    $87962bbf3b745078$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $87962bbf3b745078$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($87962bbf3b745078$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});



parcelRegister("hlD8q", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $0b2aea899823ac41$export$5523c5f3222291d0);

var $5uXOq = parcelRequire("5uXOq");

var $hafqu = parcelRequire("hafqu");
const $0b2aea899823ac41$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $hafqu.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("hafqu", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $1399d8e741932d07$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $1399d8e741932d07$export$c1cf1cf4c5d51937);

var $eTKMF = parcelRequire("eTKMF");

var $lzG7s = parcelRequire("lzG7s");

var $5uXOq = parcelRequire("5uXOq");

var $gDcOc = parcelRequire("gDcOc");
class $1399d8e741932d07$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $1399d8e741932d07$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $5uXOq.useState)((0, $gDcOc.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eTKMF.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $5uXOq.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        }).then((0, $gDcOc.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $gDcOc.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $1399d8e741932d07$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $gDcOc.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("lzG7s", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("gDcOc", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $a4567f63d19a2f1c$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $a4567f63d19a2f1c$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $a4567f63d19a2f1c$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $a4567f63d19a2f1c$export$24a6b176bdc41ce5);
const $a4567f63d19a2f1c$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $a4567f63d19a2f1c$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($a4567f63d19a2f1c$export$18a0019e5439b209(res));
};
const $a4567f63d19a2f1c$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $a4567f63d19a2f1c$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $a4567f63d19a2f1c$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("fsWkK", function(module, exports) {

$parcel$export(module.exports, "usePlacementApi", () => $3ab11d5c24f21540$export$201bbce8187a6e3c);

var $gI4nF = parcelRequire("gI4nF");

var $gVa2e = parcelRequire("gVa2e");

var $5jPdY = parcelRequire("5jPdY");

var $axKDH = parcelRequire("axKDH");

var $5uXOq = parcelRequire("5uXOq");
const $3ab11d5c24f21540$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $axKDH.usePlacementContext)();
    const context = (0, $gI4nF.usePostOfficeContext)();
    const fetcher = (0, $gVa2e.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        return (0, $5jPdY.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    return placementApi(path, context, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: [
            config?.autoRefetch?.updateKey
        ]
    });
};

});
parcelRegister("gVa2e", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $dcb2c186a002633f$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $dcb2c186a002633f$export$5f25a6ddf0324fa8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $dcb2c186a002633f$export$afec669dc416ee7e = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $dcb2c186a002633f$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($dcb2c186a002633f$export$afec669dc416ee7e);
const $dcb2c186a002633f$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dcb2c186a002633f$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("5jPdY", function(module, exports) {

$parcel$export(module.exports, "createUsePlacement", () => $206c1aaa7085751d$export$ee1d67e435d25cb5);

var $gbCI7 = parcelRequire("gbCI7");

var $5uXOq = parcelRequire("5uXOq");

var $hafqu = parcelRequire("hafqu");
const $206c1aaa7085751d$var$depsIsValid = (deps)=>Array.isArray(deps);
const $206c1aaa7085751d$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const dependencyList = $206c1aaa7085751d$var$depsIsValid(config?.deps) ? [
            ...config.deps,
            config?.isEnabled
        ] : [
            path,
            config?.isEnabled
        ];
        const timerRef = (0, $5uXOq.useRef)();
        const isRunningPromise = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $hafqu.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $gbCI7.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencyList);
        return (0, $hafqu.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("gbCI7", function(module, exports) {

$parcel$export(module.exports, "fetchPlacementData", () => $60ac25b21e6f9589$export$ce743d02f83ee521);
const $60ac25b21e6f9589$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $60ac25b21e6f9589$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $60ac25b21e6f9589$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$60ac25b21e6f9589$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $60ac25b21e6f9589$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const contextAsSearchParams = new URLSearchParams($60ac25b21e6f9589$var$stringifyObjectValues(context)).toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$60ac25b21e6f9589$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});



parcelRegister("2VVeB", function(module, exports) {

$parcel$export(module.exports, "scopes", () => $f1b3b1f54f88fdd2$export$54a06e3f4a159ad8);
const $f1b3b1f54f88fdd2$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'boards'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    }
];

});

parcelRegister("8eyXr", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $664b892d30b2972c$export$2df1250b8f917a59);
/* GeneratedContentHash: 3cb6cf61e4d1a4b8f604d8bf6e1ab4815270623ad61101f536107283c030de54 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $c4UtS = parcelRequire("c4UtS");

var $hKhj9 = parcelRequire("hKhj9");

var $c13fk = parcelRequire("c13fk");

var $eUGeI = parcelRequire("eUGeI");
const $664b892d30b2972c$export$e30378e28ad3e6ab = {
    ...(0, $hKhj9.default),
    ...(0, $c13fk.default),
    ...(0, $eUGeI.default)
};
const { initializeMessageRenderer: $664b892d30b2972c$export$bce4e5106d86e473, MessageRenderer: $664b892d30b2972c$export$2df1250b8f917a59 } = (0, $c4UtS.asMessageRenderer)($664b892d30b2972c$export$e30378e28ad3e6ab);

});
parcelRegister("c4UtS", function(module, exports) {

$parcel$export(module.exports, "asMessageRenderer", () => $0087221c1bf4dd6a$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $2OMIu = parcelRequire("2OMIu");

var $gywce = parcelRequire("gywce");

var $2z5Oa = parcelRequire("2z5Oa");
var $8FQgd = parcelRequire("8FQgd");

var $gxOsV = parcelRequire("gxOsV");

var $2LRSL = parcelRequire("2LRSL");

var $lng8d = parcelRequire("lng8d");

var $EbDQA = parcelRequire("EbDQA");

var $5uXOq = parcelRequire("5uXOq");

var $jL0ta = parcelRequire("jL0ta");

var $hoVEu = parcelRequire("hoVEu");

var $5dx8l = parcelRequire("5dx8l");
const $0087221c1bf4dd6a$export$14fe1fc3395b6e3f = ({ children: children })=>{
    const { messageViewed: messageViewed } = (0, $lng8d.useMessageEvent)();
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
        messageViewed();
    }, [
        messageViewed
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hoVEu.TrackMount), {
        onMount: messageViewedVoidFunction,
        children: children
    });
};
const $0087221c1bf4dd6a$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, ...data })=>{
            const isUFOEnabled = (0, $gywce.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $2z5Oa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hoVEu.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $gxOsV.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $gxOsV.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOLoadHold, {
                        name: (0, $8FQgd.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jL0ta.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($0087221c1bf4dd6a$var$FeatureFlaggedUfoWrapper, {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2LRSL.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $EbDQA.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)($0087221c1bf4dd6a$export$14fe1fc3395b6e3f, {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $5dx8l.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        };
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
const $0087221c1bf4dd6a$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOSegment, {
        name: (0, $8FQgd.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOSegment, {
            name: `${(0, $8FQgd.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("2z5Oa", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $d582503a05ae260d$export$96236906ebaa7f87);

var $aOre5 = parcelRequire("aOre5");

var $70yja = parcelRequire("70yja");
const $d582503a05ae260d$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $aOre5.MessagePerformanceTracker,
    PlacementPerformanceTracker: $70yja.PlacementPerformanceTracker
};

});
parcelRegister("aOre5", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $6119d88ec0fc0687$export$ae5c73c7c4f454e6);

var $ivxS0 = parcelRequire("ivxS0");
var $n3syj = parcelRequire("n3syj");

var $8RcWC = parcelRequire("8RcWC");
class $6119d88ec0fc0687$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $n3syj.UFOExperience)((0, $8RcWC.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $ivxS0.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $ivxS0.ExperienceTypes).Load,
            platform: {
                component: (0, $8RcWC.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $n3syj.UFOExperience)(`${(0, $8RcWC.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $ivxS0.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $ivxS0.ExperienceTypes).Load,
            platform: {
                component: (0, $8RcWC.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("8RcWC", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $77da3d70ff1d2979$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $77da3d70ff1d2979$export$6d482cfa20c9d220);
const $77da3d70ff1d2979$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $77da3d70ff1d2979$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("70yja", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $c17c11b11a35c157$export$8b48c2105ba0b35a);

var $ivxS0 = parcelRequire("ivxS0");
var $n3syj = parcelRequire("n3syj");

var $8RcWC = parcelRequire("8RcWC");
const $c17c11b11a35c157$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $c17c11b11a35c157$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $ivxS0.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $ivxS0.ExperienceTypes).Load,
    platform: {
        component: (0, $8RcWC.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$c17c11b11a35c157$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$c17c11b11a35c157$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$c17c11b11a35c157$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$c17c11b11a35c157$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $c17c11b11a35c157$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$c17c11b11a35c157$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$c17c11b11a35c157$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $c17c11b11a35c157$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $c17c11b11a35c157$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$c17c11b11a35c157$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $c17c11b11a35c157$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $n3syj.UFOExperience)((0, $8RcWC.UFOExperienceNames).PLACEMENT, $c17c11b11a35c157$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $n3syj.UFOExperience)(`${(0, $8RcWC.UFOExperienceNames).PLACEMENT}.${placementId}`, $c17c11b11a35c157$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("gxOsV", function(module, exports) {

$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $151a889543cd269d$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $151a889543cd269d$export$3dfc27a8d3942f4d);
var $151a889543cd269d$export$b9722560029694e7;
(function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
})($151a889543cd269d$export$b9722560029694e7 || ($151a889543cd269d$export$b9722560029694e7 = {}));
class $151a889543cd269d$export$46f86d28cd0a5d38 extends Error {
}
class $151a889543cd269d$export$627bc00a5ef5f6ae extends Error {
}
class $151a889543cd269d$export$d145ea5319863172 extends Error {
    constructor(message, code){
        super(message);
        this.code = code;
    }
}
class $151a889543cd269d$export$f649da38897d27f7 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$c2852c1c4d9aba3e extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$4b7b4e09547e4bb3 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$360a094a97597d87 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$4d068b43eb55165b extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$ac007ee150add337 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$b79ba63f8ae791e0 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message){
        super(message, "HandlerValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$19cb89dd679394cb extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$78651662ad470cc5 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$913b8e68dc7ae8fe extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$3dfc27a8d3942f4d extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$e5ccdf8bbfead7a2 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$823733742d803ae6 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$a6f2aad8fa094b39 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(accountId){
        super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError");
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$2f1e27130c2bf271 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$d0dc094613469f2b extends $151a889543cd269d$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$5603eab37ce562f5 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$b35ca1cf49054efc extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, email){
        super(message, "UnsupportedEmailError");
        this.name = this.constructor.name;
        this.email = email;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$e0e9aa0e9c6b37ff extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$3ad818f64601e141 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$25470bb6cba4fba0 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$ce14d445679448b6 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(message, "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$8ab4fb362168b928 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$2afd69f57fe5285f extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$7635d2b1a281d626 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$9e1c6d00e675bc86 extends $151a889543cd269d$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed');
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$6d1a4929f6ff1a32 extends $151a889543cd269d$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$89bf5f64fbf0698 extends $151a889543cd269d$export$46f86d28cd0a5d38 {
    constructor(message, error){
        super(message, {
            ...error ? {
                cause: error
            } : {}
        });
        this.error = error;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $151a889543cd269d$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed');
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $151a889543cd269d$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("2LRSL", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $29f9f1c490e17f66$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $29f9f1c490e17f66$export$a5b6d14a2e25725a);

var $5uXOq = parcelRequire("5uXOq");
const $29f9f1c490e17f66$var$initialValue = {};
const $29f9f1c490e17f66$export$b060d577040138d8 = (0, $5uXOq.createContext)($29f9f1c490e17f66$var$initialValue);
const $29f9f1c490e17f66$export$42de33f7652dc3de = $29f9f1c490e17f66$export$b060d577040138d8.Provider;
const $29f9f1c490e17f66$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($29f9f1c490e17f66$export$b060d577040138d8);

});

parcelRegister("lng8d", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $82d9c592a796d1d8$export$3cbbf1e81e2ecb39);

var $hynLS = parcelRequire("hynLS");
var $gI4nF = parcelRequire("gI4nF");

var $2LRSL = parcelRequire("2LRSL");

var $axKDH = parcelRequire("axKDH");

var $EbDQA = parcelRequire("EbDQA");

var $9mz4M = parcelRequire("9mz4M");

var $dfEaN = parcelRequire("dfEaN");

var $7MkC4 = parcelRequire("7MkC4");
const $82d9c592a796d1d8$export$3cbbf1e81e2ecb39 = ()=>{
    if (!window.postOfficeMessageEventClient) window.postOfficeMessageEventClient = new (0, $dfEaN.MessageEventClient)();
    const client = window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement } = (0, $hynLS.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $2LRSL.useMessageContext)();
    const { placementId: placementId } = (0, $axKDH.usePlacementContext)();
    const browserContext = (0, $gI4nF.usePostOfficeContext)();
    const recommendationContext = (0, $EbDQA.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    return {
        /**
		 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
		 */ markAllAsRead: async (messages)=>{
            const messagesEventPostPayload = messages.map((message)=>{
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
                return {
                    messageInstanceId: message['messageInstanceId'],
                    messageTemplateId: message['messageTemplateId'],
                    type: (0, $7MkC4.InAppMessageEventType).Read,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                };
            });
            try {
                await client.markAllAsReadEvent(messagesEventPostPayload);
            } catch (error) {
                throw new (0, $9mz4M.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as read. Calls sendEvent() as the API call
		 * has to happen immediately.
		 */ messageRead: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            markReadFromPlacement({
                messageInstanceId: messageInstanceId
            });
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: (0, $7MkC4.InAppMessageEventType).Read,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            } catch (error) {
                throw new (0, $9mz4M.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as unread. Calls sendEvent() as the API call
		 * has to happen immediately.
		 */ messageUnread: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: (0, $7MkC4.InAppMessageEventType).Unread,
                    placement: placementId,
                    createdAt: Date.now(),
                    context: context,
                    analyticsDetails: analyticsDetails
                });
            } catch (error) {
                throw new (0, $9mz4M.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
		 */ messageViewed: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            markViewedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $7MkC4.InAppMessageEventType).Viewed,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as clicked.
		 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageClicked: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            markClickedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $7MkC4.InAppMessageEventType).Clicked,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as clicked.
		 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
		 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageClickedSecondary: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $7MkC4.InAppMessageEventType).ClickedSecondary,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as acknowledged
		 */ messageAcknowledged: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $7MkC4.InAppMessageEventType).Acknowledged,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as dismissed.
		 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageDismissed: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $9mz4M.MessageLifecycleContextError)();
            dismissMessageFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $7MkC4.InAppMessageEventType).Dismissed,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }
    };
};

});
parcelRegister("EbDQA", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $157694cca039176e$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $157694cca039176e$export$3321c0b02f750bcc);

var $2OMIu = parcelRequire("2OMIu");

var $kbNdD = parcelRequire("kbNdD");

var $5uXOq = parcelRequire("5uXOq");
const $157694cca039176e$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $157694cca039176e$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($157694cca039176e$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbNdD.default), {
            data: value,
            children: children
        })
    });
};
const $157694cca039176e$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($157694cca039176e$export$ba2f44035effd9c1);

});

parcelRegister("9mz4M", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $bf152af85cdf171d$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $bf152af85cdf171d$export$44f397e2afeb89e0);
class $bf152af85cdf171d$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $bf152af85cdf171d$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("dfEaN", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $c0cf294af6d5e18e$export$ae86a6dabe385178);
const $c0cf294af6d5e18e$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $c0cf294af6d5e18e$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $c0cf294af6d5e18e$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $c0cf294af6d5e18e$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $c0cf294af6d5e18e$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $c0cf294af6d5e18e$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $c0cf294af6d5e18e$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($c0cf294af6d5e18e$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $c0cf294af6d5e18e$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $c0cf294af6d5e18e$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("fS9d8", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $b8e30b448f738d08$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $b8e30b448f738d08$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $b8e30b448f738d08$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $b8e30b448f738d08$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $b8e30b448f738d08$var$support = {
    searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
    iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $b8e30b448f738d08$var$g,
    arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
};
function $b8e30b448f738d08$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b8e30b448f738d08$var$support.arrayBuffer) {
    var $b8e30b448f738d08$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b8e30b448f738d08$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b8e30b448f738d08$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b8e30b448f738d08$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    value = $b8e30b448f738d08$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
function $b8e30b448f738d08$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $b8e30b448f738d08$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b8e30b448f738d08$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $b8e30b448f738d08$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b8e30b448f738d08$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
            this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b8e30b448f738d08$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
        return this.text().then($b8e30b448f738d08$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b8e30b448f738d08$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $b8e30b448f738d08$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $b8e30b448f738d08$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b8e30b448f738d08$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
    var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
$b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
    var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $b8e30b448f738d08$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
try {
    new $b8e30b448f738d08$export$fe58bcf938607f6a();
} catch (err) {
    $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
}
function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
            else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b8e30b448f738d08$var$normalizeName(name));
                xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b8e30b448f738d08$var$g.fetch) {
    $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
    $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
    $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
    $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
}

});


parcelRegister("7MkC4", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $f59532a971c81fb7$export$b31ffc6f7c85f1b);
var $f59532a971c81fb7$export$b31ffc6f7c85f1b;
(function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
})($f59532a971c81fb7$export$b31ffc6f7c85f1b || ($f59532a971c81fb7$export$b31ffc6f7c85f1b = {}));

});


parcelRegister("jL0ta", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $3e1a46b5ce5c97ac$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $gywce = parcelRequire("gywce");

var $eTKMF = parcelRequire("eTKMF");

var $5uXOq = parcelRequire("5uXOq");

var $dqhxC = parcelRequire("dqhxC");
const $3e1a46b5ce5c97ac$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $3e1a46b5ce5c97ac$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $dqhxC.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eTKMF.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $gywce.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $gywce.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($3e1a46b5ce5c97ac$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("hKhj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0785e38712d4e2a7$export$2e2bcd8739ae039);
/* GeneratedContentHash: 1c81eea795b65db22117af2640553e44a6199a829d731e2f582d4993abefb68b */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $0785e38712d4e2a7$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hMRsP")))
};

});
parcelRegister("hMRsP", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("7SIO0")
]).then(()=>parcelRequire('knXfk'));

});


parcelRegister("c13fk", function(module, exports) {

$parcel$export(module.exports, "default", () => $157a1a6fb8d22368$export$2e2bcd8739ae039);
/* GeneratedContentHash: 4d32a4689c92500edf1c336e733018ff47b68304e95803187f464b342d5f6598 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $157a1a6fb8d22368$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("87NWW")))
};

});
parcelRegister("87NWW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("d57sn").then(()=>parcelRequire('jWJmC'));

});


parcelRegister("eUGeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5091ca199663b5e$export$2e2bcd8739ae039);
/* GeneratedContentHash: 1a5276e3605ad78395d281339cb88b6cdf499079e915b878d4e4f78de51617e9 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");


var $b5091ca199663b5e$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("59IB4"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("kpDgu")))
};

});
parcelRegister("59IB4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4cKRc").then(()=>parcelRequire('hyVlX'));

});

parcelRegister("kpDgu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9Ry88").then(()=>parcelRequire('3XkGq'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $3adb2c051b516f3b$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("adGTL", function(module, exports) {

$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $916bc6d2c9f60528$export$b0eee5de066b2bf5);
/* GeneratedContentHash: e3d04393a47322d23880e298768acb64afdfd94233a58eec204386851be825fc */ /**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 *
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $gPNu0 = parcelRequire("gPNu0");

var $47dlm = parcelRequire("47dlm");

var $47ABU = parcelRequire("47ABU");

var $dgE7G = parcelRequire("dgE7G");
const $916bc6d2c9f60528$var$loadMessagesByTeam = async (locale)=>{
    return Promise.allSettled([
        (0, $47dlm.messagesLoader)(locale),
        (0, $47ABU.messagesLoader)(locale),
        (0, $dgE7G.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $916bc6d2c9f60528$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $gPNu0.withIntlProvider)({
        messagesLoader: $916bc6d2c9f60528$var$loadMessagesByTeam
    }, Component);
};

});
parcelRegister("gPNu0", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $79855fd61044c28a$export$a5d940130f33be3f);

var $2OMIu = parcelRequire("2OMIu");

var $45V96 = parcelRequire("45V96");
const $79855fd61044c28a$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $45V96.default), {
            ...intlProviderProps,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });

});
parcelRegister("45V96", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa17ec2e72f5784$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $eTKMF = parcelRequire("eTKMF");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $a1yBM = parcelRequire("a1yBM");
function $6fa17ec2e72f5784$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eTKMF.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $koVbs.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $6fa17ec2e72f5784$export$2e2bcd8739ae039(props) {
    const { locale: locale } = $6fa17ec2e72f5784$var$useFetchLocale();
    const messages = (0, $a1yBM.useIntlMessages)(locale, props.messagesLoader);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("a1yBM", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $f38f674153c69a6a$export$2641ec9a2025a81f);

var $eTKMF = parcelRequire("eTKMF");

var $5uXOq = parcelRequire("5uXOq");
const $f38f674153c69a6a$export$2641ec9a2025a81f = (locale, messageLoader)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eTKMF.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale
    ]);
    return messages;
};

});



parcelRegister("47dlm", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $ddbfb41c3a0b48f2$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# 
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $L03R5 = parcelRequire("L03R5");

var $2G4nV = parcelRequire("2G4nV");






























const $ddbfb41c3a0b48f2$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2G4nV.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("hZvT7"))).default;
        case 'da':
            return (await (parcelRequire("8VdAS"))).default;
        case 'de':
            return (await (parcelRequire("hkbyu"))).default;
        case 'en-GB':
            return (await (parcelRequire("4Idq4"))).default;
        case 'en-US':
            return (await (parcelRequire("ggPL6"))).default;
        case 'en-XA':
            return (await (parcelRequire("11yzO"))).default;
        case 'en-XB':
            return (await (parcelRequire("kpNGF"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("eBIvU"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("L03R5")))).default;
        case 'es':
            return (await (parcelRequire("2KV2U"))).default;
        case 'et':
            return (await (parcelRequire("iIQzR"))).default;
        case 'fi':
            return (await (parcelRequire("aTk35"))).default;
        case 'fr':
            return (await (parcelRequire("4A2h0"))).default;
        case 'hu':
            return (await (parcelRequire("8Xtlg"))).default;
        case 'it':
            return (await (parcelRequire("gsXzM"))).default;
        case 'ja':
            return (await (parcelRequire("kUHQK"))).default;
        case 'ko':
            return (await (parcelRequire("6RoE4"))).default;
        case 'nb':
            return (await (parcelRequire("4u44M"))).default;
        case 'nl':
            return (await (parcelRequire("hoByj"))).default;
        case 'pl':
            return (await (parcelRequire("du1Ad"))).default;
        case 'pt-BR':
            return (await (parcelRequire("9hQk4"))).default;
        case 'ro':
            return (await (parcelRequire("3aRMz"))).default;
        case 'ru':
            return (await (parcelRequire("hdfdG"))).default;
        case 'sv':
            return (await (parcelRequire("ecAgV"))).default;
        case 'th':
            return (await (parcelRequire("2KUiG"))).default;
        case 'tr':
            return (await (parcelRequire("k3iwK"))).default;
        case 'uk':
            return (await (parcelRequire("7qJZY"))).default;
        case 'vi':
            return (await (parcelRequire("bbRlI"))).default;
        case 'zh-CN':
            return (await (parcelRequire("53dhR"))).default;
        case 'zh-TW':
            return (await (parcelRequire("aIEeB"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($L03R5));
    }
};

});
parcelRegister("L03R5", function(module, exports) {
module.exports = JSON.parse("{\"post-office.components.in-app.step-context.default-next-button.main\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.components.in-app.step-context.default-previous-button.main\":[{\"type\":0,\"value\":\"Back\"}],\"post-office.components.in-app.step-context.next-button.step-state\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("hZvT7", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bMoe7").then(()=>parcelRequire('g116W'));

});

parcelRegister("8VdAS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6i2Xu").then(()=>parcelRequire('6Ooxi'));

});

parcelRegister("hkbyu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("dr5NF").then(()=>parcelRequire('dF8qA'));

});

parcelRegister("4Idq4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8OPmy").then(()=>parcelRequire('hfoUc'));

});

parcelRegister("ggPL6", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3jRx9").then(()=>parcelRequire('emGZJ'));

});

parcelRegister("11yzO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fGvd9").then(()=>parcelRequire('5Juvr'));

});

parcelRegister("kpNGF", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jYNxT").then(()=>parcelRequire('gChvT'));

});

parcelRegister("eBIvU", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("xLc0c").then(()=>parcelRequire('9rpzB'));

});

parcelRegister("2KV2U", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("blBUX").then(()=>parcelRequire('gLZv8'));

});

parcelRegister("iIQzR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9lqem").then(()=>parcelRequire('amPis'));

});

parcelRegister("aTk35", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5Owp9").then(()=>parcelRequire('25rSX'));

});

parcelRegister("4A2h0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hndc4").then(()=>parcelRequire('kfGET'));

});

parcelRegister("8Xtlg", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("cXdrf").then(()=>parcelRequire('hWiu0'));

});

parcelRegister("gsXzM", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kdRbI").then(()=>parcelRequire('89JVk'));

});

parcelRegister("kUHQK", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3GH4I").then(()=>parcelRequire('jJwjR'));

});

parcelRegister("6RoE4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9GL5f").then(()=>parcelRequire('jSTks'));

});

parcelRegister("4u44M", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iEduC").then(()=>parcelRequire('4R7Yc'));

});

parcelRegister("hoByj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("dU7am").then(()=>parcelRequire('aC16J'));

});

parcelRegister("du1Ad", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iJYJY").then(()=>parcelRequire('bKpc6'));

});

parcelRegister("9hQk4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6ep4t").then(()=>parcelRequire('5seMO'));

});

parcelRegister("3aRMz", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9ewVT").then(()=>parcelRequire('5xXmq'));

});

parcelRegister("hdfdG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5xHGu").then(()=>parcelRequire('4uyvg'));

});

parcelRegister("ecAgV", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9I5t8").then(()=>parcelRequire('axZYS'));

});

parcelRegister("2KUiG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("2iZk9").then(()=>parcelRequire('fIbYE'));

});

parcelRegister("k3iwK", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4mwOq").then(()=>parcelRequire('ldktY'));

});

parcelRegister("7qJZY", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4sZUb").then(()=>parcelRequire('2haK4'));

});

parcelRegister("bbRlI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("27N4U").then(()=>parcelRequire('aYqp2'));

});

parcelRegister("53dhR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("04s9U").then(()=>parcelRequire('lpL5Z'));

});

parcelRegister("aIEeB", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("e5lkY").then(()=>parcelRequire('ktQpK'));

});


parcelRegister("47ABU", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $587bdd1e7da7b2b1$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# 
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $frdAs = parcelRequire("frdAs");

var $2G4nV = parcelRequire("2G4nV");






























const $587bdd1e7da7b2b1$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2G4nV.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("clKca"))).default;
        case 'da':
            return (await (parcelRequire("f6iy0"))).default;
        case 'de':
            return (await (parcelRequire("i6ReV"))).default;
        case 'en-GB':
            return (await (parcelRequire("Sohm4"))).default;
        case 'en-US':
            return (await (parcelRequire("fqmqT"))).default;
        case 'en-XA':
            return (await (parcelRequire("5yPW0"))).default;
        case 'en-XB':
            return (await (parcelRequire("fjzvq"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("hSofl"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("frdAs")))).default;
        case 'es':
            return (await (parcelRequire("j2e4m"))).default;
        case 'et':
            return (await (parcelRequire("aWgpj"))).default;
        case 'fi':
            return (await (parcelRequire("3FmEx"))).default;
        case 'fr':
            return (await (parcelRequire("6oeEI"))).default;
        case 'hu':
            return (await (parcelRequire("2DjwU"))).default;
        case 'it':
            return (await (parcelRequire("lqDao"))).default;
        case 'ja':
            return (await (parcelRequire("bNz2P"))).default;
        case 'ko':
            return (await (parcelRequire("8oWkD"))).default;
        case 'nb':
            return (await (parcelRequire("ch1mp"))).default;
        case 'nl':
            return (await (parcelRequire("gZUGy"))).default;
        case 'pl':
            return (await (parcelRequire("4sMHH"))).default;
        case 'pt-BR':
            return (await (parcelRequire("a2xyW"))).default;
        case 'ro':
            return (await (parcelRequire("lVB7Z"))).default;
        case 'ru':
            return (await (parcelRequire("k3Xsf"))).default;
        case 'sv':
            return (await (parcelRequire("7c6w2"))).default;
        case 'th':
            return (await (parcelRequire("jSagI"))).default;
        case 'tr':
            return (await (parcelRequire("iphof"))).default;
        case 'uk':
            return (await (parcelRequire("lBKXN"))).default;
        case 'vi':
            return (await (parcelRequire("65Y3s"))).default;
        case 'zh-CN':
            return (await (parcelRequire("gW6Mu"))).default;
        case 'zh-TW':
            return (await (parcelRequire("3UcvF"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($frdAs));
    }
};

});
parcelRegister("frdAs", function(module, exports) {
module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("clKca", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fJam0").then(()=>parcelRequire('jvx0I'));

});

parcelRegister("f6iy0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1ps6u").then(()=>parcelRequire('biGYk'));

});

parcelRegister("i6ReV", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9Hlb8").then(()=>parcelRequire('26iqe'));

});

parcelRegister("Sohm4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4mHSJ").then(()=>parcelRequire('1j5Y8'));

});

parcelRegister("fqmqT", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("durS5").then(()=>parcelRequire('khby2'));

});

parcelRegister("5yPW0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hp7Uh").then(()=>parcelRequire('dsYGn'));

});

parcelRegister("fjzvq", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("g40FE").then(()=>parcelRequire('lMNeJ'));

});

parcelRegister("hSofl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("azo4D").then(()=>parcelRequire('kVGFs'));

});

parcelRegister("j2e4m", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("j4QEL").then(()=>parcelRequire('hH4mM'));

});

parcelRegister("aWgpj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("gv7GM").then(()=>parcelRequire('1qZPH'));

});

parcelRegister("3FmEx", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1cwbv").then(()=>parcelRequire('2Lq2l'));

});

parcelRegister("6oeEI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Sz8kC").then(()=>parcelRequire('jAZ5p'));

});

parcelRegister("2DjwU", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8AK7y").then(()=>parcelRequire('TbSOK'));

});

parcelRegister("lqDao", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jBapG").then(()=>parcelRequire('k5ZE7'));

});

parcelRegister("bNz2P", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5kFnU").then(()=>parcelRequire('7BZG7'));

});

parcelRegister("8oWkD", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1m5j0").then(()=>parcelRequire('kF27b'));

});

parcelRegister("ch1mp", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4LT5j").then(()=>parcelRequire('af17F'));

});

parcelRegister("gZUGy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("im9zP").then(()=>parcelRequire('cXkG0'));

});

parcelRegister("4sMHH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iVj96").then(()=>parcelRequire('dnvQJ'));

});

parcelRegister("a2xyW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4luCL").then(()=>parcelRequire('3T9zI'));

});

parcelRegister("lVB7Z", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3HtCJ").then(()=>parcelRequire('h8k19'));

});

parcelRegister("k3Xsf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("dReha").then(()=>parcelRequire('hQlcY'));

});

parcelRegister("7c6w2", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hcoga").then(()=>parcelRequire('9NSVd'));

});

parcelRegister("jSagI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("h1TNK").then(()=>parcelRequire('73ozM'));

});

parcelRegister("iphof", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lSCC5").then(()=>parcelRequire('52bHB'));

});

parcelRegister("lBKXN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("99GGx").then(()=>parcelRequire('lrLqK'));

});

parcelRegister("65Y3s", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("ckSWA").then(()=>parcelRequire('7yvgm'));

});

parcelRegister("gW6Mu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9Jqit").then(()=>parcelRequire('74GBF'));

});

parcelRegister("3UcvF", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lscBv").then(()=>parcelRequire('30JWv'));

});


parcelRegister("dgE7G", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $f45c6765bc3f4735$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jhFe2 = parcelRequire("jhFe2");

var $2G4nV = parcelRequire("2G4nV");






























const $f45c6765bc3f4735$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2G4nV.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("k3Pj5"))).default;
        case 'da':
            return (await (parcelRequire("Wuy2d"))).default;
        case 'de':
            return (await (parcelRequire("jAb2N"))).default;
        case 'en-GB':
            return (await (parcelRequire("dt9nj"))).default;
        case 'en-US':
            return (await (parcelRequire("j73dn"))).default;
        case 'en-XA':
            return (await (parcelRequire("fEU0s"))).default;
        case 'en-XB':
            return (await (parcelRequire("aET7Q"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("11MnN"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("jhFe2")))).default;
        case 'es':
            return (await (parcelRequire("7t3Eh"))).default;
        case 'et':
            return (await (parcelRequire("994Dd"))).default;
        case 'fi':
            return (await (parcelRequire("kOHvo"))).default;
        case 'fr':
            return (await (parcelRequire("ifS9K"))).default;
        case 'hu':
            return (await (parcelRequire("diuhG"))).default;
        case 'it':
            return (await (parcelRequire("iWXsh"))).default;
        case 'ja':
            return (await (parcelRequire("knHhR"))).default;
        case 'ko':
            return (await (parcelRequire("2Tn7W"))).default;
        case 'nb':
            return (await (parcelRequire("k3gzo"))).default;
        case 'nl':
            return (await (parcelRequire("hyfuN"))).default;
        case 'pl':
            return (await (parcelRequire("dPqXj"))).default;
        case 'pt-BR':
            return (await (parcelRequire("dCWCT"))).default;
        case 'ro':
            return (await (parcelRequire("gWspe"))).default;
        case 'ru':
            return (await (parcelRequire("bQhzJ"))).default;
        case 'sv':
            return (await (parcelRequire("h3Quf"))).default;
        case 'th':
            return (await (parcelRequire("iS0JO"))).default;
        case 'tr':
            return (await (parcelRequire("eSu9p"))).default;
        case 'uk':
            return (await (parcelRequire("i0wMy"))).default;
        case 'vi':
            return (await (parcelRequire("2o2w1"))).default;
        case 'zh-CN':
            return (await (parcelRequire("gmIaO"))).default;
        case 'zh-TW':
            return (await (parcelRequire("7HByI"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jhFe2));
    }
};

});
parcelRegister("jhFe2", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("k3Pj5", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hb4jQ").then(()=>parcelRequire('7mRgy'));

});

parcelRegister("Wuy2d", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("d6o5c").then(()=>parcelRequire('iherO'));

});

parcelRegister("jAb2N", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fAsm8").then(()=>parcelRequire('bBCZW'));

});

parcelRegister("dt9nj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8yEZr").then(()=>parcelRequire('iAaWL'));

});

parcelRegister("j73dn", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iAQrr").then(()=>parcelRequire('90s83'));

});

parcelRegister("fEU0s", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3kDC3").then(()=>parcelRequire('bNypG'));

});

parcelRegister("aET7Q", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kqd1p").then(()=>parcelRequire('99pho'));

});

parcelRegister("11MnN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Ra43T").then(()=>parcelRequire('gYX2W'));

});

parcelRegister("7t3Eh", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9Lz4u").then(()=>parcelRequire('7S8bm'));

});

parcelRegister("994Dd", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8NCS8").then(()=>parcelRequire('eNMuc'));

});

parcelRegister("kOHvo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hFf5W").then(()=>parcelRequire('jsBCE'));

});

parcelRegister("ifS9K", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6Ypf7").then(()=>parcelRequire('fjW2f'));

});

parcelRegister("diuhG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("db31f").then(()=>parcelRequire('aftwu'));

});

parcelRegister("iWXsh", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hGIDZ").then(()=>parcelRequire('8ENS7'));

});

parcelRegister("knHhR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7K2Sm").then(()=>parcelRequire('fTr8d'));

});

parcelRegister("2Tn7W", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1rD5B").then(()=>parcelRequire('8aFhi'));

});

parcelRegister("k3gzo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5U3wE").then(()=>parcelRequire('aGFXE'));

});

parcelRegister("hyfuN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("aUROq").then(()=>parcelRequire('lHMba'));

});

parcelRegister("dPqXj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kMsh9").then(()=>parcelRequire('1I4X9'));

});

parcelRegister("dCWCT", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("cz9W0").then(()=>parcelRequire('eR0lc'));

});

parcelRegister("gWspe", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hs2CU").then(()=>parcelRequire('6JBsF'));

});

parcelRegister("bQhzJ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1uTCw").then(()=>parcelRequire('b4k45'));

});

parcelRegister("h3Quf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("gLNth").then(()=>parcelRequire('cAigy'));

});

parcelRegister("iS0JO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("cPKUJ").then(()=>parcelRequire('aggJE'));

});

parcelRegister("eSu9p", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8GWZz").then(()=>parcelRequire('4V6RG'));

});

parcelRegister("i0wMy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hOLsv").then(()=>parcelRequire('93pf6'));

});

parcelRegister("2o2w1", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iZPkM").then(()=>parcelRequire('6Uipa'));

});

parcelRegister("gmIaO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fSMKf").then(()=>parcelRequire('hC9ae'));

});

parcelRegister("7HByI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7iwvQ").then(()=>parcelRequire('6EYJt'));

});




parcelRegister("hpfWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $83a377d480a09abc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $bgidj = parcelRequire("bgidj");

var $gFiTr = parcelRequire("gFiTr");

var $812Tf = parcelRequire("812Tf");

var $5uXOq = parcelRequire("5uXOq");

var $dIq8X = parcelRequire("dIq8X");

const $83a377d480a09abc$var$STABLE_OBJECT = {};
const $83a377d480a09abc$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, $812Tf.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $bgidj.useStableObject)(placementProps ?? $83a377d480a09abc$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gFiTr.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIq8X.default), {
                analyticsChannel: (0, $447515388add14e7$export$85183a312807388d),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: Fallback,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
            })
    });
};
var $83a377d480a09abc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($83a377d480a09abc$var$Placement);

});
parcelRegister("gFiTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5724d58f6bbdb5b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $bVYhW = parcelRequire("bVYhW");

var $gywce = parcelRequire("gywce");

var $gI4nF = parcelRequire("gI4nF");
var $jGbvv = parcelRequire("jGbvv");
var $bgidj = parcelRequire("bgidj");

var $2z5Oa = parcelRequire("2z5Oa");
var $8FQgd = parcelRequire("8FQgd");

var $gVa2e = parcelRequire("gVa2e");

var $5uXOq = parcelRequire("5uXOq");


var $egKHz = parcelRequire("egKHz");

var $ki5Nf = parcelRequire("ki5Nf");

var $iIXps = parcelRequire("iIXps");
const $e5724d58f6bbdb5b$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gVa2e.usePlacementFetchingContext)();
    return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, $egKHz.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $e5724d58f6bbdb5b$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = (0, $gywce.default).checkGate('enable_ufo_tracking_in_post_office');
    const postOfficeRoute = (0, $jGbvv.usePostOfficeRoute)();
    const context = (0, $gI4nF.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $ki5Nf.useBuildBasePath)();
    const stableContextWithRoute = (0, $bgidj.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, $2z5Oa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $e5724d58f6bbdb5b$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
            source: (0, $3d7666cd676c3f7b$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app',
                postOfficeFrontendVersion: $iIXps.version
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e5724d58f6bbdb5b$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $e5724d58f6bbdb5b$export$2e2bcd8739ae039 = $e5724d58f6bbdb5b$var$Placement;
const $e5724d58f6bbdb5b$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOSegment, {
        name: (0, $8FQgd.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FQgd.UFOv2).UFOSegment, {
            name: `${(0, $8FQgd.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
const $3d7666cd676c3f7b$export$85183a312807388d = 'postOffice';
const $3d7666cd676c3f7b$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("egKHz", function(module, exports) {

$parcel$export(module.exports, "requestInitialData", () => $db9463977619d4df$export$c4c39037cc4b06ab);
const $db9463977619d4df$var$defaultFetcher = (url)=>fetch(url, {
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        }
    });
const $db9463977619d4df$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $db9463977619d4df$var$defaultFetcher, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("ki5Nf", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $89b553176b8b6295$export$83d6c58b7ab7ae67);

var $gmmIB = parcelRequire("gmmIB");
var $ZKvet = parcelRequire("ZKvet");

var $5uXOq = parcelRequire("5uXOq");
const $89b553176b8b6295$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $ZKvet.usePostOfficeEnvironment)();
    return (0, $5uXOq.useMemo)(()=>(0, $gmmIB.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});
parcelRegister("gmmIB", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $fdf8e6f09d819659$export$e8b30f9c4a80230f);


var $ZKvet = parcelRequire("ZKvet");
const $fdf8e6f09d819659$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $ZKvet.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7ecc71a1b310ea07$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});


parcelRegister("iIXps", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.3.0\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\",\"./request-initial-data\":\"./src/initialDataClient.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@atlassian/post-office-placement-data\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");

});


parcelRegister("dIq8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0096761780243fe1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $2keUK = parcelRequire("2keUK");

var $5uXOq = parcelRequire("5uXOq");
class $0096761780243fe1$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $0096761780243fe1$export$2e2bcd8739ae039 = (0, $2keUK.default)()($0096761780243fe1$var$ErrorBoundary);

});

const $447515388add14e7$export$85183a312807388d = 'postOffice';


const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';

parcelRegister("j2nvL", function(module, exports) {

$parcel$export(module.exports, "PlacementFetchProvider", () => $d1dd0ebdae4a4c66$export$9be10e5cc29463c9);

var $5uXOq = parcelRequire("5uXOq");

var $gVa2e = parcelRequire("gVa2e");

var $fyLzM = parcelRequire("fyLzM");
const $d1dd0ebdae4a4c66$export$9be10e5cc29463c9 = ({ children: children, placementId: placementId })=>{
    const fetch = (0, $fyLzM.usePlacementSSRFetch)(placementId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVa2e.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});
parcelRegister("fyLzM", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $121a6aea82ff4ae0$export$420f2f91a928b3b6);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $gmmIB = parcelRequire("gmmIB");
var $gI4nF = parcelRequire("gI4nF");
var $ZKvet = parcelRequire("ZKvet");

var $egKHz = parcelRequire("egKHz");

var $adncp = parcelRequire("adncp");
/**
 * This is a cached fetcher that is used by the Post Office requests.
 *
 * See also `post-office/packages/post-office-clients/post-office-placement-shared/src/Placement.tsx` for the initial data fetching.
 *
 * @param url
 * @returns
 */ const $121a6aea82ff4ae0$var$jiraFetcher = (url)=>{
    return (0, $eusud.performGetRequest)(url);
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $121a6aea82ff4ae0$var$preloadPostOfficePlacement = (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    return (0, $egKHz.requestInitialData)(placementId, postOfficeContext, $121a6aea82ff4ae0$var$jiraFetcher, (0, $gmmIB.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $121a6aea82ff4ae0$export$420f2f91a928b3b6 = (placementId)=>{
    const postOfficeContext = (0, $gI4nF.usePostOfficeContext)();
    const environment = (0, $ZKvet.usePostOfficeEnvironment)();
    return (0, $5uXOq.useCallback)(()=>$121a6aea82ff4ae0$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: postOfficeContext,
            environment: environment
        }), [
        placementId,
        postOfficeContext,
        environment
    ]);
};
const $121a6aea82ff4ae0$export$65b5eab182e1ca6f = (placementId, preloadedTenantContext)=>{
    return $121a6aea82ff4ae0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $adncp.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});



parcelRegister("eKtC8", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $31b7f947593face8$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $heNNl = parcelRequire("heNNl");
const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("bAjl9", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $fad1cef37914a278$export$c9d8cd4516cc55a8);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $1nUas = parcelRequire("1nUas");
const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
        messages: messages,
        locale: (0, $lzeFL.standardizeLocale)(locale)
    }, children);

});
parcelRegister("1nUas", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $0264700d4de7e638$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("lvG9V", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $2bc2dec1250f1cf8$export$2d1617bc0040e5d9);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $jb5yn = parcelRequire("jb5yn");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $kDdFQ = parcelRequire("kDdFQ");
const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jb5yn.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDdFQ.SubProductUpdater), null)), children));

});
parcelRegister("jb5yn", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $bcd25bc85dfeb009$export$6f49c95a810d59fa);

var $5uXOq = parcelRequire("5uXOq");

var $dpjj4 = parcelRequire("dpjj4");
var $kh3Cl = parcelRequire("kh3Cl");

var $9sAyK = parcelRequire("9sAyK");
const $bcd25bc85dfeb009$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
        callback
    ]);
const $bcd25bc85dfeb009$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $dpjj4.ExperienceTracker)());
    const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, $9sAyK.sliSubscriber)));
    const cleanup = (0, $5uXOq.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $bcd25bc85dfeb009$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kh3Cl.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("9sAyK", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $6b2f2360dd11edee$export$db0b99fe17114899);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

const $6b2f2360dd11edee$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $6b2f2360dd11edee$var$transformApplication(application),
            edition: $6b2f2360dd11edee$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("kDdFQ", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5dc03f10b4b74566$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $16v4H = parcelRequire("16v4H");
const $5dc03f10b4b74566$export$eb40d3df56aa5c53 = ()=>{
    const subProduct = (0, $16v4H.useSubProduct)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});
parcelRegister("16v4H", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $f7eda04ad2dc7e84$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $f7eda04ad2dc7e84$export$16aa2ad52cd8992a);

var $4DPZY = parcelRequire("4DPZY");
const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
};

});



parcelRegister("gPTB6", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $1720b620f5483501$export$36f9ed697cae18ae);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8ploF = parcelRequire("8ploF");
let $1720b620f5483501$var$Containers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
if (!false) $1720b620f5483501$var$Containers = (0, $8ploF.ClientOnlyNavigationContainers);
const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
    (0, $gKZoD.di)($1720b620f5483501$var$Containers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
        baseUrl: baseUrl
    }, children);
};

});
parcelRegister("8ploF", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $f5cf024286957bf6$export$68d7c1e44acfd599);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");
const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Provider), null, children);
    return null;
};

});


parcelRegister("9kep9", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $83e79f36d4d977db$export$9c661932489b4130);

var $5uXOq = parcelRequire("5uXOq");

var $9MAC1 = parcelRequire("9MAC1");

var $j8DrX = parcelRequire("j8DrX");

var $6nkVm = parcelRequire("6nkVm");

var $aX7Cy = parcelRequire("aX7Cy");
const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MAC1.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleContainer), {
        titleSuffix: (0, $aX7Cy.ripTitleTemplateFromMeta)((0, $j8DrX.default))
    }, children));

});
parcelRegister("9MAC1", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $a1f770a9d49220c1$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $a1f770a9d49220c1$export$11eb671888ed6e7d);

var $7JoAD = parcelRequire("7JoAD");

var $LtWMd = parcelRequire("LtWMd");
const $a1f770a9d49220c1$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $a1f770a9d49220c1$var$Store = (0, $7JoAD.createStore)({
    name: 'theme',
    initialState: $a1f770a9d49220c1$var$initialState,
    actions: $LtWMd
});
const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $7JoAD.createSubscriber)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $7JoAD.createHook)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $7JoAD.createContainer)($a1f770a9d49220c1$var$Store, {
    onInit: $LtWMd.bootstrap
});

});
parcelRegister("LtWMd", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9594f0aa641d3463$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $9594f0aa641d3463$export$722fbec263ad908a);

const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $dbda9f692ace54dd$exports).N0 || ajsHighlightColor !== (0, $dbda9f692ace54dd$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $dbda9f692ace54dd$exports).N0})`,
            highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $dbda9f692ace54dd$exports).B400})`
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("6nkVm", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $301148c3154b34a4$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $301148c3154b34a4$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $301148c3154b34a4$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $301148c3154b34a4$export$573bf8d2ae7d60dc);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $3Nww0 = parcelRequire("3Nww0");

var $aX7Cy = parcelRequire("aX7Cy");
const $301148c3154b34a4$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $301148c3154b34a4$var$Store = (0, $7JoAD.createStore)({
    name: 'document-title',
    initialState: $301148c3154b34a4$var$initialState,
    actions: $3Nww0
});
const $301148c3154b34a4$export$57c0fda036e12d67 = (0, $7JoAD.createActionsHook)($301148c3154b34a4$var$Store);
const $301148c3154b34a4$export$1aad43993172f16f = (0, $7JoAD.createContainer)($301148c3154b34a4$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $301148c3154b34a4$export$b88d5abf3e0bec8c = (0, $7JoAD.createSubscriber)($301148c3154b34a4$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
class $301148c3154b34a4$export$573bf8d2ae7d60dc extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $aX7Cy.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("3Nww0", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => (parcelRequire("9vNeL")).default);
$parcel$export(module.exports, "addDocumentTitle", () => (parcelRequire("5Oj7f")).addDocumentTitle);
$parcel$export(module.exports, "removeDocumentTitle", () => (parcelRequire("gJBAO")).removeDocumentTitle);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $9vNeL = parcelRequire("9vNeL");

var $5Oj7f = parcelRequire("5Oj7f");

var $gJBAO = parcelRequire("gJBAO");

});
parcelRegister("9vNeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0c91bbbd212a23$export$2e2bcd8739ae039);

var $aX7Cy = parcelRequire("aX7Cy");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$aa0c91bbbd212a23$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $aX7Cy.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("aX7Cy", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $45855f8363268b1b$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $45855f8363268b1b$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $45855f8363268b1b$export$7f8be70a0bed1bae);
const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $45855f8363268b1b$export$7f8be70a0bed1bae = (title, contextArray)=>{
    if (contextArray[contextArray.length - 1] === title) return true;
    return false;
};

});


parcelRegister("5Oj7f", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $53f35561ab86eb34$export$a0c188c0ea474bb8);
const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        contextArray.push(title);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("gJBAO", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $bcdbd43154f62b45$export$e844009b77f80a72);
const $bcdbd43154f62b45$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((symbol)=>symbol !== title)
        });
    };

});




parcelRegister("eSznd", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $ca023ab667a452ba$export$41286c339a88ca24);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $e0Brz = parcelRequire("e0Brz");

var $5zgk6 = parcelRequire("5zgk6");

var $9rAvm = parcelRequire("9rAvm");
let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
if (!false) // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '({ children }: ClientUiManagersProps) => JSX.Element' but required in type 'ExoticComponent<{ children?: ReactNode; }>'.
$ca023ab667a452ba$var$ClientUiManagers = (0, $9rAvm.ClientUiManagers);
const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
    (0, $gKZoD.di)($ca023ab667a452ba$var$ClientUiManagers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5zgk6.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
};

});
parcelRegister("e0Brz", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $e20dc5e8426041f9$export$cd5073909dd92c28);

var $5uXOq = parcelRequire("5uXOq");

var $aIVNN = parcelRequire("aIVNN");
const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbContainer), null, children);

});

parcelRegister("5zgk6", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $20f0b1159f4863ef$export$4a04ad01c410b415);

var $5uXOq = parcelRequire("5uXOq");

var $c34Wf = parcelRequire("c34Wf");

var $dIdda = parcelRequire("dIdda");

var $7JoAD = parcelRequire("7JoAD");

var $8CM3x = parcelRequire("8CM3x");

var $5e5zm = parcelRequire("5e5zm");
const $20f0b1159f4863ef$var$LayoutContainer = (0, $7JoAD.createContainer)((0, $5e5zm.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
            dispatch((0, $8CM3x.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $8CM3x.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
        }
});
const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $20f0b1159f4863ef$var$useIsChromeless = (0, $dIdda.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $dIdda.useResource)((0, $c34Wf.navigationUiStateResource));
    const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $5uXOq.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("9rAvm", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $2b5f3846e82b020b$export$d1db6ae5bf84e489);

var $5uXOq = parcelRequire("5uXOq");

var $4XPvd = parcelRequire("4XPvd");

var $6pvrS = parcelRequire("6pvrS");

var $4041n = parcelRequire("4041n");

var $pa9q9 = parcelRequire("pa9q9");

var $2HbP2 = parcelRequire("2HbP2");

var $4yEIl = parcelRequire("4yEIl");

var $bKCrm = parcelRequire("bKCrm");
const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pvrS.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XPvd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, children))))));
};

});
parcelRegister("6pvrS", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $2cd77fddb456dca8$export$d900e4062895cd7c);

var $5uXOq = parcelRequire("5uXOq");

var $eXSag = parcelRequire("eXSag");

var $fjcgS = parcelRequire("fjcgS");

var $9OXo1 = parcelRequire("9OXo1");

var $g2XuF = parcelRequire("g2XuF");

var $5emZd = parcelRequire("5emZd");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXSag.default), {
            cloudId: cloudId,
            // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
            analyticsClient: $2cd77fddb456dca8$var$getAnalyticsInstance(),
            locale: locale,
            plugins: [
                (0, $g2XuF.getContainersPlugin),
                (0, $5emZd.getUsersPlugin)
            ]
        }, children));

});
parcelRegister("eXSag", function(module, exports) {

$parcel$export(module.exports, "default", () => $9130acad4126262c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2OGI7 = parcelRequire("2OGI7");

var $aL98Y = parcelRequire("aL98Y");
const $9130acad4126262c$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2OGI7.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $9130acad4126262c$export$2e2bcd8739ae039 = $9130acad4126262c$var$JiraProvider;

});
parcelRegister("2OGI7", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $13b7bc1242d47f94$export$d900e4062895cd7c);

var $5uXOq = parcelRequire("5uXOq");

var $iK75U = parcelRequire("iK75U");

var $kHN4O = parcelRequire("kHN4O");

var $gywce = parcelRequire("gywce");

var $fxC8m = parcelRequire("fxC8m");

var $69XbM = parcelRequire("69XbM");

var $5eiNb = parcelRequire("5eiNb");

var $5nI6X = parcelRequire("5nI6X");

var $96stg = parcelRequire("96stg");

var $fVOYV = parcelRequire("fVOYV");

var $3bGZ8 = parcelRequire("3bGZ8");

const $13b7bc1242d47f94$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("1y02m")));
const $13b7bc1242d47f94$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        // TBLZ-852: Product Store - Personal Use Case
        // go/trailblazerexperiments
        const tblz852ExperimentCohort = (0, $gywce.default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
            fireExperimentExposure: false
        });
        const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
        // TBLZ-852
        const onCloseResolver = (0, $5uXOq.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
        const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $fxC8m.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
        const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            const gasV3Event = (0, $69XbM.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $fVOYV.enrichWithRequestOptions)((0, $96stg.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $6252f4c5224b497a$export$12346a674644c156),
                        action: (0, $3bGZ8.uiInitialized),
                        actionSubject: (0, $3bGZ8.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $3bGZ8.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $5uXOq.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $fVOYV.enrichWithRequestOptions)({
                    eventType: (0, $6252f4c5224b497a$export$12346a674644c156),
                    action: (0, $3bGZ8.openInvoked),
                    actionSubject: (0, $3bGZ8.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $3bGZ8.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $iK75U.Journeys).GET_STARTED && redirectToWac) {
                (0, $5eiNb.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $kHN4O.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iK75U.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5nI6X.ErrorBoundary), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $13b7bc1242d47f94$export$d900e4062895cd7c = $13b7bc1242d47f94$export$79d79d8dd8574306($13b7bc1242d47f94$var$IntegrationView);

});
parcelRegister("fxC8m", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $90cf80fa4a4c2478$export$91b4dd3bfc301325);

const $90cf80fa4a4c2478$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $6252f4c5224b497a$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $6252f4c5224b497a$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $6252f4c5224b497a$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $6252f4c5224b497a$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("69XbM", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $d1356c52135a14e7$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $d1356c52135a14e7$var$GROWTH_TAG = 'growth';
const $d1356c52135a14e7$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $d1356c52135a14e7$var$getSources = (context)=>$d1356c52135a14e7$var$extractFromEventContext([
        'source'
    ], context);
const $d1356c52135a14e7$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $d1356c52135a14e7$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $d1356c52135a14e7$var$last = (values)=>values[values.length - 1];
const $d1356c52135a14e7$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $d1356c52135a14e7$var$getSources(context);
    const source = $d1356c52135a14e7$var$last(sources) || (0, $6252f4c5224b497a$export$b055de0e665cb20c);
    const extraAttributes = $d1356c52135a14e7$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $d1356c52135a14e7$var$last($d1356c52135a14e7$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $6252f4c5224b497a$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($d1356c52135a14e7$var$GROWTH_TAG);
    switch(eventType){
        case 0, $6252f4c5224b497a$export$a1562d08625f5d7e:
        case 0, $6252f4c5224b497a$export$12346a674644c156:
        case 0, $6252f4c5224b497a$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $6252f4c5224b497a$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("5eiNb", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $81d806aed0a6ae50$export$2827e2473cb9a346);

var $c3gJm = parcelRequire("c3gJm");


var $kREsZ = parcelRequire("kREsZ");
const $81d806aed0a6ae50$var$utmCampaignMap = {
    'atlassian-switcher': (0, $kREsZ.UtmCampaign)['atlassian-switcher']
};
const $81d806aed0a6ae50$var$isBundledProduct = (productKey)=>{
    return [
        (0, $c3gJm.Targets).JIRA_SOFTWARE,
        (0, $c3gJm.Targets).JIRA_SERVICE_DESK,
        (0, $c3gJm.Targets).JIRA_CORE,
        (0, $c3gJm.Targets).CONFLUENCE
    ].includes(productKey);
};
const $81d806aed0a6ae50$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $c3gJm.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $c3gJm.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $c3gJm.Targets).JIRA_CORE]: 'jira-core',
        [(0, $c3gJm.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $81d806aed0a6ae50$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $c3gJm.Targets).OPSGENIE
    ].includes(productKey);
};
const $81d806aed0a6ae50$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $c3gJm.Targets).OPSGENIE]: (0, $92fb5147017f45b9$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $81d806aed0a6ae50$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($81d806aed0a6ae50$var$utmCampaignMap[sourceComponent]);
};
const $81d806aed0a6ae50$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $81d806aed0a6ae50$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$81d806aed0a6ae50$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $81d806aed0a6ae50$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $92fb5147017f45b9$export$c37558e5c67d2b01) : (0, $92fb5147017f45b9$export$f199baf8dfc7621e);
    const utmParams = $81d806aed0a6ae50$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $92fb5147017f45b9$export$2a45a00073911255);
    if ($81d806aed0a6ae50$var$isBundledProduct(productKey)) {
        path = (0, $92fb5147017f45b9$export$e6c04a1dd86d1c14);
        bundleParams = $81d806aed0a6ae50$var$getBundleSignUpParams(productKey);
    } else if ($81d806aed0a6ae50$var$isProductWithCustomSignUpPath(productKey)) path = $81d806aed0a6ae50$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $81d806aed0a6ae50$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $81d806aed0a6ae50$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $92fb5147017f45b9$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $92fb5147017f45b9$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $92fb5147017f45b9$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $92fb5147017f45b9$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $92fb5147017f45b9$export$2a45a00073911255 = '/software';

parcelRegister("kREsZ", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $174358dc09433f7e$export$fc604aa353a97e10);
var $174358dc09433f7e$export$fc604aa353a97e10;
(function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
})($174358dc09433f7e$export$fc604aa353a97e10 || ($174358dc09433f7e$export$fc604aa353a97e10 = {}));

});


parcelRegister("5nI6X", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $c1c6ad0724423f09$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $3bGZ8 = parcelRequire("3bGZ8");
const $c1c6ad0724423f09$var$name = "platform-pkg";
const $c1c6ad0724423f09$var$version = "0.0.0-use.local";
const $c1c6ad0724423f09$var$payload = {
    eventType: (0, $6252f4c5224b497a$export$12346a674644c156),
    action: (0, $3bGZ8.errorBoundaryAction),
    actionSubject: (0, $3bGZ8.errorBoundaryActionSubject)
};
const $c1c6ad0724423f09$var$context = [
    {
        source: $3bGZ8.source
    },
    {
        packageName: $c1c6ad0724423f09$var$name,
        packageVersion: $c1c6ad0724423f09$var$version
    }
];
class $c1c6ad0724423f09$export$e926676385687eaf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $c1c6ad0724423f09$var$payload,
            context: $c1c6ad0724423f09$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("3bGZ8", function(module, exports) {

$parcel$export(module.exports, "source", () => $71fae2c856c13338$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $71fae2c856c13338$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $71fae2c856c13338$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $71fae2c856c13338$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $71fae2c856c13338$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $71fae2c856c13338$export$e67cdcb8867a3bd0);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $6252f4c5224b497a$export$12346a674644c156);

const $71fae2c856c13338$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $71fae2c856c13338$export$9d8252a268f4fa72 = 'errorCaught';
const $71fae2c856c13338$export$1045419caf49b395 = 'errorBoundary';
const $71fae2c856c13338$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $71fae2c856c13338$export$e5c2c058fa8068a6 = 'uiInitialized';
const $71fae2c856c13338$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("96stg", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $2631650796a624b0$export$59518efab336a8b5);
const $2631650796a624b0$var$version = "0.0.0-use.local";
const $2631650796a624b0$export$84f9cf7ef89d4c26 = {
    version: $2631650796a624b0$var$version
};
const $2631650796a624b0$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $2631650796a624b0$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("fVOYV", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $3649e220db80790e$export$a5a156dc5df42f0);
const $3649e220db80790e$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("1y02m", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("agqwW")
]).then(()=>parcelRequire('aIAUi'));

});



parcelRegister("g2XuF", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $014cd965663d7125$export$81d1d40061d190bc);
parcelRequire("7KmmO");
var $kmXhu = parcelRequire("kmXhu");
var $7KmmO = parcelRequire("7KmmO");

var $4Pf62 = parcelRequire("4Pf62");
const $014cd965663d7125$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $kmXhu.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $kmXhu.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $014cd965663d7125$export$81d1d40061d190bc = (0, $7KmmO.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);

});
parcelRegister("7KmmO", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $e641bba009c8a121$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $e641bba009c8a121$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("kmXhu")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("kmXhu")).UserIdTypes);

var $kmXhu = parcelRequire("kmXhu");
const $e641bba009c8a121$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $kmXhu.PluginTypes).GetContainers,
        fetch
    ];
};
const $e641bba009c8a121$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $kmXhu.PluginTypes).GetUsers,
        fetch
    ];
};
const $e641bba009c8a121$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $kmXhu.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $e641bba009c8a121$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $kmXhu.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("kmXhu", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $5a80d0f6a4ce954b$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $5a80d0f6a4ce954b$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $5a80d0f6a4ce954b$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $5a80d0f6a4ce954b$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5a80d0f6a4ce954b$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5a80d0f6a4ce954b$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5a80d0f6a4ce954b$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("5emZd", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $83dd2c216cba0381$export$7c44908d2777db01);

var $7KmmO = parcelRequire("7KmmO");
var $kmXhu = parcelRequire("kmXhu");
const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $kmXhu.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $7KmmO.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);

});


parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $bbMRv = parcelRequire("bbMRv");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $bbMRv.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $bbMRv.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $bbMRv.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1zWF7 = parcelRequire("1zWF7");

var $k24Fu = parcelRequire("k24Fu");

var $7sE1A = parcelRequire("7sE1A");

var $axGKd = parcelRequire("axGKd");

var $fByX6 = parcelRequire("fByX6");

var $ljMDN = parcelRequire("ljMDN");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $ljMDN.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $axGKd.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $7sE1A.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $fByX6.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $k24Fu.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1zWF7.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("2HbP2", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $d012230882eb31a4$export$7c9538f5f3c365e9);

var $5uXOq = parcelRequire("5uXOq");

var $1bqnV = parcelRequire("1bqnV");

var $gJdig = parcelRequire("gJdig");
function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJdig.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bqnV.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        }))));
}

});
parcelRegister("gJdig", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $308ba6e6ba886f08$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $308ba6e6ba886f08$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("bKCrm", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $645a52f2fa143509$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $645a52f2fa143509$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $645a52f2fa143509$export$8172ff4ed0f75a1e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $58GFP = parcelRequire("58GFP");

var $8YEE2 = parcelRequire("8YEE2");

var $dIdda = parcelRequire("dIdda");

var $gL2cg = parcelRequire("gL2cg");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $645a52f2fa143509$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }
});
const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        };
        // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        };
        this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            });
        };
        this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        };
        this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        };
        this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        };
        this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $58GFP.getIsJsmBlankProjectTemplate)(templateKey)) (0, $8YEE2.LazyComponent).preload();
            (0, $gL2cg.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
$645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$fb658bddae7f81bb);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};

});

parcelRegister("8YEE2", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $300188a98a9fded7$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $300188a98a9fded7$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $300188a98a9fded7$export$ff317c5d87147a19);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $9noxX = parcelRequire("9noxX");

var $7B17s = parcelRequire("7B17s");

const $300188a98a9fded7$export$31f1740ae531af94 = (0, $7B17s.lazy)(()=>(parcelRequire("e167Q")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("8H3A4", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $4d76b3bac8f2b7c8$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $4d76b3bac8f2b7c8$export$bc2de1c42df30b10);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $dIdda = parcelRequire("dIdda");


const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("9YBmF"));
const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $dIdda.createResource)({
    type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
    maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
});
const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("dK8AG", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $9ffe1ab8f180b628$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $9ffe1ab8f180b628$export$b87af5b274141bd6);

var $1nb22 = parcelRequire("1nb22");
const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("9YBmF", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3rvO2").then(()=>parcelRequire('btHFe'));

});



parcelRegister("e167Q", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("kWrFZ"),
    $6fhBS("92sUi"),
    $6fhBS("i5RRW"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("c8LNs")
]).then(()=>parcelRequire('c9lEE'));

});


parcelRegister("gL2cg", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $e1d0138bae1db723$export$c0c81c1828c7638c);

var $jcw0u = parcelRequire("jcw0u");

var $dIdda = parcelRequire("dIdda");
const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $dIdda.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("ivvwC", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $0fd080febb09e205$export$c1b371eec908681a);

var $5uXOq = parcelRequire("5uXOq");

var $d9VAQ = parcelRequire("d9VAQ");

var $leRCk = parcelRequire("leRCk");
const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $leRCk.UserContainer), {
        isGlobal: true,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9VAQ.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("d9VAQ", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $3038471ea054300f$export$aa278641ded1adf);

var $7JoAD = parcelRequire("7JoAD");

var $eYegl = parcelRequire("eYegl");
const $3038471ea054300f$export$be74e04eaea4530 = (0, $7JoAD.createSubscriber)((0, $eYegl.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $3038471ea054300f$export$aa278641ded1adf = (0, $7JoAD.createContainer)((0, $eYegl.default));

});
parcelRegister("eYegl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc414d73e667f785$export$2e2bcd8739ae039);

var $7JoAD = parcelRequire("7JoAD");

var $7AJyg = parcelRequire("7AJyg");
const $bc414d73e667f785$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$bc414d73e667f785$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
    name: 'user-preference',
    initialState: $bc414d73e667f785$var$initialState,
    actions: $7AJyg
});

});
parcelRegister("7AJyg", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("g6Vt5")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("ePV4l")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("8Lrq8")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $g6Vt5 = parcelRequire("g6Vt5");

var $ePV4l = parcelRequire("ePV4l");

var $8Lrq8 = parcelRequire("8Lrq8");

});
parcelRegister("g6Vt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a561c8a03710a3f2$export$2e2bcd8739ae039);

var $goEOn = parcelRequire("goEOn");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $goEOn.default)({
                baseUrl: baseUrl,
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("goEOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be3c96b3fac1b7f$export$2e2bcd8739ae039);

var $4Lzq2 = parcelRequire("4Lzq2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $4Lzq2.default)(baseUrl, preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("4Lzq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdd8b3604a0d493$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
    const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
    return (0, $eusud.performGetRequest)(requestUrl);
};

});



parcelRegister("ePV4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fcb0eb90bce4cf$export$2e2bcd8739ae039);

var $g6Vt5 = parcelRequire("g6Vt5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, $g6Vt5.default)('issue-create');

});

parcelRegister("8Lrq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea442a302ef98b1$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});






parcelRegister("62C9r", function(module, exports) {

$parcel$export(module.exports, "HorizontalNav", () => $df8ca37c4f42ad24$export$3821fe730064297d);
$parcel$export(module.exports, "HorizontalNavWrapper", () => $df8ca37c4f42ad24$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cPiXk = parcelRequire("cPiXk");

var $cM67N = parcelRequire("cM67N");

var $erBFB = parcelRequire("erBFB");
const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    return HorizontalNavComponent && /*#__PURE__*/ $5uXOq.createElement((0, $cM67N.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cM67N.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $5uXOq.createElement(HorizontalNavComponent, null));
};
const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
    return /*#__PURE__*/ $5uXOq.createElement($df8ca37c4f42ad24$var$ThemedContainer, null, /*#__PURE__*/ $5uXOq.createElement((0, $cM67N.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cM67N.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $5uXOq.createElement(HorizontalNavComponent, null)), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df8ca37c4f42ad24$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71o10 _11q31r52 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cM67N", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $5ad940bec1d10db7$export$afc779e659fd533f);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
function $5ad940bec1d10db7$export$35c1e8d8e59e87e7() {
    return [
        // to be kept up-to-date
        // last update 2024/08/14
        // reference: https://hello.atlassian.net/wiki/spaces/JNR/pages/4001046109/Coding+for+the+nav4+rollout
        [
            'jira_nav4',
            (0, $4R6GH.fg)('jira_nav4')
        ],
        [
            'jira_nav4_dogfooding',
            (0, $4R6GH.fg)('jira_nav4_dogfooding')
        ],
        [
            'jira_nav4_dogfooding_phase-1',
            (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1')
        ],
        [
            'jira_nav4_dogfooding_phase-2',
            (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2')
        ]
    ];
}
const $5ad940bec1d10db7$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $5ad940bec1d10db7$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $3HwlS.getWillShowNav4)() ? 'v4' : 'v3';
}
function $5ad940bec1d10db7$var$getExtraAttributes(_error) {
    const attributes = {
        ffs: $5ad940bec1d10db7$export$35c1e8d8e59e87e7().filter(([, value])=>value).map(([key])=>key).join(),
        rev: $5ad940bec1d10db7$var$inferNavRevision()
    };
    return attributes;
}
function $5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$5ad940bec1d10db7$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $5ad940bec1d10db7$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $5uXOq.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($5ad940bec1d10db7$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $jcw0u.default)($5ad940bec1d10db7$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $5ad940bec1d10db7$export$afc779e659fd533f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ad940bec1d10db7$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), props));

});

parcelRegister("erBFB", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $cd61d83e2e343ff1$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $cd61d83e2e343ff1$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $cd61d83e2e343ff1$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $cd61d83e2e343ff1$export$b1498dd122ea3284);

var $koVbs = parcelRequire("koVbs");

var $iqLcb = parcelRequire("iqLcb");

var $lOt1w = parcelRequire("lOt1w");
const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $lOt1w.default).skipToJiraNavigation), 0);
    return null;
};
const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $lOt1w.default).skipToSideNavigation), 1);
    return null;
};
const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $lOt1w.default).skipToProjectViewNavigation), 2);
    return null;
};
const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-main-content', formatMessage((0, $lOt1w.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("lOt1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d368a0de790f751$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("4s15Z", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $ac6bd493ba1cffad$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $2Ioew = parcelRequire("2Ioew");


var $frBVt = parcelRequire("frBVt");

var $39xOx = parcelRequire("39xOx");

var $co1wz = parcelRequire("co1wz");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $hsmeR = parcelRequire("hsmeR");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $1XrjK = parcelRequire("1XrjK");

var $6ncxj = parcelRequire("6ncxj");

var $gwZ1O = parcelRequire("gwZ1O");

var $l8ruj = parcelRequire("l8ruj");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $ac6bd493ba1cffad$var$routeComponents = [];
const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $1XrjK.renderGlobalComponents)((0, $6ncxj.sharedLayout).rightSidebars));
const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $1XrjK.renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
};
const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPoint = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
    const route = (0, $6jY6G.useCurrentRoute)();
    const entrypoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    if (!entrypoint || !rightSideBarEntryPoint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gwZ1O.ProjectListSidebarSkeleton), null),
        /* @ts-expect-error - TS2322 - We're using JSResourceReference from @atlassian/react-async. */ entryPoint: entrypoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPoint,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    const RightSideBarOrPanel = (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? (0, $iqLcb.RightPanel) : (0, $iqLcb.RightSidebar);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RightSideBarOrPanel, {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $ac6bd493ba1cffad$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, $co1wz.ff)('server-render-projects-directory-sidebar_rj9ki') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), (0, $co1wz.ff)('server-render-projects-directory-sidebar_rj9ki') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
            __cmplp.className
        ])
    });
});
const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);

});
parcelRegister("2Ioew", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $dcf886ac39f7cfda$export$fe1c839e8baf4110);

var $h22md = parcelRequire("h22md");

var $6jY6G = parcelRequire("6jY6G");
const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const entryPointReference = (0, $h22md.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("h22md", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $4e1bc9edc261b42d$export$c96377f800cdddb4);

var $3I4nj = parcelRequire("3I4nj");
const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $3I4nj.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("3I4nj", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $f09634e8d32626d1$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $f09634e8d32626d1$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $f09634e8d32626d1$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $f09634e8d32626d1$export$7e18f3e3cbd04326);

var $7JoAD = parcelRequire("7JoAD");
const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$var$actions = {
    setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
};
const $f09634e8d32626d1$var$EntryPointsStore = (0, $7JoAD.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $f09634e8d32626d1$var$actions,
    name: 'react-resource-router/entry-points'
});
const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $7JoAD.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $7JoAD.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;

});



const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';

parcelRegister("gwZ1O", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $b3acbd60cf8d3dfa$export$808c25bcc6102427);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gnABE = parcelRequire("gnABE");

var $d8ped = parcelRequire("d8ped");
const $b3acbd60cf8d3dfa$var$customCssStyles = null;
const $b3acbd60cf8d3dfa$var$sidebarCssStyles = null;
const $b3acbd60cf8d3dfa$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1gwv _1yt41ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnABE.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d8ped))),
        className: (0, $bwpsq.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("gnABE", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $93b95cd5afe27e51$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $koVbs = parcelRequire("koVbs");

var $iziuT = parcelRequire("iziuT");

var $d0Ozr = parcelRequire("d0Ozr");
const $93b95cd5afe27e51$var$skeletonImageStyles = null;
const $93b95cd5afe27e51$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iziuT.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93b95cd5afe27e51$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93b95cd5afe27e51$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("d8ped", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});



parcelRegister("eF0qp", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $803f61b5dea1399f$export$1ba59dacbcbf90fe);

var $fZBia = parcelRequire("fZBia");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $azzrO = parcelRequire("azzrO");

var $5e7oM = parcelRequire("5e7oM");

var $gwIPs = parcelRequire("gwIPs");

var $39xOx = parcelRequire("39xOx");

var $7XYc4 = parcelRequire("7XYc4");

var $aWse0 = parcelRequire("aWse0");

var $gPQRI = parcelRequire("gPQRI");

var $5e5zm = parcelRequire("5e5zm");

var $2fwuR = parcelRequire("2fwuR");

var $acDan = parcelRequire("acDan");

var $c6x3L = parcelRequire("c6x3L");

var $3HwlS = parcelRequire("3HwlS");

var $jHUgj = parcelRequire("jHUgj");

var $4DrQd = parcelRequire("4DrQd");

var $eGkew = parcelRequire("eGkew");

var $iqLcb = parcelRequire("iqLcb");

var $ht71P = parcelRequire("ht71P");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $ao2h1 = parcelRequire("ao2h1");

var $5M3R9 = parcelRequire("5M3R9");

var $4V52L = parcelRequire("4V52L");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $l28zt = parcelRequire("l28zt");
var $T0nre = parcelRequire("T0nre");

var $erBFB = parcelRequire("erBFB");

var $gxq4u = parcelRequire("gxq4u");

var $7x18A = parcelRequire("7x18A");
const $803f61b5dea1399f$var$SidebarNew = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2fwuR.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
};
const $803f61b5dea1399f$var$SidebarInternalAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $T0nre.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHUgj.SidebarSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l28zt.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd
    })));
};
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar';
const $803f61b5dea1399f$var$SidebarInternal = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $fZBia.default), queryReference); /*
                                                                                               	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                                                                                               	under a scenario where a new user joins an existing Jira site.
                                                                                               	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                                                                                               	So, default values are used in such a case.
                                                                                               */ 
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $4DrQd.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $T0nre.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHUgj.SidebarSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $803f61b5dea1399f$var$feedbackButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4V52L.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l28zt.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ht71P.AsyncNudgeBundledUsersFlagContainer), null)));
};
const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $803f61b5dea1399f$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7x18A.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props))))
    }
};
const $803f61b5dea1399f$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
    const { width: width, isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const intl = (0, $aWse0.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $gxq4u.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $803f61b5dea1399f$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    }))))));
};
const $803f61b5dea1399f$var$SidebarInternalOldMemo = /*#__PURE__*/ (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
        sidebar: sidebar
    }) : null;
const $803f61b5dea1399f$var$SidebarOld = ()=>{
    const { shouldRender: shouldRender } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGkew.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $803f61b5dea1399f$var$renderChildren);
};
const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld); /**
                                                                                         * In the @atlaskit/page-layout, resize control uses button for
                                                                                         * the grab area. At the same time, legacy batch.css reset all
                                                                                         * the button to have a box-shadow when focused. So when user
                                                                                         * resizing the sidebar, they will see two blue lines around
                                                                                         * the grab area.
                                                                                         */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $803f61b5dea1399f$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $lD23V.default)((0, $gwIPs.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});
const $803f61b5dea1399f$var$feedbackButtonContainerStyles = (0, $ii5wQ.xcss)({
    position: 'sticky',
    insetBlockEnd: 'space.0',
    marginBlockStart: 'auto'
});

});
parcelRegister("fZBia", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c8513a288fea00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6397372677267ea3c070486a779d6ada>>
 * @relayHash a62980e6f93cb5f2ad31fdebd70c38b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8
const $79c8513a288fea00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.leftSidebarWidth"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79c8513a288fea00$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;

});

parcelRegister("azzrO", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $4d07bc740e316cc0$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $4d07bc740e316cc0$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $4d07bc740e316cc0$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $4d07bc740e316cc0$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $4d07bc740e316cc0$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $4d07bc740e316cc0$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $4d07bc740e316cc0$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $4d07bc740e316cc0$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $4d07bc740e316cc0$export$a018e347341b3640);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hC3PM = parcelRequire("hC3PM");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5M3R9 = parcelRequire("5M3R9");

var $5e7oM = parcelRequire("5e7oM");
const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, $hC3PM.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$8df02628d98cae7e = {
    ADDONS: (0, $hC3PM.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, $hC3PM.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
        [(0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $5uXOq.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5M3R9.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $cfDZ3.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("5M3R9", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $ca67b9a5090b457c$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $ca67b9a5090b457c$export$345f21b0287f67e5);

var $5uXOq = parcelRequire("5uXOq");

var $6Csk1 = parcelRequire("6Csk1");

var $9XE6b = parcelRequire("9XE6b");

var $jR67t = parcelRequire("jR67t");

var $7JoAD = parcelRequire("7JoAD");

const $ca67b9a5090b457c$var$initialState = {
    start: undefined,
    traces: {}
};
let $ca67b9a5090b457c$var$currentTraces = {};
const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
    if ($ca67b9a5090b457c$var$currentTraces[key]) return;
    $ca67b9a5090b457c$var$currentTraces[key] = {
        startTime: (0, $jR67t.performance).now()
    };
};
const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
    if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
    $ca67b9a5090b457c$var$currentTraces[key].duration = (0, $jR67t.performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
};
const $ca67b9a5090b457c$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
        }
};
const $ca67b9a5090b457c$var$Store = (0, $7JoAD.createStore)({
    name: 'jira-render-tracer',
    initialState: $ca67b9a5090b457c$var$initialState,
    actions: $ca67b9a5090b457c$var$actions
});
const $ca67b9a5090b457c$var$RenderTracerActions = (0, $7JoAD.createSubscriber)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$export$719a95758870be58 = (0, $7JoAD.createHook)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $7JoAD.createContainer)($ca67b9a5090b457c$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $jR67t.performance).now()
                    }
                }
            });
        }
});
const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $jR67t.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $jR67t.performance).now());
        return null;
    });
const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
        [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("jR67t", function(module, exports) {

$parcel$export(module.exports, "performance", () => $c026bc7061377d6e$export$f2d2284f5fec51f8);
const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $c026bc7061377d6e$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $c026bc7061377d6e$var$now();
    }
    now() {
        if (false) return $c026bc7061377d6e$var$now() - this.startAt;
        return $c026bc7061377d6e$var$now();
    }
    constructor(){
        this.startAt = $c026bc7061377d6e$var$now();
    }
}
const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();

});

const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';


parcelRegister("5e7oM", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $83022b592d1d8567$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $83022b592d1d8567$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $83022b592d1d8567$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $83022b592d1d8567$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $83022b592d1d8567$export$1d10ee0c85c3cb21);
const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $83022b592d1d8567$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});


parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("2fwuR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $692dbcae1edae2a1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $692dbcae1edae2a1$export$a46129bd512544d7);

var $jhS4y = parcelRequire("jhS4y");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $ao2h1 = parcelRequire("ao2h1");

var $2OeZv = parcelRequire("2OeZv");

var $fZBia = parcelRequire("fZBia");
const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
        // console.log('Route name', routerContext.route.name);
        return {
            parameters: (0, $2OeZv.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_APPS)),
                isDashboardsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_DASHBOARDS)),
                isFiltersExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OPERATIONS))
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $fZBia.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("jhS4y", function(module, exports) {

$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $d66e3a3484b422c6$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $d66e3a3484b422c6$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $d66e3a3484b422c6$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $d66e3a3484b422c6$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $d66e3a3484b422c6$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $d66e3a3484b422c6$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $d66e3a3484b422c6$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $d66e3a3484b422c6$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $d66e3a3484b422c6$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $d66e3a3484b422c6$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $d66e3a3484b422c6$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $d66e3a3484b422c6$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $d66e3a3484b422c6$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $d66e3a3484b422c6$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $d66e3a3484b422c6$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $d66e3a3484b422c6$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $d66e3a3484b422c6$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $d66e3a3484b422c6$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $d66e3a3484b422c6$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $d66e3a3484b422c6$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $d66e3a3484b422c6$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $d66e3a3484b422c6$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $d66e3a3484b422c6$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $d66e3a3484b422c6$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $d66e3a3484b422c6$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $d66e3a3484b422c6$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $d66e3a3484b422c6$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $d66e3a3484b422c6$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $d66e3a3484b422c6$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $d66e3a3484b422c6$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $d66e3a3484b422c6$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $d66e3a3484b422c6$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $d66e3a3484b422c6$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $d66e3a3484b422c6$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $d66e3a3484b422c6$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $d66e3a3484b422c6$export$100a1a639a0db980);
// These IDs are used with the user-customisable navigation service.
const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps'
};
const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
const $d66e3a3484b422c6$export$e682260eda678e61 = 'proj-dir';
const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("3Jbkp", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $e52131b0b61339d3$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bxYf9 = parcelRequire("bxYf9");

var $7Ckoi = parcelRequire("7Ckoi");
const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))((0, $7Ckoi.routeToSelectedPath));

});
parcelRegister("7Ckoi", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $551cdf5d088747a1$export$a92474c098a1fd13);

var $4R6GH = parcelRequire("4R6GH");

var $fBDpl = parcelRequire("fBDpl");

var $ezq2z = parcelRequire("ezq2z");

var $j3mSh = parcelRequire("j3mSh");

var $1RoZ2 = parcelRequire("1RoZ2");

var $hdJn1 = parcelRequire("hdJn1");

var $2m3Yb = parcelRequire("2m3Yb");

var $3weqe = parcelRequire("3weqe");

var $c6hlO = parcelRequire("c6hlO");

var $3lNyZ = parcelRequire("3lNyZ");

var $8bXrC = parcelRequire("8bXrC");

var $eReVn = parcelRequire("eReVn");
function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convert(routeContext);
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convert(routeContext);
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convert(routeContext);
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convert(routeContext);
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convert(routeContext);
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convert(routeContext);
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convert(routeContext);
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convert(routeContext);
    if ((0, $4R6GH.fg)('jira_nav4_eap_drop_1')) {
        if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convert(routeContext);
    }
    return [];
}

});
parcelRegister("fBDpl", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $55a8ac7f9c56fb94$export$d017a63045c88c47);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
// TODO: verify these routes
const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    (0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ (0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_CONNECT_PROJECT)
];
const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
    (0, $65Ltd.ROUTE_NAMES_FORGE_GLOBAL),
    (0, $65Ltd.ROUTE_NAMES_MARKETPLACE_INDEX)
];
const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
    ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $55a8ac7f9c56fb94$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_MARKETPLACE_INDEX:
            path.push((0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL:
        case 0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL_INVALID:
        case 0, $65Ltd.ROUTE_NAMES_FORGE_GLOBAL:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
            path.push((0, $jhS4y.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 0, $65Ltd.ROUTE_NAMES_CONNECT_PROJECT:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
    routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
    convert: $55a8ac7f9c56fb94$var$convert
};

});

parcelRegister("ezq2z", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $bdd6509d07f3cefb$export$6cfeba0849032a84);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $bdd6509d07f3cefb$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
]);
function $bdd6509d07f3cefb$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    // const { match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
            path.push((0, $jhS4y.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
    routes: $bdd6509d07f3cefb$var$routes,
    convert: $bdd6509d07f3cefb$var$convert
};

});

parcelRegister("j3mSh", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $257dabfdf8711aa2$export$6468819b4be328b1);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $257dabfdf8711aa2$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_DASHBOARD_EDIT),
    (0, $65Ltd.ROUTE_NAMES_DASHBOARD_VIEW),
    (0, $65Ltd.ROUTE_NAMES_DASHBOARD_WALLBOARD)
]);
function $257dabfdf8711aa2$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_DASHBOARDS_DIRECTORY:
            path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 0, $65Ltd.ROUTE_NAMES_DASHBOARD_WALLBOARD:
            query.dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $257dabfdf8711aa2$export$6468819b4be328b1 = {
    routes: $257dabfdf8711aa2$var$routes,
    convert: $257dabfdf8711aa2$var$convert
};

});

parcelRegister("1RoZ2", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $c2ae3b230f933dc6$export$6e91331b5debb7c8);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $c2ae3b230f933dc6$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_GIN),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_GIN_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
]);
function $c2ae3b230f933dc6$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_FILTERS_DIRECTORY:
            path.push((0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 0, $65Ltd.ROUTE_NAMES_ISSUE:
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $jhS4y.MENU_ID_PROJECTS),
                        (0, $jhS4y.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $jhS4y.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
    routes: $c2ae3b230f933dc6$var$routes,
    convert: $c2ae3b230f933dc6$var$convert
};

});

parcelRegister("hdJn1", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $9b181cf5d70a46b3$export$7fc92455d5020e1);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $9b181cf5d70a46b3$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_EOC_AUTOMATIONS),
    (0, $65Ltd.ROUTE_NAMES_EOC_CUSTOM_ROLES),
    (0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_ALERTS),
    (0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
    (0, $65Ltd.ROUTE_NAMES_EOC_HEARTBEATS),
    (0, $65Ltd.ROUTE_NAMES_EOC_MAINTENANCE),
    (0, $65Ltd.ROUTE_NAMES_EOC_ON_CALL),
    (0, $65Ltd.ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_EOC_OVERVIEW),
    (0, $65Ltd.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
    (0, $65Ltd.ROUTE_NAMES_EOC_PERMISSIONS),
    (0, $65Ltd.ROUTE_NAMES_EOC_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_EOC_REPORTS_TEAM),
    (0, $65Ltd.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERTS),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
    (0, $65Ltd.ROUTE_NAMES_EOC_TEAM_POLICIES),
    (0, $65Ltd.ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
]);
function $9b181cf5d70a46b3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
            path.push((0, $jhS4y.MENU_ID_OPS_ON_CALL));
            break;
        case 0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_ALERTS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
            {
                path.push((0, $jhS4y.MENU_ID_OPS_ALERTS));
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_REPORTS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
        case 0, $65Ltd.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
            path.push((0, $jhS4y.MENU_ID_OPS_REPORTS));
            break;
        case 0, $65Ltd.ROUTE_NAMES_EOC_AUTOMATIONS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
        case 0, $65Ltd.ROUTE_NAMES_EOC_HEARTBEATS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_MAINTENANCE:
        case 0, $65Ltd.ROUTE_NAMES_EOC_PERMISSIONS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_ON_CALL:
        case 0, $65Ltd.ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
        case 0, $65Ltd.ROUTE_NAMES_EOC_OVERVIEW:
        case 0, $65Ltd.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_REPORTS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_REPORTS_TEAM:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERTS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_POLICIES:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
        case 0, $65Ltd.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
            path.push((0, $jhS4y.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
    routes: $9b181cf5d70a46b3$var$routes,
    convert: $9b181cf5d70a46b3$var$convert
};

});

parcelRegister("2m3Yb", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $c60c27b55fbcd9c5$export$a33f2d74a674bf8a);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $c60c27b55fbcd9c5$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_YOUR_WORK),
    // ROUTE_NAMES_HOME_ONBOARDING_REDIRECT,
    // ROUTE_NAMES_HOME_REDIRECT
    (0, $65Ltd.ROUTE_NAMES_PEOPLE_INDEX)
]);
function $c60c27b55fbcd9c5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_YOUR_WORK:
            path.push((0, $jhS4y.MENU_ID_YOUR_WORK));
            break;
        case 0, $65Ltd.ROUTE_NAMES_PEOPLE_INDEX:
            path.push((0, $jhS4y.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
    routes: $c60c27b55fbcd9c5$var$routes,
    convert: $c60c27b55fbcd9c5$var$convert
};

});

parcelRegister("3weqe", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $b8a10fc0a37e731b$export$5469f6c6536ca9c5);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $b8a10fc0a37e731b$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
]);
function $b8a10fc0a37e731b$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $jhS4y.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
    routes: $b8a10fc0a37e731b$var$routes,
    convert: $b8a10fc0a37e731b$var$convert
};

});

parcelRegister("c6hlO", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $a783e1b6f52291a3$export$3bde637b58016d1);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $a783e1b6f52291a3$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_PLANS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
    (0, $65Ltd.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
]);
function $a783e1b6f52291a3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_PLANS_DIRECTORY:
        case 0, $65Ltd.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
            path.push((0, $jhS4y.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 0, $65Ltd.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $jhS4y.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $a783e1b6f52291a3$export$3bde637b58016d1 = {
    routes: $a783e1b6f52291a3$var$routes,
    convert: $a783e1b6f52291a3$var$convert
};

});

parcelRegister("3lNyZ", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $6eaade1a69d23d1d$export$c41b724886e5872b);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $6eaade1a69d23d1d$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_ALL_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_NOT_FOUND),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
    // Apps
    (0, $65Ltd.ROUTE_NAMES_FORGE_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
    // JPD
    (0, $65Ltd.ROUTE_NAMES_POLARIS_IDEAS),
    (0, $65Ltd.ROUTE_NAMES_POLARIS_ONBOARDING),
    // JSW
    (0, $65Ltd.ROUTE_NAMES_OPSGENIE_SCHEDULE),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_PAGES),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_CODE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_GOALS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_INCIDENTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_LIST),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PERISCOPE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REQUESTS),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_SECURITY),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
    // JSM
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
    (0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
    (0, $65Ltd.ROUTE_NAMES_NOTIFICATION_LOGS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ISSUES),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SERVICES),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
    // JWM
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
]);
function $6eaade1a69d23d1d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_POLARIS_ONBOARDING:
            break;
        case 0, $65Ltd.ROUTE_NAMES_PROJECTS_DIRECTORY:
            path.push((0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 0, $65Ltd.ROUTE_NAMES_FORGE_PROJECT:
        case 0, $65Ltd.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $jhS4y.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $jhS4y.ENTITY_ID).APP(appId));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
        case 0, $65Ltd.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_NOTIFICATION_LOGS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS:
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CALENDAR:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ISSUES:
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $jhS4y.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SERVICES:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $jhS4y.ENTITY_ID).FORM(formId));
            }
    }
    return path;
}
const $6eaade1a69d23d1d$export$c41b724886e5872b = {
    routes: $6eaade1a69d23d1d$var$routes,
    convert: $6eaade1a69d23d1d$var$convert
};

});

parcelRegister("8bXrC", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $8c39d6aa787bb969$export$5761942b1e0c2dd0);

var $65Ltd = parcelRequire("65Ltd");

var $jhS4y = parcelRequire("jhS4y");
const $8c39d6aa787bb969$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_POLARIS_COLLECTIONS)
]);
function $8c39d6aa787bb969$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_POLARIS_COLLECTIONS:
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $jhS4y.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
    routes: $8c39d6aa787bb969$var$routes,
    convert: $8c39d6aa787bb969$var$convert
};

});

parcelRegister("eReVn", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $59806d8088c642c3$export$dd307ede503fe0e);

var $65Ltd = parcelRequire("65Ltd");

var $2VkCP = parcelRequire("2VkCP");

var $bOhA4 = parcelRequire("bOhA4");

var $2nb5R = parcelRequire("2nb5R");

var $040pa = parcelRequire("040pa");

var $YXuQ6 = parcelRequire("YXuQ6");

var $iQZ89 = parcelRequire("iQZ89");

var $jhS4y = parcelRequire("jhS4y");
const $59806d8088c642c3$var$routes = new Set([
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
    (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
    (0, $2VkCP.routeGroupsProjectSettingsLegacyAutomationRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskAccessRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskFieldsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChatRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskEmailRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskWidgetRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $2VkCP.virtualAgentConversationsRoute).name,
    (0, $2VkCP.virtualAgentIntentsRoute).name,
    (0, $2VkCP.virtualAgentSettingsRoute).name,
    (0, $2VkCP.virtualAgentStandardFlowsRoute).name,
    (0, $2VkCP.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $2VkCP.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
    (0, $bOhA4.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $bOhA4.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $2nb5R.routeGroupsProjectSettingsServicedeskKbRoute).name,
    (0, $YXuQ6.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $YXuQ6.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $iQZ89.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
    (0, $2VkCP.projectSettingsServicedeskAutomationRoute).name,
    (0, $040pa.servicedeskSlaSettingsRoute).name,
    (0, $2VkCP.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
]);
function $59806d8088c642c3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        // Access Menu
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskAccessRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
        case (0, $YXuQ6.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $YXuQ6.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
        case (0, $iQZ89.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
        case (0, $040pa.servicedeskSlaSettingsRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskFieldsRoute).name:
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
        case (0, $2VkCP.routeGroupsProjectSettingsLegacyAutomationRoute).name:
        case (0, $2VkCP.projectSettingsServicedeskAutomationRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskEmailRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChatRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskWidgetRoute).name:
        case (0, $2nb5R.routeGroupsProjectSettingsServicedeskKbRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
        case (0, $2VkCP.virtualAgentIntentsRoute).name:
        case (0, $2VkCP.virtualAgentStandardFlowsRoute).name:
        case (0, $2VkCP.virtualAgentConversationsRoute).name:
        case (0, $2VkCP.virtualAgentSettingsRoute).name:
            // case issueCollectors.name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 0, $65Ltd.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
        case (0, $bOhA4.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $bOhA4.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $2VkCP.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $2VkCP.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
        case (0, $2VkCP.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $59806d8088c642c3$export$dd307ede503fe0e = {
    routes: $59806d8088c642c3$var$routes,
    convert: $59806d8088c642c3$var$convert
};

});
parcelRegister("2VkCP", function(module, exports) {

$parcel$export(module.exports, "getJsmProjectSettingsUrl", () => $2a557627656b882a$export$b7cec47cdf9c76f1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", () => $2a557627656b882a$export$666cdeccf1f430a6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", () => $2a557627656b882a$export$5ed718db41f9c966);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", () => $2a557627656b882a$export$60b14f135c03f9c7);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", () => $2a557627656b882a$export$87914ccacd42ab35);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", () => $2a557627656b882a$export$e382068c2b8a7b9f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", () => $2a557627656b882a$export$7ae67c73ac5367a8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", () => $2a557627656b882a$export$b237f4f6820b26e9);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", () => $2a557627656b882a$export$f7e149bf217bbb2c);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", () => $2a557627656b882a$export$eb1177fbc6c41b97);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", () => $2a557627656b882a$export$f919d82b98f9257a);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", () => $2a557627656b882a$export$ce59d5cb98345f8e);
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $2a557627656b882a$export$1a2228d5e07202a0);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", () => $2a557627656b882a$export$1596046a0b047934);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", () => $2a557627656b882a$export$3ab501c22b91462b);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", () => $2a557627656b882a$export$324e5a618f1ac5a1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $2a557627656b882a$export$e6f711e47860f891);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", () => $2a557627656b882a$export$4ef3eecacde57780);
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $2a557627656b882a$export$40539cb16771014e);
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $2a557627656b882a$export$1f37a1aff4f594af);
$parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", () => $2a557627656b882a$export$18c6f3890d9fd8b8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", () => $2a557627656b882a$export$d195c572a6155c05);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", () => $2a557627656b882a$export$8152b460f5961d94);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $2a557627656b882a$export$e184fa302b6981b6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", () => $2a557627656b882a$export$dd22cfc45fe86c35);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", () => $2a557627656b882a$export$b03f0a1a580a902f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", () => $2a557627656b882a$export$d29fa1140db9296d);
$parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", () => $2a557627656b882a$export$abc6508b4dce2d9b);
$parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", () => $2a557627656b882a$export$680ccfe6e5af63a8);
$parcel$export(module.exports, "virtualAgentIntentsRoute", () => $2a557627656b882a$export$1e70273fc2a407f5);
$parcel$export(module.exports, "virtualAgentStandardFlowsRoute", () => $2a557627656b882a$export$f45c942ecfcc5682);
$parcel$export(module.exports, "virtualAgentConversationsRoute", () => $2a557627656b882a$export$837f003bb6f40f9);
$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $2a557627656b882a$export$80422a49e17dfd6b);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", () => $2a557627656b882a$export$394d5ca6ce9e5949);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", () => $2a557627656b882a$export$e856498dc02e46e8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", () => $2a557627656b882a$export$d0198d2da30de212);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", () => $2a557627656b882a$export$fe54e02c94ff5613);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", () => $2a557627656b882a$export$164572fb58075291);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", () => $2a557627656b882a$export$10089d339d8e30d1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", () => $2a557627656b882a$export$ff20eaee6cf19401);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", () => $2a557627656b882a$export$8e2543080acfc7c2);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", () => $2a557627656b882a$export$3a3e70b8651d8d57);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", () => $2a557627656b882a$export$77d19d35e71558b3);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", () => $2a557627656b882a$export$cd46cad965f517e2);
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $2a557627656b882a$export$10bafd1256118bb8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", () => $2a557627656b882a$export$43b5b901d4988763);

var $65Ltd = parcelRequire("65Ltd");
const $2a557627656b882a$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $2a557627656b882a$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$2a557627656b882a$var$SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
const $2a557627656b882a$var$jsmProjectSettingsUrl = $2a557627656b882a$export$b7cec47cdf9c76f1();
const $2a557627656b882a$export$666cdeccf1f430a6 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId?`,
    exact: true
};
const $2a557627656b882a$export$5ed718db41f9c966 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId/:initialSection(workflow)`,
    exact: true
};
const $2a557627656b882a$export$60b14f135c03f9c7 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/request-types/category/:practice`,
    exact: true
};
const $2a557627656b882a$export$87914ccacd42ab35 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/fields`,
    exact: true
};
const $2a557627656b882a$export$e382068c2b8a7b9f = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/app-fields`,
    exact: true
};
const $2a557627656b882a$export$7ae67c73ac5367a8 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId?`,
    exact: true
};
const $2a557627656b882a$export$b237f4f6820b26e9 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
    // /settings/details
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/details`,
    exact: true
};
const $2a557627656b882a$export$f7e149bf217bbb2c = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/access`,
    exact: true
};
const $2a557627656b882a$export$eb1177fbc6c41b97 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/people`,
    exact: true
};
const $2a557627656b882a$export$f919d82b98f9257a = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms`,
    exact: true
};
const $2a557627656b882a$export$ce59d5cb98345f8e = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms/form/:templateFormId/edit`,
    exact: true
};
const $2a557627656b882a$export$1a2228d5e07202a0 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automate`
};
const $2a557627656b882a$export$1596046a0b047934 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/data-classifications`,
    exact: true
};
const $2a557627656b882a$export$3ab501c22b91462b = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps`,
    exact: true
};
const $2a557627656b882a$export$324e5a618f1ac5a1 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/itsm-features`,
    exact: true
};
const $2a557627656b882a$export$e6f711e47860f891 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/internal-notifications`
};
const $2a557627656b882a$export$4ef3eecacde57780 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/internal-notifications`
};
const $2a557627656b882a$export$40539cb16771014e = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/notification-email`,
    exact: true
};
const $2a557627656b882a$export$1f37a1aff4f594af = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notification-email`,
    exact: true
};
const $2a557627656b882a$export$18c6f3890d9fd8b8 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications`,
    exact: true
};
const $2a557627656b882a$export$d195c572a6155c05 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language/:languageKey/:sidebarItemKey?`
};
const $2a557627656b882a$export$8152b460f5961d94 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language`,
    exact: true
};
const $2a557627656b882a$export$e184fa302b6981b6 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/customer-permissions`,
    exact: true
};
const $2a557627656b882a$export$dd22cfc45fe86c35 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/customer-permissions`,
    exact: true
};
const $2a557627656b882a$export$b03f0a1a580a902f = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/email`,
    exact: true
};
const $2a557627656b882a$export$d29fa1140db9296d = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/email`,
    exact: true
};
const $2a557627656b882a$export$abc6508b4dce2d9b = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automation`,
    exact: true
};
const $2a557627656b882a$export$680ccfe6e5af63a8 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent`,
    exact: true
};
const $2a557627656b882a$export$1e70273fc2a407f5 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/intents`,
    exact: true
};
const $2a557627656b882a$export$f45c942ecfcc5682 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/standard-flows`,
    exact: true
};
const $2a557627656b882a$export$837f003bb6f40f9 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/conversations`,
    exact: true
};
const $2a557627656b882a$export$80422a49e17dfd6b = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/settings`,
    exact: true
};
const $2a557627656b882a$export$394d5ca6ce9e5949 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/portal-settings`,
    exact: true
};
const $2a557627656b882a$export$e856498dc02e46e8 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/portal-settings/:subPath(portal-groups)?`,
    exact: true
};
const $2a557627656b882a$export$d0198d2da30de212 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/external-links`,
    exact: true
};
const $2a557627656b882a$export$fe54e02c94ff5613 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/widget`,
    exact: true
};
const $2a557627656b882a$export$164572fb58075291 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/widget`,
    exact: true
};
const $2a557627656b882a$export$10089d339d8e30d1 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/change-management`,
    exact: true
};
const $2a557627656b882a$export$ff20eaee6cf19401 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/incident-management`,
    exact: true
};
const $2a557627656b882a$export$8e2543080acfc7c2 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/chat`,
    exact: true
};
const $2a557627656b882a$export$3a3e70b8651d8d57 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/chat`,
    exact: true
};
const $2a557627656b882a$export$77d19d35e71558b3 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels`,
    exact: true
};
const $2a557627656b882a$export$cd46cad965f517e2 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/feedback-settings`
};
const $2a557627656b882a$export$10bafd1256118bb8 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
    path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId/:envId/:route?`
};
const $2a557627656b882a$export$43b5b901d4988763 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
    path: $2a557627656b882a$var$jsmProjectSettingsUrl
};

});

parcelRegister("bOhA4", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", () => $2d3fa729818e1379$export$7fc567ce6cdc6b52);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $2d3fa729818e1379$export$688d2c8abd7b3661);

var $65Ltd = parcelRequire("65Ltd");
const $2d3fa729818e1379$export$5575497f0592ee94 = 'servicedesk';
const $2d3fa729818e1379$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $2d3fa729818e1379$export$7fc567ce6cdc6b52 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
    path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/customer-notifications`
};
const $2d3fa729818e1379$export$688d2c8abd7b3661 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
    path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/notifications/customer-notifications`
};

});

parcelRegister("2nb5R", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", () => $787a3748538c85bb$export$8855316927afaed1);

var $65Ltd = parcelRequire("65Ltd");
const $787a3748538c85bb$export$5575497f0592ee94 = 'servicedesk';
const $787a3748538c85bb$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $787a3748538c85bb$export$8855316927afaed1 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
    path: `${$787a3748538c85bb$var$projectSettingsUrl($787a3748538c85bb$export$5575497f0592ee94)}/confluence-kb`,
    exact: true
};

});

parcelRegister("040pa", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $b24230704c8d21b6$export$bfbf66468910573e);

var $65Ltd = parcelRequire("65Ltd");
const $b24230704c8d21b6$export$5575497f0592ee94 = 'servicedesk';
const $b24230704c8d21b6$export$bfbf66468910573e = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("YXuQ6", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $810950199d0bd223$export$cd0f363eecbc2379);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute", () => $810950199d0bd223$export$96fd54e139924473);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", () => $810950199d0bd223$export$1eebd582a7db1c90);

var $65Ltd = parcelRequire("65Ltd");
const $810950199d0bd223$export$5575497f0592ee94 = 'servicedesk';
const $810950199d0bd223$export$cd0f363eecbc2379 = {
    exact: true,
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
    path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
};
const $810950199d0bd223$export$96fd54e139924473 = {
    exact: true,
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
    path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
};
const $810950199d0bd223$export$1eebd582a7db1c90 = {
    exact: true,
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
    path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
};

});

parcelRegister("iQZ89", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", () => $c6b26f9ea53dbefe$export$ad30542ae2fd7196);

var $65Ltd = parcelRequire("65Ltd");
const $c6b26f9ea53dbefe$export$ad30542ae2fd7196 = {
    group: (0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $65Ltd.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});




parcelRegister("ao2h1", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $5f6ac21695ec30bb$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $5f6ac21695ec30bb$export$42ca7b248c7aaee);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $4R6GH = parcelRequire("4R6GH");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $dIdda = parcelRequire("dIdda");

var $7nt8t = parcelRequire("7nt8t");
const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $5f6ac21695ec30bb$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $x9xyg.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // We either have a sync query or an async one from loadParameters. Never neither
    // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const query = parameters ?? await loadParameters?.();
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables || {}, options));
    if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
    if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $x9xyg.setMark)(endMark);
        (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $7nt8t.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $5f6ac21695ec30bb$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $x9xyg.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $x9xyg.setMark)(endMark);
            (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $7nt8t.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $x9xyg.setMark)(endMark);
        (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $7nt8t.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $dIdda.createResource)({
        type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            if ((0, $4R6GH.fg)('blu-3813-improve-ssr-hydration-of-relay')) return $5f6ac21695ec30bb$var$getDataNew({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
            return $5f6ac21695ec30bb$var$getDataOld({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                loadParameters: loadParameters,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $dIdda.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("2OeZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $70949048397986dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ab0d176e93fd3713f0a33c8824a9cc0>>
 * @relayHash 711189c661e6ba22952d3dead09a873f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ce115dfac7d411aad701a1ec8193e1e1bd0fc461e5adf846cb87cdcf6ac7978
const $70949048397986dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDashboardsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "label"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "order": "DESC"
    }, v16 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v17 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v21 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v22 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v23 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v24 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v11 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        v19 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "typeKey"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "navigationMetadata",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "boardId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSimpleBoard"
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "JiraSoftwareProjectNavigationMetadata"
                                }
                            ]
                        },
                        {
                            "alias": "editProjectConfig",
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v22 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webUrl"
                        },
                        {
                            "alias": "canEditProjectConfig",
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v22 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "alias": "canViewProjectConfig",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "VIEW_PROJECT_CONFIG"
                                }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v22 /*: any*/ ,
                            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                        },
                        v23 /*: any*/ ,
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v22 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        }
                    ],
                    "type": "JiraProject"
                },
                v20 /*: any*/ 
            ]
        }
    ], v25 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v26 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v8 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v8 /*: any*/ 
        ]
    }, v31 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v11 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v29 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v30 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v20 /*: any*/ 
            ]
        }
    ], v32 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v11 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        v29 /*: any*/ ,
                        v30 /*: any*/ 
                    ],
                    "type": "JiraDashboard"
                },
                v20 /*: any*/ 
            ]
        }
    ], v33 = [
        v8 /*: any*/ ,
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v14 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v15 /*: any*/ ,
                                                "type": "PROJECT"
                                            }
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v24 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentProjects",
                                    "args": [
                                        v9 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PROJECT"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v24 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v15 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v9 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v15 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v9 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isDashboardsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "dashboardFavourites",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v15 /*: any*/ ,
                                                "type": "DASHBOARD"
                                            }
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "dashboardRecents",
                                    "args": [
                                        v9 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "DASHBOARD"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "theme"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0ce115dfac7d411aad701a1ec8193e1e1bd0fc461e5adf846cb87cdcf6ac7978",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70949048397986dd$var$node.hash = "3924b1f11b61ac6cf33dddcea40b965b";
var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;

});


parcelRegister("acDan", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b5a3a4467dac2130$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b5a3a4467dac2130$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b5a3a4467dac2130$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b5a3a4467dac2130$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b5a3a4467dac2130$export$ddb17534fdfb7dc6);

var $5uXOq = parcelRequire("5uXOq");

var $azzrO = parcelRequire("azzrO");

var $5e7oM = parcelRequire("5e7oM");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4QcD9 = parcelRequire("4QcD9");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $6IzHB = parcelRequire("6IzHB");

var $dIdda = parcelRequire("dIdda");

var $kvHKs = parcelRequire("kvHKs");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, $4QcD9.createValueController)('sidebar-id');
const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $dIdda.useRouter)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $5uXOq.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $5uXOq.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE)
    });
    return (0, $5uXOq.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("93jKl", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $e2626e1ab0692489$export$606da7704d8eaf06);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $65nWi = parcelRequire("65nWi");

var $l9g16 = parcelRequire("l9g16");
const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $65nWi.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $fZneA.isClientFetchError)(error)) return;
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("l9g16", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $79f23c22d88dd8d5$export$be8ec22ac9208049);

var $5uXOq = parcelRequire("5uXOq");

var $kh3Cl = parcelRequire("kh3Cl");
const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $kh3Cl.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("kaHBi", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $e1187df33c58b997$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $e1187df33c58b997$export$f20b867e738a222c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $l9g16 = parcelRequire("l9g16");
const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $5uXOq.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $5uXOq.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $e1187df33c58b997$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $5uXOq.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});

parcelRegister("3bQtK", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $f46ca4b214d7cdb6$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $l9g16 = parcelRequire("l9g16");
const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const self = (0, $5uXOq.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};
const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("4QcD9", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $3f293f209341d999$export$ff0ab9dd4ceb4a93);

var $7JoAD = parcelRequire("7JoAD");
const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $7JoAD.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $7JoAD.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $7JoAD.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("6IzHB", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $57184c749af08735$export$3434ba5eadb360dc);

var $7JoAD = parcelRequire("7JoAD");

var $7w9eZ = parcelRequire("7w9eZ");
const $57184c749af08735$var$useSweetStatePageId = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage.uuid
});
const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $57184c749af08735$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("kvHKs", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $f1419662a60c783a$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $f1419662a60c783a$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $f1419662a60c783a$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $f1419662a60c783a$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $f1419662a60c783a$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $f1419662a60c783a$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $f1419662a60c783a$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $f1419662a60c783a$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $f1419662a60c783a$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $f1419662a60c783a$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $f1419662a60c783a$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $f1419662a60c783a$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $f1419662a60c783a$export$f57650e6e7be03dc);
const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
const $f1419662a60c783a$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $f1419662a60c783a$export$83016cff6318a5dd = Object.freeze({
    CODE_TAB: 'CODE_TAB',
    ONCALL_TAB: 'ONCALL_TAB',
    PAGES_TAB: 'PAGES_TAB'
});
const $f1419662a60c783a$export$f371b4c263b142af = {
    [$f1419662a60c783a$export$83016cff6318a5dd.CODE_TAB]: 'code',
    [$f1419662a60c783a$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
    [$f1419662a60c783a$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
};
const $f1419662a60c783a$export$b66c40cadee12a0b = 'project/agility/index';
const $f1419662a60c783a$export$6f454e69bce3a691 = 'project/business/index';
const $f1419662a60c783a$export$3a0f7f7a8a0b306b = 'project/ops/index';
const $f1419662a60c783a$export$1346c9aa3cbb477d = 'project/software/index';
const $f1419662a60c783a$export$4598dd67943205cf = 'project/software/issues';
const $f1419662a60c783a$export$8f36e85c5afae5 = 'project/software/reports';
const $f1419662a60c783a$export$8151e5564c0016a1 = 'attachments';
const $f1419662a60c783a$export$4acd0d06a25e56b5 = 'eventtypes';
const $f1419662a60c783a$export$211ab01804585e09 = 'webhooks-admin';
const $f1419662a60c783a$export$294b9ab8545a9f36 = 'services';
const $f1419662a60c783a$export$665efe695022359b = 'greenhopper-lexorank-manage';
const $f1419662a60c783a$export$47fbefc73055eb9d = 'admin-helper-admin-section';
const $f1419662a60c783a$export$76e6bd729450de52 = 'advanced_section';
const $f1419662a60c783a$export$ac928a90c0d3daa8 = 'collectors';
const $f1419662a60c783a$export$309ac0136b7d5dfa = 'dark_features';
const $f1419662a60c783a$export$998f1706a6ca29b = 'general_configuration';
const $f1419662a60c783a$export$e9af81a594543847 = 'import_export_section';
const $f1419662a60c783a$export$bbf19cc23216c6b = 'mail_section';
const $f1419662a60c783a$export$693dd06b18660b78 = 'security_section';
const $f1419662a60c783a$export$c6d1221ea0bce75e = 'shared_section';
const $f1419662a60c783a$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
const $f1419662a60c783a$export$af156d8e27fc5458 = 'user_interface';
const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $f1419662a60c783a$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
];

});


parcelRegister("c6x3L", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $313dc1bbe6a8339e$export$dc46c14934833db2);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $7Ckoi = parcelRequire("7Ckoi");
const $313dc1bbe6a8339e$var$SidebarNav4Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $dIdda.useRouter)();
    const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $5uXOq.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $7Ckoi.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $fMcVX.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $fMcVX.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $313dc1bbe6a8339e$export$dc46c14934833db2() {
    const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("jHUgj", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $727f611db6c21522$export$7937e2d32a777fcb);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $65Ltd = parcelRequire("65Ltd");

var $8J6rn = parcelRequire("8J6rn");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");




var $3F9p6 = parcelRequire("3F9p6");

var $jKa0E = parcelRequire("jKa0E");

var $3ed52 = parcelRequire("3ed52");

var $dOB7H = parcelRequire("dOB7H");

var $dEbXe = parcelRequire("dEbXe");

var $Tdcaw = parcelRequire("Tdcaw");

var $fbami = parcelRequire("fbami");

var $bCaZu = parcelRequire("bCaZu");

var $gYSoA = parcelRequire("gYSoA");

var $ieEgo = parcelRequire("ieEgo");

var $kNJsg = parcelRequire("kNJsg");

var $aWnEG = parcelRequire("aWnEG");

var $2KXa8 = parcelRequire("2KXa8");

var $hrRcW = parcelRequire("hrRcW");

var $lF3VU = parcelRequire("lF3VU");

var $bJJms = parcelRequire("bJJms");

var $6ZLHo = parcelRequire("6ZLHo");

var $7VBev = parcelRequire("7VBev");

var $YiTdm = parcelRequire("YiTdm");

var $kqEpF = parcelRequire("kqEpF");

var $1G9rm = parcelRequire("1G9rm");

var $drQWa = parcelRequire("drQWa");

var $2DtJE = parcelRequire("2DtJE");

var $cnyf1 = parcelRequire("cnyf1");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $dIdda = parcelRequire("dIdda");
const $727f611db6c21522$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null);
    if (project?.projectType === (0, $2vSU6.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZLHo.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJJms.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnyf1.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DtJE.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQWa.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1G9rm.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqEpF.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQWa.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1G9rm.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (error) throw error;
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project"
    }, sidebar);
};
const $727f611db6c21522$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOB7H.default), null));
};
const $727f611db6c21522$var$REDIRECT_ROUTES_NAMES = new Set([
    (0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_REDIRECT)
]);
const $727f611db6c21522$var$InternalSidebarSelector = ()=>{
    const [{ match: { params: params }, route: route, location: location, query: query }] = (0, $dIdda.useRouter)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jKa0E.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $Tdcaw.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $kNJsg.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    switch(route.navigation?.sidebarId){
        case (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lF3VU.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!location.pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
            break;
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ieEgo.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCaZu.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, $4R6GH.fg)('fix_chatops_new_nav_bug')) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYSoA.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
        case (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrRcW.default), null);
        case (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KXa8.default), null);
        case (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
        default:
            break;
    }
    // Project settings sidebars
    if (route.name === (0, $65Ltd.ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$ProjectSettingsSidebarSelector, null);
    // Board settings sidebar
    if (route.group === (0, $65Ltd.ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, $co1wz.ff)('simplified-boards-milestone-2_07hbk')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$BoardSettingsSidebar, null);
    // Global settings sidebars
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
    // don't render the sidebar if on a redirect route (i.e. /browse/:projectKey).
    if ($727f611db6c21522$var$REDIRECT_ROUTES_NAMES.has(route.name) && (0, $4R6GH.fg)('jira_nav4_eap_drop_2')) return null;
    // the route to navigate back to will be whichever route was last displayed
    // with the default sidebar on
    saveCurrentRoute();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ed52.default), null);
};
const $727f611db6c21522$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKa0E.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($727f611db6c21522$var$InternalSidebarSelector, null)));
};

});
parcelRegister("lmyls", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $ee51d260cb059727$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $ee51d260cb059727$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $ee51d260cb059727$export$adf978edbdfaf080);
const $ee51d260cb059727$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $ee51d260cb059727$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $ee51d260cb059727$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS'
};

});

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';

parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $7qZOo = parcelRequire("7qZOo");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMVPExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});
parcelRegister("9glig", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");
/** Error message constants. */ var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $6be62026d39b34ea$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
    pairs = !length ? [] : $1nIHN(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $g7i7g(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
        }
    });
}
module.exports = $6be62026d39b34ea$var$cond;

});

parcelRegister("hMlwW", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $cf179ed6624748c2$var$stubTrue() {
    return true;
}
module.exports = $cf179ed6624748c2$var$stubTrue;

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1MhR0 = parcelRequire("1MhR0");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1MhR0.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1MhR0 = parcelRequire("1MhR0");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1MhR0.getIsNav4UserOptOut)()
    });

});


parcelRegister("jKa0E", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $e131d9d1fc634955$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $e131d9d1fc634955$export$e1e76f4ee7f8174d);

var $5uXOq = parcelRequire("5uXOq");

var $kbked = parcelRequire("kbked");

var $dIdda = parcelRequire("dIdda");

var $bOr6i = parcelRequire("bOr6i");
const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
const $e131d9d1fc634955$var$NavigateBackContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
const $e131d9d1fc634955$export$e1e76f4ee7f8174d = ({ children: children })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, $bOr6i.storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY));
    const saveCurrentRoute = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        setPreviousUrl(url);
        (0, $bOr6i.storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, url);
    }, []);
    const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? (0, $kbked.jiraHomeRoute).path), [
        previousUrl,
        push
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            goBack: goBack
        }), [
        saveCurrentRoute,
        goBack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
        value: value
    }, children);
};

});
parcelRegister("kbked", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $aa927057995152d9$export$11ebbd6d4e57759c);

var $65Ltd = parcelRequire("65Ltd");
const $aa927057995152d9$export$11ebbd6d4e57759c = {
    group: (0, $65Ltd.ROUTE_GROUPS_HOME),
    name: (0, $65Ltd.ROUTE_NAMES_YOUR_WORK),
    path: '/jira/your-work'
};

});

parcelRegister("bOr6i", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $36fbcced1b17c587$export$ce7751641b93537d);

var $eNf8a = parcelRequire("eNf8a");
const $36fbcced1b17c587$export$ce7751641b93537d = (0, $eNf8a.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("3ed52", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2e015ea5d0812b1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $a2e015ea5d0812b1$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("iSW4Y")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
});
const $a2e015ea5d0812b1$var$AsyncSidebarContent = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "asyncSidebarContent",
        packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazySidebarContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2e015ea5d0812b1$var$LazySidebarContent, null))));
$a2e015ea5d0812b1$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
var // Used in jira/src/packages/page-container-v2/src/common/ui/sidebar
$a2e015ea5d0812b1$export$2e2bcd8739ae039 = $a2e015ea5d0812b1$var$AsyncSidebarContent;

});
parcelRegister("cljJ9", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $f6d5489447b9aa6b$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $cfDZ3 = parcelRequire("cfDZ3");

var $cKjfv = parcelRequire("cKjfv");

var $6Jt8x = parcelRequire("6Jt8x");
const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
    const { experience: experience, attributes: attributes } = (0, $cKjfv.useSidebarExperience)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Jt8x.Fallback), {
            error: error
        }), []);
    const handleError = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarStart), null), children);
};

});
parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("cKjfv", function(module, exports) {

$parcel$export(module.exports, "useSidebarExperience", () => $c4243e40cbbf3b86$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $c4243e40cbbf3b86$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $c4243e40cbbf3b86$export$a06ecbbe5820282);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $6IzHB = parcelRequire("6IzHB");

var $9eD1s = parcelRequire("9eD1s");
const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $6IzHB.usePageId)();
    return (0, $5uXOq.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $5uXOq.useEffect)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eD1s.default), {
        data: customData
    });
};

});
parcelRegister("9eD1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef9bd6ca92ade3b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $4ef9bd6ca92ade3b$export$d12f56a472cdbe6c);

var $5uXOq = parcelRequire("5uXOq");

var $7sZUk = parcelRequire("7sZUk");

var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");
function $4ef9bd6ca92ade3b$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $7sZUk.default));
    (0, $5uXOq.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $4ef9bd6ca92ade3b$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $99lTN.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $hhGDe.addCustomData)(currentInteractionId, [], data);
}

});


parcelRegister("6Jt8x", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8pO1a = parcelRequire("8pO1a");

var $e65Lk = parcelRequire("e65Lk");
var $dPXOV = parcelRequire("dPXOV");
var $2zROn = parcelRequire("2zROn");

var $kobfu = parcelRequire("kobfu");

var $7q5TP = parcelRequire("7q5TP");

var $koVbs = parcelRequire("koVbs");

var $5Ntjt = parcelRequire("5Ntjt");
const $d1b1aff7b337b0d4$var$styles = {
    wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
    error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7q5TP.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pO1a.default), {
        size: "xsmall"
    }, formatMessage((0, $5Ntjt.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zROn.default), null, formatMessage((0, $5Ntjt.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.error
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("7q5TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8d7b09135bd30b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8ODZY")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("b2nX8")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $dCLgq = parcelRequire("dCLgq");

var $b2nX8 = parcelRequire("b2nX8");

var $8ODZY = parcelRequire("8ODZY");
const $dc8d7b09135bd30b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8ODZY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($b2nX8))
});
var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
// for advanced use only
const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5gBas = parcelRequire("5gBas");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $5gBas.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("b2nX8", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("8ODZY", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("5Ntjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef9823ba7f6e404$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $7VHMR = parcelRequire("7VHMR");
var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("iSW4Y", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");


module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3cwJf")),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("c5OxX")
]).then(()=>parcelRequire('gyZtn'));

});


parcelRegister("dOB7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $358df587d3e80a76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

var $dEbXe = parcelRequire("dEbXe");

const $358df587d3e80a76$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("8AK0s")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $358df587d3e80a76$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
var $358df587d3e80a76$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);

});
parcelRegister("dEbXe", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $01SST = parcelRequire("01SST");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    })));
const $ff13cb96c7f2cede$var$containerStyles = (0, $ii5wQ.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $ff13cb96c7f2cede$var$backButton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $ff13cb96c7f2cede$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $ff13cb96c7f2cede$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("8AK0s", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("gS3ma")
]).then(()=>parcelRequire('gNcDN'));

});


parcelRegister("Tdcaw", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $a54a68c44d0262b5$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $a54a68c44d0262b5$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $a54a68c44d0262b5$export$83008eebb9fccef3);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $dIdda = parcelRequire("dIdda");
const $a54a68c44d0262b5$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $hz6Yb.useConnectGeneralResource)();
    return {
        isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("8maDO", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $c4af9df81f308e02$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
        const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);

var $65Ltd = parcelRequire("65Ltd");
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
    (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    (0, $65Ltd.ROUTE_NAMES_CONNECT_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $65Ltd.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    (0, $65Ltd.ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
]);

});


parcelRegister("hWBtO", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $90a1a565c575dc5b$export$8054dcb2b42da45c);

var $9KzPc = parcelRequire("9KzPc");
const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $9KzPc.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $9KzPc.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $9KzPc.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("9KzPc", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $f13744297e4a8bc9$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $f13744297e4a8bc9$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $f13744297e4a8bc9$export$b1c2c1fc5d10280);

var $16J3A = parcelRequire("16J3A");
const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
    $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
    (0, $16J3A.REPORTS_IDS).REPORTS_ADDONS,
    $f13744297e4a8bc9$var$jsdQueuesConnectSection
];

});


parcelRegister("efOLn", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $179f73798c754e8b$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $179f73798c754e8b$export$27267b6b6650eaa5);
const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("bYoAQ", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $37852a2b10dca6fc$export$1e1c317ed5b99faa);

var $atU1t = parcelRequire("atU1t");

var $dIdda = parcelRequire("dIdda");
const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});
parcelRegister("atU1t", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $587727b78e9bd173$export$44e7ad3c66a3f25f);

var $3NIpU = parcelRequire("3NIpU");

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $dIdda.createResource)({
    type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $3NIpU.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("3NIpU", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $8ba40d865239bafe$export$d1d13c4b972a22f1);

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");
const $8ba40d865239bafe$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $8ba40d865239bafe$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("aOyKS"));
        if (!fetchProtobuf) (0, $dJl1T.default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $8ba40d865239bafe$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $8ba40d865239bafe$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $8ba40d865239bafe$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $7f4tk.default)(sidebarUrl);
};

});
parcelRegister("aOyKS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7erVk").then(()=>parcelRequire('g4I8Z'));

});


const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';



parcelRegister("hz6Yb", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $07e636c36bc19b52$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $07e636c36bc19b52$export$53479840ec6d4024);

var $dIdda = parcelRequire("dIdda");


const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $dIdda.createResource)({
    type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("bBygl"))
});
const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $dIdda.useResource)($07e636c36bc19b52$export$f34ab0d904621847);

});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("bBygl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("W2aDd").then(()=>parcelRequire('6LiLg'));

});



parcelRegister("fbami", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82a04fb3eb62635$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $f82a04fb3eb62635$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("ajhZM")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $f82a04fb3eb62635$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
var $f82a04fb3eb62635$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);

});
parcelRegister("cnlm7", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);

var $5uXOq = parcelRequire("5uXOq");

var $8pO1a = parcelRequire("8pO1a");

var $e65Lk = parcelRequire("e65Lk");
var $48zIy = parcelRequire("48zIy");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");

var $koVbs = parcelRequire("koVbs");

var $iI75Y = parcelRequire("iI75Y");

var $iGYW6 = parcelRequire("iGYW6");

var $9GB5z = parcelRequire("9GB5z");

var $jDuwy = parcelRequire("jDuwy");
const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.200",
        xcss: $eb45bd1b3d8207f6$var$settingsHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48zIy.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iI75Y.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pO1a.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $jDuwy.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9GB5z.AsyncPageSwitcher), {
        currentPageName: currentPageName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $eb45bd1b3d8207f6$var$contentStyles,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGYW6.MenuList), null, children)));
};
const $eb45bd1b3d8207f6$var$settingsHeading = (0, $ii5wQ.xcss)({
    position: 'sticky',
    top: 'space.0',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.100',
    backgroundColor: 'elevation.surface',
    // @ts-expect-error this is ridiculous I don't want a z-index of 100
    zIndex: 1
});
const $eb45bd1b3d8207f6$var$contentStyles = (0, $ii5wQ.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.200',
    paddingInline: 'space.200'
});

});
parcelRegister("iI75Y", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => $8c6efbfad9d4699a$export$e0d897ee21382f67);

var $5uXOq = parcelRequire("5uXOq");

var $1Cygm = parcelRequire("1Cygm");

var $aGUgk = parcelRequire("aGUgk");

var $9fYN9 = parcelRequire("9fYN9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $jKa0E = parcelRequire("jKa0E");

var $dJXtD = parcelRequire("dJXtD");
const $8c6efbfad9d4699a$export$e0d897ee21382f67 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { goBack: goBack } = (0, $jKa0E.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fYN9.default), {
        content: formatMessage((0, $dJXtD.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Cygm.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aGUgk))),
        label: formatMessage((0, $dJXtD.default).label),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
            goBack();
        }
    }));
};

});
parcelRegister("aGUgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c897826f4df3586$var$_react = $7c897826f4df3586$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c897826f4df3586$var$_UNSAFE_baseNew = $7c897826f4df3586$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7c897826f4df3586$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c897826f4df3586$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $7c897826f4df3586$var$_react.default.createElement($7c897826f4df3586$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$7c897826f4df3586$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $7c897826f4df3586$var$_default = module.exports.default = $7c897826f4df3586$var$ArrowLeftIcon;

});

parcelRegister("dJXtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b400b92991a2960$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("iGYW6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $b037593257217cdf$export$d4c4e98c5044dc8);

var $h6z7n = parcelRequire("h6z7n");
const $b037593257217cdf$export$d4c4e98c5044dc8 = (0, $h6z7n.List);

});
parcelRegister("h6z7n", function(module, exports) {

$parcel$export(module.exports, "List", () => $9b0d8b9797d19f27$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jE7nX = parcelRequire("jE7nX");
function $9b0d8b9797d19f27$var$_List({ children: children, xcss: xcss }, forwardedRef) {
    const internalRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    const ref = (0, $jE7nX.default)([
        internalRef,
        forwardedRef
    ]);
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "list",
        ref: ref,
        className: xcss
    }, children));
}
const $9b0d8b9797d19f27$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($9b0d8b9797d19f27$var$_List);
/**
 * Returns true if the child is either:
 * - a list item
 * - one or more list items wrapped only in presentational elements
 */ function $9b0d8b9797d19f27$var$isValidChild(element) {
    /**
   * These elements are ignored by screen readers.
   */ if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') return true;
    /**
   * Recursive case:
   * If this is a presentational element (no semantics) then it is valid
   * if all of its children are valid.
   *
   * This check is currently much stricter than it needs to be
   * (only allowing `div` and not allowing an explicit role).
   *
   * We can make it looser in the future if necessary.
   */ if (element.tagName === 'DIV' && element.getAttribute('role') === null) return Array.from(element.children).every($9b0d8b9797d19f27$var$isValidChild);
    return element.getAttribute('role') === 'listitem';
}

});


parcelRegister("9GB5z", function(module, exports) {

$parcel$export(module.exports, "AsyncPageSwitcher", () => $8f72ed6ff9af1bd8$export$3130bd98029942c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");
const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
    }));

const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("iPVb9")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("iPVb9", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("6XfVR")
]).then(()=>parcelRequire('8dyHT'));

});


parcelRegister("jDuwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdc401436033e3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("i8077", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }));
const $8a8cf6e18096ea33$var$sectionHeading = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $8a8cf6e18096ea33$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("ajhZM", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4HmNO")
]).then(()=>parcelRequire('6JIAx'));

});


parcelRegister("bCaZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b39e5bf0fb90a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("gxGwA")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);

});
parcelRegister("gxGwA", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hEv4j")
]).then(()=>parcelRequire('fUdDx'));

});


parcelRegister("gYSoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $425ce2b571ab3ef5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $425ce2b571ab3ef5$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("f6lak")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "products"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);

});
parcelRegister("f6lak", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("eOt8B")
]).then(()=>parcelRequire('864s3'));

});


parcelRegister("ieEgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bb6161ed4902f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $b88bb6161ed4902f$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("jLd8z")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $b88bb6161ed4902f$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
var $b88bb6161ed4902f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);

});
parcelRegister("jLd8z", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("7bkDd")
]).then(()=>parcelRequire('fbdwm'));

});


parcelRegister("kNJsg", function(module, exports) {

$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $90305fd4b8d90c67$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $90305fd4b8d90c67$export$5efb701a2106707a);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $fgeiD = parcelRequire("fgeiD");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $dIdda = parcelRequire("dIdda");
const $90305fd4b8d90c67$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $90305fd4b8d90c67$export$68950d4e14439158 = (0, $fgeiD.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $hz6Yb.useConnectGeneralResource)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("fgeiD", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f9ce174aaa2e063b$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("aWnEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $59776b430a24875d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $59776b430a24875d$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("gsY8o")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $59776b430a24875d$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "system"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
var $59776b430a24875d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);

});
parcelRegister("gsY8o", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("9yM86")
]).then(()=>parcelRequire('rQUQs'));

});


parcelRegister("2KXa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d93ac4546abf11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $eri9L = parcelRequire("eri9L");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

var $aUxXz = parcelRequire("aUxXz");

const $b5d93ac4546abf11$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("68Ad0")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $b5d93ac4546abf11$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eri9L.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUxXz.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null))));
var $b5d93ac4546abf11$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);

});
parcelRegister("eri9L", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $4db4e46cf49a33db$export$f39f3f768bc98e3d);

var $5uXOq = parcelRequire("5uXOq");

var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $4db4e46cf49a33db$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.200",
        xcss: $4db4e46cf49a33db$var$containerStyles
    }, children);
const $4db4e46cf49a33db$var$containerStyles = (0, $ii5wQ.xcss)({
    height: '100%',
    padding: 'space.200'
});

});

parcelRegister("aUxXz", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c42d7c14b1508227$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $01SST = parcelRequire("01SST");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    })));
const $c42d7c14b1508227$var$backButton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $c42d7c14b1508227$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("68Ad0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("jvUDk")
]).then(()=>parcelRequire('22iKv'));

});


parcelRegister("hrRcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7cdaae12475462$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

var $jUfLV = parcelRequire("jUfLV");

const $8e7cdaae12475462$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("kgoik")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
});
const $8e7cdaae12475462$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUfLV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
var $8e7cdaae12475462$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);

});
parcelRegister("jUfLV", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $01SST = parcelRequire("01SST");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $1cdf070fb698d8d2$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $1cdf070fb698d8d2$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $1cdf070fb698d8d2$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    })));
const $1cdf070fb698d8d2$var$containerStyles = (0, $ii5wQ.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $1cdf070fb698d8d2$var$backButton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $1cdf070fb698d8d2$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $1cdf070fb698d8d2$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("kgoik", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("6lHZh")
]).then(()=>parcelRequire('hox2O'));

});


parcelRegister("lF3VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $442721cda4044790$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eri9L = parcelRequire("eri9L");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

var $bhcrK = parcelRequire("bhcrK");

const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("8Vrou")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
});
const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eri9L.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhcrK.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
        store: store
    })));
var $442721cda4044790$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);

});
parcelRegister("bhcrK", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $d204c752b5086975$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $01SST = parcelRequire("01SST");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $d204c752b5086975$var$menuItem
    })));
const $d204c752b5086975$var$titleSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$backButton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $d204c752b5086975$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$subtitleItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("8Vrou", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("b8Lgd")
]).then(()=>parcelRequire('7UsxD'));

});


parcelRegister("bJJms", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce9becc602ac5ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $cce9becc602ac5ad$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("h9v0v")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
});
const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
        project: project
    })));
var $cce9becc602ac5ad$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);

});
parcelRegister("7VBev", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $af3b5ba721400353$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $01SST = parcelRequire("01SST");
var $dAbZI = parcelRequire("dAbZI");
var $dPXOV = parcelRequire("dPXOV");
var $ii5wQ = parcelRequire("ii5wQ");
const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.200",
        xcss: $af3b5ba721400353$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01SST.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAbZI.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $af3b5ba721400353$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPXOV.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $af3b5ba721400353$var$menuItem
    })));
const $af3b5ba721400353$var$containerStyles = (0, $ii5wQ.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $af3b5ba721400353$var$backButton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$headingSkeleton = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $af3b5ba721400353$var$projectHeading = (0, $ii5wQ.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $af3b5ba721400353$var$projectAvatar = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectName = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectType = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$menuItem = (0, $ii5wQ.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("h9v0v", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("f7rnD")
]).then(()=>parcelRequire('kaECc'));

});


parcelRegister("6ZLHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b222bb97daacff3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $b222bb97daacff3e$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("hqP7F")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
});
const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
        project: project
    })));
var $b222bb97daacff3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);

});
parcelRegister("hqP7F", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("l1ol4")
]).then(()=>parcelRequire('v17He'));

});


parcelRegister("YiTdm", function(module, exports) {

$parcel$export(module.exports, "useIsConnectAppActive", () => $c92d349d32b0fe9a$export$249b2e8512031cae);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $dIdda = parcelRequire("dIdda");

var $eNZur = parcelRequire("eNZur");
const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: connectApps, error: error, loading: loading } = (0, $eNZur.useConnectApps)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, $8maDO.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eNZur", function(module, exports) {

$parcel$export(module.exports, "useConnectApps", () => $5ce3bcf534d9d0ea$export$4864478dcab77643);

var $5uXOq = parcelRequire("5uXOq");

var $loy04 = parcelRequire("loy04");

var $efOLn = parcelRequire("efOLn");

var $9MFH3 = parcelRequire("9MFH3");
const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $loy04.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $5uXOq.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $efOLn.transformLinkV4)(item);
            if (transformedItem && !(0, $9MFH3.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("9MFH3", function(module, exports) {

$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $b25e3cd9691dd3ed$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
]);

});



parcelRegister("kqEpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c80e831fc4dee6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $c2c80e831fc4dee6$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("1eKvX")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
});
const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
        project: project
    })));
var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);

});
parcelRegister("1eKvX", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("9Dnuj")
]).then(()=>parcelRequire('aDwWR'));

});


parcelRegister("1G9rm", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $5b1e7bac8593a90d$export$2ce6ad449436c545);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $5b1e7bac8593a90d$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("jZAtN")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
});
const $5b1e7bac8593a90d$var$analyticsAttributes = {
    navVersion: '4',
    projectType: 'cmp'
};
const $5b1e7bac8593a90d$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $5b1e7bac8593a90d$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("84dyl", function(module, exports) {

$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $8fdaf51231934b8c$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $8fdaf51231934b8c$export$8092325c2fa271de);
const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: 'fixedItem',
    level: 1
};
const $8fdaf51231934b8c$export$8092325c2fa271de = {
    ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: 'projectSettingsNavigationMenuItem'
};

});

parcelRegister("jZAtN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("k1zH8")
]).then(()=>parcelRequire('58Da3'));

});


parcelRegister("drQWa", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $723c8db5701ca405$export$dadf0f8c840cb26d);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $723c8db5701ca405$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("2enEN")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
});
const $723c8db5701ca405$var$analyticsAttributes = {
    navVersion: '4',
    projectType: 'tmp'
};
const $723c8db5701ca405$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $723c8db5701ca405$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("2enEN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("2ALx4")
]).then(()=>parcelRequire('dJT47'));

});


parcelRegister("2DtJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd62495e40b7984d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $fd62495e40b7984d$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("218yI")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
});
const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
        project: project
    })));
var $fd62495e40b7984d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);

});
parcelRegister("218yI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("iNMXx")
]).then(()=>parcelRequire('cLlaG'));

});


parcelRegister("cnyf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $713dabe47adbee45$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

const $713dabe47adbee45$var$LazySidebarContent = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("ihu1m")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
});
const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
        project: project
    })));
var $713dabe47adbee45$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);

});
parcelRegister("ihu1m", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("cxRoY")
]).then(()=>parcelRequire('4yoHz'));

});



parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $9wGSO = parcelRequire("9wGSO");

var $jb3mD = parcelRequire("jb3mD");

var $jJXCs = parcelRequire("jJXCs");

var $PWXuv = parcelRequire("PWXuv");

var $fa67x = parcelRequire("fa67x");

var $7ZTLj = parcelRequire("7ZTLj");

var $9I7MX = parcelRequire("9I7MX");

var $6ydmx = parcelRequire("6ydmx");

var $1RuMY = parcelRequire("1RuMY");

var $10vfQ = parcelRequire("10vfQ");

var $1eDun = parcelRequire("1eDun");

var $4F7i4 = parcelRequire("4F7i4");

var $bka90 = parcelRequire("bka90");

var $jhS4y = parcelRequire("jhS4y");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9wGSO)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6ydmx)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZTLj)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($10vfQ)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1RuMY)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fa67x)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($PWXuv)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9I7MX)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1eDun)))
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb3mD)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bka90)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jJXCs)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4F7i4)))
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("jb3mD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44aca55c74a9b184f2a5b64fe5be98d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df61a769a793d86e$var$_react = $df61a769a793d86e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $df61a769a793d86e$var$_UNSAFE_baseNew = $df61a769a793d86e$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $df61a769a793d86e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df61a769a793d86e$var$AssetsIcon = (props)=>/*#__PURE__*/ $df61a769a793d86e$var$_react.default.createElement($df61a769a793d86e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.59 6.409a2.25 2.25 0 0 1 0 3.182m0-3.182a2.25 2.25 0 0 0-3.181 0m3.182 0 2.598-2.598M9.591 9.59a2.25 2.25 0 0 1-3.182 0m3.182 0 2.598 2.598M6.41 9.591a2.25 2.25 0 0 1 0-3.182m0 3.182-2.6 2.598m2.598-5.78L3.81 3.811m8.378 0a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Zm0 8.378a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122ZM3.811 3.811a1.5 1.5 0 1 0-2.122-2.122 1.5 1.5 0 0 0 2.122 2.122Zm0 8.378a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122Z"/>`
    }, props));
$df61a769a793d86e$var$AssetsIcon.displayName = 'AssetsIcon';
var $df61a769a793d86e$var$_default = module.exports.default = $df61a769a793d86e$var$AssetsIcon;

});

parcelRegister("7ZTLj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dbfb80dd8b5d8923ab37cee015ffdd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d297c1d62b1c22a$var$_react = $5d297c1d62b1c22a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d297c1d62b1c22a$var$_UNSAFE_baseNew = $5d297c1d62b1c22a$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $5d297c1d62b1c22a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d297c1d62b1c22a$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $5d297c1d62b1c22a$var$_react.default.createElement($5d297c1d62b1c22a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 14.25a1 1 0 0 1-1-1V3c0-.69.56-1.25 1.25-1.25h3.25L7 3.5h5c.69 0 1.25.56 1.25 1.25v2m-11.5 7.5 2.116-7.055a.625.625 0 0 1 .599-.445h8.785m-11.5 7.5h10.57a1.25 1.25 0 0 0 1.197-.89l1.742-5.805a.625.625 0 0 0-.599-.805h-1.41"/>`
    }, props));
$5d297c1d62b1c22a$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $5d297c1d62b1c22a$var$_default = module.exports.default = $5d297c1d62b1c22a$var$FolderOpenIcon;

});

parcelRegister("9I7MX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ad89a50f2d6c4ddd31d869ae54509dc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $711e43c5b1344d81$var$_react = $711e43c5b1344d81$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $711e43c5b1344d81$var$_UNSAFE_baseNew = $711e43c5b1344d81$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $711e43c5b1344d81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $711e43c5b1344d81$var$GlobeIcon = (props)=>/*#__PURE__*/ $711e43c5b1344d81$var$_react.default.createElement($711e43c5b1344d81$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
    }, props));
$711e43c5b1344d81$var$GlobeIcon.displayName = 'GlobeIcon';
var $711e43c5b1344d81$var$_default = module.exports.default = $711e43c5b1344d81$var$GlobeIcon;

});

parcelRegister("6ydmx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f76d8cc6226f5c4506902cfd524d6ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c50488f647808b9$var$_react = $4c50488f647808b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4c50488f647808b9$var$_UNSAFE_baseNew = $4c50488f647808b9$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $4c50488f647808b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c50488f647808b9$var$GoalIcon = (props)=>/*#__PURE__*/ $4c50488f647808b9$var$_react.default.createElement($4c50488f647808b9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
    }, props));
$4c50488f647808b9$var$GoalIcon.displayName = 'GoalIcon';
var $4c50488f647808b9$var$_default = module.exports.default = $4c50488f647808b9$var$GoalIcon;

});

parcelRegister("10vfQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf2cef03a1c42b52984c96f46580b3eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bbe090a3404a656$var$_react = $0bbe090a3404a656$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0bbe090a3404a656$var$_UNSAFE_baseNew = $0bbe090a3404a656$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $0bbe090a3404a656$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bbe090a3404a656$var$RoadmapIcon = (props)=>/*#__PURE__*/ $0bbe090a3404a656$var$_react.default.createElement($0bbe090a3404a656$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$0bbe090a3404a656$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $0bbe090a3404a656$var$_default = module.exports.default = $0bbe090a3404a656$var$RoadmapIcon;

});

parcelRegister("1eDun", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e63dc1773124ff24739f4bfd66f50f0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e65baf3572e2607$var$_react = $0e65baf3572e2607$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e65baf3572e2607$var$_UNSAFE_baseNew = $0e65baf3572e2607$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $0e65baf3572e2607$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e65baf3572e2607$var$ShieldIcon = (props)=>/*#__PURE__*/ $0e65baf3572e2607$var$_react.default.createElement($0e65baf3572e2607$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 4.5S10.75 3.5 8 .75C5.25 3.5 1.75 4.5 1.75 4.5 1.75 12.75 8 15.125 8 15.125S14.25 12.75 14.25 4.5Z"/>`
    }, props));
$0e65baf3572e2607$var$ShieldIcon.displayName = 'ShieldIcon';
var $0e65baf3572e2607$var$_default = module.exports.default = $0e65baf3572e2607$var$ShieldIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});

parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$export$f263c05bb04cefc9 = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$export$f263c05bb04cefc9
};

});


parcelRegister("eGkew", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $8451f19a8196b45e$export$6af584355cfb32c6);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $lGo7j = parcelRequire("lGo7j");

var $cin8p = parcelRequire("cin8p");

var $awp39 = parcelRequire("awp39");

var $b69Lc = parcelRequire("b69Lc");

var $dlYil = parcelRequire("dlYil");

var $jjzbO = parcelRequire("jjzbO");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $dmKXV = parcelRequire("dmKXV");

var $iFaFr = parcelRequire("iFaFr");

var $4IWRY = parcelRequire("4IWRY");

var $hBv66 = parcelRequire("hBv66");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $7AyKX = parcelRequire("7AyKX");

var $koWFd = parcelRequire("koWFd");

var $937TY = parcelRequire("937TY");

var $lgSL3 = parcelRequire("lgSL3");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");

var $hz6Yb = parcelRequire("hz6Yb");

var $dIdda = parcelRequire("dIdda");
const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IHt2.default), null);
    switch(project.type){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0bZU.default), null);
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lgSL3.default), null);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koWFd.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9s3j1.default), null);
        case 0, $2vSU6.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmKXV.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $8451f19a8196b45e$var$ProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $lpwtK.useProject)();
    const isInsightMenuSelected = (0, $jjzbO.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $jjzbO.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $gZbSF.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $hWtQt.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $jfqNX.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $dlYil.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $b69Lc.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $awp39.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $dIdda.useResource)((0, $hz6Yb.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $4IWRY.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7AyKX.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $937TY.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $937TY.default), null));
    if (sidebar === (0, $iFaFr.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFaFr.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $hBv66.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cin8p.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHiHz.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOg46.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("lGo7j", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $0c703bf4651638aa$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3UPSn = parcelRequire("3UPSn");
var $b9QsN = parcelRequire("b9QsN");

var $iziuT = parcelRequire("iziuT");
const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iziuT.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3UPSn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9QsN.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c703bf4651638aa$var$BackgroundedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tem _1yt4s5g3",
            __cmplp.className
        ])
    });
});
const $0c703bf4651638aa$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3UPSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bc0f70e9ef6bf9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cyZtb = parcelRequire("cyZtb");

var $jce0d = parcelRequire("jce0d");

var $kS2yi = parcelRequire("kS2yi");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $46bc0f70e9ef6bf9$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $kS2yi.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyZtb.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $jce0d.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $46bc0f70e9ef6bf9$export$2e2bcd8739ae039 = $46bc0f70e9ef6bf9$var$Section;

});
parcelRegister("jce0d", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $d7f5dc17c9fd3faa$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $d7f5dc17c9fd3faa$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $d7f5dc17c9fd3faa$export$a5c27bed78cfecb9);

const $d7f5dc17c9fd3faa$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $d7f5dc17c9fd3faa$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $dbda9f692ace54dd$export$226de0355ed012f8)})`
    }
};
const $d7f5dc17c9fd3faa$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $dbda9f692ace54dd$export$226de0355ed012f8)})`,
        color: `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`
    }
};
const $d7f5dc17c9fd3faa$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $d7f5dc17c9fd3faa$var$defaultStyles,
        ...!isDisabled && isSelected && $d7f5dc17c9fd3faa$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $d7f5dc17c9fd3faa$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});


parcelRegister("b9QsN", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8029048da0389$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1wrAu = parcelRequire("1wrAu");

var $jce0d = parcelRequire("jce0d");

var $kS2yi = parcelRequire("kS2yi");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $63b8029048da0389$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $kS2yi.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wrAu.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $jce0d.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $63b8029048da0389$export$2e2bcd8739ae039 = $63b8029048da0389$var$SkeletonItem;

});


parcelRegister("cin8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $760a63d3e4200cc2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("bxwfY")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $760a63d3e4200cc2$var$ConnectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
$760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;

});
parcelRegister("dZQxE", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $e39fc1e1d73100a0$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $azzrO = parcelRequire("azzrO");

var $5e7oM = parcelRequire("5e7oM");

var $lfTZh = parcelRequire("lfTZh");

var $5Hj3V = parcelRequire("5Hj3V");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");
const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $acDan.useSidebarFail)();
    const onSuccess = (0, $acDan.useSidebarSuccess)();
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("5Hj3V", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c3958cf153a091e2$export$62853c5766dad0c4);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $cfDZ3 = parcelRequire("cfDZ3");

var $kqzba = parcelRequire("kqzba");
const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqzba.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("kqzba", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $790c5d1c3d335eca$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8pO1a = parcelRequire("8pO1a");

var $kobfu = parcelRequire("kobfu");

var $koVbs = parcelRequire("koVbs");

var $evbHg = parcelRequire("evbHg");

var $h8OaL = parcelRequire("h8OaL");
const $790c5d1c3d335eca$var$styles = {
    wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($evbHg))),
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pO1a.default), {
        size: "xsmall"
    }, formatMessage((0, $h8OaL.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $h8OaL.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.error
        ])
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("evbHg", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("h8OaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c8a71ff5065c1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});




parcelRegister("gbGmI", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $46c186c6902de7dc$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $46c186c6902de7dc$export$edbd543f308bbef5);

var $azzrO = parcelRequire("azzrO");

var $5e7oM = parcelRequire("5e7oM");
const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("bxwfY", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("a8u2l")
]).then(()=>parcelRequire('caET0'));

});


parcelRegister("awp39", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $6ac80db07eab2a1e$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $6ac80db07eab2a1e$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $5W6pd.transformLink)).filter(Boolean));
const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("aUDLa", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $dbad5a19b82e4911$export$1e1c317ed5b99faa);

var $5uXOq = parcelRequire("5uXOq");

var $atU1t = parcelRequire("atU1t");

var $dIdda = parcelRequire("dIdda");
const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("4gymV", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $6dc7ee8ba2a1371f$export$8054dcb2b42da45c);

var $83mn0 = parcelRequire("83mn0");

var $7NH5Y = parcelRequire("7NH5Y");
const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $83mn0.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $7NH5Y.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $7NH5Y.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $7NH5Y.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("83mn0", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $90215f5482fce08d$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $90215f5482fce08d$export$9b7e0e4dd8bfade8);
const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("7NH5Y", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $a36a125359bfc961$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $a36a125359bfc961$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $a36a125359bfc961$export$b1c2c1fc5d10280);

var $kvHKs = parcelRequire("kvHKs");
const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
    $a36a125359bfc961$var$legacyAddonPanelLinkId,
    (0, $kvHKs.REPORTS_IDS).REPORTS_ADDONS,
    $a36a125359bfc961$var$jsdQueuesConnectSection
];

});


parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("b69Lc", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $ba4edc5b901e34a6$export$f0785b98c99d344c);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $ba4edc5b901e34a6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $5W6pd.transformLink)).filter(Boolean));
const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("dlYil", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $17cad8174f7acae6$export$ee355b2e42d6462b);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $17cad8174f7acae6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $5W6pd.transformLink)).filter((item)=>item != null && item.items));
const $17cad8174f7acae6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
        data
    ]);
    const searchResult = (0, $5uXOq.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jjzbO", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $25e0b1dc21125803$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $25e0b1dc21125803$export$1f0bd21403710fc);

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if ((0, $3HwlS.getWillShowNav4)()) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $dIdda = parcelRequire("dIdda");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("dmKXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac63d95d52d9688b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, $7B17s.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("6RP79")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
var $ac63d95d52d9688b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);

});
parcelRegister("6RP79", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("bpTJC")
]).then(()=>parcelRequire('8rIQt'));

});


parcelRegister("iFaFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86720f4c83cfbb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, $7B17s.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("l65XP")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
$b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;

});
parcelRegister("l65XP", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("6eoVI")
]).then(()=>parcelRequire('4opkK'));

});


parcelRegister("4IWRY", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $e660bc01a5db5a53$export$ff333fd2f0bf5254);

var $5uXOq = parcelRequire("5uXOq");

var $4NrfJ = parcelRequire("4NrfJ");

var $7Tlti = parcelRequire("7Tlti");

var $c70gQ = parcelRequire("c70gQ");

var $dIdda = parcelRequire("dIdda");
const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $dIdda.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $4NrfJ.useGlobalForgeApps)();
    const extension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $5uXOq.useMemo)(()=>extension && (0, $7Tlti.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4NrfJ", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $7a76aaaa3a23f02a$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $7a76aaaa3a23f02a$export$f834c14187f80532);

var $5uXOq = parcelRequire("5uXOq");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $e0AC8 = parcelRequire("e0AC8");

var $awp3q = parcelRequire("awp3q");

var $dvdr4 = parcelRequire("dvdr4");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $dIdda = parcelRequire("dIdda");
const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $5bkvv.forgeGlobalModuleV1Resource));
    const globalPageData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: globalPageData ? globalPageData.filter((extension)=>(0, $awp3q.doesExtensionMeetConditions)(extension, {})) : null,
            loading: loading,
            error: error
        }), [
        globalPageData,
        loading,
        error
    ]);
};
const $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $5bkvv.forgeGlobalModuleV2Resource));
    // TODO: To be removed with new_graphql_endpoint_for_fetching_forge_modules FG cleanup.
    (0, $dvdr4.useDisplayConditionsConsistencyCheck)(data, {});
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.filter((0, $5cmSg.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};
const $7a76aaaa3a23f02a$export$f834c14187f80532 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $7a76aaaa3a23f02a$var$useGlobalForgeAppsV2, $7a76aaaa3a23f02a$var$useGlobalForgeAppsV1);

});
parcelRegister("e0AC8", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $d4c89d40e0b3eaac$export$a92b17288693d366);
const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});

parcelRegister("awp3q", function(module, exports) {

$parcel$export(module.exports, "useDoesExtensionMeetConditions", () => $bd52741229b769de$export$642911220fb6609f);
$parcel$export(module.exports, "doesExtensionMeetConditions", () => $bd52741229b769de$export$b1e4ed7044e85aa3);

var $5uXOq = parcelRequire("5uXOq");

var $kvQVg = parcelRequire("kvQVg");

var $4Pf62 = parcelRequire("4Pf62");

var $daoB1 = parcelRequire("daoB1");

var $9OXo1 = parcelRequire("9OXo1");
const $bd52741229b769de$export$642911220fb6609f = ()=>{
    const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $5uXOq.useCallback)((extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        if (displayConditions == null) return true;
        const context = {
            ...extraContext,
            isAdmin: // User info
            isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasCoreAccess: // App permissions
            hasCoreAccess,
            hasServiceManagementAccess: hasServiceManagementAccess,
            hasSoftwareAccess: hasSoftwareAccess
        };
        return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
    }, [
        hasCoreAccess,
        hasServiceManagementAccess,
        hasSoftwareAccess,
        isAdmin,
        isAnonymous,
        isSiteAdmin
    ]);
};
const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("dvdr4", function(module, exports) {

$parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", () => $79a96011350576c4$export$cd62caf01a15f56b);
$parcel$export(module.exports, "checkDisplayConditionsConsistency", () => $79a96011350576c4$export$4169695e1a68bda7);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $dJl1T = parcelRequire("dJl1T");

var $awp3q = parcelRequire("awp3q");

var $5cmSg = parcelRequire("5cmSg");
const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {})=>{
    const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
    const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
    (0, $5uXOq.useEffect)(()=>{
        $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext);
    }, [
        memoizedContext,
        memoizedData
    ]);
};
const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {})=>{
    if (data == null) return;
    const falsePositives = new Set();
    const falseNegatives = new Set();
    data.forEach((extension)=>{
        const perClient = (0, $awp3q.doesExtensionMeetConditions)(extension, context);
        const perServer = !(0, $5cmSg.isExtensionHiddenByDisplayConditions)(extension);
        if (perClient !== perServer) {
            if (perServer) falsePositives.add(extension);
            else falseNegatives.add(extension);
        }
    });
    if (falsePositives.size || falseNegatives.size) (0, $dJl1T.default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
        context: JSON.stringify(context),
        falsePositives_count: falsePositives.size,
        falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                id: ext.id,
                type: ext.type,
                displayConditions: ext.properties.displayConditions
            }))) : null,
        falseNegatives_count: falseNegatives.size,
        falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                id: ext.id,
                type: ext.type,
                displayConditions: ext.properties.displayConditions
            }))) : null
    });
};
const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))))=>{
    const memoizedData = (0, $5uXOq.useRef)(data);
    return (0, $5uXOq.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
$parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", () => $30771269db74e480$export$3cc53b8cca25d64);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});


parcelRegister("5bkvv", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleV1Resource", () => $3d515a0fe8e87c81$export$168ac1f97221e90b);
$parcel$export(module.exports, "forgeAdminModuleV2Resource", () => $3d515a0fe8e87c81$export$536a08360f048bac);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $3d515a0fe8e87c81$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleV1Resource", () => $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
$parcel$export(module.exports, "forgeProjectModuleV2Resource", () => $3d515a0fe8e87c81$export$1a17680eb0746291);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $3d515a0fe8e87c81$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", () => $3d515a0fe8e87c81$export$fa67d109c2a45864);
$parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", () => $3d515a0fe8e87c81$export$23c2bb87c561c9db);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleV1Resource", () => $3d515a0fe8e87c81$export$60e774d0427b56fc);
$parcel$export(module.exports, "forgeGlobalModuleV2Resource", () => $3d515a0fe8e87c81$export$75f594fe5ce76af);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $3d515a0fe8e87c81$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", () => $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", () => $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $3d515a0fe8e87c81$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $3d515a0fe8e87c81$export$e6be2f0ca0849869);

var $8O7FC = parcelRequire("8O7FC");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $5vSAE = parcelRequire("5vSAE");

var $dK8AG = parcelRequire("dK8AG");

var $gNStA = parcelRequire("gNStA");

var $dIdda = parcelRequire("dIdda");

var $47m5i = parcelRequire("47m5i");

var $1yLrr = parcelRequire("1yLrr");
const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $3d515a0fe8e87c81$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
        const { match: params } = route;
        const dataClassification = $3d515a0fe8e87c81$export$eb46cc3d7c1a6649(params, moduleName);
        const contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        return (0, $47m5i.fetchForgeModule)({
            cloudId: cloudId,
            moduleName: moduleName,
            dataClassification: dataClassification,
            shouldReturnANExtensions: shouldReturnANExtensions,
            contextIds: contextIds,
            locale: locale
        });
    };
const $3d515a0fe8e87c81$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ];
const $3d515a0fe8e87c81$export$168ac1f97221e90b = (0, $dIdda.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: $3d515a0fe8e87c81$var$createDataGetter((0, $k2DRb.ADMIN_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$536a08360f048bac = (0, $dIdda.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.ADMIN_PAGE_MODULE], (0, $1yLrr.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$var$forgeAdminModuleResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$536a08360f048bac, $3d515a0fe8e87c81$export$168ac1f97221e90b);
const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
        $3d515a0fe8e87c81$var$forgeAdminModuleResource
    ];
const $3d515a0fe8e87c81$export$ad95e2d07d6fa1a = (0, $dIdda.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $3d515a0fe8e87c81$var$createDataGetter((0, $k2DRb.PROJECT_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$1a17680eb0746291 = (0, $dIdda.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$1a17680eb0746291, $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
const $3d515a0fe8e87c81$export$fa67d109c2a45864 = (0, $dIdda.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $3d515a0fe8e87c81$var$createDataGetter((0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$23c2bb87c561c9db = (0, $dIdda.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$23c2bb87c561c9db, $3d515a0fe8e87c81$export$fa67d109c2a45864);
const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $dIdda.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
const $3d515a0fe8e87c81$export$60e774d0427b56fc = (0, $dIdda.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: $3d515a0fe8e87c81$var$createDataGetter((0, $k2DRb.GLOBAL_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$75f594fe5ce76af = (0, $dIdda.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.GLOBAL_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$var$forgeGlobalModuleResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$75f594fe5ce76af, $3d515a0fe8e87c81$export$60e774d0427b56fc);
const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
        $3d515a0fe8e87c81$var$forgeGlobalModuleResource
    ];
const $3d515a0fe8e87c81$export$b555dc3ff28ae9cc = (0, $dIdda.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $3d515a0fe8e87c81$var$createDataGetter((0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942 = (0, $dIdda.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942, $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $dIdda.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>(0, $4R6GH.fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, $5vSAE.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_NAVIGATION)
        }).then((modules)=>modules[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE]) : (0, $iVaKa.default)(cloudId, [
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
        ], null, undefined, (0, $k2DRb.SOURCE_NAVIGATION), $3d515a0fe8e87c81$var$createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }), locale) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        .then((modules)=>modules.extensions.jiraCustomFieldType),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("8O7FC", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $7c4745a46edf6307$export$89a1f01f2a7cb2a1);

var $dJl1T = parcelRequire("dJl1T");
const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $dJl1T.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("k2DRb", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $e80aa4d4aac5b0dc$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $e80aa4d4aac5b0dc$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e80aa4d4aac5b0dc$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $e80aa4d4aac5b0dc$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $e80aa4d4aac5b0dc$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $e80aa4d4aac5b0dc$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $e80aa4d4aac5b0dc$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $e80aa4d4aac5b0dc$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $e80aa4d4aac5b0dc$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $e80aa4d4aac5b0dc$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $e80aa4d4aac5b0dc$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $e80aa4d4aac5b0dc$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $e80aa4d4aac5b0dc$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $e80aa4d4aac5b0dc$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$51ab2784839ce348);
const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
    $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
    $e80aa4d4aac5b0dc$export$259bab989b0129d0,
    $e80aa4d4aac5b0dc$export$75f224942f595e13,
    $e80aa4d4aac5b0dc$export$ba0968f9752844,
    $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
    $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
    $e80aa4d4aac5b0dc$export$811b7f067a43b422,
    $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
    $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
    $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
    $e80aa4d4aac5b0dc$export$151b03356f566603,
    $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
    $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
    $e80aa4d4aac5b0dc$export$353acf28daa75c79,
    $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
    $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
    $e80aa4d4aac5b0dc$export$5592ab836d562168,
    $e80aa4d4aac5b0dc$export$842eb4236828ac9,
    $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
    $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
    $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
];
const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
const $e80aa4d4aac5b0dc$export$6d00582aa947900f = 'workflow-list';
const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
const $e80aa4d4aac5b0dc$export$bf75cf7720bd8fde = 'transition-view';
const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$e80aa4d4aac5b0dc$export$a48dade1864725a
};
const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
        ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;

});

parcelRegister("iVaKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1a9656c7bb4ee4$export$2e2bcd8739ae039);

var $e4eHl = parcelRequire("e4eHl");

var $fn8B5 = parcelRequire("fn8B5");

var $cuHs1 = parcelRequire("cuHs1");

var $1UikQ = parcelRequire("1UikQ");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $bPtOr = parcelRequire("bPtOr");

var $dYScp = parcelRequire("dYScp");

var $hBuqR = parcelRequire("hBuqR");

var $bOLUk = parcelRequire("bOLUk");

var $k2DRb = parcelRequire("k2DRb");

var $d5W4H = parcelRequire("d5W4H");

var $1MlDe = parcelRequire("1MlDe");

var $lG6pQ = parcelRequire("lG6pQ");

var $ioGTN = parcelRequire("ioGTN");

var $dnsCJ = parcelRequire("dnsCJ");

var $eIGUr = parcelRequire("eIGUr");
const $1b1a9656c7bb4ee4$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(module);
const $1b1a9656c7bb4ee4$export$3361e9be8093ddcc = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $1b1a9656c7bb4ee4$var$moduleToVariableKey(key));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(groupedExtensionsWithMappedKeys, (0, $k2DRb.getEmptyExtensionsObject)());
};
const $1b1a9656c7bb4ee4$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key)), (0, $k2DRb.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $1MlDe.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $k2DRb.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $k2DRb.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES = [
    (0, $bPtOr.FAILED_TO_FETCH),
    (0, $bPtOr.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)
];
const $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
    if (modules.length === 0) throw new Error('No modules to fetch provided');
    const dataClassificationTags = await (0, $lG6pQ.getDataClassification)(dataClassification, source);
    const includeConfig = extras?.include || {};
    const query = (0, $eIGUr.buildForgeQuery)(includeConfig);
    const variables = {
        contextIds: contextIds || [
            `ari:cloud:jira::site/${cloudId}`
        ],
        extensionsFilter: [
            {
                type: 'EXTENSION_TYPE',
                value: modules
            }
        ],
        dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
        locale: (0, $4R6GH.fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
    };
    const { data: data, errors: errors, extensions: extensions } = await (0, $dYScp.measureExecutionTimeMetrics)(()=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            method: 'POST'
        }));
    const traceId = (0, $dnsCJ.getTraceIdFromExtensions)({
        extensions: extensions
    });
    if (errors) throw new (0, $ioGTN.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
    if (!data) throw new (0, $ioGTN.ForgeFetchError)('No data returned', traceId, errors);
    if (data.extensionContexts.length < 1) throw new (0, $ioGTN.ForgeFetchError)('No extensionContext returned', traceId, errors);
    return {
        data: data,
        traceId: traceId
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b1a9656c7bb4ee4$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $k2DRb.SOURCE_UNKNOWN), contextIds, locale)=>{
    try {
        // Just in case something goes very much wrong we don't want to call the XIS
        if (!(0, $d5W4H.canFetchForgeModules)()) return {
            extensions: (0, $k2DRb.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $k2DRb.getEmptyExtensionsObject)()
        };
        const { data: data, traceId: traceId } = await $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
        if (Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE)) (0, $bOLUk.fireInitializationFetchFinishedEvent)(source, {
            traceId: traceId
        });
        return $1b1a9656c7bb4ee4$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const errorType = (0, $bPtOr.getErrorType)(error);
        const traceId = (0, $dnsCJ.getTraceIdFromError)(error);
        (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error,
            traceId: traceId
        });
        if ($1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
            extensions: (0, $k2DRb.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $k2DRb.getEmptyExtensionsObject)()
        };
        throw error;
    }
};

});
parcelRegister("bPtOr", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $e4bddb38a31390d9$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $e4bddb38a31390d9$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $e4bddb38a31390d9$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $e4bddb38a31390d9$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $e4bddb38a31390d9$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $e4bddb38a31390d9$export$e19f9f08a6d79fd2);


var $fZneA = parcelRequire("fZneA");

var $65nWi = parcelRequire("65nWi");
const $e4bddb38a31390d9$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
    GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
};
const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $65nWi.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $fZneA.isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
    return 'OTHER';
};

});

parcelRegister("dYScp", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $d79aabebae5ffeb3$export$a859f6866f4653e0);

var $7Jxgt = parcelRequire("7Jxgt");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $8kVg1 = parcelRequire("8kVg1");
const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE);
    if ((0, $4R6GH.fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
    else try {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesFetchTime).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesFetchTime).stop({
            stopTime: performance.now()
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesFetchTime).cancel();
        throw error;
    }
};

});
parcelRegister("hBuqR", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $bbc089ab376d4a7b$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $bbc089ab376d4a7b$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $bbc089ab376d4a7b$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $bbc089ab376d4a7b$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $bbc089ab376d4a7b$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $bbc089ab376d4a7b$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $bbc089ab376d4a7b$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $bbc089ab376d4a7b$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $bbc089ab376d4a7b$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("8kVg1", function(module, exports) {

$parcel$export(module.exports, "forgeModulesFetchTime", () => $f1fed22795d0c676$export$cd129f3639657eae);
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $f1fed22795d0c676$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $f1fed22795d0c676$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $f1fed22795d0c676$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $f1fed22795d0c676$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $f1fed22795d0c676$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $f1fed22795d0c676$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $f1fed22795d0c676$export$a318f99472db73c8);

var $hC3PM = parcelRequire("hC3PM");

var $6RCeq = parcelRequire("6RCeq");

var $ivxS0 = parcelRequire("ivxS0");
var $n3syj = parcelRequire("n3syj");

var $hBuqR = parcelRequire("hBuqR");
const $f1fed22795d0c676$export$cd129f3639657eae = (0, $hC3PM.metrics).custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, $hC3PM.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $f1fed22795d0c676$export$292f3b557281044f = (0, $hC3PM.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, $n3syj.UFOExperience)((0, $hBuqR.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $ivxS0.ExperienceTypes).Experience,
    performanceType: (0, $ivxS0.ExperiencePerformanceTypes).InlineResult
});
async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $6RCeq.default).getEntriesByName(startMark).length > 0 || (0, $6RCeq.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $6RCeq.default).mark(startMark);
    const result = await fn();
    (0, $6RCeq.default).mark(endMark);
    return result;
}
const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $6RCeq.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $6RCeq.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $6RCeq.default).clearMarks(name);
    });
};
const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $hC3PM.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $hC3PM.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("bOLUk", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2f4555f4bd0f0eef$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2f4555f4bd0f0eef$export$b274c658390b491b);

var $6yg2S = parcelRequire("6yg2S");

var $8uOa6 = parcelRequire("8uOa6");
const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, $6yg2S.toEventId)('issueViewInitialization');
const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, $6yg2S.toEventId)('fetchModulesInitialization');
const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("6yg2S", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $cb46d7d052e3d68d$export$75e84ef5a3771f9a);
const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("8uOa6", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $73635d33815c9f98$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $73635d33815c9f98$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $73635d33815c9f98$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $73635d33815c9f98$export$390a62413962e4f0);

var $fjcgS = parcelRequire("fjcgS");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $7yD9b = parcelRequire("7yD9b");

var $eGXs2 = parcelRequire("eGXs2");
const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hBuqR.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $6MtPV.createAttributes)(attributes),
        source: source,
        action: action
    });
const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, $fjcgS.getAnalyticsWebClientPromise)()).getInstance();
const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $73635d33815c9f98$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7yD9b.logError)((0, $7yD9b.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $eGXs2.isSynthetic)().toString()}, id=${id}, source=${(0, $6MtPV.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("6MtPV", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $31dca5b0e1651a2f$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $31dca5b0e1651a2f$export$c7c9603a6b1fd815);

var $84Tib = parcelRequire("84Tib");

var $9uiWt = parcelRequire("9uiWt");

var $bPtOr = parcelRequire("bPtOr");

var $eGXs2 = parcelRequire("eGXs2");
const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $eGXs2.isSynthetic)(),
        isOverridingFragments: (0, $9uiWt.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
            attributes.errorType = (0, $bPtOr.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("9uiWt", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $c677f4c9cc5e982f$export$1d1321d2b374d697);
const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("eGXs2", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $58ae13ec31f88266$export$947749d756ccb0a);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");
const $58ae13ec31f88266$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');

});


parcelRegister("7yD9b", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $187fc325525eefe3$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $187fc325525eefe3$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $187fc325525eefe3$export$58da9968c3170cb1);

var $dJl1T = parcelRequire("dJl1T");

var $hBuqR = parcelRequire("hBuqR");
const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
    [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("d5W4H", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $4Pf62 = parcelRequire("4Pf62");
const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ()=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    // There is no anonymous access for now
    return !isAnonymous;
};

});

parcelRegister("1MlDe", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $11a6461020d3329a$export$e0393e97f15a28a5);

var $lbWm4 = parcelRequire("lbWm4");

var $k2DRb = parcelRequire("k2DRb");
const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $k2DRb.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("lG6pQ", function(module, exports) {

$parcel$export(module.exports, "getDataClassification", () => $013c8a0b6d7ef450$export$1635afa94064952c);

var $eusud = parcelRequire("eusud");

var $bPtOr = parcelRequire("bPtOr");

var $bOLUk = parcelRequire("bOLUk");

var $dqtU7 = parcelRequire("dqtU7");

var $6P5IG = parcelRequire("6P5IG");
const $013c8a0b6d7ef450$var$handleError = (err, source)=>{
    const errorMessage = err instanceof Error ? err.message : String(err);
    const error = Error(`Data classification request failed: ${errorMessage}`);
    const errorType = (0, $bPtOr.getErrorType)(error);
    // prevent fetching extensions in case of no access
    if (errorType === (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
    (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
        isSSR: false,
        errorType: errorType,
        error: error
    });
    // otherwise, optimistically fetch the extensions
    return [];
};
async function $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $6P5IG.DataClassificationTagsCache).get(`${(0, $6P5IG.issueKeyPrefix)}-${props.issueKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $6P5IG.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $eusud.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
            (0, $6P5IG.DataClassificationTagsCache).set(`${(0, $6P5IG.issueKeyPrefix)}-${props.issueKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $013c8a0b6d7ef450$var$handleError(err, source);
    }
}
async function $013c8a0b6d7ef450$var$getDataClassificationProject(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $6P5IG.DataClassificationTagsCache).get(`${(0, $6P5IG.projectKeyPrefix)}-${props.projectIdOrKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $6P5IG.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $eusud.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
            (0, $6P5IG.DataClassificationTagsCache).set(`${(0, $6P5IG.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $013c8a0b6d7ef450$var$handleError(err, source);
    }
}
const $013c8a0b6d7ef450$export$1635afa94064952c = async (props, source)=>{
    if (props !== null) {
        if ((0, $dqtU7.hasPrefetchedData)(props)) return props.tags;
        if ((0, $dqtU7.hasProjectIdOrKey)(props)) {
            const tags = await $013c8a0b6d7ef450$var$getDataClassificationProject(props, source);
            return tags;
        }
        if ((0, $dqtU7.hasIssueKey)(props)) {
            const tags = await $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source);
            return tags;
        }
    }
    return [];
};

});
parcelRegister("dqtU7", function(module, exports) {

$parcel$export(module.exports, "hasPrefetchedData", () => $3920146879a40338$export$c19d255b92c7c2da);
$parcel$export(module.exports, "hasProjectIdOrKey", () => $3920146879a40338$export$494434246e5dea0d);
$parcel$export(module.exports, "hasIssueKey", () => $3920146879a40338$export$b1490cfc7a90c75b);

var $8LQ84 = parcelRequire("8LQ84");
const $3920146879a40338$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(props.tags);
const $3920146879a40338$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
const $3920146879a40338$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;

});

parcelRegister("6P5IG", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $ca591e08be1a6f54$export$6ebb1381174e92a7);
$parcel$export(module.exports, "issueKeyPrefix", () => $ca591e08be1a6f54$export$a040db2850f159b0);
$parcel$export(module.exports, "projectKeyPrefix", () => $ca591e08be1a6f54$export$df256a06d24ff906);
$parcel$export(module.exports, "DataClassificationTagsCache", () => $ca591e08be1a6f54$export$b7adc37405b5ff0d);
const $ca591e08be1a6f54$export$6ebb1381174e92a7 = 60000;
const $ca591e08be1a6f54$export$a040db2850f159b0 = 'issue';
const $ca591e08be1a6f54$export$df256a06d24ff906 = 'project';
const $ca591e08be1a6f54$export$b7adc37405b5ff0d = new Map();

});


parcelRegister("ioGTN", function(module, exports) {

$parcel$export(module.exports, "ForgeFetchError", () => $03e8a2344fd340fa$export$2e3b53e53bafa);
class $03e8a2344fd340fa$export$2e3b53e53bafa extends Error {
    constructor(message, traceId, errors){
        super(message);
        this.name = $03e8a2344fd340fa$export$2e3b53e53bafa.name;
        this.traceId = traceId;
        this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        if ('captureStackTrace' in Error) // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        Error.captureStackTrace(this, $03e8a2344fd340fa$export$2e3b53e53bafa); // :tableflip:
    }
}

});

parcelRegister("dnsCJ", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromExtensions", () => $06cecb1cf20a09b8$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getTraceIdFromError", () => $06cecb1cf20a09b8$export$9955d05ba83067ba);

var $jJZqs = parcelRequire("jJZqs");

var $ioGTN = parcelRequire("ioGTN");
const $06cecb1cf20a09b8$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    const traceId = extensions?.gateway?.request_id;
    if (traceId && typeof traceId === 'string') return traceId;
    return undefined;
};
const $06cecb1cf20a09b8$export$9955d05ba83067ba = (error)=>{
    if (error instanceof (0, $ioGTN.ForgeFetchError) || error instanceof (0, $jJZqs.default)) return error.traceId;
    return undefined;
};

});

parcelRegister("eIGUr", function(module, exports) {

$parcel$export(module.exports, "buildForgeQuery", () => $5112ddb3344b355d$export$497b2dc04db7bd76);

var $co1wz = parcelRequire("co1wz");
const $5112ddb3344b355d$export$497b2dc04db7bd76 = (include)=>{
    const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
    const scopesField = include.scopes === true ? 'scopes' : '';
    const capabilitySetField = (0, $co1wz.ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
    const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
    return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
};

});


parcelRegister("5vSAE", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $f16089506a319d17$export$24d8e11b15325c53);

var $gPjkL = parcelRequire("gPjkL");

var $8Uumt = parcelRequire("8Uumt");

var $bPtOr = parcelRequire("bPtOr");

var $dYScp = parcelRequire("dYScp");

var $hBuqR = parcelRequire("hBuqR");

var $bOLUk = parcelRequire("bOLUk");

var $k2DRb = parcelRequire("k2DRb");

var $5yJb9 = parcelRequire("5yJb9");

var $d5W4H = parcelRequire("d5W4H");

var $dyPNS = parcelRequire("dyPNS");
const $f16089506a319d17$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, source: source = (0, $k2DRb.SOURCE_UNKNOWN) } = params;
    if (!(0, $d5W4H.canFetchForgeModules)()) return (0, $dyPNS.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $dYScp.measureExecutionTimeMetrics)(()=>$f16089506a319d17$export$8ff66c70be1c563a(params));
        if (Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE)) (0, $bOLUk.fireInitializationFetchFinishedEvent)(source);
        return (0, $dyPNS.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $bPtOr.getErrorType)(error);
        (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($f16089506a319d17$export$458cbcb6374269d2.includes(errorType)) return (0, $dyPNS.toMappedExtensions)(types, []);
        throw error;
    }
};
function $f16089506a319d17$export$8ff66c70be1c563a(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    return (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $gPjkL.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        cloudId: cloudId,
        context: context,
        types: types,
        includeHidden: includeHidden,
        includeScopes: includeScopes
    }).toPromise().then((response)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.jira.forge.extensions.concat();
    });
}
const $f16089506a319d17$export$458cbcb6374269d2 = [
    (0, $bPtOr.FAILED_TO_FETCH),
    (0, $bPtOr.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("gPjkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $13cd104237d48c31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00f75613e524ae31b8e6562d9f3105b5>>
 * @relayHash c628a7ddbc1f6e28bf1109b39c9df871
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05
const $13cd104237d48c31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "context",
                "variableName": "context"
            },
            {
                "kind": "Variable",
                "name": "includeHidden",
                "variableName": "includeHidden"
            },
            {
                "kind": "Variable",
                "name": "types",
                "variableName": "types"
            }
        ],
        "concreteType": "JiraForgeExtension",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "condition": "includeHidden",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hiddenBy"
                    }
                ]
            },
            {
                "condition": "includeScopes",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "scopes"
                    }
                ]
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "environmentId"
            },
            {
                "kind": "ScalarField",
                "name": "environmentKey"
            },
            {
                "kind": "ScalarField",
                "name": "environmentType"
            },
            {
                "kind": "ScalarField",
                "name": "installationId"
            },
            {
                "kind": "ScalarField",
                "name": "appVersion"
            },
            {
                "kind": "ScalarField",
                "name": "consentUrl"
            },
            {
                "kind": "ScalarField",
                "name": "properties"
            },
            {
                "concreteType": "JiraForgeAppEgressDeclaration",
                "kind": "LinkedField",
                "name": "egress",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "addresses"
                    },
                    v5 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraForgeExtensionLicense",
                "kind": "LinkedField",
                "name": "license",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "active"
                    },
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "supportEntitlementNumber"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialEndDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subscriptionEndDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEvaluation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "billingPeriod"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementSlug"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilitySet"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraForgeQuery",
                                    "kind": "LinkedField",
                                    "name": "forge",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.forge.extensions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.forge"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13cd104237d48c31$var$node.hash = "7d0cf33c9221c468dec00db8d99ae484";
var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;

});

parcelRegister("dyPNS", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $12d1a959cf63073a$export$e073e0c0d1c23345);
function $12d1a959cf63073a$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    returnedExtensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}

});


parcelRegister("gNStA", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $4fbc57fe7e788209$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $4fbc57fe7e788209$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $4fbc57fe7e788209$export$5284559c6d2f1a7b);

var $kbVA4 = parcelRequire("kbVA4");
const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $kbVA4.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("kbVA4", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $513d12eeb22c04a1$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $513d12eeb22c04a1$export$5664a170ac5a9781);
const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;

});


parcelRegister("47m5i", function(module, exports) {

$parcel$export(module.exports, "fetchForgeModule", () => $9024d8f047e9df37$export$e1683e15cedb5f17);

var $e4eHl = parcelRequire("e4eHl");

var $8O7FC = parcelRequire("8O7FC");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $g5X3G = parcelRequire("g5X3G");

var $gLloR = parcelRequire("gLloR");
const $9024d8f047e9df37$var$dataClassificatedModulesConfig = {
    names: new Set(),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    request: Promise.resolve({})
};
const $9024d8f047e9df37$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
    $9024d8f047e9df37$var$dataClassificatedModulesConfig.names.add(moduleName);
    // simulate next tick so other resources could register their modules to fetch
    await new Promise((resolve)=>setTimeout(resolve, 0));
    const moduleNamesToFetch = Array.from($9024d8f047e9df37$var$dataClassificatedModulesConfig.names);
    let extensions = [];
    let accessNarrowedExtensions = [];
    // If the fetch is not already handled
    if (moduleNamesToFetch.length > 0) {
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.names = new Set();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.request = (0, $iVaKa.default)((0, $g5X3G.toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, $k2DRb.SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
    }
    const result = await $9024d8f047e9df37$var$dataClassificatedModulesConfig.request;
    extensions = result.extensions[(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(moduleName)];
    if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(moduleName)];
    const getExtensionsFilter = (fullPageModuleName)=>{
        switch(fullPageModuleName){
            case 0, $k2DRb.ADMIN_PAGE_MODULE:
                return 0, $gLloR.adminPageFilter;
            default:
                // filtered, as we allow only one extension per module
                return 0, $gLloR.uniqueExtensionsFilter;
        }
    };
    return {
        extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title)),
        accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title))
    };
};

});
parcelRegister("gLloR", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $11790a142fe832e3$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $11790a142fe832e3$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $11790a142fe832e3$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $11790a142fe832e3$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const adminExtensions = extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
        ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
        ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
    ];
};

});


parcelRegister("1yLrr", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $8bb90f56b7c2b78a$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});



parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});

parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});


parcelRegister("hBv66", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $0b920001492d0ef4$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $0b920001492d0ef4$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $0b920001492d0ef4$export$844d342b575ead35);

var $cin8p = parcelRequire("cin8p");

var $dmKXV = parcelRequire("dmKXV");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $koWFd = parcelRequire("koWFd");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");
const $0b920001492d0ef4$export$d88d2d25355bc89a = [
    (0, $dmKXV.default),
    (0, $koWFd.default),
    (0, $h0bZU.default),
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$c04daf123cec1f1e = [
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$844d342b575ead35 = [
    ...$0b920001492d0ef4$export$d88d2d25355bc89a,
    (0, $cin8p.default),
    (0, $iHiHz.default),
    (0, $cOg46.default)
];

});
parcelRegister("iHiHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $883820dc444dc59c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("6xFyF")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
$883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;

});
parcelRegister("6xFyF", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3EO4A")
]).then(()=>parcelRequire('kO26e'));

});


parcelRegister("cOg46", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc7dd640caeb91$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("2YlLB")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
$18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;

});
parcelRegister("2YlLB", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("gQZpl")
]).then(()=>parcelRequire('6Pefo'));

});


parcelRegister("koWFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e9a7a50d60fc40$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("ioGL3")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar, null)));
$73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;

});
parcelRegister("ioGL3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4OI1j")
]).then(()=>parcelRequire('4WgKv'));

});


parcelRegister("h0bZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3f1b5dd616f02b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $ca3f1b5dd616f02b$export$5b9febabdab63fba = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("in19N")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $ca3f1b5dd616f02b$var$ServicedeskSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$5b9febabdab63fba, null)));
$ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;

});
parcelRegister("in19N", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("kWrFZ"),
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("aOxtZ")
]).then(()=>parcelRequire('eufGV'));

});


parcelRegister("9s3j1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed71aad279526f75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("fIIJQ")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar, null)));
$ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("fIIJQ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("kWrFZ"),
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hXBFn")
]).then(()=>parcelRequire('dydBa'));

});


parcelRegister("2IHt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8627747b0236ab96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $8627747b0236ab96$var$LazyUserSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("j9Afm")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8627747b0236ab96$var$UserSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
$8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;

});
parcelRegister("j9Afm", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("36IoX")
]).then(()=>parcelRequire('3AQ56'));

});



parcelRegister("7AyKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf06d255b5e49f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, $7B17s.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("icPex")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
$6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;

});
parcelRegister("icPex", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("92sUi"),
    $6fhBS("i5RRW"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("a8Tkc")
]).then(()=>parcelRequire('48ZOK'));

});


parcelRegister("937TY", function(module, exports) {

$parcel$export(module.exports, "default", () => $375ae1bde651f684$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $375ae1bde651f684$var$LazyPlanSidebar = (0, $7B17s.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("9Kv1r")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $375ae1bde651f684$var$PlanSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
$375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;

});
parcelRegister("9Kv1r", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");


module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fRQHe")),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("exGqx")
]).then(()=>parcelRequire('5q8CD'));

});


parcelRegister("lgSL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $756fa7b51ff3cfd4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $7B17s = parcelRequire("7B17s");

const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, $7B17s.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("9vvGA")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
$756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;

});
parcelRegister("9vvGA", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("blsmD")
]).then(()=>parcelRequire('aSh9m'));

});



parcelRegister("ht71P", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $7676eec527946b59$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("esy1S")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));

});
parcelRegister("esy1S", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("ev3ZS").then(()=>parcelRequire('6vucW'));

});


parcelRegister("4V52L", function(module, exports) {

$parcel$export(module.exports, "SidebarFeedbackButton", () => $ea1c2dd9a94de02f$export$b270ed097d20c023);

var $5uXOq = parcelRequire("5uXOq");

var $YIdgD = parcelRequire("YIdgD");

var $50Ng1 = parcelRequire("50Ng1");

var $lxThX = parcelRequire("lxThX");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $9fYN9 = parcelRequire("9fYN9");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $j5Q6Z = parcelRequire("j5Q6Z");

var $dkkQn = parcelRequire("dkkQn");

var $4DrQd = parcelRequire("4DrQd");

var $bw7Gm = parcelRequire("bw7Gm");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $83YFz = parcelRequire("83YFz");
const $ea1c2dd9a94de02f$export$b270ed097d20c023 = ()=>{
    const environment = (0, $2tT7R.useEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        const showFeedbackTitleDetailsWithLink = (0, $j5Q6Z.getWillShowNav4UserOptIn)() || (0, $dkkQn.getWillShowNav4UserOptOut)();
        const formattedMessageNode = showFeedbackTitleDetailsWithLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $83YFz.default).feedbackTitleDetailsWithLink,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxThX.default), {
                        href: "/jira/settings/personal/general",
                        onClick: closeFeedbackCollector
                    }, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleDetailsNoLink);
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $bw7Gm.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $4DrQd.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $83YFz.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        closeFeedbackCollector,
        cloudId,
        environment,
        formatMessage,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
        xcss: $ea1c2dd9a94de02f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fYN9.default), {
        content: formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YIdgD.default), {
        shouldFitContainer: true,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($50Ng1))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel))));
};
const $ea1c2dd9a94de02f$var$containerStyles = (0, $ii5wQ.xcss)({
    flex: 'none',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    padding: 'space.150',
    background: "var(--ds-surface-raised, #FFF)"
});

});
parcelRegister("50Ng1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a6329587697f6c8$var$_react = $3a6329587697f6c8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a6329587697f6c8$var$_UNSAFE_baseNew = $3a6329587697f6c8$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $3a6329587697f6c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a6329587697f6c8$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $3a6329587697f6c8$var$_react.default.createElement($3a6329587697f6c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$3a6329587697f6c8$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $3a6329587697f6c8$var$_default = module.exports.default = $3a6329587697f6c8$var$MegaphoneIcon;

});

parcelRegister("7iULw", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $384a8a865c8f714d$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $384a8a865c8f714d$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $384a8a865c8f714d$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $384a8a865c8f714d$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $384a8a865c8f714d$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $384a8a865c8f714d$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $384a8a865c8f714d$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $384a8a865c8f714d$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $384a8a865c8f714d$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $384a8a865c8f714d$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $384a8a865c8f714d$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $384a8a865c8f714d$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $384a8a865c8f714d$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $384a8a865c8f714d$export$1b65c2053cba0686);
$parcel$export(module.exports, "EntryKeys", () => $384a8a865c8f714d$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies'
});

});

parcelRegister("dseDh", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c996142feb877ddb$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c996142feb877ddb$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c996142feb877ddb$export$c35dbf16ebe9df04);

var $7JoAD = parcelRequire("7JoAD");
const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c996142feb877ddb$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c996142feb877ddb$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c996142feb877ddb$var$Store = (0, $7JoAD.createStore)({
    name: 'feedback-collector',
    initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
    actions: $c996142feb877ddb$export$e324594224ef24da
});
const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $7JoAD.createHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $7JoAD.createActionsHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $7JoAD.createSubscriber)($c996142feb877ddb$var$Store, {
    selector: null
});

});

parcelRegister("j5Q6Z", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptIn", () => $13f1e9a404b61bdc$export$46a00895da9889a2);

var $4R6GH = parcelRequire("4R6GH");
const $13f1e9a404b61bdc$export$46a00895da9889a2 = ()=>(0, $4R6GH.fg)('jira_nav4') && $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers();
// Update this when the existing customers stage gets closer.
// See https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design+draft#User-opt-in-checkbox
const $13f1e9a404b61bdc$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;

});

parcelRegister("dkkQn", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOut", () => $1db1544bbdad6d19$export$acb346134ed05173);

var $4R6GH = parcelRequire("4R6GH");

var $9Qkfw = parcelRequire("9Qkfw");

var $d1JDF = parcelRequire("d1JDF");
const $1db1544bbdad6d19$export$acb346134ed05173 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_nav4') && ((0, $9Qkfw.getWillShowNav4UserOptOutForDogfooding)() || (0, $4R6GH.fg)('jira_nav4_eap')) || // User opt out is being shared with visual refresh. It should show if visual refresh is on regardless of nav4.
    (0, $d1JDF.getWillShowNav4UserOptOutForVisualRefresh)();

});
parcelRegister("9Qkfw", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", () => $a6cd9fbcbab14454$export$9edbe3a98989e15b);

var $4R6GH = parcelRequire("4R6GH");
const $a6cd9fbcbab14454$export$9edbe3a98989e15b = ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding') && ((0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1') || (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'));

});

parcelRegister("d1JDF", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", () => $1ed6defa01bf1a51$export$17e35ae7beae962d);

var $4R6GH = parcelRequire("4R6GH");
const $1ed6defa01bf1a51$export$17e35ae7beae962d = ()=>(0, $4R6GH.fg)('visual-refresh') && ((0, $4R6GH.fg)('visual-refresh-dogfood') || (0, $4R6GH.fg)('visual-refresh-eap'));

});


parcelRegister("83YFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $583ab6a643d91da5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    }
});

});


parcelRegister("l28zt", function(module, exports) {

$parcel$export(module.exports, "PanelSplitter", () => $4a08e8dca20345b6$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $13czV = parcelRequire("13czV");

var $hFKXd = parcelRequire("hFKXd");

var $edZ8f = parcelRequire("edZ8f");

var $jA7Eh = parcelRequire("jA7Eh");
parcelRequire("blKce");
var $aSQiB = parcelRequire("aSQiB");
parcelRequire("yyHto");
var $fBegs = parcelRequire("fBegs");
parcelRequire("dT14S");
var $ufPHI = parcelRequire("ufPHI");

var $d8maQ = parcelRequire("d8maQ");

var $8iEvh = parcelRequire("8iEvh");

var $3XefF = parcelRequire("3XefF");

var $51DoY = parcelRequire("51DoY");

var $hDb1d = parcelRequire("hDb1d");
const $4a08e8dca20345b6$var$containerStyles = {
    root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $4a08e8dca20345b6$var$buttonStyles = {
    grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
    content: "_1bsb1osq _4t3i1osq"
};
const $4a08e8dca20345b6$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $4a08e8dca20345b6$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $3XefF.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $hDb1d.useTextDirection)(portalRef.current);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $edZ8f.combine)((0, $hFKXd.fg)('jira_nav4_eap_drop_1') ? (0, $aSQiB.blockDraggingToIFrames)({
            element: splitter
        }) : (0, $13czV.default), (0, $jA7Eh.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $fBegs.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $ufPHI.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return {
                    initialWidth: (0, $51DoY.getPixelWidth)(panelRef.current)
                };
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $51DoY.getWidthFromDragLocation)({
                    initialWidth: source.data.initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                })}px, ${resizeBounds.max})`);
            },
            onDrop ({ source: source }) {
                (0, $ufPHI.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                const finalWidth = (0, $51DoY.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        resizeBounds,
        direction,
        position,
        isEnabled
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $4a08e8dca20345b6$var$containerStyles.root,
            position === 'start' && $4a08e8dca20345b6$var$containerStyles.positionStart,
            position === 'end' && $4a08e8dca20345b6$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $d8maQ.default), {
        // To win the specificity war we need to use inline styles so Compiled wins over Emotion.
        // Sorry Kylor!
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            outline: 'none'
        },
        ref: splitterRef,
        xcss: $4a08e8dca20345b6$var$buttonStyles.grabArea,
        interactionName: interactionName,
        testId: testId
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        // Due to a Firefox bug with button element drag events we need to make the button
        // content (children) fill up the entire space of the button.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=568313#c16
        className: (0, $bwpsq.default)([
            $4a08e8dca20345b6$var$buttonStyles.content
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $8iEvh.default), null, label), /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $4a08e8dca20345b6$var$lineStyles.root
        ])
    })))), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $4a08e8dca20345b6$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, hasMounted ? children : null);
};
const $4a08e8dca20345b6$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>/*#__PURE__*/ $5uXOq.createElement($4a08e8dca20345b6$var$ClientOnly, null, /*#__PURE__*/ $5uXOq.createElement($4a08e8dca20345b6$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        interactionName: interactionName,
        testId: testId
    }));

});
parcelRegister("blKce", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("aSQiB")).blockDraggingToIFrames);

var $aSQiB = parcelRequire("aSQiB");

});
parcelRegister("aSQiB", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $1c71338ee91257ed$export$6ae1d8fab001518c);

var $frREC = parcelRequire("frREC");

var $aha0J = parcelRequire("aha0J");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $1c71338ee91257ed$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $1c71338ee91257ed$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $1c71338ee91257ed$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($1c71338ee91257ed$var$isActive) return;
    $1c71338ee91257ed$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$1c71338ee91257ed$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $aha0J.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $frREC.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $1c71338ee91257ed$var$isActive = false;
    });
}
function $1c71338ee91257ed$export$6ae1d8fab001518c({ element: element }) {
    return (0, $frREC.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $1c71338ee91257ed$var$tryStart();
        }
    });
}

});


parcelRegister("yyHto", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("fBegs")).disableNativeDragPreview);

var $fBegs = parcelRequire("fBegs");

});
parcelRegister("fBegs", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $0e2c67dc07496d1a$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $0e2c67dc07496d1a$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $0e2c67dc07496d1a$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $0e2c67dc07496d1a$var$tinyTransparentImage) nativeSetDragImage($0e2c67dc07496d1a$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("dT14S", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ufPHI")).preventUnhandled);

var $ufPHI = parcelRequire("ufPHI");

});
parcelRegister("ufPHI", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $d5850dd55259a0bc$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $bcxuN = parcelRequire("bcxuN");
function $d5850dd55259a0bc$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $d5850dd55259a0bc$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $d5850dd55259a0bc$var$start() {
    $d5850dd55259a0bc$var$cleanup();
    $d5850dd55259a0bc$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $d5850dd55259a0bc$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $d5850dd55259a0bc$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $d5850dd55259a0bc$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $d5850dd55259a0bc$var$cleanup
        },
        ...(0, $bcxuN.getBindingsForBrokenDrags)({
            onDragEnd: $d5850dd55259a0bc$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $d5850dd55259a0bc$var$cleanup() {
    $d5850dd55259a0bc$var$unbindEvents?.();
    $d5850dd55259a0bc$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $d5850dd55259a0bc$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $d5850dd55259a0bc$var$cleanup();
}
const $d5850dd55259a0bc$export$453c0582481cc59d = {
    start: $d5850dd55259a0bc$var$start,
    stop: $d5850dd55259a0bc$var$stop
};

});


parcelRegister("51DoY", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $5199407f713451ca$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $5199407f713451ca$export$d942790ad00c41f9);
const $5199407f713451ca$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $5199407f713451ca$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("hDb1d", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $299fb93a682170ff$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $299fb93a682170ff$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});


parcelRegister("gxq4u", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17a71abc75e8d96c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $17a71abc75e8d96c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    }
});

});

parcelRegister("7x18A", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $15587b8ab3be3aba$export$e12f5b3a390577de);

var $7B17s = parcelRequire("7B17s");

const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("gHSSC")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("gHSSC", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("ikCLZ").then(()=>parcelRequire('iIrS6'));

});



parcelRegister("gxCm0", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $5815562a2673ba2a$export$41d0d88a6b0e456f);

var $5uXOq = parcelRequire("5uXOq");

var $azzrO = parcelRequire("azzrO");

var $5e7oM = parcelRequire("5e7oM");

var $Mp6qH = parcelRequire("Mp6qH");

var $ghgbB = parcelRequire("ghgbB");

var $e6AHy = parcelRequire("e6AHy");

var $44v1T = parcelRequire("44v1T");

var $gwIPs = parcelRequire("gwIPs");

var $39xOx = parcelRequire("39xOx");

var $93jKl = parcelRequire("93jKl");

var $7XYc4 = parcelRequire("7XYc4");

var $3bl6P = parcelRequire("3bl6P");

var $9aaiB = parcelRequire("9aaiB");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $lfTZh = parcelRequire("lfTZh");

var $5M3R9 = parcelRequire("5M3R9");

var $l8ruj = parcelRequire("l8ruj");

var $erBFB = parcelRequire("erBFB");

var $dm0Uk = parcelRequire("dm0Uk");

var $iIpJ6 = parcelRequire("iIpJ6");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $gwIPs.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
const $5815562a2673ba2a$var$NewTopNav = ()=>{
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        testId: $5815562a2673ba2a$var$TEST_ID
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null)))));
};
/**
 * This has been inlined from `@atlassian/jira-common-constants/src/page-layout`
 * because it isn't used anywhere else, and to prevent new usage.
 */ const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ const $5815562a2673ba2a$var$OldTopNav = ()=>{
    const fullscreenRef = (0, $5uXOq.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $3bl6P.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
    }))))));
};
const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);

});
parcelRegister("Mp6qH", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $d722fd8ef23adae6$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $d722fd8ef23adae6$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $d722fd8ef23adae6$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $d722fd8ef23adae6$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $d722fd8ef23adae6$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $d722fd8ef23adae6$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $d722fd8ef23adae6$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $d722fd8ef23adae6$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $d722fd8ef23adae6$export$cc578bc72d7a7308);
const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
const $d722fd8ef23adae6$export$8666f31c8873bff = 10;
const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant'
};
const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $d722fd8ef23adae6$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $d722fd8ef23adae6$export$bbaa49b5be375ff3 = 3;
const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
const $d722fd8ef23adae6$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';

});

parcelRegister("ghgbB", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $d610646e169deef8$export$831e6a6e875b5ef8);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $8CVvd = parcelRequire("8CVvd");


var $4oDnX = parcelRequire("4oDnX");

var $6IzHB = parcelRequire("6IzHB");

var $dIdda = parcelRequire("dIdda");

var $Mp6qH = parcelRequire("Mp6qH");
const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $5uXOq.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});
parcelRegister("8CVvd", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav3", () => $5acda4891dbe9afe$export$23a7d978e17f1720);

var $3HwlS = parcelRequire("3HwlS");
const $5acda4891dbe9afe$export$23a7d978e17f1720 = ()=>!(0, $3HwlS.getWillShowNav4)();

});


parcelRegister("e6AHy", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $33751c6bf425b3ee$export$38e532bc6b824200);

var $5uXOq = parcelRequire("5uXOq");

var $fCXUn = parcelRequire("fCXUn");

var $iziuT = parcelRequire("iziuT");

var $eoNiZ = parcelRequire("eoNiZ");
const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iziuT.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCXUn.NavigationSkeleton), {
        theme: theme
    }));
};

});
parcelRegister("fCXUn", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", () => $7f04290d5402a0f6$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");



var $7kQ0s = parcelRequire("7kQ0s");
var $dA3Qn = parcelRequire("dA3Qn");

var $9qoFN = parcelRequire("9qoFN");

var $dzM6u = parcelRequire("dzM6u");

var $JGwE4 = parcelRequire("JGwE4");

var $askP0 = parcelRequire("askP0");

var $5HrnI = parcelRequire("5HrnI");
function $7f04290d5402a0f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7f04290d5402a0f6$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ba0702020718e486$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $7f04290d5402a0f6$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $7f04290d5402a0f6$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $7f04290d5402a0f6$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $7kQ0s.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dA3Qn.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $7f04290d5402a0f6$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7f04290d5402a0f6$var$leftStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9qoFN.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $JGwE4.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dzM6u.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7f04290d5402a0f6$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5HrnI.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9qoFN.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $askP0.ProfileSkeleton), null))));
};
var $7f04290d5402a0f6$export$2e2bcd8739ae039 = $7f04290d5402a0f6$export$ad5e8e6ace98cc2;

});
const $ba0702020718e486$export$30fa7cc5f2690a43 = 56;
const $ba0702020718e486$export$4033a111ca79977d = 1280;
const $ba0702020718e486$export$24ec62cee78b7042 = 1130;
const $ba0702020718e486$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ba0702020718e486$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ba0702020718e486$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ba0702020718e486$export$d81606c1fc5119bc = '--ds--ans--c';
const $ba0702020718e486$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("9qoFN", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", () => $d64632262f703cc0$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uSZd = parcelRequire("5uSZd");
function $d64632262f703cc0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d64632262f703cc0$var$buttonHeight = "var(--ds-space-400, 32px)";
const $d64632262f703cc0$var$skeletonStyles = {
    name: "28gj0e",
    styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
};
const $d64632262f703cc0$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $5uSZd.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $d64632262f703cc0$var$buttonHeight,
        height: typeof size === 'number' ? size : $d64632262f703cc0$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $d64632262f703cc0$var$skeletonStyles
    });
};

});

parcelRegister("dzM6u", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $14bfd9158c27644e$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $66suM = parcelRequire("66suM");
function $14bfd9158c27644e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $14bfd9158c27644e$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $14bfd9158c27644e$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ count: count })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $66suM.PrimaryButtonSkeleton), {
            key: index,
            css: $14bfd9158c27644e$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("66suM", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $cd1629eb0d0de9e2$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uSZd = parcelRequire("5uSZd");
const $cd1629eb0d0de9e2$var$paddingAll = 4;
const $cd1629eb0d0de9e2$var$buttonHeight = 32;
const $cd1629eb0d0de9e2$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$cd1629eb0d0de9e2$var$buttonHeight - $cd1629eb0d0de9e2$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
const $cd1629eb0d0de9e2$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $5uSZd.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $cd1629eb0d0de9e2$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("JGwE4", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", () => $d58a2bb1de4b96c7$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uSZd = parcelRequire("5uSZd");

var $aPj4O = parcelRequire("aPj4O");
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $d58a2bb1de4b96c7$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $d58a2bb1de4b96c7$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $ba0702020718e486$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $ba0702020718e486$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $d58a2bb1de4b96c7$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $ba0702020718e486$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $d58a2bb1de4b96c7$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $ba0702020718e486$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $d58a2bb1de4b96c7$var$siteTitleStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$d58a2bb1de4b96c7$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
const $d58a2bb1de4b96c7$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $5uSZd.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $aPj4O.stripEmptyProperties)({
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$d58a2bb1de4b96c7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$d58a2bb1de4b96c7$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$d58a2bb1de4b96c7$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $d58a2bb1de4b96c7$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $d58a2bb1de4b96c7$var$productLogoStyles
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $d58a2bb1de4b96c7$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $d58a2bb1de4b96c7$var$siteTitleStyles
    }));
};

});

parcelRegister("askP0", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", () => $93d9c4909de29eef$export$2bab43fd33adda3b);

var $5uXOq = parcelRequire("5uXOq");

var $9qoFN = parcelRequire("9qoFN");
const $93d9c4909de29eef$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9qoFN.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("5HrnI", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", () => $abb00d1ec711fb02$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uSZd = parcelRequire("5uSZd");

var $9qoFN = parcelRequire("9qoFN");
const $abb00d1ec711fb02$var$searchInputContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $ba0702020718e486$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $abb00d1ec711fb02$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
const $abb00d1ec711fb02$var$searchIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $ba0702020718e486$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $abb00d1ec711fb02$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $5uSZd.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $abb00d1ec711fb02$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $abb00d1ec711fb02$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9qoFN.IconButtonSkeleton), {
        css: $abb00d1ec711fb02$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});


parcelRegister("eoNiZ", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $96d5309c36bfdfee$export$93d4e7f90805808f);

var $5uXOq = parcelRequire("5uXOq");

var $kQxcj = parcelRequire("kQxcj");

var $8KKb4 = parcelRequire("8KKb4");
var $5gBas = parcelRequire("5gBas");

var $9MAC1 = parcelRequire("9MAC1");

var $2Ql51 = parcelRequire("2Ql51");

var $bt2pf = parcelRequire("bt2pf");

var $ihBhD = parcelRequire("ihBhD");
const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $8KKb4.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $ihBhD.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $5gBas.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $2Ql51.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $kQxcj.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};

});
parcelRegister("2Ql51", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $14feb59df5995657$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $14feb59df5995657$export$3416635c8aeb5bab);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $dIdda = parcelRequire("dIdda");


var $Y0b1l = parcelRequire("Y0b1l");

const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $dIdda.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $14feb59df5995657$var$getDataLoader,
    maxAge: 300000
});
const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $dIdda.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
            actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $Y0b1l.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("Y0b1l", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $fb319b2ef1da4e47$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $fb319b2ef1da4e47$export$2f7a12048d96237);

var $b9op4 = parcelRequire("b9op4");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $aHuqL.userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $aHuqL.userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $b9op4.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $b9op4.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("b9op4", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $a1d11c8212b90b3e$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $a1d11c8212b90b3e$export$2faeed762aac6741);
const $a1d11c8212b90b3e$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';

});

parcelRegister("aHuqL", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f87ed1c6d708024$export$4f7929ca6b50a436);


var $eusud = parcelRequire("eusud");
const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f87ed1c6d708024$var$get = async (key)=>{
    try {
        const result = await (0, $eusud.performGetRequest)($0f87ed1c6d708024$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f87ed1c6d708024$var$set = (key, value)=>(0, $eusud.performPutRequest)($0f87ed1c6d708024$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f87ed1c6d708024$var$remove = (key)=>(0, $eusud.performDeleteRequest)($0f87ed1c6d708024$var$url(key));
const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
    get: $0f87ed1c6d708024$var$get,
    set: $0f87ed1c6d708024$var$set,
    remove: $0f87ed1c6d708024$var$remove
};

});


parcelRegister("7QoEx", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("5DvFw")
]).then(()=>parcelRequire('jyeNt'));

});


parcelRegister("bt2pf", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $274a73c0f1d6297a$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $274a73c0f1d6297a$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("ihBhD", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $dbd7508aaed6851f$export$8b5544bab97b10dd);
const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
    const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
    return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
};

});



parcelRegister("44v1T", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $81918a2ef6db1f93$export$d60454526e2281af);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $1uoeA = parcelRequire("1uoeA");
const $81918a2ef6db1f93$export$d60454526e2281af = `(${(0, $1uoeA.TOP_NAVIGATION_HEIGHT)} + ${(0, $1uoeA.BANNER_HEIGHT)})`;

});

parcelRegister("3bl6P", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $0124d1f81a2437a4$export$d397eccea5f37b0a);

var $5uXOq = parcelRequire("5uXOq");
const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("9aaiB", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $dd484d7e2bde5991$export$bccbd45ab793bd09);

var $7JoAD = parcelRequire("7JoAD");

var $5e5zm = parcelRequire("5e5zm");
const $dd484d7e2bde5991$var$useTopNav = (0, $7JoAD.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
    const [state] = $dd484d7e2bde5991$var$useTopNav();
    return state;
};

});

parcelRegister("iIpJ6", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $8c4a7263d22ebdbf$export$932edb7b1b20d079);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $adY3A = parcelRequire("adY3A");

var $ffza4 = parcelRequire("ffza4");

var $e6AHy = parcelRequire("e6AHy");

var $fDtbf = parcelRequire("fDtbf");

var $2Ioew = parcelRequire("2Ioew");


var $frBVt = parcelRequire("frBVt");

var $6jY6G = parcelRequire("6jY6G");

var $2SVPM = parcelRequire("2SVPM");
const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
    const isUsingEntryPoint = Boolean((0, $6jY6G.useCurrentRoute)().entryPoint?.());
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    (0, $5uXOq.useState)(()=>{
        if (!false && isUsingEntryPoint) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $adY3A.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
                (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return isUsingEntryPoint ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null),
        /* @ts-expect-error - TS2322 - We're using JSResourceReference from @atlassian/react-async. */ entryPoint: (0, $adY3A.topNavigationEntryPoint)
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffza4.LazyAtlassianNavigation), null);
};

});
parcelRegister("adY3A", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $e6a45c27809ae082$export$f780be9e138f456f);

var $fuQSj = parcelRequire("fuQSj");

var $5pTlS = parcelRequire("5pTlS");

const $e6a45c27809ae082$export$f780be9e138f456f = (0, $5pTlS.createEntryPoint)({
    root: (0, $fuQSj.JSResourceForInteraction)(()=>(parcelRequire("lesge")), {
        moduleId: "1f1265b4"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});
parcelRegister("lesge", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("1eG9i")
]).then(()=>parcelRequire('9DfkH'));

});


parcelRegister("ffza4", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $772c987a24839dcf$export$4caed23aa0274abb);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $7B17s = parcelRequire("7B17s");

const $772c987a24839dcf$export$4caed23aa0274abb = (0, $7B17s.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("2KdiI"));
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
});

});
parcelRegister("2KdiI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("kV4Fy")
]).then(()=>parcelRequire('jC2al'));

});




parcelRegister("lvpKt", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $c63a700e8bea75a2$export$33e617ec5e4e4f76);

var $5uXOq = parcelRequire("5uXOq");
const $c63a700e8bea75a2$var$styleFullHeight = {
    height: '100vh'
};
const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: $c63a700e8bea75a2$var$styleFullHeight
    }, children);

});

parcelRegister("8Ceqd", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $5b61f4226ddd6087$export$ce1303eaa27a0d3a);

var $5uXOq = parcelRequire("5uXOq");

var $l0D7Q = parcelRequire("l0D7Q");
var $5gBas = parcelRequire("5gBas");

var $hRqXk = parcelRequire("hRqXk");

var $fjcgS = parcelRequire("fjcgS");

var $2Ql51 = parcelRequire("2Ql51");

var $dIdda = parcelRequire("dIdda");
const $5b61f4226ddd6087$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

const $5b61f4226ddd6087$var$GlobalThemeSetter = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, $2Ql51.themePreferenceResource));
    const { colorMode: colorMode } = (0, $5gBas.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
    const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("hxMHI"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            setThemeWithToken($5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
            const handler = (e)=>{
                setThemeWithToken(e.matches ? 'dark' : 'light');
            };
            $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
        }
        return undefined;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initally rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $l0D7Q.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};
const $5b61f4226ddd6087$export$ce1303eaa27a0d3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b61f4226ddd6087$var$GlobalThemeSetter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hRqXk.ThemeSetter), null));

});
parcelRegister("l0D7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $00af4c5f10cba6ed$export$2e2bcd8739ae039);

var $hFKXd = parcelRequire("hFKXd");

var $iag7z = parcelRequire("iag7z");

var $73dwg = parcelRequire("73dwg");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $00af4c5f10cba6ed$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $73dwg.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $iag7z.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $hFKXd.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $73dwg.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $iag7z.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $00af4c5f10cba6ed$export$2e2bcd8739ae039 = $00af4c5f10cba6ed$var$getSSRAutoScript;

});

parcelRegister("hRqXk", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $19ba4484a548afa5$export$ce1303eaa27a0d3a);

var $5uXOq = parcelRequire("5uXOq");

var $7eveN = parcelRequire("7eveN");

var $ceKVk = parcelRequire("ceKVk");

var $g6tJC = parcelRequire("g6tJC");

var $cfg3u = parcelRequire("cfg3u");

var $65Ltd = parcelRequire("65Ltd");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $19ba4484a548afa5$export$ce1303eaa27a0d3a = ()=>{
    const projectTheme = (0, $ceKVk.useProjectTheme)();
    const overviewTheme = (0, $7eveN.useOverviewTheme)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const entityTheme = (0, $5uXOq.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, $65Ltd.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            if (isFormSubmitView) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfg3u.ThemeContainer), {
        isGlobal: true,
        entityTheme: entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g6tJC.ThemeTokensSetter), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfg3u.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g6tJC.ThemeTokensSetter), null));
};

});
parcelRegister("7eveN", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $c0a2b1dfc34915dc$export$a55763fd17eab357);

var $6cG4N = parcelRequire("6cG4N");

var $jrO9m = parcelRequire("jrO9m");
const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $jrO9m.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});
parcelRegister("6cG4N", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $cd302866fea6f361$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $cd302866fea6f361$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $cd302866fea6f361$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $cd302866fea6f361$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $cd302866fea6f361$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $cd302866fea6f361$export$34373eced7ee212e);
$parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", () => $cd302866fea6f361$export$5ddfadab7b1e12c1);
$parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$349e5dbeac874253);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$242b2d2213fedf27);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $cd302866fea6f361$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$cab9d853866386f2);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $cd302866fea6f361$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $cd302866fea6f361$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$410e3d6221a052e);
$parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$8588194807a0ca4b);
$parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$254a8b23553b7df3);
$parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$41cffad47189e5bd);
$parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$ef343e01db40c562);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $cd302866fea6f361$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $cd302866fea6f361$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $1uoeA = parcelRequire("1uoeA");


var $44v1T = parcelRequire("44v1T");
const $cd302866fea6f361$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--jwm-backdrop-filter',
    COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--jwm-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
    COLOR_BORDER: '--jwm-color-border',
    COLOR_BORDER_INPUT: '--jwm-color-border-input',
    COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
    COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
    COLOR_ICON_DANGER: '--jwm-color-icon-danger',
    COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
    COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
    COLOR_ICON_WARNING: '--jwm-color-icon-warning',
    COLOR_LINK: '--jwm-color-link',
    COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
    COLOR_SKELETON: '--jwm-skeleton',
    COLOR_TEXT: '--jwm-color-text',
    COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
    COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
    COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
    COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
    CONTENT_HEIGHT: '--jwm-content-height',
    CONTENT_WIDTH: '--jwm-content-width',
    ELEVATION_SURFACE: '--jwm-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--jwm-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
    WRAPPER_HEIGHT: '--jwm-wrapper-height',
    WRAPPER_PADDING: '--jwm-wrapper-padding',
    WRAPPER_WIDTH: '--jwm-wrapper-width'
};
const $cd302866fea6f361$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
    COLOR_BORDER: 'var(--jwm-color-border)',
    COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
    COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
    COLOR_LINK: 'var(--jwm-color-link)',
    COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
    COLOR_SKELETON: 'var(--jwm-skeleton)',
    COLOR_TEXT: 'var(--jwm-color-text)',
    COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--jwm-content-height)',
    CONTENT_WIDTH: 'var(--jwm-content-width)',
    ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
    WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
};
const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
    'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': `var(--ds-background-input, ${(0, $dbda9f692ace54dd$exports).N0})`,
    'color.background.neutral': `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$exports).N30A})`,
    'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $dbda9f692ace54dd$exports).N40A})`,
    'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $dbda9f692ace54dd$exports).N50A})`,
    'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $dbda9f692ace54dd$exports).N40A})`,
    'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $dbda9f692ace54dd$exports).N50A})`,
    'color.background.selected': `var(--ds-background-selected, ${(0, $dbda9f692ace54dd$exports).B400})`,
    'color.elevation.surface': `var(--ds-surface, ${(0, $dbda9f692ace54dd$exports).N0})`,
    'color.border': `var(--ds-border, ${(0, $dbda9f692ace54dd$exports).N40A})`,
    'color.border.input': "var(--ds-border-input, #091E4224)",
    'color.border.inverse': `var(--ds-border-inverse, ${(0, $dbda9f692ace54dd$exports).N0})`,
    'color.border.selected': `var(--ds-border-selected, ${(0, $dbda9f692ace54dd$exports).B400})`,
    'color.icon.danger': `var(--ds-icon-danger, ${(0, $dbda9f692ace54dd$exports).R200})`,
    'color.icon.information': `var(--ds-icon-information, ${(0, $dbda9f692ace54dd$exports).B200})`,
    'color.icon.success': `var(--ds-icon-success, ${(0, $dbda9f692ace54dd$exports).G200})`,
    'color.icon.warning': `var(--ds-icon-warning, ${(0, $dbda9f692ace54dd$exports).Y200})`,
    'color.link': "var(--ds-link, #0c66e4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
    'color.skeleton': `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$exports).N20A})`,
    'color.text': `var(--ds-text, ${(0, $dbda9f692ace54dd$exports).N800})`,
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$exports).N0})`,
    'color.text.selected': `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$exports).B400})`,
    'color.text.subtle': `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$exports).N500})`,
    'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$exports).N0})`
};
const $cd302866fea6f361$export$97cb21c6432e07e8 = {
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $dbda9f692ace54dd$exports).N0,
    'color.icon.danger': (0, $dbda9f692ace54dd$exports).N0,
    'color.icon.information': (0, $dbda9f692ace54dd$exports).N0,
    'color.icon.success': (0, $dbda9f692ace54dd$exports).N0,
    'color.icon.warning': (0, $dbda9f692ace54dd$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $dbda9f692ace54dd$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $cd302866fea6f361$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $cd302866fea6f361$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$exports).N0})`,
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $dbda9f692ace54dd$exports).N0})`
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $dbda9f692ace54dd$exports).N0,
            'color.icon.information': (0, $dbda9f692ace54dd$exports).N0,
            'color.icon.success': (0, $dbda9f692ace54dd$exports).N0,
            'color.icon.warning': (0, $dbda9f692ace54dd$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
            'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $dbda9f692ace54dd$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #1D2125)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
        }
    }
};
// Old Colors
const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
        dark: $cd302866fea6f361$export$8a6e9b3370a0f87a
    }
};
// Gradients
const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $cd302866fea6f361$export$34373eced7ee212e = [
    $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$5ddfadab7b1e12c1 = [
    $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$349e5dbeac874253 = [
    ...$cd302866fea6f361$export$5ddfadab7b1e12c1,
    $cd302866fea6f361$export$4c351ec1dc290344
];
const $cd302866fea6f361$export$242b2d2213fedf27 = [
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
];
const $cd302866fea6f361$export$8f118a95a310853a = [
    ...$cd302866fea6f361$export$242b2d2213fedf27,
    ...$cd302866fea6f361$export$349e5dbeac874253
];
const $cd302866fea6f361$export$fe05a238062e2c3d = {
    white: $cd302866fea6f361$export$4c351ec1dc290344,
    'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
const $cd302866fea6f361$export$ed7cc0d417ee89e = '--jwm-banner-height';
const $cd302866fea6f361$export$7009ab5fba189797 = `var(${$cd302866fea6f361$export$ed7cc0d417ee89e}, 0px)`;
const $cd302866fea6f361$export$8e357501548afe78 = 24;
const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
const $cd302866fea6f361$export$d9035bc768f8226d = `calc(${$cd302866fea6f361$export$baaf8255c30ea280}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$2af5673c2fa63c55 = 126;
const $cd302866fea6f361$export$5771162cdeebfb85 = `calc(${$cd302866fea6f361$export$2af5673c2fa63c55}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$8588194807a0ca4b = 146;
const $cd302866fea6f361$export$254a8b23553b7df3 = `calc(${$cd302866fea6f361$export$8588194807a0ca4b}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
const $cd302866fea6f361$export$41cffad47189e5bd = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3})`;
const $cd302866fea6f361$export$ef343e01db40c562 = `calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, $1uoeA.LEFT_PANEL_WIDTH)} - ${(0, $1uoeA.LEFT_SIDEBAR_WIDTH)} - ${(0, $1uoeA.RIGHT_PANEL_WIDTH)} - ${(0, $1uoeA.RIGHT_SIDEBAR_WIDTH)}) !important`;
const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $1uoeA.LEFT_PANEL_WIDTH)} - ${(0, $1uoeA.LEFT_SIDEBAR_WIDTH)} - ${(0, $1uoeA.RIGHT_PANEL_WIDTH)} - ${(0, $1uoeA.RIGHT_SIDEBAR_WIDTH)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;

});

parcelRegister("jrO9m", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $e1715b61e2fa96e9$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $e1715b61e2fa96e9$export$626541a5c6f2cfa1);

var $dIdda = parcelRequire("dIdda");

var $hFi7P = parcelRequire("hFi7P");
const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $dIdda.createResource)({
    type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $hFi7P.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $dIdda.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);

});
parcelRegister("hFi7P", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $692d3aa28ecf0a74$export$f0395142dbdd6c61);

var $63wRx = parcelRequire("63wRx");

var $jlq4V = parcelRequire("jlq4V");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dXq4S = parcelRequire("dXq4S");

var $dpLxG = parcelRequire("dpLxG");

const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $dpLxG.QUERY),
                variables: {
                    id: (0, $dXq4S.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project-overview',
                        resourceId: overviewId,
                        activationId: activationId
                    })
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63wRx.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $jlq4V.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("63wRx", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc1a4d4cd369fa52$export$e79bf238de33eabb);
const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("jlq4V", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $503bc83696833cc0$export$89c202e66b2de2b6);

var $7hpBk = parcelRequire("7hpBk");

var $8LQ84 = parcelRequire("8LQ84");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
        this.message = $503bc83696833cc0$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("7hpBk", function(module, exports) {

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $54cdfac2bc83c2a9$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $8LQ84(value) ? value : [
        value
    ];
}
module.exports = $54cdfac2bc83c2a9$var$castArray;

});


parcelRegister("dpLxG", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $42259e945f9fd88b$export$2b91517d6d5b4365);

const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;

});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';




parcelRegister("ceKVk", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $f0c1f93a3181b765$export$18084206b9430153);

var $5uXOq = parcelRequire("5uXOq");

var $6cG4N = parcelRequire("6cG4N");

var $l2N2a = parcelRequire("l2N2a");

var $dIdda = parcelRequire("dIdda");
const $f0c1f93a3181b765$export$18084206b9430153 = ()=>{
    const { data: data } = (0, $dIdda.useResource)((0, $l2N2a.projectDetailsResource));
    return (0, $5uXOq.useMemo)(()=>{
        if (data != null) {
            const entityId = `project/${data.currentProject?.id}`;
            const themeSetting = data.themeSetting ?? {
                type: 'color',
                value: (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
            };
            return {
                themeSetting: themeSetting,
                entityId: entityId
            };
        }
        return null;
    }, [
        data
    ]);
};

});
parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "projectDetailsResource", () => $a72df1053ff3c9a0$export$e541d9eb202b4972);
$parcel$export(module.exports, "useProject", () => $a72df1053ff3c9a0$export$51b1383ef8844a7);
$parcel$export(module.exports, "useMediaConfiguration", () => $a72df1053ff3c9a0$export$ab5cf8327e07f046);

var $1nb22 = parcelRequire("1nb22");

var $dIdda = parcelRequire("dIdda");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$e541d9eb202b4972 = (0, $dIdda.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$51b1383ef8844a7 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $a72df1053ff3c9a0$export$ab5cf8327e07f046 = ()=>{
    const { data: data } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
    return data?.media ?? null;
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dXq4S = parcelRequire("dXq4S");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $dXq4S.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project',
                        resourceId: projectId
                    }) : ''
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        status: node.status,
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            deleteIssues: node.deleteIssues.canPerform,
            editIssues: node.editIssues.canPerform,
            linkIssues: node.linkIssues.canPerform,
            scheduleIssues: node.scheduleIssues.canPerform,
            transitionIssues: node.transitionIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data),
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
    });

});




parcelRegister("g6tJC", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $e87da32ae7e01ae2$export$41f41c7ff10d45cd);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");


var $cfg3u = parcelRequire("cfg3u");

var $gwIPs = parcelRequire("gwIPs");

var $6cG4N = parcelRequire("6cG4N");

var $fHEdP = parcelRequire("fHEdP");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");


var $cgL4i = parcelRequire("cgL4i");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $e87da32ae7e01ae2$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
}
const $e87da32ae7e01ae2$var$buildHorizontalNavVariables = (theme)=>{
    if ((0, $3HwlS.getWillShowNav4)()) return `${0, $9ca01df94f066b97$export$539c074adec2188a}: ${theme['color.link']};
${0, $9ca01df94f066b97$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $9ca01df94f066b97$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $9ca01df94f066b97$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $9ca01df94f066b97$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $9ca01df94f066b97$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $9ca01df94f066b97$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $9ca01df94f066b97$export$4cd72d361867c565}: ${theme['color.border']};
${0, $9ca01df94f066b97$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
    return '';
};
// eslint-disable-next-line complexity
const $e87da32ae7e01ae2$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $6cG4N.HIGH_BRIGHTNESS_THEME) : (0, $6cG4N.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $fHEdP.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $e87da32ae7e01ae2$var$mergeThemes(// the base theme for the application
    (0, $6cG4N.BASE_THEME), // the brightness overrides
    isImageConfig ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $6cG4N.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    if (backgroundImageUrl) // in dark mode, the image will be darkened by blending with a black transparent background
    elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    else if (applicationColorMode === 'dark') {
        if ((0, $6cG4N.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $dbda9f692ace54dd$export$29a4f05edc054374})` : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $gwIPs.gridSize}px` : '0';
    const isNav4 = (0, $3HwlS.getWillShowNav4)();
    const isNav4HighTab = (0, $4R6GH.fg)('horizontal_navigation_increase_tab_height');
    // eslint-disable-next-line no-nested-ternary
    const businessWrapperWithBackgroundHeight = isNav4 ? isNav4HighTab ? (0, $6cG4N.NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $6cG4N.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    // eslint-disable-next-line no-nested-ternary
    const businessWrapperHeight = isNav4 ? isNav4HighTab ? (0, $6cG4N.NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT) : (0, $6cG4N.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $6cG4N.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $6cG4N.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $6cG4N.Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $6cG4N.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $6cG4N.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $6cG4N.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $6cG4N.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $6cG4N.Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, $6cG4N.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $6cG4N.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $6cG4N.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $6cG4N.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $6cG4N.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $6cG4N.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $6cG4N.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $6cG4N.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $6cG4N.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $6cG4N.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $6cG4N.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $6cG4N.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $6cG4N.Variables).CONTENT_WIDTH}: ${0, $6cG4N.BUSINESS_WRAPPER_WIDTH};
${(0, $6cG4N.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $6cG4N.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $6cG4N.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $6cG4N.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $6cG4N.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $6cG4N.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$e87da32ae7e01ae2$var$buildHorizontalNavVariables(theme)}`;
};
const $e87da32ae7e01ae2$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const [{ themeSetting: themeSetting }] = (0, $cfg3u.useThemeHook)();
    const backgroundConfig = (0, $fHEdP.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true
    });
    const backgroundImageUrl = (0, $cgL4i.useBackgroundImageUrl)(themeSetting);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$e87da32ae7e01ae2$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$e87da32ae7e01ae2$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
        }
    }));
});

});
parcelRegister("cfg3u", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $d5f9de57f6b85a68$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $d5f9de57f6b85a68$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $d5f9de57f6b85a68$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $d5f9de57f6b85a68$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $d5f9de57f6b85a68$export$4ba6f9d407e18961);

var $ajpes = parcelRequire("ajpes");

var $fHEdP = parcelRequire("fHEdP");

var $7JoAD = parcelRequire("7JoAD");
const $d5f9de57f6b85a68$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $d5f9de57f6b85a68$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $d5f9de57f6b85a68$var$actions = {
    setTheme: $d5f9de57f6b85a68$var$setTheme,
    setSelectedThemeSetting: $d5f9de57f6b85a68$var$setSelectedThemeSetting
};
const $d5f9de57f6b85a68$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $d5f9de57f6b85a68$var$Store = (0, $7JoAD.createStore)({
    initialState: $d5f9de57f6b85a68$var$initialState,
    actions: $d5f9de57f6b85a68$var$actions,
    name: 'BusinessTheme'
});
const $d5f9de57f6b85a68$export$c6e50a832af54243 = (0, $7JoAD.createContainer)($d5f9de57f6b85a68$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $d5f9de57f6b85a68$export$11eb671888ed6e7d = (0, $7JoAD.createContainer)($d5f9de57f6b85a68$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $d5f9de57f6b85a68$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $d5f9de57f6b85a68$var$initialState);
        }
});
const $d5f9de57f6b85a68$export$b95ba2c6b597cfbb = (0, $7JoAD.createHook)($d5f9de57f6b85a68$var$Store);
const $d5f9de57f6b85a68$var$getThemeSetting = (0, $7JoAD.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $d5f9de57f6b85a68$export$87d26f94ea053d38 = (0, $7JoAD.createHook)($d5f9de57f6b85a68$var$Store, {
    selector: $d5f9de57f6b85a68$var$getThemeSetting
});
const $d5f9de57f6b85a68$var$getSelectedThemeSetting = (0, $7JoAD.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $d5f9de57f6b85a68$export$4ba6f9d407e18961 = (0, $7JoAD.createHook)($d5f9de57f6b85a68$var$Store, {
    selector: $d5f9de57f6b85a68$var$getSelectedThemeSetting
});

});
parcelRegister("fHEdP", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $a34e148e1f33a06a$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $a34e148e1f33a06a$export$fe2402bbc6ac3125);

var $6cG4N = parcelRequire("6cG4N");
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a34e148e1f33a06a$var$ThemeManager {
    init() {
        (0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        (0, $6cG4N.SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $6cG4N.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $6cG4N.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $6cG4N.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $6cG4N.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
$a34e148e1f33a06a$export$aba92a7f3273f617.init();
function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}

});


const $9ca01df94f066b97$export$d1b9ea3245b6a5de = 2;
const $9ca01df94f066b97$export$7f37240649d2a1e2 = 36;
const $9ca01df94f066b97$export$d07bba395c9390f1 = 56;
const $9ca01df94f066b97$export$29911ec08ab2ca2d = 5;
const $9ca01df94f066b97$export$b61e6f89a9db76de = 12;
const $9ca01df94f066b97$export$7fd2e391116c6ef5 = 9;
const $9ca01df94f066b97$export$e1633e494d305bfb = 'MORE';
const $9ca01df94f066b97$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $9ca01df94f066b97$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $9ca01df94f066b97$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $9ca01df94f066b97$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $9ca01df94f066b97$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $9ca01df94f066b97$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $9ca01df94f066b97$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $9ca01df94f066b97$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $9ca01df94f066b97$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $9ca01df94f066b97$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("cgL4i", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $1ecd26e60d717442$export$16f28a2a10ece447);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $YWuyq = parcelRequire("YWuyq");

var $fHEdP = parcelRequire("fHEdP");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $l2N2a = parcelRequire("l2N2a");
const $1ecd26e60d717442$export$16f28a2a10ece447 = (themeSetting)=>{
    (0, $gKZoD.di)(URL, fetch);
    const media = (0, $l2N2a.useMediaConfiguration)();
    const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
    const currentThemeId = (0, $5uXOq.useRef)(null);
    currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
    (0, $5uXOq.useEffect)(()=>{
        setImageUrl(lowResUrl);
        // if we don't have an image theme, do nothing
        if (!media || themeSetting?.type !== 'image') return;
        // build a new URL to the /binary path
        const binaryUrl = (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            mediaEndpoint: 'binary',
            'max-age': Number.MAX_SAFE_INTEGER
        });
        // send a request to fetch the image with the binary URL with bearer token authentication
        fetch(binaryUrl.toString(), {
            headers: {
                Authorization: `Bearer ${themeSetting.mediaReadToken}`
            }
        }).then((response)=>response.blob()).then((blob)=>{
            const objectUrl = URL.createObjectURL(blob);
            if (currentThemeId.current === themeSetting.id) {
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $YWuyq.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }
        }).catch((error)=>{
            // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                meta: {
                    id: 'fetchBinaryBackgroundImage',
                    packageName: 'jiraBusinessThemeComponents',
                    teamName: 'work-management-frontier'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("YWuyq", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $20589baa06c4bf13$export$1869e04dbed4c16c);

var $azYnG = parcelRequire("azYnG");

var $lFKmC = parcelRequire("lFKmC");
const $20589baa06c4bf13$var$APP_ID = '7066';
const $20589baa06c4bf13$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$20589baa06c4bf13$var$APP_ID}`;
const $20589baa06c4bf13$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $20589baa06c4bf13$var$ID_LENGTH = 12; // the length of an unsplash image id
const $20589baa06c4bf13$export$28219189b23a0628 = Math.floor($20589baa06c4bf13$var$MAX_URL_LENGTH / $20589baa06c4bf13$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $20589baa06c4bf13$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(imageIds, $20589baa06c4bf13$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$20589baa06c4bf13$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $20589baa06c4bf13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $20589baa06c4bf13$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$20589baa06c4bf13$var$UnsplashTracker.instance) $20589baa06c4bf13$var$UnsplashTracker.instance = new $20589baa06c4bf13$var$UnsplashTracker();
        return $20589baa06c4bf13$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.send, 1000);
    }
}
const $20589baa06c4bf13$export$1869e04dbed4c16c = $20589baa06c4bf13$var$UnsplashTracker.getInstance();

});
parcelRegister("azYnG", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");

var $4rDUz = parcelRequire("4rDUz");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
    if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
    else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
    return result;
}
module.exports = $7b3c02adf390bcc6$var$chunk;

});





parcelRegister("hxMHI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("OgDz0").then(()=>parcelRequire('gEdc8'));

});



parcelRegister("9fJwh", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $e4e869477f65bb91$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "BusinessWrapper", () => $e4e869477f65bb91$export$17220b5b22a6586);
/* BusinessWrapper.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $7tVGO = parcelRequire("7tVGO");
const $e4e869477f65bb91$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm _1pbyidpf",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y22u",
    insetRootVisualRefresh: "_ca0qv47k",
    insetContainer: "_2rkolsi6 _bfhk8q8z"
};
const $e4e869477f65bb91$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jwm_fix_popup_broken_with_custom_background') && $e4e869477f65bb91$var$styles.root,
            !(0, $4R6GH.fg)('jwm_fix_popup_broken_with_custom_background') && $e4e869477f65bb91$var$styles.rootOld,
            $e4e869477f65bb91$var$styles.fullHeight,
            appearance === 'inset' && $e4e869477f65bb91$var$styles.insetRoot,
            (0, $dCm1o.isVisualRefreshEnabled)() && appearance === 'inset' && $e4e869477f65bb91$var$styles.insetRootVisualRefresh
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $e4e869477f65bb91$var$styles.fullHeight,
            appearance === 'inset' && $e4e869477f65bb91$var$styles.insetContainer
        ])
    }, children));
const $e4e869477f65bb91$export$17220b5b22a6586 = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $5uXOq.createElement((0, $7tVGO.OuterWrapperWithBackground), null, /*#__PURE__*/ $5uXOq.createElement((0, $7tVGO.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $5uXOq.createElement((0, $7tVGO.OuterWrapper), null, /*#__PURE__*/ $5uXOq.createElement((0, $7tVGO.InnerWrapper), null, children));
};

});
parcelRegister("dCm1o", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $322f7f27e3ad3058$export$48345cb467db19b6);

var $4R6GH = parcelRequire("4R6GH");

var $1MhR0 = parcelRequire("1MhR0");
/*
 *  This is a similar implementation to Nav4
 *  (ref: src/packages/navigation-apps/sidebar-nav4/rollout/src/common/utils/get-will-show-nav4/get-will-show-nav4-for-eap/index.tsx)
 *  to accommodate the complex rollout logic of the visual refresh.
 */ // We have to use a DUMMY_CONDITION to not trigger ESLint errors.
const $322f7f27e3ad3058$var$DUMMY_CONDITION = true;
const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, $4R6GH.fg)('visual-refresh') && // Kill switch for the entire rollout of the visual refresh
    ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
// Used for the dogfooding of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, $4R6GH.fg)('visual-refresh-dogfood') && !(0, $1MhR0.getIsNav4UserOptOut)();
// Used for the EAP of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, $4R6GH.fg)('visual-refresh-eap') && !(0, $1MhR0.getIsNav4UserOptOut)();
// Used for the OpenBeta of the visual refresh
// TODO: Implement the OpenBeta experiment
const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>$322f7f27e3ad3058$var$DUMMY_CONDITION && (0, $4R6GH.fg)('visual-refresh-open-beta');

});

parcelRegister("7tVGO", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0d4f1f0817ef6a9b$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $0d4f1f0817ef6a9b$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $0d4f1f0817ef6a9b$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $0d4f1f0817ef6a9b$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $cSD7y = parcelRequire("cSD7y");

var $3HwlS = parcelRequire("3HwlS");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0d4f1f0817ef6a9b$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1jzz",
            __cmplp.className
        ])
    });
});
const $0d4f1f0817ef6a9b$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154ieda8",
            __cmplp.className
        ])
    });
});
const $0d4f1f0817ef6a9b$var$Nav4HighTabOuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1f46",
            __cmplp.className
        ])
    });
});
const $0d4f1f0817ef6a9b$export$edaaad985a878983 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $cSD7y.componentWithFG)('horizontal_navigation_increase_tab_height', $0d4f1f0817ef6a9b$var$Nav4HighTabOuterWrapper, $0d4f1f0817ef6a9b$var$Nav4OuterWrapper), $0d4f1f0817ef6a9b$var$Nav3OuterWrapper);
const $0d4f1f0817ef6a9b$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0d4f1f0817ef6a9b$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4y22u",
            __cmplp.className
        ])
    });
});
const $0d4f1f0817ef6a9b$export$f185744748c379a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2d3f1oc1 _japi1mcq _iu1g1fl4 _fok81wug _q7c11wug",
            __cmplp.className
        ])
    });
});
const $0d4f1f0817ef6a9b$export$2e149d12a18af14b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0d4f1f0817ef6a9b$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkolsi6 _bfhk8q8z _2d3f1yz2 _japi1e8k",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8Orxo", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $66a85aa0db68ca7e$export$5b4913142e03bca8, (v) => $66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $66a85aa0db68ca7e$export$10497c7ce66fcb84, (v) => $66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $66a85aa0db68ca7e$export$b69e3301ce081aa3, (v) => $66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $66a85aa0db68ca7e$export$d95b4586d238a081, (v) => $66a85aa0db68ca7e$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v) => $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $66a85aa0db68ca7e$export$fe53371bee54353d, (v) => $66a85aa0db68ca7e$export$fe53371bee54353d = v);
var $66a85aa0db68ca7e$export$1e511d4a378977f5;
var $66a85aa0db68ca7e$export$5b4913142e03bca8;
var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
var $66a85aa0db68ca7e$export$d95b4586d238a081;
var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
var $66a85aa0db68ca7e$export$fe53371bee54353d;
'use strict';
$66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("vrkiK", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $fd0af9cf1691807e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $fd0af9cf1691807e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $fd0af9cf1691807e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $fd0af9cf1691807e$export$9f3e656a7f6a3adc);

var $65Ltd = parcelRequire("65Ltd");
const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [
                (0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
            ];
            resetDone = true;
            break;
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT:
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf((0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT:
            // use search to navigate to board
            if (rapidBoardPaths.includes((0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes((0, $65Ltd.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 0, $65Ltd.ROUTE_NAMES_ISSUE:
        case 0, $65Ltd.ROUTE_NAMES_ISSUE_EMBED:
        case 0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
        case 0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
        case 0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_ISSUES:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("5SZ4u", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $a9ed4d6a262d7251$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $a9ed4d6a262d7251$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $a9ed4d6a262d7251$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $a9ed4d6a262d7251$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $a9ed4d6a262d7251$export$3fd21eaf97df4718);

var $7JoAD = parcelRequire("7JoAD");

var $gCQRW = parcelRequire("gCQRW");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $7JoAD.defaults))) (0, $7JoAD.defaults).devtools = false;
const $a9ed4d6a262d7251$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $gCQRW.actions,
    name: 'remoteActionsStore'
});
const $a9ed4d6a262d7251$export$28c2e4c663a86266 = (0, $7JoAD.createContainer)($a9ed4d6a262d7251$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $gCQRW.actions).initStore());
        }
});
const $a9ed4d6a262d7251$export$333357b3de3e67a0 = (selector)=>(0, $7JoAD.createHook)($a9ed4d6a262d7251$var$Store, {
        selector: selector
    })();
const $a9ed4d6a262d7251$export$3cc006661ae2a759 = (0, $7JoAD.createStateHook)($a9ed4d6a262d7251$var$Store, {
    selector: (state)=>state.remoteActions
});
const $a9ed4d6a262d7251$export$3fb9275d3845bd5a = (0, $7JoAD.createStateHook)($a9ed4d6a262d7251$var$Store, {
    selector: (state)=>state.meta
});
const $a9ed4d6a262d7251$export$3fd21eaf97df4718 = (0, $7JoAD.createActionsHook)($a9ed4d6a262d7251$var$Store);

});
parcelRegister("gCQRW", function(module, exports) {

$parcel$export(module.exports, "actions", () => $17c82c0e7d12a826$export$e324594224ef24da);

var $NVso8 = parcelRequire("NVso8");

var $lkeuz = parcelRequire("lkeuz");

var $bbfU8 = parcelRequire("bbfU8");

var $bVCeZ = parcelRequire("bVCeZ");
const $17c82c0e7d12a826$export$e324594224ef24da = {
    processRemoteActions: $bbfU8.processRemoteActions,
    saveActionPerformedAttempt: $bVCeZ.saveActionPerformedAttempt,
    initStore: $lkeuz.initStore,
    clearActionId: $NVso8.clearActionId
};

});
parcelRegister("NVso8", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $0d2e82c11cc0f019$export$8d8b492eefa9efba);

var $3kQAO = parcelRequire("3kQAO");
const $0d2e82c11cc0f019$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $3kQAO.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("3kQAO", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $10e7e58c8915ac9c$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $10e7e58c8915ac9c$export$7228aaade919a8b6);
const $10e7e58c8915ac9c$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $10e7e58c8915ac9c$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$10e7e58c8915ac9c$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $10e7e58c8915ac9c$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$10e7e58c8915ac9c$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("lkeuz", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $1bb1ebce3780f127$export$41f27b3823a442c6);

var $3kQAO = parcelRequire("3kQAO");
const $1bb1ebce3780f127$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $3kQAO.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("bbfU8", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $ba6449e92d9dcd18$export$15e69d1dd38ccaa3);

var $jN9B9 = parcelRequire("jN9B9");
const $ba6449e92d9dcd18$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $jN9B9.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $jN9B9.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: Date.now()
        });
    };

});
parcelRegister("jN9B9", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $873203fe87d09f68$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $873203fe87d09f68$export$c7cc93192d09a3d7);

var $d00Oa = parcelRequire("d00Oa");
const $873203fe87d09f68$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $873203fe87d09f68$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $873203fe87d09f68$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $873203fe87d09f68$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $d00Oa.ConditionType).buildRange:
            return $873203fe87d09f68$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $d00Oa.ConditionType).featureFlag:
            return $873203fe87d09f68$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $d00Oa.ConditionType).featureGate:
            return $873203fe87d09f68$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $873203fe87d09f68$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("d00Oa", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $f718d03fe84ec779$export$748d1c753cdf4bfd);
var $f718d03fe84ec779$export$748d1c753cdf4bfd;
(function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
})($f718d03fe84ec779$export$748d1c753cdf4bfd || ($f718d03fe84ec779$export$748d1c753cdf4bfd = {}));

});



parcelRegister("bVCeZ", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $44d4912ce215b35b$export$e3144a2e886e0e77);

var $3kQAO = parcelRequire("3kQAO");
const $44d4912ce215b35b$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $3kQAO.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("7LpuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c62dfc18679e80c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $bNvU3 = parcelRequire("bNvU3");

var $7N30e = parcelRequire("7N30e");

var $6b6Tk = parcelRequire("6b6Tk");


var $8Qrwl = parcelRequire("8Qrwl");

var $hXKq5 = parcelRequire("hXKq5");
class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args);
        this.customMarks = [];
        this.onStart = ()=>{
            (0, $kUU4G.default)((0, $ce556f125dee8174$export$56940a9488e85199));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
        };
        this.onCustomMark = (markName)=>{
            (0, $x9xyg.setMark)((0, $hXKq5.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        };
        this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        };
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("8Qrwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87d05828c384551$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
var $d87d05828c384551$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);

});

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("dZw8H", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $b1cd152eb196251c$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $b1cd152eb196251c$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $b1cd152eb196251c$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $b1cd152eb196251c$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $b1cd152eb196251c$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $b1cd152eb196251c$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $b1cd152eb196251c$export$6e9ab893e97cccef);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $dIdda = parcelRequire("dIdda");

var $7JoAD = parcelRequire("7JoAD");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $7JoAD.createContainer)((0, $7w9eZ.default));
const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $4oDnX.useSpaState)();
    (0, $5uXOq.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $dIdda.createRouterSelector)((state)=>state.match);
const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $7JoAD.createHook)((0, $7w9eZ.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
    const match = $b1cd152eb196251c$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: setAppReady
        }));
const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: setAppReady,
            args: comparer
        }));
const $b1cd152eb196251c$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
            op: setAppErrorReady
        }));
class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $7JoAD.defaultRegistry).getStore((0, $7w9eZ.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});

parcelRegister("5eQ1m", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $64cfd661e498c7fe$export$5f8d39834fd61797);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");
const $64cfd661e498c7fe$export$5f8d39834fd61797 = ({ children: children })=>{
    // otherwise if the feature flag is enabled/or force opt-in, use React.StrictMode
    return (0, $co1wz.ff)('jfp.magma.enable-strict-mode') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).StrictMode, null, children) : children;
};

});

parcelRegister("b7awD", function(module, exports) {

$parcel$export(module.exports, "Router", () => $87aa2fd82c8be71a$export$55185c17a0fcbe46);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $d8orV = parcelRequire("d8orV");
const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $d8orV.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("d8orV", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $0614c9d3afc2dd7f$export$c41e96fd89bc6106);

var $5uXOq = parcelRequire("5uXOq");

var $a2g00 = parcelRequire("a2g00");

var $5yJb9 = parcelRequire("5yJb9");

var $9OXo1 = parcelRequire("9OXo1");

var $8Y8sk = parcelRequire("8Y8sk");
const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $8Y8sk.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $a2g00.createEntryPointsPlugin)({
            environment: (0, $5yJb9.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("a2g00", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $e3cbf02360bc6f96$export$33586718f82f356f);

var $8Uumt = parcelRequire("8Uumt");

var $3gC8D = parcelRequire("3gC8D");

var $3I4nj = parcelRequire("3I4nj");

var $ktB2C = parcelRequire("ktB2C");
const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $3gC8D.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else entryPointReference = (0, $8Uumt.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: context,
                    ...entryPointParams
                });
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $3I4nj.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $3gC8D.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $3gC8D.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $ktB2C.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        }
    });

});
parcelRegister("3gC8D", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $f48ce76f20803aec$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $f48ce76f20803aec$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $f48ce76f20803aec$export$5997e70fc4543270);
const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("ktB2C", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $67d2b262678828c6$export$944f853f194e5dd5);

var $kipqU = parcelRequire("kipqU");
const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $kipqU.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});


parcelRegister("8Y8sk", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $d3b2f44f58ee61bb$export$23ed892c481a96fe);

var $8fYaK = parcelRequire("8fYaK");

var $4CEu1 = parcelRequire("4CEu1");
const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $8fYaK.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $8fYaK.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
            const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $8fYaK.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4CEu1", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $448a0fea894dd469$export$7cbbc763e2f3d65d);

var $9KbzN = parcelRequire("9KbzN");

var $dj41J = parcelRequire("dj41J");
const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $dj41J.routeHasResources)(nextRoute)) return [];
    if ((0, $dj41J.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $9KbzN.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $9KbzN.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("9KbzN", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $82cfa1d66d41fab5$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $82cfa1d66d41fab5$export$cd7fbe7e979df558);
const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("dj41J", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $9c8422e0259b24f6$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $9c8422e0259b24f6$export$221027ff1aa38f82);
const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("81ezV", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $33ea5bfeb747665b$export$a580704a2f3cfca);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");
const $33ea5bfeb747665b$export$a580704a2f3cfca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("6YRTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd6eeaf3add142$export$2e2bcd8739ae039);

var $6vAaw = parcelRequire("6vAaw");

var $fr1K2 = parcelRequire("fr1K2");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("TtQEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ee37fd26b4ccf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");


var $l7nSX = parcelRequire("l7nSX");
const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, $jzjy1.AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, $l7nSX.default));
class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
            actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("l7nSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5cee06f4a100e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $78DCi = parcelRequire("78DCi");

var $8oe80 = parcelRequire("8oe80");

var $hhweD = parcelRequire("hhweD");
class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $78DCi.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.sendDwellEvent = (payload)=>(0, $hhweD.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, $8oe80.default)('dwellTime', {
    onDwell: 'dwelled'
})($8c5cee06f4a100e3$export$1c7ccff61c195c75);

});
parcelRegister("hhweD", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $a4297ed46523d116$export$13990ad4625571ed);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
const $a4297ed46523d116$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $a4297ed46523d116$var$isNotUndefined);
};
const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$a4297ed46523d116$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("5Jsi2", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $65e6525a854bf206$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $65e6525a854bf206$export$c092460ed33e0e35);
const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $65e6525a854bf206$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});

parcelRegister("bShz7", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $fd73e472799b8227$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $fd73e472799b8227$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $fd73e472799b8227$export$d6b0928f07bafe57);
const $fd73e472799b8227$var$prefetchTiming = new Map();
const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
    if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("5HG6S", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $804f5602998bd8a4$export$1f61c5e3f6410afa);
const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("kKlrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f44f620ca2fe28$export$2e2bcd8739ae039);

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $aZWa4 = parcelRequire("aZWa4");

var $3dQJA = parcelRequire("3dQJA");

var $darnD = parcelRequire("darnD");

var $23oLI = parcelRequire("23oLI");

var $hhGDe = parcelRequire("hhGDe");

var $bsNVL = parcelRequire("bsNVL");

var $jIiO6 = parcelRequire("jIiO6");
var $986xT = parcelRequire("986xT");

var $ds51m = parcelRequire("ds51m");

var $fJbQ9 = parcelRequire("fJbQ9");

var $itoGf = parcelRequire("itoGf");

var $dQKfU = parcelRequire("dQKfU");
const $71f44f620ca2fe28$var$getUFOConfigFromFF = ()=>(0, $co1wz.getFeatureFlagValue)('ufo.config', {});
function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $3dQJA.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("fjcgS")));
}
function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = $71f44f620ca2fe28$var$getUFOConfigFromFF();
    (0, $aZWa4.retrieveAndSetPageLoadTrace)((0, $j8DrX.default));
    (0, $jIiO6.configure)((0, $itoGf.jiraResourceTimingsConfig));
    (0, $986xT.startResourceTimingBuffer)();
    (0, $23oLI.configure)((0, $fJbQ9.jiraBundleEvalTimingsConfig));
    (0, $ds51m.configure)((0, $dQKfU.jiraSsrConfig));
    (0, $darnD.GlobalReactLooselyLazyProfiler).current = (0, $hhGDe.ModuleLoadingProfiler);
    const stopVCAtInteractionFinish = (0, $4R6GH.fg)('stop_vc_at_interaction_finish');
    const enableSegmentHighlighting = (0, $4R6GH.fg)('ufo_enable_segment_highlighting_jira');
    (0, $bsNVL.init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: enableSegmentHighlighting,
        product: 'jira',
        region: (0, $j8DrX.default)('ajs-region') || 'unknown',
        additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
        captureLateReRenders: (0, $4R6GH.fg)('ufo_capture_late_rerenders_jira'),
        vc: {
            enabled: (0, $co1wz.ff)('uip.vc.partial', false),
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $co1wz.ff)('uip.vc.devtools', false),
            selectorConfig: {
                id: true,
                role: true,
                className: true,
                testId: false
            },
            ssr: (0, $co1wz.ff)('uip.vc.ssr', false),
            stopVCAtInteractionFinish: stopVCAtInteractionFinish
        },
        enableBetterPageVisibilityApi: (0, $co1wz.ff)('uip.vc.better-page-visibility', false)
    });
}

});
parcelRegister("aZWa4", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $b515f2bc55199ff5$export$1a71d2bbe236de99);

var $b5JOY = parcelRequire("b5JOY");
let $b515f2bc55199ff5$var$alreadySet = false;
const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $b515f2bc55199ff5$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $b515f2bc55199ff5$var$alreadySet = true;
    (0, $b5JOY.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("3dQJA", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $f5569bfee184b069$export$abf5e20822fa925);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $3HwlS = parcelRequire("3HwlS");

var $sUexw = parcelRequire("sUexw");

var $5YDBW = parcelRequire("5YDBW");

var $5uZVJ = parcelRequire("5uZVJ");

var $eV38z = parcelRequire("eV38z");

var $jgkaQ = parcelRequire("jgkaQ");

var $9NJeU = parcelRequire("9NJeU");

var $3Itig = parcelRequire("3Itig");

var $6R03U = parcelRequire("6R03U");

var $bo7zb = parcelRequire("bo7zb");

var $ax2PR = parcelRequire("ax2PR");

var $4xsv9 = parcelRequire("4xsv9");
function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    customData['network:assetEncoding'] = (0, $sUexw.getAssetEncoding)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.navType = (0, $3HwlS.getWillShowNav4)() ? 'nav4' : 'nav3';
    customData.httpProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $9NJeU.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $eV38z.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $jgkaQ.getMarks)({
            start: start
        }),
        ...(0, $3Itig.getPageSizeMetrics)(),
        ...(0, $3Itig.getExtraNavigationTimings)(),
        ...(0, $bo7zb.getServerDurationMetrics)(),
        ...(0, $6R03U.getRouterResourceMetrics)(),
        ...(0, $4xsv9.getWRMStats)(),
        ...(0, $3Itig.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $5YDBW.getCacheHitRatio)({
            start: start
        }),
        ...(0, $5uZVJ.getCHRInfo)({
            start: start
        }),
        ...(0, $ax2PR.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $5uXOq.version)
    };
    return customData;
}

});
parcelRegister("sUexw", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $7cf3b2ddfe1abab1$export$fd12d8f45e126585);
function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("5YDBW", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $62c0824bd7614469$export$e8a9322c3d9da8a6);

var $6RCeq = parcelRequire("6RCeq");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $62c0824bd7614469$var$cacheableTypes = [
    'script',
    'link'
];
const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
const $62c0824bd7614469$var$CACHE_DISK = 'disk';
const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
    if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
    if (size === undefined) return null;
    return $62c0824bd7614469$var$CACHE_NETWORK;
};
const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("5uZVJ", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $e76f22784dfe18ae$export$9e005e111be93521);

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $d1SfZ = parcelRequire("d1SfZ");
const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, $x9xyg.getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
    const reporter = new (0, $d1SfZ.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("d1SfZ", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $850475b27a81c50e$export$7d0d4cfb6455ffa5);

var $80WiQ = parcelRequire("80WiQ");

var $d1r8j = parcelRequire("d1r8j");
class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $d1r8j.CHRSummary)();
        this.all = new (0, $d1r8j.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $80WiQ.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.size[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("80WiQ", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $0b57baf495baebc5$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("d1r8j", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $d000becd84478ee1$export$783d6618ee601ba);

var $80WiQ = parcelRequire("80WiQ");
const $d000becd84478ee1$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $80WiQ.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
};
class $d000becd84478ee1$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $d000becd84478ee1$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("eV38z", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $45336243ca9d66b9$export$b46cecdf698e4bb5);

var $akIBh = parcelRequire("akIBh");

var $5HXkx = parcelRequire("5HXkx");

var $7hESW = parcelRequire("7hESW");

var $aOwtG = parcelRequire("aOwtG");

var $8YqT3 = parcelRequire("8YqT3");
function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
    (0, $8YqT3.startLSObserver)();
    (0, $8YqT3.startLTObserver)();
}
const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $7hESW.getTBT)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $akIBh.getCLS)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("akIBh", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $b182c515ac203eb1$export$fc6227831ee7c7);
const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("5HXkx", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $b2a196da23758bb0$export$a4def92db6fc8e17);
const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("7hESW", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $e79996724decdf66$export$2d6e933b35bd3407);
const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("aOwtG", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $14dd3fd4391f2796$export$f7dc16cbd16f7bbe);

var $5HXkx = parcelRequire("5HXkx");
class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
    [(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
    [(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
};

});

parcelRegister("8YqT3", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $f3198686c7919898$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $f3198686c7919898$export$54fb8b6aaf70ec9c);

var $5HXkx = parcelRequire("5HXkx");

var $aOwtG = parcelRequire("aOwtG");
let $f3198686c7919898$var$pe = null;
const $f3198686c7919898$var$getObserver = ()=>{
    if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
    $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LongTask) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $f3198686c7919898$var$pe;
};
const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jgkaQ", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $0fe8913ad7f2f853$export$9d952633c9c2237b);

var $bobSR = parcelRequire("bobSR");

var $fDtbf = parcelRequire("fDtbf");
const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $bobSR.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $fDtbf.JS_EVAL_START)) && !item.name.endsWith((0, $fDtbf.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("9NJeU", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $8fa3790b95082ce5$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("3Itig", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $d593ead38e6ee650$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $d593ead38e6ee650$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $d593ead38e6ee650$export$b72e035af6568be7);

var $6RCeq = parcelRequire("6RCeq");
const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
    if (!(0, $6RCeq.default)) return {};
    const navigation = (0, $6RCeq.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $d593ead38e6ee650$var$assetsTypes = [
    'script',
    'link'
];
const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("6R03U", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $7077665729c4125c$export$e703af446a67c7f4);
const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("bo7zb", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $c797c35a7f1d14f1$export$efd8b60b870e5282);
const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("ax2PR", function(module, exports) {

$parcel$export(module.exports, "getSSRStateInformation", () => $cefad605288b959d$export$9a46186893ad76bd);

var $x9xyg = parcelRequire("x9xyg");
const $cefad605288b959d$var$getState = ()=>{
    if ((0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $x9xyg.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $cefad605288b959d$var$getState()
    };
};

});

parcelRegister("4xsv9", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $a91d766509875677$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("23oLI", function(module, exports) {

$parcel$export(module.exports, "configure", () => $cae2d24fdb1ad5ec$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $cae2d24fdb1ad5ec$export$2eda1519e91a4386);

var $kkR2c = parcelRequire("kkR2c");
let $cae2d24fdb1ad5ec$var$config = null;
function $cae2d24fdb1ad5ec$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $cae2d24fdb1ad5ec$var$config = bundleEvalTimingConfiguration;
}
const $cae2d24fdb1ad5ec$var$getPerformanceObject = ()=>(window ?? {}).performance;
function $cae2d24fdb1ad5ec$export$2eda1519e91a4386(interactionStartTime) {
    if ($cae2d24fdb1ad5ec$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $cae2d24fdb1ad5ec$var$config;
    const performance = $cae2d24fdb1ad5ec$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $kkR2c.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $kkR2c.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("kkR2c", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $87a20ef13e2e9a4e$export$56014375de40214b);
const $87a20ef13e2e9a4e$export$56014375de40214b = (num, places = 3)=>{
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("bsNVL", function(module, exports) {

$parcel$export(module.exports, "init", () => $90e39b0e300d2e47$export$2cd8252107eb640b);

var $gg6CF = parcelRequire("gg6CF");

var $jl4TP = parcelRequire("jl4TP");

var $4iUSN = parcelRequire("4iUSN");

var $jwzt3 = parcelRequire("jwzt3");

var $hhGDe = parcelRequire("hhGDe");

var $aoclM = parcelRequire("aoclM");
let $90e39b0e300d2e47$var$initialized = false;
function $90e39b0e300d2e47$var$sinkInteraction(instance, payloadPackage) {
    (0, $hhGDe.sinkInteractionHandler)((interactionId, interaction)=>{
        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
            const payloads = payloadPackage.createPayloads(interactionId, interaction);
            payloads?.forEach((payload)=>{
                instance.sendOperationalEvent(payload);
            });
        });
    });
}
function $90e39b0e300d2e47$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $hhGDe.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), ()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}


const $90e39b0e300d2e47$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
    if ($90e39b0e300d2e47$var$initialized) return;
    (0, $4iUSN.setUFOConfig)(config);
    if (config.vc?.enabled) (0, $aoclM.getVCObserver)({
        heatmapSize: config.vc.heatmapSize,
        oldDomUpdates: config.vc.oldDomUpdates,
        devToolsEnabled: config.vc.devToolsEnabled,
        selectorConfig: config.vc.selectorConfig
    }).start({
        startTime: 0
    });
    (0, $jwzt3.setupHiddenTimingCapture)();
    (0, $jl4TP.startLighthouseObserver)();
    $90e39b0e300d2e47$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("eVmHt")),
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("hzfks"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $90e39b0e300d2e47$var$sinkInteraction(instance, payloadPackage);
            if (config.captureLateReRenders) $90e39b0e300d2e47$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $90e39b0e300d2e47$var$sinkInteraction(awc, payloadPackage);
            if (config.captureLateReRenders) $90e39b0e300d2e47$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
};

});
parcelRegister("jl4TP", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $3d7ad20aa303ca35$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $3d7ad20aa303ca35$export$b46cecdf698e4bb5);

var $9St6u = parcelRequire("9St6u");

var $5V8lP = parcelRequire("5V8lP");

var $hoovg = parcelRequire("hoovg");

var $1FEJY = parcelRequire("1FEJY");

var $3oyzG = parcelRequire("3oyzG");
function $3d7ad20aa303ca35$export$5ecf2aafafee3e0() {
    (0, $3oyzG.startLSObserver)();
    (0, $3oyzG.startLTObserver)();
}
const $3d7ad20aa303ca35$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $hoovg.getTBT)(start, stop, (0, $1FEJY.EntriesBuffer)[(0, $5V8lP.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $9St6u.getCLS)(start, stop, (0, $1FEJY.EntriesBuffer)[(0, $5V8lP.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("9St6u", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $d3571cf8e27186f9$export$fc6227831ee7c7);
const $d3571cf8e27186f9$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("5V8lP", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $1481908d6355ff01$export$a4def92db6fc8e17);
const $1481908d6355ff01$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("hoovg", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $342b7e36daf730a4$export$2d6e933b35bd3407);
const $342b7e36daf730a4$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $342b7e36daf730a4$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $342b7e36daf730a4$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $342b7e36daf730a4$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $342b7e36daf730a4$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("1FEJY", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $76e4fbe5af7003dd$export$f7dc16cbd16f7bbe);

var $5V8lP = parcelRequire("5V8lP");
class $76e4fbe5af7003dd$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $76e4fbe5af7003dd$export$f7dc16cbd16f7bbe = {
    [(0, $5V8lP.PerformanceObserverEntryTypes).LongTask]: new $76e4fbe5af7003dd$export$2c6e86519c9e8188(),
    [(0, $5V8lP.PerformanceObserverEntryTypes).LayoutShift]: new $76e4fbe5af7003dd$export$2c6e86519c9e8188()
};

});

parcelRegister("3oyzG", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $d9d986e5395919bb$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $d9d986e5395919bb$export$54fb8b6aaf70ec9c);

var $5V8lP = parcelRequire("5V8lP");

var $1FEJY = parcelRequire("1FEJY");
let $d9d986e5395919bb$var$pe = null;
const $d9d986e5395919bb$var$getObserver = ()=>{
    if ($d9d986e5395919bb$var$pe !== null) return $d9d986e5395919bb$var$pe;
    $d9d986e5395919bb$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $5V8lP.PerformanceObserverEntryTypes).LayoutShift) (0, $1FEJY.EntriesBuffer)[(0, $5V8lP.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $5V8lP.PerformanceObserverEntryTypes).LongTask) (0, $1FEJY.EntriesBuffer)[(0, $5V8lP.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $d9d986e5395919bb$var$pe;
};
const $d9d986e5395919bb$export$768ccc3ab7bac3ea = ()=>{
    $d9d986e5395919bb$var$getObserver().observe({
        type: (0, $5V8lP.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $d9d986e5395919bb$export$54fb8b6aaf70ec9c = ()=>{
    $d9d986e5395919bb$var$getObserver().observe({
        type: (0, $5V8lP.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jwzt3", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $e41b3be7c32eba81$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $e41b3be7c32eba81$export$768b2008623433e1);

var $cBeZP = parcelRequire("cBeZP");
const $e41b3be7c32eba81$var$timings = [];
let $e41b3be7c32eba81$var$wasHiddenFlag;
let $e41b3be7c32eba81$var$setupFlag = false;
function $e41b3be7c32eba81$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $e41b3be7c32eba81$var$SIZE = 50;
let $e41b3be7c32eba81$var$insertIndex = 0;
function $e41b3be7c32eba81$var$pushHidden(isPageHiddenFlag, time) {
    $e41b3be7c32eba81$var$timings[$e41b3be7c32eba81$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $e41b3be7c32eba81$var$insertIndex = ($e41b3be7c32eba81$var$insertIndex + 1) % $e41b3be7c32eba81$var$SIZE;
    $e41b3be7c32eba81$var$wasHiddenFlag = isPageHiddenFlag;
}
function $e41b3be7c32eba81$var$handleChange() {
    const isPageHiddenFlag = $e41b3be7c32eba81$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$e41b3be7c32eba81$var$wasHiddenFlag) $e41b3be7c32eba81$var$pushHidden(isPageHiddenFlag);
        $e41b3be7c32eba81$var$wasHiddenFlag = true;
    } else {
        if ($e41b3be7c32eba81$var$wasHiddenFlag) $e41b3be7c32eba81$var$pushHidden(isPageHiddenFlag);
        $e41b3be7c32eba81$var$wasHiddenFlag = false;
    }
}
function $e41b3be7c32eba81$var$setup() {
    (0, $cBeZP.bind)(window, {
        type: 'pageshow',
        listener: $e41b3be7c32eba81$var$handleChange
    });
    (0, $cBeZP.bind)(window, {
        type: 'pagehide',
        listener: $e41b3be7c32eba81$var$handleChange
    });
    (0, $cBeZP.bind)(document, {
        type: 'visibilitychange',
        listener: $e41b3be7c32eba81$var$handleChange
    });
}
function $e41b3be7c32eba81$export$554cefe0f0373da4() {
    if (!$e41b3be7c32eba81$var$setupFlag) {
        const isPageHiddenFlag = $e41b3be7c32eba81$var$isPageHidden();
        $e41b3be7c32eba81$var$pushHidden(isPageHiddenFlag, 0);
        $e41b3be7c32eba81$var$setup();
        $e41b3be7c32eba81$var$setupFlag = true;
    }
}
function $e41b3be7c32eba81$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($e41b3be7c32eba81$var$timings.length === 0) return 'visible';
    const currentSize = $e41b3be7c32eba81$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $e41b3be7c32eba81$var$insertIndex;
    let endIdx = $e41b3be7c32eba81$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($e41b3be7c32eba81$var$insertIndex + i) % currentSize;
        if ($e41b3be7c32eba81$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($e41b3be7c32eba81$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($e41b3be7c32eba81$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("eVmHt", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iEWTu").then(()=>parcelRequire('f98pl'));

});

parcelRegister("hzfks", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4rzvi").then(()=>parcelRequire('2OdOt'));

});


parcelRegister("jIiO6", function(module, exports) {

$parcel$export(module.exports, "configure", () => $0715510bf4a5f6c7$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $0715510bf4a5f6c7$export$44487a86467333c3);

var $4iUSN = parcelRequire("4iUSN");
const $0715510bf4a5f6c7$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
const $0715510bf4a5f6c7$var$getAllowedParams = ()=>{
    const config = (0, $4iUSN.getConfig)();
    return config?.allowedResourcesParams || $0715510bf4a5f6c7$var$defaultAllowedParams;
};
const $0715510bf4a5f6c7$var$handleQueryParams = (urlString)=>{
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $0715510bf4a5f6c7$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
let $0715510bf4a5f6c7$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $0715510bf4a5f6c7$var$handleQueryParams(url);
    }
};
function $0715510bf4a5f6c7$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $0715510bf4a5f6c7$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $0715510bf4a5f6c7$var$config = newConfig;
}
const $0715510bf4a5f6c7$export$44487a86467333c3 = ()=>$0715510bf4a5f6c7$var$config;

});

parcelRegister("986xT", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $ef9ea5cee5e9e048$export$a311cb1baa7d2d62);

var $eCKtd = parcelRequire("eCKtd");
function $ef9ea5cee5e9e048$export$a311cb1baa7d2d62() {
    (0, $eCKtd.resourceTimingBuffer).start();
}

});
parcelRegister("eCKtd", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $7eb5be8b3d51fe46$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $7eb5be8b3d51fe46$export$4138a729ef1db028);

var $kkR2c = parcelRequire("kkR2c");
const $7eb5be8b3d51fe46$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $7eb5be8b3d51fe46$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $7eb5be8b3d51fe46$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>{
        const duration = (0, $kkR2c.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $kkR2c.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $kkR2c.roundEpsilon)(entry.startTime),
            duration: (0, $kkR2c.roundEpsilon)(entry.duration),
            fetchStart: (0, $kkR2c.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $kkR2c.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $kkR2c.roundEpsilon)(entry.responseStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $kkR2c.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $kkR2c.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: ()=>{
        const performance = $7eb5be8b3d51fe46$var$getPerformanceObject();
        const PerformanceObserver = $7eb5be8b3d51fe46$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($7eb5be8b3d51fe46$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $7eb5be8b3d51fe46$export$bea963256235a63e.timings = resources.map((resource)=>$7eb5be8b3d51fe46$export$bea963256235a63e.transformResource(resource));
        $7eb5be8b3d51fe46$export$bea963256235a63e.observer = new PerformanceObserver($7eb5be8b3d51fe46$export$bea963256235a63e.addTimings);
        $7eb5be8b3d51fe46$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($7eb5be8b3d51fe46$export$bea963256235a63e.observer) {
            $7eb5be8b3d51fe46$export$bea963256235a63e.observer.disconnect();
            $7eb5be8b3d51fe46$export$bea963256235a63e.observer = null;
        }
        $7eb5be8b3d51fe46$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$7eb5be8b3d51fe46$export$bea963256235a63e.transformResource(entry));
        const overflow = $7eb5be8b3d51fe46$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $7eb5be8b3d51fe46$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $7eb5be8b3d51fe46$export$bea963256235a63e.maxSize;
            $7eb5be8b3d51fe46$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $7eb5be8b3d51fe46$export$bea963256235a63e.timings.push(...entries);
    }
};
const $7eb5be8b3d51fe46$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
const $7eb5be8b3d51fe46$export$4138a729ef1db028 = (startTime, endTime)=>{
    const performance = $7eb5be8b3d51fe46$var$getPerformanceObject();
    const PerformanceObserver = $7eb5be8b3d51fe46$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$7eb5be8b3d51fe46$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$7eb5be8b3d51fe46$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $7eb5be8b3d51fe46$export$bea963256235a63e.timings.filter((timing)=>$7eb5be8b3d51fe46$var$isValidTiming(timing, startTime, endTime));
};

});


parcelRegister("ds51m", function(module, exports) {

$parcel$export(module.exports, "configure", () => $db680428aa3e7aa1$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $db680428aa3e7aa1$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $db680428aa3e7aa1$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $db680428aa3e7aa1$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $db680428aa3e7aa1$export$1c4a9b5e6e22393d);
const $db680428aa3e7aa1$var$NESTED_METRIC_SEPARATOR = '/';
const $db680428aa3e7aa1$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
const $db680428aa3e7aa1$var$mapEntry = (entry)=>({
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    });
const $db680428aa3e7aa1$var$SSR_PREFIX = 'ssr';
const $db680428aa3e7aa1$var$mapKey = (key)=>{
    if (key === 'total') return $db680428aa3e7aa1$var$SSR_PREFIX;
    return `${$db680428aa3e7aa1$var$SSR_PREFIX}${$db680428aa3e7aa1$var$NESTED_METRIC_SEPARATOR}${key}`;
};
let $db680428aa3e7aa1$var$config;
function $db680428aa3e7aa1$export$8d21e34596265fa2(ssrConfig) {
    $db680428aa3e7aa1$var$config = ssrConfig;
}
function $db680428aa3e7aa1$export$bf7408e83532dcd0() {
    if (!$db680428aa3e7aa1$var$config?.getTimings) return {};
    const timings = $db680428aa3e7aa1$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($db680428aa3e7aa1$var$filterEntry(entry[1])) acc[$db680428aa3e7aa1$var$mapKey(entry[0])] = $db680428aa3e7aa1$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $db680428aa3e7aa1$export$c7ad864055e75537() {
    return !!$db680428aa3e7aa1$var$config?.getDoneMark();
}
function $db680428aa3e7aa1$export$3def7672244bab0c() {
    return $db680428aa3e7aa1$var$config?.getDoneMark() ?? undefined;
}
function $db680428aa3e7aa1$export$1c4a9b5e6e22393d() {
    if (!$db680428aa3e7aa1$var$config?.getFeatureFlags) return undefined;
    try {
        return $db680428aa3e7aa1$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("fJbQ9", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $f9b1cc066b55fe02$export$791b8c0cbd574ea9);

var $fDtbf = parcelRequire("fDtbf");
const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $fDtbf.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $fDtbf.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("itoGf", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $be8f5f0d3efbf58f$export$8fa71550bcdc2104);

var $aZsz6 = parcelRequire("aZsz6");

var $6pIol = parcelRequire("6pIol");
const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $6pIol.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, $6pIol.sanitiseAssetName)(false)(url);
const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
    mapResources: $be8f5f0d3efbf58f$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("dQKfU", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $ba8cdb329bff9946$export$7bcf91e323db67dd);

var $LpImS = parcelRequire("LpImS");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $ba8cdb329bff9946$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $ba8cdb329bff9946$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = (0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings') ? '' : 'total'; // total is a special key that is no longer treated special when jira-ssr-update-perf-portal-timings is enabled
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (!(0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings')) return timings;
    return $ba8cdb329bff9946$var$insertTotalTiming('', timings); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $ba8cdb329bff9946$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
    const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $ba8cdb329bff9946$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    // this is a placeholder function, we don't get any real bifrost timings yet
    // in the meantime, let's set a placeholder only if we have no monolith timings and some tesseract timings
    if (jiraBeTimings || !tesseractTimings) return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: tesseractTimings['']?.duration
        }
    };
    return timings;
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    else return referenceTimer.startTime - timerToShift.startTime;
}
function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $ba8cdb329bff9946$var$getEdgeTime() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const navigatonPerfTimingEntry = (0, $6RCeq.default)?.getEntriesByType('navigation')?.[0];
    return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge')?.duration ?? 0;
}
function $ba8cdb329bff9946$export$6d488733a547304() {
    if (!(0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings')) return $ba8cdb329bff9946$var$getTesseractTimings();
    const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
    const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
    const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    // Calculate offsets and apply them to the timings
    // this needs to be done in stages so that the offsets from the last stages apply to the next too
    const edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
    const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...edgeTime && {
            edge: {
                startTime: 0,
                duration: edgeTime
            }
        },
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $ba8cdb329bff9946$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
let $ba8cdb329bff9946$var$ffCache;
let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $ba8cdb329bff9946$var$ffCache = null;
    }
    $ba8cdb329bff9946$var$ffCacheInitialiser = null;
};
function $ba8cdb329bff9946$var$getFeatureFlags() {
    if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
    return $ba8cdb329bff9946$var$ffCache;
}
const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
    getDoneMark: ()=>{
        if ((0, $4R6GH.fg)('ssr_success_when_spa_success')) {
            const SPASSRRenderedMark = (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
            if (SPASSRRenderedMark && (0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
            return null;
        }
        return (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
    },
    getTimings: $ba8cdb329bff9946$export$6d488733a547304,
    getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
};

});


parcelRegister("3qHVS", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $56907fa85239d7b0$export$73a94df81a7c0f2c);

var $dCm1o = parcelRequire("dCm1o");
const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
    (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $dCm1o.isVisualRefreshEnabled)
];

});

parcelRegister("4t2cE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e4ac290c58b66b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $3e4ac290c58b66b5$export$d0f99433cd4f4028);

var $7Jxgt = parcelRequire("7Jxgt");

var $hsuCW = parcelRequire("hsuCW");

var $4iUSN = parcelRequire("4iUSN");

var $b5JOY = parcelRequire("b5JOY");

var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");

var $jcCIC = parcelRequire("jcCIC");
const $3e4ac290c58b66b5$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $3e4ac290c58b66b5$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $hhGDe.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $jcCIC.default).current = routeName || null;
    const rate = ufoName ? (0, $4iUSN.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $hsuCW.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $7Jxgt.v4)();
        (0, $99lTN.DefaultInteractionID).current = newId;
        (0, $hhGDe.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $b5JOY.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $hhGDe.addHoldByID)(newId, [], $3e4ac290c58b66b5$var$AWAITING_PAGELOAD_NAME, $3e4ac290c58b66b5$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $hhGDe.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $hhGDe.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $hhGDe.removeHoldByID)(activeInteraction.id, $3e4ac290c58b66b5$var$AWAITING_PAGELOAD_NAME);
    }
}
function $3e4ac290c58b66b5$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $hhGDe.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $4iUSN.getInteractionRate)(ufoName, 'page_load');
        (0, $hhGDe.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $hsuCW.default)(rate)) (0, $jcCIC.default).current = ufoName;
        else (0, $hhGDe.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $hhGDe.removeHoldByID)(interaction.id, $3e4ac290c58b66b5$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("2ChuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe3490a17e762431$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $6YRTH = parcelRequire("6YRTH");

var $co1wz = parcelRequire("co1wz");

var $j8DrX = parcelRequire("j8DrX");

var $7AZuS = parcelRequire("7AZuS");

var $7o9iL = parcelRequire("7o9iL");
// eslint-disable-next-line jira/ff/inline-usage
const $fe3490a17e762431$var$isHeartbeatEnabled = ()=>(0, $co1wz.ff)('jfp.heartbeat_vfp2h', false);

const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
    (parcelRequire("1mY2B"));
};

const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("97qv7"));
};

const $fe3490a17e762431$var$renderHeartbeat = ()=>{
    (parcelRequire("5PCBy"));
};

const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("8UcTu"));

const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("fO7QI"));
const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $j8DrX.default)('ajs-search-session-id');
    const containerId = (0, $j8DrX.default)('ajs-search-container-id');
    const objectId = (0, $j8DrX.default)('ajs-search-object-id');
    const objectType = (0, $j8DrX.default)('ajs-search-content-type');
    (0, $6YRTH.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
        containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
        objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
        objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
    });
};
const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
    if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
    if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
    if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
};
const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $fe3490a17e762431$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $fe3490a17e762431$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: $fe3490a17e762431$var$isHeartbeatEnabled(),
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe3490a17e762431$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        $fe3490a17e762431$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $fe3490a17e762431$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("7AZuS", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $271711a34feab2aa$export$b6228dc14c5adf51);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $7B17s = parcelRequire("7B17s");

var $dJl1T = parcelRequire("dJl1T");

var $gG5I6 = parcelRequire("gG5I6");

var $1eg3p = parcelRequire("1eg3p");

var $5eQ1m = parcelRequire("5eQ1m");
const $271711a34feab2aa$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $dJl1T.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $271711a34feab2aa$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$Flags = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("aw7rz")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$AfterPaintFlags = (0, $7B17s.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aw7rz")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5eQ1m.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gG5I6.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());

});
parcelRegister("gG5I6", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $2e767f203a33f0d2$export$6f7845cc5e693f16);

var $5uXOq = parcelRequire("5uXOq");

var $lRFpu = parcelRequire("lRFpu");

var $lzeFL = parcelRequire("lzeFL");

var $5tsrJ = parcelRequire("5tsrJ");

var $jb5yn = parcelRequire("jb5yn");

var $j8DrX = parcelRequire("j8DrX");

var $1nUas = parcelRequire("1nUas");

var $2HbP2 = parcelRequire("2HbP2");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $a83ud = parcelRequire("a83ud");
const $2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, children);

const $2e767f203a33f0d2$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hWnRN"))
    };
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
            messages: state.messages,
            locale: (0, $lzeFL.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lRFpu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jb5yn.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a83ud.LoadingPhaseManager), null));
};

});
parcelRegister("a83ud", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $9dfz4 = parcelRequire("9dfz4");
const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $9dfz4.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hWnRN", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("1eg3p", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $6fa78f2e53e42d4a$export$8b4a0fffcddd96f4);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");
const $6fa78f2e53e42d4a$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, children));

});

parcelRegister("aw7rz", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eNmuD"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("h46oV")
]).then(()=>parcelRequire('3jTq3'));

});


parcelRegister("7o9iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $87698987077682aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $5eQ1m = parcelRequire("5eQ1m");

var $TtQEC = parcelRequire("TtQEC");
const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5eQ1m.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
        sessionId: sessionId,
        data: data
    })), $87698987077682aa$var$getPlaceholder(placeholder));
};
var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;

});

parcelRegister("1mY2B", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eNmuD"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("2ZtG1")
]).then(()=>parcelRequire('2Q8el'));

});

parcelRegister("97qv7", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("54DPr")
]).then(()=>parcelRequire('forzB'));

});

parcelRegister("5PCBy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bERdS").then(()=>parcelRequire('8ymsB'));

});

parcelRegister("8UcTu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("kWrFZ"),
    $6fhBS("92sUi"),
    $6fhBS("i5RRW"),
    $6fhBS("561Jq"),
    $6fhBS("1QYl5"),
    $6fhBS("2Lfdl"),
    $6fhBS("hPzOn"),
    $6fhBS("dsiAd"),
    $6fhBS("eNmuD"),
    $6fhBS("dzRix")
]).then(()=>parcelRequire('faPQm'));

});

parcelRegister("fO7QI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("Nlduf")
]).then(()=>parcelRequire('jEc6C'));

});


parcelRegister("80kW8", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("5gip9")
]).then(()=>parcelRequire('lOTPs'));

});

$parcel$global.rwr("jfj4N", () => { parcelRequire("lRSO6");
parcelRequire("8oLfs");

var $x9xyg = parcelRequire("x9xyg");

var $2SVPM = parcelRequire("2SVPM");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kUr4d = parcelRequire("kUr4d");

var $kUEfY = parcelRequire("kUEfY");
var $6UjWj = parcelRequire("6UjWj");

var $gWHEk = parcelRequire("gWHEk");

var $kuiU5 = parcelRequire("kuiU5");

var $hh0bW = parcelRequire("hh0bW");

var $jpY8v = parcelRequire("jpY8v");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");


var $8ApFP = parcelRequire("8ApFP");
const $6a69127f0604feb0$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $jpY8v.getBrowser)().name === filterCriteria.browser : true;
const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $jpY8v.getBrowser)().version === filterCriteria.browserVersion : true;
const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $6a69127f0604feb0$var$checkBrowserCondition,
            $6a69127f0604feb0$var$checkBrowserVersionCondition,
            $6a69127f0604feb0$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $kuiU5.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, $hh0bW.default)({
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    (0, $jcw0u.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    throw error;
};



var $aTq2A = parcelRequire("aTq2A");
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';



var $87OsA = parcelRequire("87OsA");
parcelRequire("2YzDH");

var $x9xyg = parcelRequire("x9xyg");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $39xOx = parcelRequire("39xOx");

var $co1wz = parcelRequire("co1wz");
var $7bkFJ = parcelRequire("7bkFJ");

var $4R6GH = parcelRequire("4R6GH");

var $fz3fB = parcelRequire("fz3fB");

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");


var $2SVPM = parcelRequire("2SVPM");

var $erCTW = parcelRequire("erCTW");

var $5uXOq = parcelRequire("5uXOq");

var $ghpaW = parcelRequire("ghpaW");

var $9fJwh = parcelRequire("9fJwh");

var $39xOx = parcelRequire("39xOx");

var $co1wz = parcelRequire("co1wz");

var $7XYc4 = parcelRequire("7XYc4");

var $5uXOq = parcelRequire("5uXOq");

var $44v1T = parcelRequire("44v1T");
const $0251eb7e80a5bbb6$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)}) }`
        }
    });



var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $5M3R9 = parcelRequire("5M3R9");

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $gAeCk = parcelRequire("gAeCk");

var $2SVPM = parcelRequire("2SVPM");

var $5uXOq = parcelRequire("5uXOq");

var $fq71H = parcelRequire("fq71H");

var $8Orxo = parcelRequire("8Orxo");

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $2SVPM = parcelRequire("2SVPM");

var $4oDnX = parcelRequire("4oDnX");

var $ajpes = parcelRequire("ajpes");

var $65Ltd = parcelRequire("65Ltd");

var $vrkiK = parcelRequire("vrkiK");
const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, $65Ltd.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $vrkiK.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $vrkiK.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $vrkiK.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $vrkiK.isValidRoute)(nextRoute) || nextRoute.group === (0, $65Ltd.ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};



var $imS60 = parcelRequire("imS60");

var $dIdda = parcelRequire("dIdda");

var $gF0M5 = parcelRequire("gF0M5");
function $340277bc3319e610$export$2e2bcd8739ae039(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}



var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");

var $jcCIC = parcelRequire("jcCIC");
function $af7b5ae738b7797a$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $jcCIC.default).current = nextUfoName;
    const interactionId = (0, $99lTN.DefaultInteractionID).current;
    if (interactionId) (0, $hhGDe.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}



var $5uXOq = parcelRequire("5uXOq");

var $5SZ4u = parcelRequire("5SZ4u");
const $ff743b92b4cddd31$export$f2b2f5ef0b498d26 = 5000;
const $ff743b92b4cddd31$export$f2c0b74311ada874 = 3;
const $ff743b92b4cddd31$export$af2ff676951003fe = 60000;
const $ff743b92b4cddd31$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';


const $22edcc0e648d98db$export$50dbcb44bba3aa5c = 60;
const $22edcc0e648d98db$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $22edcc0e648d98db$export$50dbcb44bba3aa5c * 1000;
};
const $22edcc0e648d98db$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $ff743b92b4cddd31$export$f2c0b74311ada874);
const $22edcc0e648d98db$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$22edcc0e648d98db$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$22edcc0e648d98db$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};


const $5a373e1127d12e01$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $5SZ4u.useMeta)();
    const remoteActions = (0, $5SZ4u.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $5SZ4u.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $22edcc0e648d98db$export$6e0db227c9674096)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performAction
    };
};



var $7fyET = parcelRequire("7fyET");

var $ajpes = parcelRequire("ajpes");

var $bCdIp = parcelRequire("bCdIp");

var $4R6GH = parcelRequire("4R6GH");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch || // For the infinite redirect loop fix (and future Mobile Web), we want to allow SPA transitions for mobile
    // ie be able to remove the `isMobileUserAgent()` check here
    //  - fg(...) = false: becomes `true` with the negation so the check is dependant on isMobileUserAgent() (ie existing behaviour)
    //  - fg(...) = true: becomes `false` with the negation so it doesn't matter what isMobileUserAgent() returns (can remove after rollout complete)
    (0, $bCdIp.default)() && !(0, $4R6GH.fg)('jira_mobile_web_infinite_redirect_fix_gate2')) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;



var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dJl1T = parcelRequire("dJl1T");

var $2Ioew = parcelRequire("2Ioew");


var $frBVt = parcelRequire("frBVt");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");
const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPoint = (0, $5uXOq.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    const entryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869;
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $dJl1T.default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    if (!entryPointReference || !entryPoint) return null;
    let pageId = route.name;
    if (route.pageId) {
        if (typeof route.pageId === 'function') pageId = route.pageId({
            route: route,
            action: action,
            location: location,
            match: match,
            query: query
        });
        else pageId = route.pageId;
    }
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
        name: "route_entry_point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};


const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $308f7fd68513e9ff$var$useRouterLocation = (0, $dIdda.createRouterSelector)((state)=>state.location);
const $308f7fd68513e9ff$var$useRouterAction = (0, $dIdda.createRouterSelector)((state)=>state.action);
const $308f7fd68513e9ff$var$useRouterQuery = (0, $dIdda.createRouterSelector)((state)=>state.query);
const $308f7fd68513e9ff$var$useRouterRoute = (0, $dIdda.createRouterSelector)((state)=>state.route);
const $308f7fd68513e9ff$var$useRouterMatch = (0, $dIdda.createRouterSelector)((state)=>state.match);
const $308f7fd68513e9ff$var$useRouterRoutes = (0, $dIdda.createRouterSelector)((state)=>state.routes);
let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, $4R6GH.fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
    $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
};
const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $fq71H.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $308f7fd68513e9ff$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $5uXOq.useMemo)(()=>{
        (0, $x9xyg.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $f43999df472d4d05$export$ffb8c03de895ae3)(), []);
    const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $dIdda.useRouterActions)();
    const location = $308f7fd68513e9ff$var$useRouterLocation();
    const action = $308f7fd68513e9ff$var$useRouterAction();
    const query = $308f7fd68513e9ff$var$useRouterQuery();
    const route = $308f7fd68513e9ff$var$useRouterRoute();
    const match = $308f7fd68513e9ff$var$useRouterMatch();
    const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if ((0, $gF0M5.isLazyRouteMapExperimentEnabled)()) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $5a373e1127d12e01$export$1bfa74483a8ca772)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $4oDnX.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $5uXOq.useCallback)(async (nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatch = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $c27c60eec62bb2f2$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
        if ((0, $gF0M5.isLazyRouteMapExperimentEnabled)()) // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        {
            if (!canDo && routes.length <= 3) await (0, $dJl1T.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                route: nextMatch?.route.name
            });
        }
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatchObject = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $340277bc3319e610$export$2e2bcd8739ae039)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $7fyET.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $340277bc3319e610$export$2e2bcd8739ae039)(route);
                (0, $af7b5ae738b7797a$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    if (!(route && match)) return null;
    const { component: RouteComponent, meta: meta } = route;
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $813341ccf863a0ac$export$3e4cdfb894377bc9), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }) : RouteComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
};
var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;


const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $1f1817a083d388c8$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $308f7fd68513e9ff$export$2e2bcd8739ae039), {
        initRoute: initRoute,
        routes: routes
    }));
var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;



var $erBFB = parcelRequire("erBFB");
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $571ff4fe4ca2a221$export$712225703044cda = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
            __cmplp.className
        ])
    });
});


/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
const $780b11bdb912365c$var$NewContent = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $ghpaW.useBusinessLookAndFeel)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fJwh.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $780b11bdb912365c$var$OldContent = (props)=>{
    const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $ghpaW.useBusinessLookAndFeel)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0251eb7e80a5bbb6$export$2fcd4100c556a49e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f1817a083d388c8$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (hasProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fJwh.BusinessWrapper), {
        withWhiteBackground: isInset
    }, renderContent);
    return (0, $co1wz.ff)('iph.enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $571ff4fe4ca2a221$export$712225703044cda), null, renderContent) : renderContent;
};
const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $780b11bdb912365c$var$NewContent, $780b11bdb912365c$var$OldContent);


const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erCTW.PageContainer), {
        baseUrl: baseUrl,
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $780b11bdb912365c$export$7c6e2c02157bb7d2), {
        initRoute: initRoute,
        routes: routes
    }));
};



var $6jY6G = parcelRequire("6jY6G");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5eQ1m = parcelRequire("5eQ1m");

var $b7awD = parcelRequire("b7awD");

var $81ezV = parcelRequire("81ezV");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $6vAaw = parcelRequire("6vAaw");

var $gccSB = parcelRequire("gccSB");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $dIdda = parcelRequire("dIdda");

var $TtQEC = parcelRequire("TtQEC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
    else {
        const head = $751334a79f9a31ee$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
    const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};



var $5Jsi2 = parcelRequire("5Jsi2");
const $fffa056866f763fb$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $fffa056866f763fb$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (placeholderId && document.getElementById(placeholderId)) // @ts-expect-error - TS2345 - Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Element | DocumentFragment'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $7nsd3.unmountComponentAtNode)(document.getElementById(placeholderId));
};
const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, $751334a79f9a31ee$export$4267657a25105d9d));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $751334a79f9a31ee$export$c79fd820617d7f)(name, content));
};
const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, $j8DrX.default)('ajs-search-session-id');
class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        };
        this.onHistoryChange = (location)=>{
            $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $6YRTH.default)($fffa056866f763fb$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                };
                $fffa056866f763fb$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $5Jsi2.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, $dIdda.withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);



var $2SVPM = parcelRequire("2SVPM");

var $2SVPM = parcelRequire("2SVPM");
const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa', 'vendor-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/vendor', 'vendor-entry.js:eval-start', 'vendor-entry.js:eval-stop');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-stop');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/bundle-ready', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-start');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/eval', 'commons-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/bundle-ready', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-start');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
};



var $bShz7 = parcelRequire("bShz7");
/* eslint-disable no-await-in-loop */ 
var $dJl1T = parcelRequire("dJl1T");

var $dIdda = parcelRequire("dIdda");
const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $dIdda.matchRoute)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $dIdda.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: async (__, done)=>{
            try {
                const matchedRoute = (0, $dIdda.matchRoute)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
                history.location.search);
                // This should never be the case as in SPA we have a default route
                if (!matchedRoute || !nextMatchedRoute) return done(true);
                /* We reverse loop block functions as we want the ones registered later to run first
				 * (respecing the render tree: Route > Page > Form > ...)
				 * we also do it serially, so if the last registed returns false we do not call the others */ for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                    const result = await routeBlockFns[i](...blockArgs);
                    if (result === false) return done(false);
                }
                /* After running we clean up the blockers */ routeBlockFns.length = 0;
                return done(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $dJl1T.default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                return done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
        // We reset these on the assumption that loading the routes will re-render the SPA components that
        // populate these and re-add them with the correct routes captured in the closure
        routeBlockFns.length = 0;
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $dIdda.matchRoute)(currentRoutes, location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);



var $5HG6S = parcelRequire("5HG6S");

var $kKlrY = parcelRequire("kKlrY");

var $l8ruj = parcelRequire("l8ruj");

var $3qHVS = parcelRequire("3qHVS");

var $dIdda = parcelRequire("dIdda");


var $4t2cE = parcelRequire("4t2cE");

var $dPp96 = parcelRequire("dPp96");

var $aoclM = parcelRequire("aoclM");

var $7fyET = parcelRequire("7fyET");

var $2ChuC = parcelRequire("2ChuC");
const $2f70583cb46f9994$var$isPreprodSlow = ()=>(0, $co1wz.getFeatureFlagValue)('uip.preprod.slow', 0);
(0, $x9xyg.setMark)('JIRA_SPA_ENTRY_LOADED');
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
(0, $kUEfY.LooselyLazy).init({
    mode: (0, $6UjWj.MODE).RENDER,
    crossOrigin: 'anonymous'
});
const $2f70583cb46f9994$var$tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
(0, $x9xyg.setMark)('jira-spa/language-pack.start');

var $hWnRN = parcelRequire("hWnRN");
(0, $x9xyg.setMark)('jira-spa/language-pack.end');
const { locale: $2f70583cb46f9994$var$locale } = $2f70583cb46f9994$var$tenantContext;
const $2f70583cb46f9994$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $2f70583cb46f9994$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ChuC.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $2f70583cb46f9994$var$updateCapability = (capability)=>{
    (0, $87OsA.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $dIdda.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $dIdda.matchRoute)(routes, nextLocation.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        nextLocation.search, '');
        $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $6jY6G.useCurrentRoute)();
    $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $2f70583cb46f9994$var$main = async (getRoutesAsync)=>{
    (0, $kKlrY.default)();
    (0, $aTq2A.initBrowserMetrics3)();
    (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
    (0, $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed)();
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $x9xyg.setMark)('jira-spa/setup.start');
    const getRoutes = await (0, $2SVPM.measureInitialPageLoadTimingAsync)('jira-spa/setup/routes', getRoutesAsync);
    const routes = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/routes', getRoutes);
    const history = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ab2f047cd976509c$export$2e2bcd8739ae039)(routes));
    const initRoute = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $dIdda.matchRoute)(routes, window.location.pathname, window.location.search);
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $340277bc3319e610$export$2e2bcd8739ae039)(initRoute.route);
        (0, $4t2cE.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $6jY6G.useCurrentRoute)();
        (0, $gWHEk.browserMetrics).setRoute(route.name);
        (0, $dPp96.useUFOTransitionCompleter)();
        if ((0, $co1wz.ff)('uip.ufo')) (0, $7fyET.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    if ((0, $co1wz.ff)('uip.ufo')) (0, $7fyET.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $5HG6S.getSpaRouterContext)({
            tenantContext: $2f70583cb46f9994$var$tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $bShz7.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        }
    };
    const SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fffa056866f763fb$export$2e2bcd8739ae039), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fz3fB.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5eQ1m.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $454974e68bcf078d$export$6d4069f4b64f7492), {
            baseUrl: "",
            locale: $2f70583cb46f9994$var$locale,
            messages: $hWnRN,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $x9xyg.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        if ((0, $co1wz.ff)('uip.vc.partial', false)) {
            (0, $aoclM.getVCObserver)().setSSRElement(container);
            (0, $aoclM.getVCObserver)().setReactRootRenderStart();
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    (0, $aoclM.getVCObserver)().setReactRootRenderStop();
                });
            });
        }
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        // if the feature flag is false, do not opt into concurrent features
        // if the local env var is not set, or set to false, do not opt into concurrent features
        if (!(0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
            placeholders: placeholders
        }), container);
        if ((0, $4R6GH.fg)('jfp-magma-concurrent-root-jira-spa')) {
            const root = (0, $kUr4d.createRoot)(container);
            root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                placeholders: placeholders
            }));
        }
    }
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ($2f70583cb46f9994$var$isPreprodSlow() > 0) {
        (0, $x9xyg.setMark)('slow-start');
        const end = performance.now() + $2f70583cb46f9994$var$isPreprodSlow();
        while(performance.now() < end);
        (0, $x9xyg.setMark)('slow-stop');
    }
    (0, $2ChuC.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $2f70583cb46f9994$var$superbatchInit();
    return null;
};
const $2f70583cb46f9994$export$f71867a5b2484020 = async (getRoutesAsync)=>{
    return $2f70583cb46f9994$var$main(getRoutesAsync).catch((reason)=>(0, $6a69127f0604feb0$export$a5c16644a2d3c205)(reason));
};


(0, $x9xyg.setMark)('JIRA_SPA_ENTRY_LOADED');

(0, $2f70583cb46f9994$export$f71867a5b2484020)(async ()=>(0, $2SVPM.measureInitialPageLoadTimingAsync)('jira-spa/setup/load-routes', async ()=>{
        const { default: getRoutes } = await (parcelRequire("80kW8"));
        return getRoutes;
    }));
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","1QYl5","561Jq","i5RRW","92sUi","kWrFZ","bYT2S","h2MrD","fr9NE","cM9em","1WmWM"]);

$parcel$global.rlb("jfj4N")
//# sourceMappingURL=jira-spa.cf14a14d.js.map
